const lang = {
    en: {
        qr_text: 'Scan the QR code to download the app',
        Favorites: "Favorites",
        inecobank: "INECOBANK",
        order_product: "We will contact you to find out details",
        by_installation: "By installation",
        no_installation: "No Installation",
        online_price_info: "Online price",
        credit_info_product: "Loan terms",
        branches: "Branches",
        cred_info_prod_popup:
            "Monthly installment payments and maximum duration of loan can differ for particular bank. This amounts include monthly service fees and/or interest amount.",
        online_price_prod_popup:
            "Data and image on this page can differ from actual product specifications․ The price is mentioned for shops in Yerevan, Abovyan and Gyumri. In other stores, depending on the logistics costs, prices may vary.",
        copy_right: "© Copyright VLV CENTRE LLC, 2014-2023.",
        cite_development: "Site Development:",
        flat_room: "Fill in the apartment/house/floor",
        comment_order:
            "Fill in the address of delivery or move the red dot in the map",
        read_agree_terms: "I agree to the terms",
        credit_text: "Add Text",
        order_accepted: "Your order has been accepted",
        show_more: "Show more",
        fill_fields_ordered_products:
            "Fill in the following fields, and we'll get in touch with you to go over the specifics.",
        collapse: "Collapse",
        excel_file: "Excel File",
        back_to_site: "Back to site",
        fast_delivery: "Express Delivery",
        order_search: "Order Search",
        fast_delivery_title: "Express Delivery",
        with_installation: "with installation",
        without_installation: "without installation",
        fast_delivery_descr:
            "If you have purchased the product before 15:00 and want to receive it on the same day, please note that there is an Express delivery service. Delivery will be made on the same day until 20:00.  The cost of the service is 2000 drams, the service is available only in Yerevan.",
        i_have_read: "I have read and agree to the terms",
        check_privacy: "Please check this input",
        error_product: "select a product",
        error_date_start: "select a start date",
        shipping_amount: "Shipping Amount",
        error_date_end: "select an end date",
        create_product_date: "Products sale date",
        acba_score:
            'We inform you <b style="color:#D10000;text-decoration: underline;"> that the number of credit applications submitted by you has a negative effect on your credit score, in particular, the FAICO score. </b>',
        thanks_for_subscribe: "Thanks for subscription",
        discounted_price: "Discounted Price",
        surname: "Surname",
        "subscribed ": "You've already subscribed to the newsletter",
        select_payment_option: "Select the payment option.",
        coupon_is_avilable: "This Coupon is not available for selected products",
        coupon_have_more_purchase:
            "You should have more purchases to get This Coupon.",
        coupon_already: "This coupon is already used",
        print_labels: "Print label",
        create_labels: "Create label",
        promo_price: "Promo Price",
        rrp: "Recommended Retail Price",
        coupon_expirad: "coupon is expired",
        invalid_coupon: "invalid Coupon",
        fill_coupon: "fill in the coupon number",
        date_discount_start: "Promotion Date Start",
        date_discount_end: "Promotion Date End",
        COMPARE: "COMPARE",
        buy: "Buy",
        pay_by_receipt: "PAY BY INVOICE",
        receipt_info: "Information about the organization",
        legal_address: "Legal address",
        hvhh: "INN",
        corporate_name: "Corporate name",
        Delivery_Type: "Delivery details",
        "Delivery in Yerevan": "Delivery in Yerevan",
        "Delivery Regions": "Delivery in Regions",
        "Pick up in store": "Pick up from store",
        "Add an address": "Add an address",
        "Fill in the data":
            "Fill in the field below or mark it by moving the red dot",
        success_resume: "Your CV has been successfully submitted",
        "Payment type": "Payment type",
        "By bank card": "By bank card",
        PAY_BY_invoice: "PAY BY INVOICE",
        PAY_ON_THE_SPOT_BY_CASH_OR_Bank_Card_Policy:
            "• Name of the organization << VLV Center >> LLC<br />        • Legal address: G. Nzhdehi 21, Yerevan<br />        • Business Address: 69/5 Arshakunyants, Yerevan<br />        • Tax ID: 02235463<br />        • E-mail: vlv_hashvapahutyun@mail.ru<br />        • Director: Vaghinak Hovhannesyan<br /><br />        • Bank details:<br />        << Inecobank CJSC >> 2050022129881001<br />        << ACBA-CREDIT AGRICULTURAL BANK OJSC >> 220090125786000<br />        << ARTSAKH BANK CJSC >> 22317003448000<br />        << EVOKABANK CJSC >> 1660010863460100<br />        << ARMECONOMBANK OJSC >> 1636103950040100<br />        << CONVERSE BANK CJSC >> 1930047229410100<br />        << UNIBANK OJSC >> 24137000146300<br />        << AMERIABANK CJSC >> 1570018294390200<br />        << VTB-ARMENIA BANK CJSC >> 16046028825300<br />        << IDBank CJSC >> 11815025411800",
        easy_pay: "Easy Pay",
        attach_cv: "Attach CV",
        level: "Level",
        resumes: "Resumes",
        "Online credit": "Online credit",
        path: "Path",
        "PAY ON THE SPOT BY CASH OR Bank Card":
            "PAY ON THE SPOT BY CASH OR Bank Card",
        "Payment with bonuses": "Payment with bonuses",
        "Installment payment": "Installment payment",
        "Product:": "Product:",
        footer_baner: "Footer banner",
        "City:": "City",
        State: "State",
        "Community:": "Community",
        "Postal code:": "Postal code",
        "Street, house, apartment": "Street, house, apartment",
        Shipment: "Shipping",
        "Bonus:": "Bonus",
        shiping_state:
            "To check the cost of delivery to RA regions, call the following phone number +37491767117",
        "Card code": "Card code",
        "Order confirmation": "Order confirmation",
        "Do you have a promotion?": "Do you have a promo code?",
        "Promo code:": "Promo code",
        Activate: "Activate",
        "Show on map": "Show on map",
        "City, region, community, address...":
            "City, region, community, address...",
        Personal_information: "Personal information",
        Honor_another_persons_data: "Add another person details",
        vlv: "VLV CENTRE",
        many_viewed_products: "Many viewed products",
        active_in_filter: "Active in filter",
        vlv_type: "VLV Type",
        filter: "Filter",
        srch_plach: "Search for a product in the category",
        to_learn_more: "To learn more",
        to_learn_more_attr: "See more",
        to_close: "To close",
        discounted_products: "Discounted products",
        famous_category: "Popular Categories",
        type_pay: "Types of payment",
        video: "Video",
        pay_text: "You can pay by cash on delivery or choose",
        pay_href: "another payment method",
        dw_app: "Download the app",
        soc_linkes: "We on social media",
        inf_text: "News and promotions for members only",
        bonus_cart: "club bonus card",
        spick_voic: "Speak up  ...",
        three_in_one: "Three in one",
        inf: "Information",
        buy_er_in: "To the buyer",
        sl: "SL",
        title_en: "Title En",
        title_ru: "Title Ru",
        title_hy: "Title Hy",
        sub_title_en: "Sub Title En",
        sub_title_ru: "Sub Title Ru",
        sub_title_hy: "Sub Title Hy",
        sticker_list: "Sticker List",
        add: "Add",
        by_nou: "BUY NOW",
        buy_two: "Buy two",
        get_a_product: "GET A PRODUCT",
        by_gif: "AS A GIFT",
        ip: "IP",
        sale_search: "Sale search",
        href: "Reference",
        home_page_baner: "Home Page Baner",
        catalog_page_baner: "Catalog Page Baner",
        all_category: "All Category",
        add_slider: "Add Slider",
        add_photos: "Add Photos",
        slider_image_en: "Slider image En",
        slider_image_ru: "Slider  image Ru",
        slider_image_hy: "Slider image Hy",
        photos_image_en: "Photos image En",
        photos_image_ru: "Photos  image Ru",
        photos_image_hy: "Photos image Hy",
        slider1: "Slider 1",
        slider2: "Slider 2",
        photos1: "Photos 1",
        photos2: "Photos 2",
        photos3: "Photos 3",
        baner1: "Banner 1",
        baner2: "Banner 2",
        guaranty: "Guarantee",
        ship_sot: "Get to buy",
        stet_ended: "The promotion is available ",
        by: "by",
        day: "Days",
        hours: "Hours",
        minutes: "Minutes",
        seconds: "Seconds",
        here: "here",
        name_en: "Name EN",
        name_hy: "Name ARM",
        name_ru: "Name RU",
        change_password: "Change Password",
        keyword: "Keyword",
        number_of_use: "Number Of Use",
        ip_list: "IP LIST",
        title: "Title",
        related_product: "Related Category",
        related_brand: "Related Brand",
        up_sale_brand: "Up Sale Brand",
        cross_sale_brand: "Cross Sale Brand",
        up_sale_category: "Up Sale Category",
        cross_sale_category: "Cross sale Category",
        secret_id: "Secret ID",
        details: "Details",
        automatic_wallet_approval: "Automatic wallet approval",
        pickup_address: "Pickup address",
        slug: "Slug",
        work_hors_shop_address: "Showroom working hours",
        address_shop_address: "Address",
        phone_shop_address: "Phone",
        image_alt_shop_address: "Image Alt",
        image_shop_address: "Image",
        longitude_shop_address: "Longitude",
        latitude_shop_address: "Latitude",
        make_default: "make as a default",
        feature: "Feature",
        request: "Request",
        restricted_in_demo_mode: "Restricted in demo mode",
        list: "List",
        enter_your_password: "Enter your password",
        invalid_password: "Invalid password",
        choose: "Choose",
        social_login: "Social login",
        secret_login: "Secret Login",
        select_product_first: "Select product first",
        my: "My",
        config: "Configuration",
        add_new: "Add New",
        csv_upload: "CSV File",
        upload_csv: "Upload CSV",
        upload_file: "Upload file",
        customer_profile: "Customer Profile",
        no_results_found: "No results found",
        merchants: "Merchants",
        quick_search: "Quick Search",
        status: "Status",
        status_is_online: "Status is online",
        status_is_online_active: "Status is online active",
        status_is_online_inactive: "Status is online inactive",
        action: "Action",
        edit: "Edit",
        delete: "Delete",
        select: "Select",
        is_trusted: "Is Trusted",
        icon: "Icon",
        minimum_order_quantity: "Minimum order quantity",
        maximum_order_quantity: "Maximum order quantity",
        listed_date: "Listed date",
        in_stock: "In stock",
        out_of_stock: "Out of stock",
        active: "Active",
        deactive: "Deactive",
        "in-active": "In-Active",
        nothing_found: "Nothing Found",
        active_status: "Active Status",
        orders: "orders",
        wallet_histories: "wallet histories",
        addresses: "Addresses",
        for: "For",
        agent: "Agent",
        device: "Device",
        system: "System",
        inhouse: "Inhouse",
        inhouse_product: "Inhouse product",
        summary: "Summary",
        danger: "Danger",
        url: "Url",
        header_menu_category: "Header Menu Category",
        "header.category.baner.index": "Header Category Banners",
        "header.category.section": "Header Category Section",
        activate: "Activate",
        are_you_sure_to_activate: "Are you sure you want to activate ?",
        total_orders: "Total Orders",
        total_sale: "Total Sale",
        total_discount: "Total Discount",
        activate_successful: "Activate successful",
        completed: "Completed",
        joined_at: "Joined at",
        average_rating: "Average rating",
        total_spend: "Total spend",
        total_recharge: "Total Recharge",
        wallet_summary: "Wallet Summary",
        pending_balance_approval: "Pending Balance Approval",
        total_balance: "Total Balance",
        empty_list: "Empty List",
        total: "Total",
        update: "Update",
        language: "Language",
        clone_successful: "Clone successful",
        clone: "Clone",
        name: "Name",
        id: "ID",
        reply: "Reply",
        we_sale: "OUR PROMOTIONS",
        back: "back",
        section_setup: "Section setup",
        category: "Category",
        create_category: "Create Category",
        product_qty: "Product Quantity",
        category_name: "Category Name",
        category_list: "Category List",
        product_type: "Product Type",
        save: "Save",
        searchable: "Searchable",
        update_title: "Update Title",
        category_group: "Category Group",
        description: "Description",
        description_hy: "Description ARM",
        description_ru: "Description RU",
        root_category: "Root Category",
        show: "Show",
        group_name: "Group Name",
        "are_you_sure_to_delete_?": "Are you sure you want to delete ?",
        cancel: "Cancel",
        main_title: "Main Title",
        sub_title: "Sub Title",
        email: "Email",
        all_customer: "All Customers",
        submitting: "Submitting",
        updating: "Updating",
        deleting: "Deleting",
        hide: "Hide",
        activity_logs: "Activity Logs",
        all_activity_logs: "All Activity Logs",
        login_activity: "Login Activity",
        type: "Type",
        IP: "IP",
        attempted_at: "Attempted At",
        user: "User",
        login_at: "Login At",
        logout_at: "Logout At",
        login_logout_activity: "Login - Logout Activity",
        inactive: "Inactive",
        browse: "Browse",
        image: "Image",
        browse_image: "Browse Image",
        browse_file: "Browse File",
        attach_file: "Attach File",
        browse_image_file: "browse image file",
        "Something Went Wrong": "Something Went Wrong",
        "Delete Confirmation": "Delete Confirmation",
        "Delete confirmation message": "Delete confirmation message",
        choose_file: "Choose File",
        seo_info: "SEO info",
        meta_keywords: "Meta Keywords",
        meta_keywords_en: "Meta Keywords en",
        meta_keywords_ru: "Meta Keywords ru",
        meta_keywords_hy: "Meta Keywords hy",
        meta_title: "Meta Title",
        meta_description: "Meta Description",
        meta_title_en: "Meta Title En",
        meta_description_en: "Meta Description En",
        meta_title_ru: "Meta Title Ru",
        meta_description_ru: "Meta Description Ru",
        meta_title_hy: "Meta Title Hy",
        meta_description_hy: "Meta Description Hy",
        Draft: "Draft",
        refunded: "Refunded",
        number: "Number",
        status_info: "Status Info",
        logo: "Logo",
        choose_one: "Choose One",
        monthly: "Monthly",
        yearly: "Yearly",
        profile: "Profile",
        transactions: "Transactions",
        documents: "Documents",
        document: "Document",
        date_of_birth: "Date of Birth",
        "Current Address": "Current Address",
        "Permanent Address": "Permanent Address",
        username: "Username",
        view: "View",
        preview: "Preview",
        select_one: "Select One",
        profile_picture: "Profile Picture",
        email_or_phone_uppercase: "Email or Phone",
        employee_id: "Employee Id",
        "Last Date Of Provisional Period": "Last Date Of Provisional Period",
        personal_info: "Personal Info",
        personal: "Personal",
        upload_document: "Upload Document",
        read_all: "Read all",
        document_title: "Document Title",
        put_your_password: "Put Your Password",
        avatar: "Avatar",
        registered_date: "Registered Date",
        submit: "Submit",
        select_type: "Select Type",
        single_day: "Single Day",
        multiple_day: "Few Days",
        start_date: "Start Date",
        end_date: "End Date",
        to_date: "To Date",
        select_role: "Select Role",
        month: "Month",
        Value: "Value",
        year: "Year",
        use_as_username: "Use as username",
        your_user_id_is: "Your User ID is",
        select_criteria: "Select Criteria",
        first_name: "First Name",
        last_name: "Last Name",
        display_type: "Display Type",
        error_message: "Something Went Wrong!",
        update_message: "Updated successfully!",
        update_successfully: "Update successfully!",
        status_change_message: "Status Changed  Successfully!",
        Timestamp: "Timestamp",
        second: "Second",
        activated: "Activated",
        admin: "Admin",
        image_second_section: "Image Second Section",
        image_first_section: "Image First Section",
        upload_photo: "Upload Photo",
        photo: "Photo",
        single: "Single",
        gst_pay: "GST Pay",
        product_tax_pay: "Product Tax Pay",
        multiple: "Multiple",
        file_less_than_1MB: "File Less Than 1 MB",
        select_brand: "Select brand",
        brand: "Brand",
        brands: "Brands",
        is_featured: "Is Featured",
        featured: "Featured",
        values: "Values",
        model_number: "Model Number",
        amount: "Amount",
        quantity: "Quantity",
        not_approved: "Not Approved",
        approved: "Approved",
        select_root_category: "Select root category",
        add_menu_item: "Add Menu Item",
        select_menu_item: "Select Menu Item",
        phone_number: "Phone Number",
        vat_number: "VAT Number",
        company_information_format: "Company Information Format",
        zip_code: "Zip Code",
        count: "Count",
        country: "Country",
        location: "Location",
        date_from: "Date From",
        cash: "Cash",
        bank: "Bank",
        banks: "Banks",
        cheque: "Cheque",
        dashboard: "Dashboard",
        confirm_password: "Confirm password",
        reset_password: "Reset password",
        customer_list: "Customer List",
        active_customer: "Active Customer",
        in_active_customer: "Inactive customer",
        is_active: "Is Active",
        customer: "Customer",
        wallet_balance: "Wallet balance",
        "referral_code_(optional)": "Referral Code (Optional)",
        referral_code: "Referral Code",
        date: "Date",
        balance: "Balance",
        add_new_seller: "Add New Seller",
        shop: "Shop",
        no_of_sale: "No. of Sale",
        seller_details: "Seller Details",
        products: "Products",
        product: "Product",
        post_image: "Post Image",
        pay_first_for_subcription: "Pay First for Subcription",
        pay_for_subcription: "Pay for Subcription",
        trusted_seller: "Trusted Seller",
        account_information: "Account Information",
        holiday_mode: "Holiday Mode",
        on: "On",
        off: "Off",
        holiday_type: "Holiday Type",
        holiday_date: "Holiday Date",
        holiday_duration: "Holiday Duration",
        "n/a": "N/A",
        owner_name: "Owner's  Name",
        address_1: "Address 1",
        state: "State",
        city: "City",
        postcode: "Postcode",
        registration_number: "Registration Number",
        business_document: "Business Document",
        tin: "Tin",
        business_information: "Business Information",
        payment_information: "Payment Information",
        bank_cheque: "Bank Cheque",
        ibn: "IBN",
        routing_number: "Routing Number",
        branch_name: "Branch Name",
        bank_name: "Bank Name",
        account_name: "Account Name",
        account_number: "Account Number",
        attachment: "Attachment",
        bank_title: "Bank Title",
        cash_payment: "Cash Payment",
        bank_payment: "Bank Payment",
        return_address: "Return Address",
        warehouse_address: "Warehouse Address",
        added_successfully: "Added successfully!",
        created_successfully: "Created successfully!",
        deleted_successfully: "Deleted successfully!",
        updated_successfully: "Updated successfully!",
        payment_successfully: "Payment successful!",
        transaction_successfully: "Transaction successful!",
        status_updated_successfully: "Status Updated successfully!",
        approved_successfully: "Approved successfully!",
        success: "Success",
        seller: "Seller",
        subscription: "Subscription",
        trx_id: "Trx Id",
        txn: "Txn",
        is_approve: "Is Approve",
        full_name: "Full Name",
        unique: "Unique",
        payment: "Payment",
        mobile: "Mobile",
        cross_sale_product_display_title: "Cross sale product display title",
        up_sale_product_display_title: "Up sale product display title",
        title_settings: "Title settings",
        settings: "Settings",
        make_Display_in_details_page: "Make Display in details page",
        up_sale: "Up Sale",
        cross_sale: "Similar products",
        package: "Package",
        of: "Of",
        total_price: "Total Price",
        qty: "qty",
        items_count: "Items count",
        coupon: "Coupon",
        apply: "Apply",
        discount: "Discount",
        discount_type: "Discount Type",
        continue: "Continue",
        cart: "Cart",
        payment_options: "Payment options",
        confirm: "Confirm",
        order: "Order",
        seller_commission: "Seller Commision",
        rate: "Rate",
        commission_rate: "Commission Rate",
        commission_type: "Commission Type",
        edit_commission_rate: "Edit Commission Rate",
        change: "Change",
        current: "Current",
        re_enter: "Re enter",
        make: "Make",
        default: "Default",
        new: "New",
        old: "Old",
        region: "Region",
        page: "Page",
        required: "Required",
        banner: "Banner",
        link: "Link",
        setup: "Setup",
        published: "Published",
        all: "All",
        notification: "Notification",
        no_notification_found: "No notification found",
        error: "Error",
        total_amount: "Total Amount",
        order_id: "Order ID",
        contact_us: "Contact us",
        shipping_charge: "Shipping Charge",
        warning: "Warning",
        max: "Max",
        min: "Min",
        access_permission: "Access Permission",
        access_denied: "Access Denied",
        updated_by: "Updated By",
        user_name: "User Name",
        no_file_selected: "No file selected",
        loan: "Loan",
        apply_for_loan: "Apply For Loan",
        monthly_installment: "Monthly Installment",
        due: "Due",
        cancelled: "Cancelled",
        apply_for: "Apply For",
        General: "General",
        Emergency: "Emergency",
        loan_date: "Loan Date",
        total_month: "Total Month",
        apply_for_loan_update: "Apply For Loan Update",
        applied_date: "Applied Date",
        paid_loan_amount: "The amount paid for the loan",
        apply_loan_details: "Apply for Loan Details",
        loan_type: "Loan Type",
        applied_loan: "Applied Loan",
        add_new_ignore_ip: "Add New Ignore IP",
        ignore_ip_from_visitor_count: "Ignore Ip from Visitor Count",
        send_successfully: "Send successfully!",
        days: "Days",
        uploaded_successfully: "Uploaded successfully!",
        quick_summery: "Quick Summery",
        gift_card_list: "Gift Card List",
        number_of_sale: "Number of Sale",
        sample_file_download: "Sample File Download",
        download_warning:
            "Please download the sample file input your desire information then upload. Don't try to upload different file format and information",
        not_editable: "Not Editable",
        not_permit: "You don't have this permission",
        no_action_permitted: "No Action Permitted",
        used: "Used",
        home: "Home",
        ignore_ip: "Ignore IP",
        visitors_setup: "Visitor Setup",
        subscription_payment: "Subscription Payment",
        referral: "Referral",
        view_all: "View All",
        total_coupon_used: "Total Coupon Used",
        operation_failed: "Operation failed",
        operation_done_successfully: "Operation completed successfully",
        successful: "Successful",
        create: "Create",
        create_template_first: "Create template First",
        duplicate_entry_is_exist_in_your_file:
            "Duplicate entry is exist in your file",
        copyright: "Copyright",
        remove: "Remove",
        write_some_messages: "Write some messages",
        you_don_t_have_this_permission: "You don't have this permission",
        mail_has_been_sent_successful: "Mail has been sent successfully",
        created_at: "Created at",
        info: "Info",
        disabled: "Disabled",
        upload_pdf: "Upload PDF",
        upload_product: "Upload product",
        recharge_amount: "Recharge amount",
        country_region: "Country / Region",
        subtract: "Subtract",
        postal_code: "Postal code",
        pending_request: "Pending request",
        user_zone: "User zone",
        notifications: "Notifications",
        see_more: "See more",
        please: "Please",
        log_out_space: "Log out",
        not_deleted: "Not deleted",
        transaction_failed: "Transaction failed",
        enter_secret_code_of_gift_card: "Enter the OPT code of gift card",
        redeem_now: "Redeem now",
        redeem: "Redeem",
        select_cancel_reason: "Select the reason of cancellation",
        address_already_used: "The address has been already used",
        account_verified_successfully: "Account Verified Successfully",
        you_have_been_disabled: "You have been disabled",
        loan_has_been_applied_successfully: "Loan has been applied successfully",
        not_found: "Not found",
        please_agree_with_our_policy_privacy:
            "Please agree with our policy privacy",
        attach_upload_limit_is_5: "Attach upload limit is 5",
        billing_address: "Billing address",
        oh_no: "Oh no",
        sidebar_manager: "Sidebar Manager",
        setting: "Setting",
        convert_as_seller: "Convert as Seller",
        verification_link_resend_successfully:
            "Verification link has been resended  successfully.",
        account_already_verified: "Account already verified.",
        admin_contact_with_you: "Admin Contact With You.",
        file_name: "File Name",
        page_link: "Page Link",
        click_here: "Click Here",
        clean_all: "Clean All",
        minimum_8_charecter: "Minimum 8 Charecter",
        total_items: "Total Items",
        please_configure_mail_settings_first:
            "Please Configure Mail Settings First.",
        sms: "SMS",
        company: "Company",
        no_data_available_in_table: "No data available in the table",
        company_rating_review: "Company Rating & Review",
        set_sms_credentials: "Set SMS Credentials.",
        postal_code_or_pin_code: "Postal Code / Pin Code",
        commision: "Commision",
        Not_Wishlist: "Not Wishlist",
        Basket: "Cart",
        Back_to_shopping: "Back to shopping",
        vat: "VAT",
        instagram: "Instagram",
        "vat/tax/gst": "VAT/TAX/GST",
        link_copied_successfully: "Link copied Successfully!",
        added_address: "Address has been added successfully",
        updated_address: "Address has been updated successfully",
        not_favs: "You do not have FAVORITE PRODCUTS",
        Download: "Download",
        no_order_history: "You do not have ORDER HISTORY",
        no_virtual_product: "You do not have VIRTUAL PRODUCTS",
        profile_page: "Profile Page",
        Bonus: "Bonus",
        "Do you have a promo code?": "Do you have a promo code?",
        "Promo code": "Promo code",
        bonuses: "Bonuses",
        bonus_cartt: "Bonus Cart",
        add_bonus_cart: "Add Bonus Cart",
        "Accumulated bonuses": "Accumulated bonuses",
        "Bonus points spent": "Bonus points spent",
        Time: "Time",
        valid_until: "Valid until",
        virtual_products: "Virtual Products",
        my_address: "My Address",
        my_addresses: "My Addresses",
        add_address: "Add Address",
        notification_email: "Send notification to email",
        order_history: "Order History",
        Orders: "Orders",
        personal_information: "Personal information",
        logout: "Log Out",
        repeat: "Repeat",
        repeat_order: "Repeat the order",
        discounts: "Discounts",
        order_number: "Order Number",
        Community: "Community",
        json_markup: "Json Markup",
        add_json_markup: "Add JSON MarkUp",
        Account: "Account",
        "Bank Accounts": "Bank Accounts",
        Expenses: "Expenses",
        "Parent Account": "Parent Account",
        Name: "Name",
        Code: "Code",
        Type: "Type",
        Description: "Description",
        "Default for": "Default for",
        "Transaction date": "Transaction date",
        Profit: "Profit",
        "From The Beginning": "From The Beginning",
        "GST / TAX / VAT": "GST / TAX / VAT",
        "Opening Balance": "Opening Balance",
        "Main Income Account": "Main Income Account",
        "Total Product Wise Tax": "Total Product Wise Tax",
        Affiliate: "Affiliate",
        "My Affiliate": "My Affiliate",
        "Update Affiliate Link": "Update Affiliate Link",
        "Create Affiliate Link": "Create Affiliate Link",
        "User Name": "User Name",
        "Enter URL": "Enter URL",
        "Affiliate Link": "Affiliate Link",
        "Affiliate Links": "Affiliate Links",
        Visits: "Visits",
        Registered: "Registered",
        Purchased: "Purchased",
        Commissions: "Commissions",
        Configurations: "Configurations",
        "Affiliate Configurations": "Affiliate Configurations",
        "Minimum Withdraw": "Minimum Withdraw",
        "Commission Type": "Commission Type",
        "Commission Amount": "Commission Amount",
        "Payment Provide Date End Of Month": "Payment Provided Date End Of Month",
        "Referral Duration Type": "Referral Duration Type",
        "Referral Duration": "Referral Duration",
        "Is GST Applicable ?": "Is GST Applicable ?",
        "GST Amount": "GST Amount",
        Percentage: "Percentage",
        Flat: "Flat",
        Fixed: "Fixed",
        Lifetime: "Lifetime",
        Yes: "Yes",
        No: "No",
        Withdrawn: "Withdrawn",
        Pending: "Pending",
        "Balance Transfer To Wallet": "Balance Transfer To Wallet",
        "Withdraw Request": "Withdraw Request",
        "Add Paypal Account For Withdraw Commissions From System":
            "Add Paypal Account For Withdraw Commissions From System",
        "Update Paypal Account For Withdraw Commissions From System":
            "Update Paypal Account For Withdraw Commissions From System",
        "Paypal Account": "Paypal Account",
        "Create Withdraw Request": "Create Withdraw Request",
        "Withdraw Amount": "Withdraw Amount",
        "Payment Type": "Payment Type",
        "Select One": "Select One",
        Paypal: "Paypal",
        Offline: "Offline",
        "Withdraw Commissions By Paypal Add Account":
            "Withdraw Commissions By Paypal,  Add your Account",
        Withdraw: "Withdraw",
        "Withdraw History": "Withdraw History",
        SL: "SL",
        "Request Date": "Request Date",
        Status: "Status",
        "Confirm Date": "Confirm Date",
        Cancel: "Cancel",
        Done: "Done",
        "Balance Transfer To User Wallet": "Balance Transfer To User Wallet",
        "Transfer Amount": "Transfer Amount",
        "Update Transfer Amount": "Update Transfer Amount",
        "Update Withdraw Request": "Update Withdraw Request",
        "Transfer To User Wallet": "Transfer To User Wallet",
        "Commission History": "Commission History",
        Course: "Course",
        From: "From",
        Date: "Date",
        "Pending Withdrawn": "Pending Withdrawn",
        "Pending Withdrawn List": "Pending Withdrawn List",
        User: "User",
        Confirm: "Confirm",
        "Select Date Range": "Select Date Range",
        Filter: "Filter",
        Reset: "Reset",
        "Pending Earning": "Pending Earning",
        "Pending Transfer": "Pending Transfer",
        "Total Earning": "Total Earning",
        "Complete Withdrawn": "Complete Withdrawn",
        "Complete Withdrawn List": "Complete Withdrawn List",
        "Confirm By": "Confirm By",
        "Day End Of Month": "Day End Of Month",
        Email: "Email",
        "All Purchase": "All Purchase",
        Onetime: "One-time",
        "Balance Add Account After": "Balance Added  Account After",
        "In Days": "In Days",
        "Transfer Approval Need ?": "Transfer Approval Need ?",
        "Affiliate Account Current Balance": "Affiliate Account Current Balance",
        "Commission Approved": "Commission Approved",
        Email_or_Username: "Email / Username",
        Submit: "Submit",
        Save: "Save",
        Update: "Update",
        Add: "Add",
        Welcome: "Welcome",
        "Join Our Affiliate Program": "Join Our Affiliate Program",
        "Join Affiliate Program": "Join Affiliate Program",
        "Admin Approval Need For Affiliate User ?":
            "Admin Approval Need For Affiliate User ?",
        "Product Wise": "Product Wise",
        "Category Wise": "Category Wise",
        "Amount Type": "Amount Type",
        "Category Wise Commission Setup": "Category Wise Commission Setup",
        Others: "Others",
        "All Category": "All Category",
        Category: "Category",
        "Calculation Method": "Calculation Method",
        "Add New": "Add New",
        Users: "Users",
        "All User": "All User",
        "Active User": "Active User",
        "Inactive User": "Inactive User",
        Info: "Info",
        "Your affiliate joining request is under review. After confirming your request you can join our affiliate program.":
            "Your affiliate joining request is under review. After confirming your request you can join our affiliate program.",
        Copy: "Copy",
        "Commission Calculate For Multi Category":
            "Commission Calculate For Multi Category",
        Minimum: "Minimum",
        Average: "Average",
        Maximum: "Maximum",
        "Common Amount": "Common Amount",
        "Common Calculation Method": "Common Calculation Method",
        Product: "Product",
        "Are you sure to delete ?": "Are you sure you want to delete ?",
        "Wallet Transfer Approval Need ?": "Wallet Transfer Approval Need ?",
        "Affiliate User Approval ?": "Affiliate User Approval ?",
        "Email address or phone": "Email address or phone",
        "Min. 8 Character": "Min. 8 Character",
        "Sign In": "Sign In",
        "Sign Up": "Sign Up",
        "Don’t have an Account?": "Don’t have an Account?",
        "Forgot Password?": "Forgot Password?",
        "Send link": "Send link",
        "Please send password link.": "Please send password link.",
        "Welcome back": "Welcome back",
        "Please confirm with new password.": "Please confirm with new password.",
        "Total Order": "Total Order",
        "Product in Cart": "Product in Cart",
        "Coupon Used": "Coupon Used",
        fill_info: "Fill in your personal information",
        wrong_msg: "The email or password is wrong",
        mail: "Email",
        reset_text_password:
            "Please, enter the six-digit code provided in the email.",
        social_acc: "Login via social accounts",
        next: "Next",
        check_email: "Check your email",
        repeat_password: "Repeat the password",
        "Completed Order": "Completed Order",
        "Low to high": "Low to high",
        "High to low": "High to low",
        please_login: "Please login to your account",
        no_brand: "No brand",
        "Register Now": "Register Now",
        free_shipping_note:
            "Free shipping avaible for this product. Delivaery time within",
        "Daily Deals": "Daily Deals",
        we_send:
            "You will soon receive a one-time code that you need to enter into the field.",
        refresh: "Refresh",
        "Filter Products": "Filter Products",
        "Seller Score": "Seller Score",
        "Seller Information": "Seller Information",
        "Choose pickup location": "Choose pickup location",
        "Email Delivery": "Email Delivery",
        "email delivery note":
            "Gift card always delivery with email. Delivery Charge is free. Gift card is not refundable.",
        "App link & others": "App link & others",
        "Get it on": "Get it on",
        "Google Play": "Google Play",
        "Apple Store": "Apple Store",
        "Out of stock": "Out of stock",
        "Recharge Amount": "Recharge Amount",
        "Add Coupons": "Add Coupons",
        "Collected Coupons": "Collected Coupons",
        "Shoping Cart": "Shoping Cart",
        "Item’s selected": "Item’s selected",
        "Variant images": "Variant images",
        "YOU CAN ALSO BUY": "YOU CAN ALSO BUY",
        "Buy Both": "Buy Both",
        "Customers who viewed this also viewed": "Customers who also viewd this",
        "Delivery Info": "Delivery Info",
        "Purchase History": "Purchase History",
        "All History": "All History",
        Received: "Received",
        "Play store link": "Play store link",
        "App store link": "App store link",
        "Sorting by": "Sorting by",
        Login: "Login",
        enter_log_pass: "Enter your username and password",
        themes: "Themes",
        live_preview: "Live Preview",
        theme_details: "Theme details",
        current_theme: "Current Theme",
        version: "version",
        black: "Black",
        scheme: "Scheme",
        white: "White",
        text: "Text",
        solid: "Solid",
        "header.category": "Header Categories",
        header_pahes: "Header Category",
        headlist: "Head List",
        headlist_setup: "Head List Setup",
        toastr_message_postion: "Toastr message postion",
        toastr_message_time: "Toastr message time",
        top_right: "Top right",
        top_left: "Top left",
        bottom_right: "Bottom right",
        bottom_left: "Bottom left",
        area: "Area",
        footer: "Footer",
        navbar: "Navbar",
        menu: "Menu",
        color: "Color",
        scroll: "Scroll",
        add_new_color: "Add new color",
        background: "Background",
        border: "Border",
        base_color: "Base color",
        upload_title: "Upload Theme. If You have Purchased ZIP File.",
        browse_zip: "Browse ZIP file",
        "upload-theme": "Upload Theme",
        install_now: "Install Now",
        input_background: "Input background",
        theme: "Theme",
        header_setup: "Header Setup",
        column_size: "Column Size",
        slider: "Slider",
        photos: "Photos",
        section_general_setting: "Section General Setting",
        "1_column": "1 Column",
        "2_column": "2 Column",
        "3_column": "3 Column",
        "4_column": "4 Column",
        "5_column": "5 Column",
        "6_column": "6 Column",
        "7_column": "7 Column",
        "8_column": "8 Column",
        "9_column": "9 Column",
        "10_column": "10 Column",
        "11_column": "11 Column",
        "12_column": "12 Column",
        enable_this_section: "Enable This Section",
        slider_section_setup: "Slider Section Setup",
        photos_section_setup: "Photos Section Setup",
        category_section_setup: "Category Section Setup",
        product_section_setup: "Product Section Setup",
        new_user_zone_section_setup: "New User Zone Section Setup",
        name_required: "Name Required",
        url_required: "URL Required",
        product_required: "Product Required",
        slider_image_required: "Slider Image Required",
        photos_image_required: "Photos Image Required",
        slider_image: "Slider Image",
        photos_image: "Photos Image",
        no_sliders: "no sliders",
        no_photos: "no photos",
        product_list: "Product List",
        slider_list: "Slider List",
        photos_list: "Photos List",
        upload_theme: "Upload Theme",
        menus: "Menus",
        header: "Header",
        appearance: "Appearance",
        slider_for: "Slider For",
        photos_for: "Photos For",
        warning_message:
            "menu already used in multi mega menu. Delete not possible",
        url_is_required: "URL is required",
        slider_type_is_required: "Slider Type is required",
        photos_type_is_required: "Photos Type is required",
        navigation_label_is_required: "Navigation label is required",
        title_is_required: "Title is required",
        priding_is_required: "Pricing is required",
        new_user_zone_is_required: "New user zone is required",
        for_product: "For Product",
        for_category: "For Category",
        for_brand: "For Brand",
        for_tag: "For Tag",
        color_mode: "Color mode",
        for_url_not_support_in_mobile_app: "For URL (Not Support in Mobile APP)",
        gradient: "Gradient",
        hide_not_recomanded:
            "Hide not recommended. It can be issue on ajax request for slow server.",
        failed: "These credentials do not match our records.",
        password: "The provided password is incorrect.",
        throttle: "Too many login attempts. Please try again in few seconds again",
        logout_successfully: "Logout Successfully!",
        logged_in_successfully: "Logged In Successfully!",
        successfully_registered: "Successfully Registered!",
        multi_vendor_system_is_temporary_disabled:
            "Multi vendor system is temporary Disabled.",
        please_verify_your_email: "Please Verify Your Email address",
        wait_for_approval: "Wait for approval",
        facebook: "Facebook",
        google: "Google",
        twitter: "Twitter",
        linkedin: "Linkedin",
        client_id: "Client id",
        client_secret: "Client secret",
        "New Account": "New Account",
        "The requested bank account deleted successful":
            "The requested bank account deleted successful",
        "The requested bank account created successful":
            "The requested bank account created successful",
        "The requested bank account updated successful":
            "The requested bank account updated successful",
        "Bank Name": "Bank Name",
        "Branch Name": "Branch Name",
        "Account Name": "Account Name",
        "Account Number": "Account Number",
        "You can\\'t delete an account which has child element":
            "You can't delete an account which has child element",
        "The requested bank account is not found":
            "The requested bank account is not found",
        blog_tag: "Blog Tag",
        blog: "Blog",
        tag: "Tag",
        post_list: "Post List",
        add_new_post: "Add New Post",
        post_info: "Post Info",
        blog_list: "Blog List",
        author: "Author",
        is_approved: "Is Approved",
        all_posts: "All Posts",
        view_post: "View Post",
        published_at: "Published At",
        suggested_tags: "Suggested Tags",
        parent_category: "Parent Category",
        close_comments: "Close Comments",
        publish: "Publish",
        edit_post: "Edit Post",
        new_article: "New Article",
        post_tag: "Post Tag",
        short_description: "Short Description",
        post_article: "Post Article",
        post: "Post",
        add_new_blog: "Add new blog",
        blog_category: "blog category",
        blog_tags: "Blog Tags",
        select_parent_category: "Select parent category",
        comments_create_successfully: "Comments created successfully",
        replay_create_successfully: "Replay create successfully",
        no_post_found: "No Post Found",
        search_posts: "Search posts",
        post_successfully_approved: "Post Successfully Approved",
        this_post_is_already_approved: "This Post is already approved",
        popular_posts: "Popular Posts",
        instagram_feed: "Instagram Feed",
        project: "Project",
        love: "Love",
        technology: "Technology",
        travel: "Travel",
        restaurant: "Restaurant",
        design: "Design",
        illustration: "Illustration",
        for_post_a_new_comment_you_need_to_login_first:
            "For post a new comment you need to login first",
        post_a_comment_now: "Post a comment now",
        post_comment: "Post comment",
        "Select your Expense Account": "Select your Expense Account",
        "Chart Of Accounts": "Chart Of Accounts",
        "Add As A Parent Account": "Add as a parent account",
        "Parent account selection will add your account as a sub account":
            "Parent account selection will be addedy to your account as a sub account",
        "Select your Income Account": "Select your Income Account",
        "Account code need to be unique, Leave blank for auto generate an unique account code":
            "Account code need to be unique, Leave blank for auto generate an unique account code",
        "Selecting a default Account, will remove previously default account for selected item":
            "Selecting a default Account, will remove previously default account for selected item",
        "Select Default Account For": "Select Default Account For",
        "The requested chart of account is not found":
            "The requested chart of account is not found",
        "The requested chart of account deleted successful":
            "The requested chart of account deleted successfully",
        "The requested chart of account created successful":
            "The requested chart of account created successfully",
        "Income Account": "Income Account",
        "Expense Account": "Expense Account",
        "Select Account": "Select Account",
        "Payment Method": "Payment Method",
        "Select your Payment method": "Select your Payment method",
        "Edit Account": "Edit Account",
        "The requested chart of account updated successful":
            "The requested chart of account updated successfully",
        contact_mail: "Contact Email",
        contact_mail_list: "Contact Email List",
        contact_request: "Contact Request",
        secret_code: "Secret Code",
        is_used: "Is Used",
        purchase_list: "Purchase List",
        money_has_been_transfered_into_wallet:
            "Money has been transfered into wallet",
        purchased_digital_products: "Purchased Digital Products",
        coupon_value: "Coupon Value",
        store_name: "Store Name",
        validity: "Validity",
        customer_panel: "Customer Panel",
        my_purchases: "My Purchases",
        gift_card: "Gift Card",
        my_wishlist: "My Wishlist",
        refund_dispute: "Refund & Dispute",
        my_coupon: "My Coupon",
        my_account: "My Account",
        my_profile: "My Profile",
        my_ticket: "My Ticket",
        digital_product: "Digital Product",
        you_will_get_referral_code_soon: "You will get referral code soon !",
        my_wallet_recharge: "Recharge my wallet",
        address_already_used_for_shipping_or_billing_address:
            "Address Already Used For Shipping Or Billing Address.",
        address_already_set_for_default_shipping_or_billing_change_first:
            "Address already set default for shopping or billling, change first",
        my_referral: "My Referral",
        my_refund_list: "My refund list",
        quick_summary: "Quick Summary",
        seller_dashboard: "Seller Dashboard",
        today: "Today",
        this_week: "This Week",
        this_year: "This Year",
        this_month: "This Month",
        total_seller: "Total Seller",
        total_customer: "Total Customer",
        total_customers: "Total Customers",
        total_pending_order: "Total Pending Order",
        total_completed_order: "Total Completed Order",
        total_review: "Total Review",
        today_revenue: "Today' Revenue",
        active_customers: "Active Customers",
        total_subscriber: "Total Subscriber",
        today_sale_revenue: "Today Revenue",
        sellers: "Sellers",
        today_order_summary: "Today's Order summary",
        orders_summary: "Orders Summary",
        guest_authorized_order_today: "Guest/Authorized Order Today",
        site_analytics: "Site Analytics",
        total_visitor: "Total Visitor",
        total_page_views: "Total Page Views",
        new_visitors: "New Visitors",
        old_visitors: "Old Visitors",
        total_in_sessions: "Total In Sessions",
        top_10_product: "Top 10 Product",
        top_10_seller: "Top 10 Seller",
        category_wise_product_qty: "Category Wise Product Qty",
        category_wise_product_sale: "Category Wise Product Sale",
        coupon_wise_sale: "Coupon Wise Sale",
        new_customers: "New Customers",
        recently_added_products: "Recently Added Products",
        top_refferers: "Top Refferers",
        latest_order: "Latest Order",
        latest_search_keyword: "Latest Search Keyword",
        appealed_disputed: "Appealed Disputed",
        top_customers: "Top Customers",
        top_sellers: "Top Sellers",
        recent_reviews: "Recent Reviews",
        seller_reviews: "Seller Reviews",
        dashboard_setup: "Dashboard Setup",
        make_widget_card_colorful: "Make Widget Card Colorful",
        normal: "Normal",
        reverse: "Reverse",
        make_visible_in_dashboard: "Make Visible in Dashboard",
        visible: "Visible",
        shop_link: "Shop Link",
        total_delivered_order: "Total Delivered Order",
        total_non_delivered_order: "Total Non-Delivered Order",
        shop_review: "Shop Review",
        total_product_refund: "Total Product Refund",
        total_order_summary: "Total Order Summary",
        total_sale_summary: "Total Sale Summary",
        sale_vs_refund: "Sale vs Refund",
        top_sale_products: "Top Sale Products",
        latest_uploaded_products: "Latest Uploaded Products",
        latest_refund_request: "Latest Refund Request",
        subscription_payments: "Subscription Payments",
        search_resalt: "Search results",
        privacy_policy_check:
            'This  <a style="color:#D10000;" href="/privacy-policy" target="_blank">Privacy Policy</a>  <a style="color:#D10000;" href="/terms-and-conditions" target="_blank">Terms & Condition</a>',
        "become a merchant": "Become a Merchant",
        "best value": "Best Value",
        "per month": "per month",
        "per year": "per year",
        "transaction charge": "transaction charge",
        mark_all_as_read: "Mark all as read",
        "commission rate": "Commission Rate",
        "choose plan": "Choose a plan",
        send_message: "Send Message",
        message: "Message",
        inquery_type: "Inquery Type",
        enter_email_address: "Enter email address",
        subscribe: "Subscribe",
        enter_name: "Enter Name",
        product_delete_in_wishList: "Product Deleted from WishList",
        write_messages: "Write a message",
        billing: "Billing",
        select_from_options: "Select from options",
        shippied_by: "shippied By",
        delivery_option: "Delivery Option",
        addtional_shipping_charge: "Addtional Shipping Charge",
        Est_arrival_date: "Estimated  Arrival Date",
        Est_arrival_time: "Estimated  Arrival Time",
        bill_to_the_same_address: "Bill To the Same Address",
        add_coupon: "Add Coupon",
        coupon_store_successfully: "Coupon Store Successfully",
        coupon_code_in_required: "Coupon Code In Required",
        order_date: "Order date",
        order_amount: "Order amount",
        sold_by: "Sold By",
        view_more: "View More",
        store: "Store",
        confirm_receive_items: "Confirm receive items",
        open_dispute: "Open Dispute",
        cancel_order: "Cancel Order",
        order_cancelled: "Order Cancelled",
        write_a_review: "Write a review",
        billing_info: "Billing Info",
        total_summary: "Total Summary",
        paid_by: "Paid By",
        payment_info: "Payment Info",
        order_has_been_recieved: "Order has been recieved.",
        order_not_recieved: "Order not recieved.",
        order_has_been_cancelled: "Order has been cancelled.",
        order_cancellation_has_failed: "Order cancellation has failed.",
        to_pay: "To Pay",
        to_ship: "To Ship",
        to_recieve: "To Recieve",
        download_invoice: "Download Invoice",
        add_invoice: "Add Invoice",
        order_details: "Order Details",
        contact_seller: "Contact Seller",
        my_referral_code: "My referral code",
        copy_code: "Copy Code",
        user_list: "User List",
        discount_amount: "Discount Amount",
        already_use: "Already Used",
        not_used: "Not Used",
        you_will_get_referral_after:
            "You Will Get Referral code After First Purchase",
        code_copied_successfully: "Code Copied Successfully",
        wishlist: "Wishlist",
        review: "Review",
        unlimited: "Unlimited",
        availability: "Availability",
        condition: "Condition",
        sku: "SKU",
        add_to_wishlist: "Add to wishlist",
        add_to_cart: "Add to Cart",
        share_on: "Share on",
        seller_info: "Seller Info",
        reviews: "Reviews",
        product_description: "Product Description",
        product_specifications: "Product Specifications",
        product_reviews: "Product Reviews",
        related_products: "Related Products",
        no_stock_found_for_this_seller: "No Stock Found For this Seller",
        maximum_quantity_limit_is: "Maximum Quantity Limit Is",
        minimum_quantity_Limit_is: "Minimum Quantity Limit Is",
        no_more_stock: "No More Stock !!!",
        product_already_in_wishList: "The Product is Already In WishList",
        thanks: "Thanks",
        successfully_added_to_wishlist: "Successfully Added to Wishlist",
        product_successfully_deleted_from_cart:
            "Product successfully deleted from cart",
        adding: "Adding",
        product_successfully_added_to_cart: "Product Successfully added to Cart",
        subscribe_successfully: "Subscribed successfully! Thanks For Subscribtion",
        wishlist_product: "Wishlist Product",
        showing: "Showing",
        out_of_total: "out of total",
        low_to_high: "Low To High",
        high_to_low: "High To Low",
        no_product_in_wishlist: "No Product in Wishlist",
        no_products: "no products",
        member_since: "Member since",
        related_category: "Related Category",
        deal_ends_in: "Deal ends in",
        deal_starts_in: "Deal starts in",
        deal_ends: "Deal ends",
        hi_welcome_to: "Hi, welcome to",
        orders_over: "Orders over",
        get_now: "Get Now",
        time_to_shop: "Time To Shop",
        place_a_refund_request: "Place A Refund Request",
        additional_information: "Additional Information",
        optional: "Optional",
        set_prefered_option: "Set Preferred Option",
        wallet: "Wallet",
        bank_transfer: "Bank Transfer",
        bank_information_to_recieve_money:
            "Fill in your Bank Information To Receive Money",
        set_shipment_option: "Set Shipment Option",
        please_select_pick_up_courier_you_prefer:
            "Please select pick up courier of your choice",
        Pickup_address: "Pick-up Address",
        drop_off_your_return_item_at_a_nearby_courier_office:
            "Drop off Your Return Item at a nearby courier office.",
        courier_address: "Courier Address",
        request_sent_date: "Request a Sent date",
        refund_method: "Refund Method",
        shipping_method: "Shipping Method",
        pick_up_info: "Pick Up Info",
        shipping_gateway: "Shipping Gateway",
        drop_off_info: "Drop off Info",
        refunds: "Refunds",
        view_details: "View Details",
        tax_amount: "TAX Amount",
        message_sent_successfully: "Message Sent successfully! Thank you.",
        question_chat_with_us: "Question? Chat with us",
        welcome_back: "Welcome back",
        welcome: "Welcome",
        please_login_to_your_account: "Please login to your account",
        minimum_8: "Minimum 8",
        by_signing_up_you_agree_to_terms_of_service_and_privacy_policy:
            "By signing up, you agree to Terms of Service and Privacy Policy",
        register: "Register",
        login_account: "Login account",
        already_a_member_yet: "Already a member ?",
        already_a_merchant: "Already a merchant",
        please_confirm_with_new_password: "Please confirm with new password",
        save_change: "Save Change",
        track_your_order: "Track Your Order",
        support: "Support",
        account: "Account",
        sign_up: "Sign up",
        login: "Login",
        log_out: "Logout",
        continue_shopping: "Continue Shopping",
        view_shopping_cart: "View Shopping Cart",
        all_categories: "All Categories",
        best_deals: "Best Deals",
        new_user_zone: "New User Zone",
        search_your_item: "Search to find",
        remember_me: "Remember me",
        forgot_password: "Forgot password",
        login_with: "Login With",
        want_to_be_a_new_merchant: "Want to be a new merchant?",
        create_account: "Create account",
        please_input_new_password: "Please Input New Password.",
        send_link: "Send Link",
        please_send_password_link: "Please Send Password Link",
        please_create_your_account: "Please Create your account",
        contact_form: "Contact Form",
        contact_message: "Contact Message",
        maximum_quantity_limit_exceed: "chosen quantity exceeds the maximum limit",
        no_more_stock_available: "No more stock available",
        please_select_product_first: "Please select product first",
        this_is_undefined: "This is undefined",
        your_cart_is_empty_please_select_item_s_before_checkout_also_add_address_first:
            "Your cart is empty! Please select item(s) before checkout as well as add a address",
        wallet_balance_is_not_enough_to_pay_for_this_order:
            "Wallet balance is not enough to pay for this order",
        your_cart_is_empty_please_select_item_s_before_checkout: "Cart is empty",
        coupon_applied_successfully: "Coupon applied successfully",
        coupon_field_is_required: "Coupon field is required",
        coupon_deleted_successfully: "Coupon deleted successfully",
        product_compare: "compare prodcuts",
        click_here_to_request_another: "click here to request another",
        gift_cards: "Gift cards",
        from_the_same_store: "From the same store",
        and_up: "And Up",
        team_member: "Team member",
        choose_plan: "Choose a plan",
        track: "Track",
        no_stock_found_for_this_vendor: "No stock found for this vendor",
        maximum_6_image_can_upload: "Maximum 6 image can be uploaded",
        write_review: "Write review",
        focus_only_on_the_product_and_its_features:
            "Focus only on the product and its features",
        please_share_your_feedback_about_the_product:
            "Please share your feedback about the product",
        how_over_all_experience_with_seller:
            "How is overall experience with seller?",
        rate_and_review_your_seller: "Rate and review your seller",
        review_details: "Review details",
        anonymous: "Anonymous",
        recently_viewed_items: "Recently Viewed Items",
        wholesale: "Wholesale",
        enter_your_order_tracking_number_and_your_secret_id:
            "Enter Your order tracking number and your Secret ID",
        order_tracking_number: "Order Tracking Number",
        secret_id_only_for_guest_user: "Secret ID (Only For Guest User)",
        phone_used_for_billing: "Phone (Used For Billing)",
        important: "Important:",
        maximum_6_images_can_be_uploaded: "Maximum 6 images can be uploaded",
        image_size_can_be_maximum_5mb: "Image size can be maximum 5mb",
        delivered_on: "Delivered on",
        rate_and_review_purchased_product: "Rate and review purchased product",
        review_detail: "Review detail",
        how_to_write_a_good_review: "How to write a good review",
        track_order: "Track order",
        price_range: "Price Range",
        refresh_filters: "Refresh Filters",
        rating: "Rating",
        product_removed_from_compare_list_successfully:
            "Product removed from compare list successfully",
        compare_reset_successfully: "COMAPARE reseted  successfully",
        please_login_first: "Please login first",
        verify_your_email: "Verify Your Email",
        before_proceeding_please_check_your_email_for_a_varification_link_if_you_din_not_get_the_email:
            "Before proceeding, please check your email for a varification link, if you did not get the email",
        thank_you_for_your_purchase: "Thank you for your purchase",
        your_order_number_is: "Your order number is",
        your_delivery_dates: "Your delivery date is",
        for_more_details_track_your_delivery_status_order:
            "For more details track your delivery status order",
        we_have_a_confirmation_email_to: "We have sent  a confirmation email to",
        with_the_order_details: "With the order details",
        order_summary: "Order summary",
        shopping: "Shopping",
        create_your_merchant_account: "Create your merchant account",
        subscription_type: "Subscription Type",
        select_all: "Select all",
        cart_is_empty: "Cart Is empty.",
        reset_compare: "Reset COMPARE",
        compare_list_is_empty: "Compare list is empty.",
        no_gift_card_found: "No gift card found",
        no_review_found: "No review found",
        child_category: "Child category",
        product_not_added: "Product not added",
        no_more_data_to_show: "No more data to show",
        product_added_to_compare_list_successfully:
            "Product added to compare list successfully",
        not_added: "Not added",
        no_product_found: "No product found",
        billing_address_is_not_as_same_as_shipping_address:
            "Billing address is not as same as shipping address",
        load_more: "Load more",
        this_page: "This page",
        add_to_compare: "Add To Compare",
        page_expired: "Page Expired",
        forbidden: "Forbidden",
        sorry_you_are_forbidden_from_accessing_this_page:
            "Sorry you are forbidden from accessing this page",
        whoops_something_went_wrong_on_our_servers:
            "Whoops, something went wrong on our servers.",
        maximum_image_6_image_can_upload: "Maximum 6 images can be uploaded",
        package_wise_shipping_charge: "Package wise shipping charge",
        proceed_to_checkout: "Proceed to checkout",
        name_a_to_z: "Name (A to Z)",
        name_z_to_a: "Name (Z to A)",
        price_low_to_high: "Price (Low to High)",
        price_high_to_low: "Price (High to Low)",
        "401_unauthorized": "401 | Unauthorized",
        sorry_you_are_not_authorized_to_access_this_page:
            "Sorry, you are not authorized to access this page.",
        go_home: "Go Home",
        go_back: "Go Back",
        sorry_page_not_found: "Sorry ! Page not found",
        sorry_the_page_you_are_looking_for_could_not_be_found:
            "Sorry, the page you are looking for could not be found.",
        sorry_your_session_has_expired_please_refresh_and_try_again:
            "Sorry, your session has expired. Please refresh and try again.",
        too_many_requests: "Too Many Requests",
        sorry_you_are_making_too_many_requests_to_our_servers:
            "Sorry, you are making too many requests to our servers consequently",
        service_unavailable: "Service Unavailable",
        sorry_we_are_doing_some_maintenance_please_check_back_soon:
            "Sorry, we are doing some maintenance. Please check back again shortly",
        compare: "Compare",
        please_product_select_from_cart_first:
            "Please Select product from compare list",
        new_member: "New Member?",
        "I agree with the terms and conditions":
            "I agree with the terms and conditions",
        process_to_payment: "Process To Payment",
        add_fund: "Add Fund",
        calculated_at_next_step: "Calculated at next step",
        click_here_to_login: "Click here to login",
        returning_customer: "Returning customer",
        contact_information: "Contact Information",
        email_me_with_news_and_offers: "Email me with news and offers",
        address_list: "Address List",
        new_address: "New Address",
        continue_to_shipping: "Continue To Shipping",
        continue_to_payment: "Continue To Payment",
        return_to_cart: "Return To Cart",
        return_to_shipping: "Return to shipping",
        return_to_information: "Return to information",
        ship_to: "Ship to",
        all_transactions_are_secure_and_encrypted:
            "All transactions are secure and encrypted",
        same_as_shipping_address: "Same as shipping address",
        use_a_different_billing_address: "Use a different billing address",
        minimum_quantity_limit_exceed: "Minimum Quantity Limit Exceeds",
        select_shipping: "Select Shipping",
        select_payment: "Select Payment",
        email_verify: "Verify email",
        checkout: "Checkout",
        customer_information: "Customer Information",
        billing_shipping_info: "Billing & Shipping Info",
        processing: "Processing",
        but_it_now: "Buy it now",
        Expense: "Expense",
        "New Expense": "New Expense",
        "Edit Expense": "Edit Expense",
        "The requested expense is not found": "The requested expense is not found",
        "The requested expense deleted successful":
            "The requested expense deleted successful",
        "The requested expense created successful":
            "The requested expense created successful",
        "The requested expense updated successful":
            "The requested expense updated successful",
        form_builder: "Form Builder",
        forms: "Forms",
        form: "Form",
        terms_page_link: "Terms Page Link",
        privacy_policy_page_link: "Privacy Policy Page Link",
        no_data: "No data found",
        about_us_contant: "About Us Contant",
        frontend_cms: "Frontend CMS",
        "main-title": "Main Title",
        shop_address: "Shop Address",
        create_shop_address: "Create Shop Address",
        benifit_title: "Advantage Link",
        selling_title: "SELLING TITLE",
        "home_page.working_info": "Web site Working Info",
        "home_page.working_info_list": "Web site Working Info List",
        selling_price: "SELLING pricing",
        main_details: "Main Details",
        benifits_details: "Advantage Description",
        selling_details: "Selling Details",
        benefit: "Benefit",
        features: "Features",
        benefit_list: "BenefitList",
        update_benefit: "Update BENEFIT",
        "career list": "Career List",
        "update career": "Update Career",
        "career content": "Career Content",
        contact_us_contant: "Contact-us Content",
        feature_list: "Feature List",
        new_feature: "New Feature",
        merchant_content: "Merchant Content",
        "benifit title": "Advantage Link",
        pricing_slogan: "Pricing Slogan",
        pricing: "Pricing",
        how_it_work_title: "How It Work Title",
        pricing_title: "Pricing Title",
        pricing_list: "Pricing List",
        faq: "FAQ",
        faq_title: "FAQ Title",
        query_title: "Query Title",
        benefits_details: "Advantage Description",
        pricing_details: "Pricing Details",
        how_it_work_details: "How it work Details",
        query_details: "Query Details",
        faq_details: "FAQ Details",
        how_it_work: "How It Work",
        "benefit list": "Benefit List",
        how_it_work_list: "How It Work List",
        faq_list: "FAQ List",
        faq_update: "FAQ Update",
        position: "Position",
        "policy list": "Policy List",
        "edit policy": "Edit Policy",
        "pricing update": "Update Pricing",
        pricing_plan: "Pricing Plan",
        add_pricing_plan: "Add Pricing Plan",
        edit_pricing_plan: "Edit Pricing Plan",
        "pricing list": "Pricing List",
        "show pricing": "Show Pricing",
        monthly_cost: "Price/Month",
        yearly_cost: "Price/Year",
        transaction_fee: "Transaction Fee",
        best_for: "Best For",
        pricing_type: "Pricing Type",
        team_size: "Team Size",
        stock_limit: "Stock Limit",
        commission: "Commission Rate",
        "return list": "Return & Exchange List",
        "update title": "Update Return & Exchange",
        page_list: "Page List",
        dynamic_page: "Dynamic Page",
        create_dynamic_page: "Create Dynamic Page",
        update_dynamic_page: "Update Dynamic Page",
        term_list: "Term & Conditions List",
        "working process list": "Working Process List",
        update_working_process: "Update Working Process",
        add_link: "Add link",
        edit_link: "Edit link",
        page_name: "Page Name",
        select_page: "Select Page",
        copyright_text: "Copyright Text",
        about_text: "About Text",
        section_name: "Section Name",
        about_description: "About Description",
        add_new_page: "Add New Page",
        widget_title: "Widget Title",
        add_InQuery: "Add InQuery",
        edit_InQuery: "Edit InQUery",
        "return&exchange": "Return & Exchange",
        exchange_details: "Exchange Details",
        return_title: "Return Title",
        return_details: "Return Details",
        inquery_list: "InQuery List",
        footer_settings: "Footer Settings",
        frontendCMS: "FrontendCMS",
        "benifit-title": "Advantage Link",
        price_monthly: "Price/Monthly",
        home_page: "Home Page",
        category_products: "Category Products",
        latest_products: "Latest Products",
        recently_viewed_products: "Recently Viewed Products",
        max_sale: "Max Sale",
        max_review: "Max Review",
        custom_products: "Custom Products",
        top_category: "Top Category",
        latest_category: "Latest Category",
        new_category: "New Category",
        custom_category: "Custom Category",
        top_brands: "Top Brands",
        latest_brands: "Latest Brands",
        new_brands: "New Brands",
        popup_content: "Popup content",
        popup_show_after_second: "Popup show after (second)",
        custom_brands: "Custom Brands",
        brand_list: "Brand List",
        add_feature: "Add Feature",
        edit_feature: "Edit Feature",
        Inquery: "InQuery",
        individuals: "Individuals",
        business: "Business",
        professional: "Professional",
        widget: "Widget",
        section_list: "Section List",
        subscription_crone_job_url: "SUBSCRIPTION CRONE JOB URL",
        seller_registration_title_for_first_page:
            "Seller Registration Title for First Page",
        exchange_title: "Exchange Title",
        return_exchange: "Return Exchange",
        contact_content: "Contact Content",
        dynamic_pages: "Dynamic Pages",
        footer_setting: "Footer Setting",
        about_us: "About Us",
        related_sale_setting: "Related Sale Setting",
        subscribe_content_update_successfully:
            "Subscribe Content Update successfully",
        title_has_been_updated_successfully: "Title has been updated Successfully",
        Link: "Link",
        subscribe_content: "Subscribe Content",
        promotion_bar: "Promotion bar",
        ads_bar: "Ads bar",
        login_page: "Login Page",
        general_settings: "General Settings",
        terms: "Terms & Conditions",
        policy: "Privacy policy",
        smtp_setting: "SMTP Setup",
        activation: "Activation",
        sms_setting: "SMS Setup",
        sms_template: "SMS template",
        code: "Code",
        symbol: "Symbol",
        shop_link_banner: "Shop link banner",
        upload_shop_link_banner: "Upload Shop link banner",
        currency_list: "Currency List",
        "Edit Currency Info": "Edit Currency Info",
        "Currency Updated Successfully": "Currency Updated Successfully",
        "Currency Added Successfully": "Currency Added Successfully",
        "Currency has been deleted Successfully":
            "Currency has been deleted Successfully",
        "SMS Gateways Credentials has been updated Successfully":
            "SMS Gateways credentials has been updated Successfully",
        "SMS has been sent Successfully": "SMS has been sent successfully",
        "SMTP Gateways Credentials has been updated Successfully":
            "SMTP Gateways Credentials has been updated successfully",
        "Mail has been sent Successfully": "Mail has been sent Successfully",
        "Please Configure SMTP settings first":
            "Please configure SMTP settings first",
        "Language has been deleted Successfully":
            "Language has been deleted successfully",
        "Language Updated Successfully": "Language Updated Successfully",
        "Language Added Successfully": "Language Added Successfully",
        Active: "Active",
        "Email Template": "Email Template",
        Translation: "Translation",
        "Native Name": "Native Name",
        "Edit Language Info": "Edit Language Info",
        "Select Translatable File": "Select Translatable File",
        Key: "Key",
        sender_name: "Sender Name",
        api_key: "API Key",
        registered_phone_number: "Registered Phone Number",
        authentication_token: "Authentication Token",
        twilio_account_sid: "Twilio Account SID",
        send_test_mail: "Send Test Mail",
        send_a_test_email_to: "Send a Test Email to",
        mail_text: "Mail Text",
        predefined_footer: "Predefined Footer",
        predefined_header: "Predefined Header",
        email_signature: "Email Signature",
        sender_email: "Sender Email",
        email_settings: "Email Settings",
        email_protocol: "Email Protocol",
        mail_engine: "Mail Engine",
        from_name: "From Name",
        from_mail: "From Mail",
        mail_host: "Mail Host",
        mail_port: "Mail Port",
        mail_username: "Mail Username",
        mail_password: "Mail Password",
        mail_encryption: "Mail Encryption",
        email_charset: "Email Charset",
        About: "About",
        Misc: "Misc",
        Tags: "Tags",
        "Theme Options": "Theme Options",
        Cronjob: "Cronjob",
        "E-Sign": "E-Sign",
        "PDF Settings": "PDF Settings",
        Calendar: "Calendar",
        SMS: "SMS",
        Support: "Support",
        "Customer Permission": "Customer Permission",
        general: "General",
        Activation: "Activation",
        system_default_language: "System Default Language",
        copywrite_text: "Copyright Text",
        file_supported: "File Supported",
        system_title: "System Title",
        upload_fav_icon: "Upload Fav Icon",
        fav_icon: "Fav Icon",
        upload_logo: "Upload Logo",
        system_logo: "System Logo",
        system_default_currency: "System Default Currency",
        currency_symbol: "Currency Symbol",
        currency_code: "Currency Code",
        SMTP: "SMTP",
        date_format: "Date Format",
        time_zone: "Time Zone",
        activate_sms_gateway: "Activate SMS Gateway",
        sms_settings: "SMS Settings",
        twilio: "Twilio",
        textlocal: "TextLocal",
        URL: "URL",
        "Margin Price": "Margin Price",
        "Agent Commission Type": "Agent Commission Type",
        Quantity: "Quantity",
        "Invoice Prefix": "Invoice Prefix",
        include_comma_with_each_word:
            "Include Comma with each word e.g. csv,doc,docs",
        preloader: "Preloader",
        send_a_test_sms: "Send a Test SMS",
        send_test_sms: "Send Test SMS",
        Agent: "Agent",
        "Currency List": "Currency List",
        add_new_currency: "Add New Currency",
        currency: "Currency",
        edit_currency_info: "Edit Currency Info",
        company_name: "Company Name",
        company_information: "Company Information",
        "Payment Gateways": "Payment Gateways",
        order_invoice: "Order Invoice",
        email_footer: "Email Footer",
        subject: "Subject",
        subject_en: "Subject En",
        subject_ru: "Subject Ru",
        subject_hy: "Subject Hy",
        template: "Template",
        template_en: "Template En",
        template_ru: "Template Ru",
        template_hy: "Template Hy",
        reciepent: "Reciepent",
        add_new_template: "Add New Template",
        set_for: "Set For",
        system_settings: "System Settings",
        short_code: "short code",
        use_these_to_get_your_neccessary_info:
            "use these to get your necessary info",
        convert_rate: "Convert Rate",
        please_select_valid_reciepent_to_create_template:
            "Please Select Valid Recipient to create template",
        mail_has_been_sent_successfully: "Mail has been sent successfully",
        please_configure_smtp_settings_first:
            "Please configure SMTP settings first",
        sms_has_been_sent_successfully: "SMS has been sent successfully",
        php_mailer: "PHP Mailer",
        php_mailer2: "PHP Mailer 2",
        logo_banner: "Logo & Banner",
        social_link: "Social Link",
        fontawesome_or_themefy_icon_only: "Note: Font awesome & Themefy Icon only.",
        smtp: "SMTP",
        php_mail: "PHP Mail",
        maintenance: "Maintenance",
        maintenance_page_banner: "Maintenance Page Banner",
        mode: "Mode",
        module: "Module",
        manage: "Manage",
        manager: "Manager",
        buy_now: "Buy Now",
        quick_buy: "Quick buy",
        upload_from_local_directory: "Upload From Local Directory",
        software_version: "Software Version",
        about_system: "About System",
        php_version: "PHP Version",
        check_update: "Check update",
        curl_enable: "Curl Enable",
        purchase_code: "Purchase code",
        install_domain: "Install Domain",
        system_activated_date: "System Activated Date",
        last_update_at: "Last updated at",
        upload_sql_file: "Upload SQL File",
        database_backup_list: "Database Backup List",
        generate_new_backup: "Generate New Backup",
        new_database_backup_has_been_created:
            "New database backup has been created",
        add_new_update_module: "Add New / Update Module",
        select_module_file: "Select Module File",
        backup: "Backup",
        gateway_settings: "Gateway Settings",
        about_update: "About & Update",
        message_for_system_notification: "Message For System Notification",
        verify: "Verify",
        verified: "Verified",
        currency_symbol_position: "Currency Symbol Position",
        decimal_number_limit: "Decimal Number Limit",
        left_with_space: "Left With Space",
        right_with_space: "Right With Space",
        facebook_messanger: "Facebook Messanger",
        paste_code_here: "Paste Code Here",
        messager_code: "Messager Code",
        social_configuration: "Social Configuration",
        send_to_parameter_name: "Send To Parameter Name",
        message_parameter_name: "Message Parameter Name",
        request_method: "Request Method",
        parameter_1_key: "Parameter 1 Key",
        parameter_2_key: "Parameter 2 Key",
        parameter_3_key: "Parameter 3 Key",
        parameter_4_key: "Parameter 4 Key",
        parameter_5_key: "Parameter 5 Key",
        parameter_6_key: "Parameter 6 Key",
        parameter_7_key: "Parameter 7 Key",
        parameter_8_key: "Parameter 8 Key",
        parameter_9_key: "Parameter 9 Key",
        parameter_10_key: "Parameter 10 Key",
        parameter_1_value: "Parameter 1 Value",
        parameter_2_value: "Parameter 2 Value",
        parameter_3_value: "Parameter 3 Value",
        parameter_4_value: "Parameter 4 Value",
        parameter_5_value: "Parameter 5 Value",
        parameter_6_value: "Parameter 6 Value",
        parameter_7_value: "Parameter 7 Value",
        parameter_8_value: "Parameter 8 Value",
        parameter_9_value: "Parameter 9 Value",
        parameter_10_value: "Parameter 10 Value",
        update_sms_setting: "Update SMS Setting",
        others: "Others",
        cloud_storage: "Cloud Storage",
        amazon_s3: "AmazonS3",
        aws_s3s_setting: "Aws S3 Setting",
        access_key_id: "Access Key Id",
        secret_key: "Secret Key",
        default_region: "Default Region",
        aws_bucket: "AWS Bucket",
        file_storage: "File Storage",
        active_file_storage: "Active File Storage",
        default_currency_not_changeble: "Default Currency Not Changeable.",
        message_for_particular_user: "Message for particular user",
        message_for_admin_site: "Message for admin site",
        homepage_seo_setup: "Homepage SEO Setup",
        meta_site_title: "Meta Site Title",
        preloader_status: "Preloader Status",
        preloader_type: "Preloader Type",
        animation: "Animation",
        preloader_image: "Preloader Image",
        preloader_style: "Preloader Style",
        preloader_setting: "Preloader Setting",
        lazyload_image: "Lazyload Image",
        upload_lazyload_image: "Upload Lazyload Image",
        guest_checkout: "Guest Checkout",
        pwa_app_name: "PWA App Name",
        product_subtitle_show: "Product Subtitle Show",
        gst_setup: "GST/VAT/TAX Setup",
        gst_list: "GST/VAT/TAX List",
        gst: "GST",
        add_new_gst: "Add New GST/VAT/TAX",
        edit_gst: "Edit GST/VAT/TAX",
        place_of_delivery_inside_state: "Delivery Inside State",
        place_of_delivery_outside_state: "Delivery Outside State",
        gst_configuration: "GST/VAT/TAX Configuration",
        select_one_or_multiple: "Select One or Multiple",
        claim_gst: "Claim GST/VAT/TAX",
        gst_claimed: "GST/VAT/TAX Claimed",
        goods_and_services_tax: "Goods and Services Tax",
        total_gst: "Total GST/VAT/TAX",
        is_active_flat_tax: "Is Active Flat Tax",
        is_active_gst: "Is Active GST/VAT/TAX",
        flat_tax_percentage: "Flat Tax Percentage",
        flat_tax: "Flat Tax",
        gst_or_flat_rate_claimed_by_seller:
            "GST/VAT/TAX or Flat Rate claimed by seller",
        gst_or_flat_tax_claim_by_seller: "GST/VAT/TAX or Flat tax claim by Seller",
        same_state_GST: "Same State GST/VAT/TAX",
        outsite_state_GST: "Outsite State GST/VAT/TAX",
        GST_group: "GST/VAT/TAX Group",
        human_resource: "Human Resource",
        applicable_for_leave: "Applicable For Leave",
        bank_branch_name: "Bank Branch Name",
        bank_info: "Bank Info",
        account_no: "Account No",
        cheque_no: "Cheque No",
        pay_now: "Pay Now",
        bank_account_details: "Bank Account Details",
        bank_account_number: "Bank account number",
        staff_info: "Staff Info",
        payroll_info: "Payroll Info",
        loan_apply: "Apply for Loan",
        loan_history: "Loan History",
        loan_approval: "Loan Approval",
        "Loan Apply": "Loan Application",
        date_of_joining: "Date of Joining",
        basic_salary: "Basic Salary",
        employment_type: "Employment Type",
        provision: "Provision",
        contract: "Contract",
        permanent: "Permanent",
        provision_time: "Provision Time",
        in_months: "In Months",
        department: "Department",
        staff_list: "Staff List",
        staff: "Staff",
        edit_staff_info: "Edit Staff Info",
        staff_id: "Staff ID",
        attendance: "Attendance",
        attendance_report: "Attendance Report",
        system_user: "System User",
        assign_permission: "Assign Permission",
        system_role: "System Role",
        regular_user: "Regular User",
        present: "Present",
        late: "Late",
        absent: "Absent",
        holiday: "Holiday",
        P: "P",
        L: "L",
        A: "A",
        H: "H",
        select_month: "Select Month",
        select_year: "Select Year",
        event_list: "Event List",
        event: "Event",
        for_whom: "For Whom",
        copy_previous_year_settings: "Copy Previous Year Settings",
        holiday_name: "Holiday Name",
        holiday_setup: "Holiday Setup",
        select_criteria_for_payroll: "Select Criteria For Payroll",
        not_generated: "Not Generated",
        generated: "Generated",
        generate_payroll: "Generate Payroll",
        view_paySlip: "View PaySlip",
        earnings: "Earnings",
        deductions: "Deductions",
        payroll_summary: "Payroll Summary",
        calculate: "Calculate",
        gross_salary: "Gross Salary",
        tax: "Tax",
        payroll: "Payroll",
        payroll_reports: "Payroll Reports",
        payslip_for_the_period_of: "Payslip for the period of",
        payslip: "Payslip",
        payment_method: "Payment Method",
        total_earning: "Total Earning",
        total_deduction: "Total Deduction",
        net_salary: "Net Salary",
        proceed_to_pay: "Proceed To Pay",
        staff_name: "Staff Name",
        payment_amount: "Payment Amount",
        paid_date: "Paid Date",
        role: "Role",
        leave: "Leave",
        apply_date: "Apply Date",
        delete_not_possible_role_has_user:
            "the role of the user can not be deleated",
        permission_given_successfully: "Permission given successfully.",
        attendance_has_been_taken_successfully:
            "Attendance has been taken successfully.",
        holiday_saved_successfully: "Holiday Saved Successfully.",
        year_holiday_not_found: "Year Holiday not Found.",
        select_Role_date_from_list: "Select Role & Date From List",
        deleted_not_possible_for_this_customer:
            'The action "deleate" can not be made for this customer',
        "You cann\\'t delete an income which has child element":
            "You can't delete an income which has child element",
        Incomes: "Incomes",
        "New Income": "New Income",
        "The requested income is not found": "The requested income is not found",
        "The requested income deleted successful":
            "The requested income deleted successful",
        "The requested income created successful":
            "The requested income created successful",
        "The requested income updated successful":
            "The requested income updated successful",
        "Edit Income": "Edit Income",
        language_list: "Language List",
        add_new_language: "Add New Language",
        RTL: "RTL",
        LTL: "LTL",
        "Language Settings": "Language Settings",
        native_name: "Native Name",
        edit_language_info: "Edit Language Info",
        translation: "Translation",
        select_translatable_file: "Select Translatable File",
        key: "Key",
        value: "Value",
        general_setting: "General Setting",
        product_section: "Product Section",
        exclusive_price_section: "Exclusive Price Section",
        coupon_section: "Coupon Section",
        background_color: "Background-Color",
        text_color: "Text-Color",
        "home.action": "Home Actions",
        product1: "One Product",
        template_1: "Template 1",
        template_2: "Template 2",
        template_3: "Template 3",
        by_template_1: "By Template 1",
        by_template_2: "By Template 2",
        by_template_3: "By Template 3",
        setup_products: "Setup Products",
        navigation_label: "Navigation Label",
        slogan: "Slogan",
        select_products: "Select Products",
        selected_product_list: "Selected Product List",
        select_category: "Select Category",
        selected_category_list: "Selected Category List",
        coupon_section_setup: "Coupon Section Setup",
        create_new_user_zone: "Create New User Zone",
        flash_deal: "Flash Deal",
        update_flash_deal: "Update Flash Deal",
        create_flash_deal: "Create Flash Deal",
        news_letter: "News Letter",
        publish_date: "Publish Date",
        created_by: "Created By",
        mail_to: "Mail To",
        create_news_letter: "Create News Letter",
        update_news_letter: "Update News Letter",
        publish_on: "Publish On",
        send_to: "Send To",
        all_user: "All User",
        role_wise: "Role Wise",
        multiple_role_select_user: "Multiple Role,  Select User",
        all_subscription: "All Subscriptions",
        selected_role_user: "Selected Role for the User",
        save_test_mail: "Save & Test Mail",
        test_mail_has_been_send_successfully:
            "Test Mail has been Send successfully!",
        test_mail: "Test Mail",
        bulk_sms: "Bulk SMS",
        sms_list: "SMS List",
        sending: "Sending",
        test_sms_has_been_send_successfully: "Test SMS has been Send successfully!",
        message_to: "Message To",
        create_bulk_sms: "Create Bulk SMS",
        update_bulk_sms: "Update Bulk SMS",
        save_test_sms: "Save & Test SMS",
        test_sms: "Test SMS",
        select_coupon_type_first: "Select Coupon Type First",
        product_base: "Product Base",
        order_base: "Order Base",
        free_shipping: "Free Shipping",
        create_coupon: "Create Coupon",
        coupon_type: "Coupon Type",
        add_coupon_for_free_shipping: "Add Coupon For Free Shipping",
        add_coupon_based_on_order: "Add Coupon Based on Order",
        add_coupon_based_on_products: "Add Coupon Based on Products",
        coupon_code: "Coupon code",
        maximum_discount: "Maximum Discount",
        allow_multiple_buy: "Allow Multiple purchases",
        minimum_shopping: "Minimum Shopping",
        referral_code_list: "Referral Code List",
        amount_is_getter_than_maximum_limit: "Amount is greater than maximum limit",
        customer_name: "Customer Name",
        create_date: "Create Date",
        maximum_limit: "Maximum Limit",
        subscriber: "Subscriber",
        subscriber_list: "Subscriber List",
        marketing: "Marketing",
        flash_deals: "Flash Deals",
        coupons: "Coupons",
        subscribers: "Subscribers",
        news_letters: "News Letters",
        referral_code_setup: "Referral Code Setup",
        num_of_uses: "Num of uses",
        this_item_already_added_to_list: "This item already added to list.",
        marketing_campaign_planning: "Marketing campaign planning",
        cool_app: "Cool App",
        awesome_app: "Awesome App",
        what_a_cool_app: "what a Cool App",
        menu_list: "Menu List",
        add_menu: "Add Menu",
        use_themefy_or_fontawesome_icon: "Use themefy or fontawesome icon",
        mega_menu: "Mega Menu",
        multi_mega_menu: "Multi Mega Menu",
        regular_menu: "Regular Menu",
        top_navbar: "Top Navbar",
        main_menu: "Main Menu",
        select_display_location: "Select Display Location",
        select_menu_type: "Select Menu Type",
        edit_menu: "Edit Menu",
        menu_type: "Menu Type",
        display_location: "Display Location",
        right_panel: "Right Panel",
        bottom_panel: "Bottom Panel",
        setup_menu: "Setup Menu",
        back_to_menu: "Back to menu",
        right_panel_setup: "Right Panel Setup",
        bottom_panel_setup: "Bottom Panel Setup",
        add_brand: "Add Brand",
        column: "Column",
        element: "Element",
        open_link_in_a_new_tab: "Open link in a new tab",
        no_categories: "no categories",
        add_column: "Add Column",
        menu_item_list: "Menu Item List",
        left: "Left",
        right: "Right",
        size: "Size",
        select_size: "Select Size",
        add_to_menu: "Add to Menu",
        add_links: "Add Links",
        add_categories: "Add Categories",
        add_pages: "Add Pages",
        add_product: "Add Product",
        add_tag: "Add Tag",
        no_brands: "no brands",
        row_required: "Row Required",
        size_required: "Size Required",
        category_required: "Category Required",
        title_required: "Title Required",
        link_required: "Link Required",
        brand_required: "Brand Required",
        tags_required: "Tags Required",
        menu_required: "Menu Required",
        top_bar: "Top bar",
        order_manage: "Order Manage",
        my_order: "My Order",
        social_security_card: "Social Security card",
        passport: "Passport",
        express_american: "AMERICAN EXPRESS",
        add_a_passport_photo: "Add a passport photo",
        download_the_file: "Download the file",
        Vtb: "VTB",
        Uni: "UNIBank",
        ineco: "INECOBANK",
        acba: "ACBA",
        evoca: "EVOCABank",
        Vtb_info:
            "ՀԱՄԱՁԱՅՆԱԳԻՐ Սույնով տալիս եմ իմ համաձայնությունը, որ.• «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ-ն հարցումներ կատարի «ԱՔՌԱ Քրեդիտ Ռեփորթինգ» ՓԲԸ-ին և վերջինիս խնդրում եմ «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ-ին տրամադրել իմ ներկա և անցյալ ֆինանսական պարտավորությունների վերաբերյալ տեղեկություններ, ինչպես նաև այլ տվյալներ, որոնք «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ կողմից կարող են հաշվի առնվել ինձ հետ վարկային (փոխառության և այլն) պայմանագիր կնքելու վերաբերյալ որոշում կայացնելիս:• «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ կողմից վարկային (փոխառության և այլն) պայմանագիր կնքելու դեպքում տվյալ վարկային (փոխառության և այլն) պայմանագրի գործողության ողջ ընթացքում, իսկ գլխավոր վարկային պայմանագրի առկայության դեպքում նաև վերջինիս գործողության ողջ ընթացքում ցանկացած պահի առանց ինձ նախապես տեղյակ պահելու «ԱՔՌԱ Քրեդիտ Ռեփորթինգ» ՓԲԸ-ն «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ-ին տրամադրի իմ ապագա ֆինանսական պարտավորությունների վերաբերյալ տեղեկություններ, ինչպես նաև այլ տվյալներ:• «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ-ն հարցումներ կատարի «ԱՔՌԱ Քրեդիտ Ռեփորթինգ» ՓԲԸ-ին և վերջինիս խնդրում եմ «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ-ին տրամադրել իմ ներկա և անցյալ ֆինանսական պարտավորությունների վերաբերյալ տեղեկություններ, ինչպես նաև այլ տվյալներ, որոնք «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ կողմից կարող են հաշվի առնվել ինձ հետ վարկային (փոխառության և այլն) պայմանագիր կնքելու վերաբերյալ որոշում կայացնելիս:• «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ կողմից վարկային (փոխառության և այլն) պայմանագիր կնքելու դեպքում տվյալ վարկային (փոխառության և այլն) պայմանագրի գործողության ողջ ընթացքում, իսկ գլխավոր վարկային պայմանագրի առկայության դեպքում նաև վերջինիս գործողության ողջ ընթացքում ցանկացած պահի առանց ինձ նախապես տեղյակ պահելու «ԱՔՌԱ Քրեդիտ Ռեփորթինգ» ՓԲԸ-ն «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ-ին տրամադրի իմ ապագա ֆինանսական պարտավորությունների վերաբերյալ տեղեկություններ, ինչպես նաև այլ տվյալներ:• «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ-ն հարցումներ կատարի «ԱՔՌԱ Քրեդիտ Ռեփորթինգ» ՓԲԸ-ին և վերջինիս խնդրում եմ «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ-ին տրամադրել իմ ներկա և անցյալ ֆինանսական պարտավորությունների վերաբերյալ տեղեկություններ, ինչպես նաև այլ տվյալներ, որոնք «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ կողմից կարող են հաշվի առնվել ինձ հետ վարկային (փոխառության և այլն) պայմանագիր կնքելու վերաբերյալ որոշում կայացնելիս:• «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ կողմից վարկային (փոխառության և այլն) պայմանագիր կնքելու դեպքում տվյալ վարկային (փոխառության և այլն) պայմանագրի գործողության ողջ ընթացքում, իսկ գլխավոր վարկային պայմանագրի առկայության դեպքում նաև վերջինիս գործողության ողջ ընթացքում ցանկացած պահի առանց ինձ նախապես տեղյակ պահելու «ԱՔՌԱ Քրեդիտ Ռեփորթինգ» ՓԲԸ-ն «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ-ին տրամադրի իմ ապագա ֆինանսական պարտավորությունների վերաբերյալ տեղեկություններ, ինչպես նաև այլ տվյալներ:",
        Uni_info:
            "ՀԱՄԱՁԱՅՆԱԳԻՐ  Սույնով տալիս եմ իմ համաձայնությունը, որպեսզի «Յունիբանկ» ԲԲԸ-ի կողմից հարցում կատարվի «ԱՔՌԱ Քրեդիտ Ռեփորթինգ» ՓԲԸ-ին և վերջինիս խնդրում եմ «Յունիբանկ» ԲԲԸ-ին տրամադրել իմ ներկա և անցյալ ֆինանսական պարտավորությունների վերաբերյալ տեղեկություններ, ինչպես նաև այլ տվյալներ, որոնք «Յունիբանկ» ԲԲԸ-ի կողմից կարող են հաշվի առնվել ինձ հետ վարկային (փոխառության և այլն) պայմանագիր կնքելու վերաբերյալ որոշում կայացնելիս: Ինչպես նաև տալիս եմ իմ համաձայնությունը, որպեսզի «Յունիբանկ» ԲԲԸ-ի կողմից վարկային (փոխառության և այլն) պայմանագիր կնքելու դեպքում տվյալ վարկային (փոխառության և այլն) պայմանագրի գործողության ողջ ընթացքում ցանկացած պահին առանց ինձ նախապես տեղյակ պահելու «ԱՔՌԱ Քրեդիտ Ռեփորթինգ» ՓԲԸ-ն «Յունիբանկ» ԲԲԸ-ին տրամադրի իմ ապագա ֆինանսական պարտավորությունների վերաբերյալ տեղեկություններ, ինչպես նաև այլ տվյալներ: Գիտակցում եմ, որ տրամադրված տեղեկությունները և տվյալները, կախված դրանց բովանդակությունից կարող են ազդել «Յունիբանկ» ԲԲԸ-ի կողմից կայացված համապատասխան որոշման վրա: Սույն համաձայնությունը կարդացել եմ և հավաստում են, որ այն ինձ համար ամբողջությամբ հասկանալի և ընդունելի է:",
        ineco_info:
            'ԱՊՐԱՆՔՆԵՐԻ ԵՎ/ԿԱՄ ԾԱՌԱՅՈՒԹՅՈՒՆՆԵՐԻ ԱՊԱՌԻԿ ԿԱՐԳՈՎ ՁԵՌՔԲԵՐՄԱՆ ՖԻՆԱՆՍԱՎՈՐՄԱՆ ՀԱՅՏ ԵՎ ՀԱՄԱՁԱՅՆՈՒԹՅՈՒՆ 1.\tՍույնով դիմում եմ ապառիկ կարգով ապրանք(ներ)ի և/կամ ծառայություն(ներ)ի ձեռքբերման նպատակով "ԻՆԵԿՈԲԱՆԿ" ՓԲԸ-ի կողմից 30.000 – 5.000.000 ՀՀ դրամ գումարի սահմաններում ֆինանսավորում ստանալու համար՝ վերջինիս կողմից սահմանված պայմաններին համապատասխան: 2.\tՏեղեկացված եմ, որ "ԻՆԵԿՈԲԱՆԿ" ՓԲԸ-ի կողմից սույն հայտի վերաբերյալ դրական կամ բացասական որոշում կայացնելու համար տեղեկատվության բավարար չլինելու դեպքում անհրաժեշտ է սույն հայտի ներկայացման պահից 3 (երեք) աշխատանքային օրվա ընթացքում ներկայանալ "ԻՆԵԿՈԲԱՆԿ" ՓԲԸ՝ ներկայացնելով սույն հայտի՝ ինձ տրված մեկ օրինակը, ինչպես նաև իմ վարկարժանության ստուգման հետագա ընթացքի համար անհրաժեշտ փաստաթղթեր և տեղեկատվություն՝ ըստ պահանջի: Հասկանում և ընդունում եմ, որ սույն կետով սահմանված ժամկետում "ԻՆԵԿՈԲԱՆԿ" ՓԲԸ չներկայանալու դեպքում սույն հայտը կմերժվի "ԻՆԵԿՈԲԱՆԿ" ՓԲԸ-ի կողմից: 3.\tՏեղեկացված եմ, որ սույն հայտը մերժելու մասին որոշում կայացնելու դեպքում "ԻՆԵԿՈԲԱՆԿ" ՓԲԸ-ն որոշման կայացման օրվանից առավելագույնը 2 (երկու) աշխատանքային օրվա ընթացքում այդ մասին գրավոր ձևով կհայտնի ինձ՝ "ԻՆԵԿՈԲԱՆԿ" ՓԲԸ-ի տարածքում թղթային օրինակն առձեռն տրամադրելով: 4.\tՍույնով տալիս եմ իմ համաձայնությունը, որպեսզի "ԻՆԵԿՈԲԱՆԿ" ՓԲԸ-ի կողմից հարցում կատարվի "ԱՔՌԱ Քրեդիտ Ռեփորթինգ" ՓԲԸ և վերջինիս խնդրում եմ "ԻՆԵԿՈԲԱՆԿ" ՓԲԸ-ին տրամադրել իմ ներկա և անցյալ ֆինանսական պարտավորությունների վերաբերյալ տեղեկություններ, ինչպես նաև այլ տվյալներ, որոնք "ԻՆԵԿՈԲԱՆԿ" ՓԲԸ-ի կողմից կարող են հաշվի առնվել ինձ հետ վարկային (փոխառության և այլն) պայմանագիր կնքելու վերաբերյալ որոշում կայացնելիս։ Ինչպես նաև տալիս եմ իմ համաձայնությունը, որպեսզի "ԻՆԵԿՈԲԱՆԿ" ՓԲԸ-ի կողմից վարկային (փոխառության և այլն) պայմանագիր կնքելու դեպքում տվյալ վարկային (փոխառության և այլն) պայմանագրի գործողության ողջ ընթացքում ցանկացած պահին` առանց ինձ նախապես տեղյակ պահելու, "ԱՔՌԱ Քրեդիտ Ռեփորթինգ" ՓԲԸ-ն "ԻՆԵԿՈԲԱՆԿ" ՓԲԸ-ին տրամադրի իմ ապագա ֆինանսական պարտավորությունների վերաբերյալ տեղեկություններ, ինչպես նաև այլ տվյալներ։ Գիտակցում եմ, որ տրամադրված տեղեկությունները և տվյալները, կախված դրանց բովանդակությունից կարող են ազդել "ԻՆԵԿՈԲԱՆԿ" ՓԲԸ-ի կողմից կայացված համապատասխան որոշման վրա։ Սույն համաձայնությունը կարդացել եմ և հավաստում եմ, որ այն ինձ համար ամբողջությամբ հասկանալի և ընդունելի է։ 5.\tՍույնով հաստատում եմ, որ սույն փաստաթղթի նախորդ կետով իմ կողմից տրված համաձայնությունն ամբողջ ծավալով տարածվում է նաև ՀՀ կենտրոնական բանկի վարկային ռեգիստրի, "ՆՈՐՔ" սոցիալական ծառայությունների տեխնոլոգիական և իրազեկման կենտրոն հիմնադրամի, հանրային տվյալների բազաների, "ԻՆԵԿՈԲԱՆԿ" ՓԲԸ-ի հետ համագործակցող վարկային բյուրոների և բանկային սպասարկման ոլորտում հաճախորդների վերաբերյալ տվյալներ մշակող անձանց կողմից "ԻՆԵԿՈԲԱՆԿ" ՓԲԸ-ին իմ ներկա և անցյալ ֆինանսական պարտավորությունների (իսկ "ԻՆԵԿՈԲԱՆԿ" ՓԲԸ-ի հետ վարկային (փոխառության և այլն) պայմանագիր կնքվելու դեպքում նաև՝ ապագա ֆինանսական պարտավորությունների) վերաբերյալ տեղեկությունների, ինչպես նաև այլ տվյալների տրամադրման վրա՝ ինչպես սույն համաձայնության տրամադրման պահին, այնպես էլ "ԻՆԵԿՈԲԱՆԿ" ՓԲԸ-ի հետ վարկային (փոխառության և այլն) պայմանագիր կնքելու դեպքում տվյալ վարկային (փոխառության և այլն) պայմանագրի գործողության ողջ ընթացքում:',
        acba_info:
            "ՀԱՄԱՁԱՅՆԱԳԻՐ  Սույնով տալիս եմ իմ համաձայնությունը, որ.  • «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ-ն հարցումներ կատարի «ԱՔՌԱ Քրեդիտ Ռեփորթինգ» ՓԲԸ-ին և վերջինիս խնդրում եմ «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ-ին տրամադրել իմ ներկա և անցյալ ֆինանսական պարտավորությունների վերաբերյալ տեղեկություններ, ինչպես նաև այլ տվյալներ, որոնք «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ կողմից կարող են հաշվի առնվել ինձ հետ վարկային (փոխառության և այլն) պայմանագիր կնքելու վերաբերյալ որոշում կայացնելիս: • «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ կողմից վարկային (փոխառության և այլն) պայմանագիր կնքելու դեպքում տվյալ վարկային (փոխառության և այլն) պայմանագրի գործողության ողջ ընթացքում, իսկ գլխավոր վարկային պայմանագրի առկայության դեպքում նաև վերջինիս գործողության ողջ ընթացքում ցանկացած պահի առանց ինձ նախապես տեղյակ պահելու «ԱՔՌԱ Քրեդիտ Ռեփորթինգ» ՓԲԸ-ն «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ-ին տրամադրի իմ ապագա ֆինանսական պարտավորությունների վերաբերյալ տեղեկություններ, ինչպես նաև այլ տվյալներ:  • «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ-ն հարցում կատարի «Նորք» սոցիալական ծառայությունների տեխնոլոգիական և իրազեկման կենտրոն հիմնադրամին, և խնդրում եմ վերջինիս տրամադրել իմ վերաբերյալ ցանկացած տեղեկատվություն, որը կարող է կիրառվել Բանկի կողմից:  • «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ-ն սեփականության կամ ընդհանուր սեփականության իրավունքով ինձ պատկանող գույքերի վերաբերյալ հարցում կատարի ՀՀ կադաստրի կոմիտե և ստանա սպառիչ տեղեկատվություն իմ գույքային իրավունքների, այդ թվում` դրանց ծագման հիմքերի վերաբերյալ, ինչպես նաև կադաստրային գործից ստանա սեփականության իրավունքի վկայականի, հատակագծի և այլ անհրաժեշտ փաստաթղթերի պատճենները, իմ անունից դիմում ներկայացնի ՀՀ կադաստրի կոմիտե, կատարի անշարժ գույքի նկատմամբ ցանկացած իրավունքի պետական գրանցում, ստանա փաստաթղթեր,կատարի վճարումներ` մինչև իմ վարկային (փոխառության և այլն) պարտավորության լրիվ կատարումը:  • «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ-ն սեփականության կամ ընդհանուր սեփականության իրավունքով ինձ պատկանող տրանսպորտային միջոցների վերաբերյալ հարցում կատարի ՀՀ Ճանապարհային ոստիկանություն և ստանա սպառիչ տեղեկատվություն տրանսպորտային միջոցների նկատմամբ իմ գույքային իրավունքների, այդ թվում` դրանց ծագման հիմքերի վերաբերյալ, ինչպես նաև ստանա սեփականության իրավունքի վկայականի և այլ անհրաժեշտ փաստաթղթերի պատճենները` մինչև իմ վարկային (փոխառության և այլն) պարտավորության լրիվ կատարումը:  • «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ-ն հարցում կատարի «Հայաստանի ավտոապահովագրողների բյուրո» ԻԱՄ-ին և ապահովագրական ընկերություններին և ստանա ցանկացած տեղեկատվություն սեփականության իրավունքով ինձ պատկանող տրանսպորտային միջոցների ապահովագրության վերաբերյալ (այդ թվում՝ ապահովադրի և շահառուների վերաբերյալ տեղեկություններ)` մինչև իմ վարկային (փոխառության և այլն) պարտավորության լրիվ կատարումը:  • «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ կողմից ինձ ուղարկվեն ծանուցումներ` «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ-ի կողմից մատուցվող ծառայությունների հետ կապված ցանկացած տեղեկատվության վերաբերյալ:  • Սույնով ծանուցվում եմ, ինչպես նաև տալիս եմ իմ համաձայնությունը, որ «Անձնական տվյալների պաշտպանության մասին» ՀՀ օրենքի համաձայն՝ «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ-ն (ՀՀ, ք. Երևան, Արամի 82-84) 50 տարվա ընթացքում հարցումներ կատարի «Էլեկտրոնային կառավարման ենթակառուցվածքների ներդրման գրասենյակ» ՓԲԸ (ԷԿԵՆԳ)` ՀՀ Ոստիկանության բնակչության պետական ռեգիստրի, ՀՀ Արդարադատության նախարարության քաղաքացիական կացության ակտերի գրանցման գործակալության, ՀՀ Ոստիկանության ճանապարհային ոստիկանության, ՀՀ ԱՆ Իրավաբանական անձանց պետական ռեգիստրի, ՀՀ Արդարադատության նախարարության հարկադիր կատարման ծառայության, ՀՀ ԿԱ Պետական եկամուտների կոմիտեի և ՀՀ կադաստրի կոմիտեի տվյալներից իմ վերաբերյալ ցանկացած տեղեկատվություն ստանալու նպատակով, որն օգտագործվելու և ուսումնասիրվելու է ծառայությունների մատուցման հետ կապված ցանկացած գործընթացում, ինչպես նաև իմ անձնական տվյալները «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ-ի կողմից փոխանցվի «ԱՔՌԱ Քրեդիտ Ռեփորթինգ» ՓԲԸ, ՀՀ կենտրոնական բանկ, պետական իրավասու մարմիններ և այն իրավաբանական անձանց, որոնց կանոնադրական կապիտալում «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ-ն ունի ուղղակի կամ անուղղակի մասնակցություն: Համաձայնությունը/անձնական տվյալները կարող են հետ կանչվել, ուղղվել, ոչնչացվել, իսկ տվյալների մշակումը՝ դադարեցվել իմ գրավոր դիմումի հիման վրա: Գիտակցում եմ, որ տրամադրված տեղեկությունները և տվյալները, կախված դրանց բովանդակությունից, կարող են ազդել «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ կողմից կայացված համապատասխան որոշման վրա: Սույն համաձայնությունը կարդացել եմ և հավաստում եմ, որ այն ինձ համար ամբողջությամբ հասկանալի և ընդունելի է:",
        evoca_info:
            'Օնլայն ապառիկ Ապառիկ վարկավորման հիմնական պայմաններ Ծանոթացեք պայմաններին և սեղմեք "Սկսել գործընթացը" կոճակը:  Վարկի համար կարող են դիմել 21 տարին լրացած ՀՀ ռեզիդենտները, որոնց տարիքը վարկի սպասարկման ընթացքում չի գերազանցի 63 տարեկանը: Վարկի տրամադրման ժամկետ\t24 ամիս Վարկավորման գումար\t100000.0 ՀՀ դրամից մինչև 3000000.0 ՀՀ դրամ Վարկի տրամադրման եղանակ\tանկանխիկ Գնորդի միջնորդավճար (հաշվարկվում է վարկի սկզբնական մայր գումարի վրա)\t0% ամսական Վարկի անվանական տոկոսադրույք\t21.5% Կանխավճար\t0 ՀՀ դրամ      Համաձայն եմ պայմաններին   Համաձայն եմ, որ «Էվոկաբանկ» ՓԲԸ-ն հարցումներ կատարի և ստանա տեղեկություններ «Նորք» սոցիալական ծառայությունների տեխնոլոգիական և իրազեկման կենտրոն հիմնադրամից, «Էլեկտրոնային կառավարման ենթակառուցվածքների ներդրման գրասենյակ» (ԷԿԵՆԳ) ՓԲԸ-ից և «ԱՔՌԱ Քրեդիտ Ռեփորթինգ» ՓԲԸ-ի կողմից',
        idram: "Idram",
        isy_pay: "Easy pay",
        telcell: "Telcell",
        thank_you: "Thank you",
        recipient: "Recipient",
        phone: "Phone number",
        email_address: "Email address",
        address: "Address",
        payment_type: "Payment type",
        product_quantity: "Product quantity",
        ushadrutyun: "Attention",
        insufficient_funds: "Insufficient funds",
        close: "Close",
        order_num: "Order №",
        express_american_mir: "AMERICAN EXPRESS",
        my_order_list: "My Order List",
        my_purchase: "My Purchase",
        sellers_order: "Sellers Order",
        complete_order: "Complete Order",
        total_order: "Total Order",
        print: "Print",
        order_status: "Order Status",
        confirmed: "Confirmed",
        declined: "Declined",
        pending: "Pending",
        manage_order_process: "Manage order process",
        order_confirmation: "Order Confirmation",
        payment_status: "Payment Status",
        delivery_status: "Delivery Status",
        note: "Note",
        cancel_reason: "Cancel Reason",
        add_new_reason: "Add New Reason",
        reason: "reason",
        proccessing: "Processing",
        shipped: "Shipped",
        grand_total: "Grand Total",
        subtotal: "Subtotal",
        delivered: "Delivered",
        delivery_process: "delivery Process",
        add_new_delivery_process: "add new delivery process",
        edit_delivery_process: "edit delivery process",
        order_list: "order_list",
        complete: "complete",
        is_completed: "is completed",
        confirmed_orders: "Confirmed Orders",
        completed_orders: "Completed Orders",
        pending_payment_orders: "Pending Payment Orders",
        cancelled_orders: "Refused/Cancelled Orders",
        total_product_qty: "Product QTY",
        is_paid: "Is Paid",
        order_state: "Order State",
        website: "Website",
        txn_id: "TXN ID",
        is_cancelled: "Is Cancelled",
        inhouse_orders: "Inhouse Orders",
        create_new_order: "Create New Order",
        all_order: "All order",
        create_order: "Create Order",
        processing_order: "Processing Order",
        no_product_selected: "No product selected",
        total_quantity: "Total Quantity",
        sub_total: "Sub Total",
        ordered_products: "Ordered Products",
        total_shipping_charge: "Total Shipping Charge",
        inhouse_order_list: "Inhouse order list",
        please_create_account_for_deposite_main_income_seller_income_product_wise_tax_and_gst_tax:
            "Please Create An Account for Deposit Main Income, Seller Income, Product wise Tax and GST Tax !!!",
        payment_successful_your_order_will_be_despatched_in_the_next_48_hours:
            "Payment successfully accepted , your order will be delivered in the next 48 hours.",
        oredre_created_successfully: "Your order has been successfully confirmed",
        order_submit_failed: "Order submition failed!",
        edit_cancel_reason: "Edit cancel reason",
        in_house_order: "In house order",
        no_order_found: "No order found",
        your_order_has_been_cancelled: "Your Order has been cancelled",
        order_cancellation_failed: "Order Cancellation Failed",
        your_order_cancellation_has_been_failed_try_again:
            "Your Order cancellation has been failed. Try again !",
        your_package_order_has_been_cancelled:
            "Your Package Order has been cancelled",
        package_order_cancellation_failed: "Package Order Cancellation Failed",
        order_confirm: "Confirm order",
        average_price: "Average price",
        som_wrong: "something went wrong",
        product_not_found: "Product not found",
        active_product_list: "active product list",
        new_product_list: "new product list",
        discount_available: "The promotion is available from :star  to  :ende",
        select_attribute_grup: "Select Attribute Grup",
        not_vos_query: "Nothing was found for your query",
        porceq_poxel: "Тry to change the request or use our",
        hew_you_watched: "You have watched",
        jobo: "Jobs",
        promotions: "Promotions",
        spec_pric: "Special prices",
        top_piketc: "Sales hits",
        catalog: "Catalog",
        them_1: "TOSHIBA Template",
        them_: "Template",
        them_2: "SAMSUNG Template",
        them_3: "HISENSE Template",
        them_4: "VIKASS Template",
        la_news: "Latest news",
        be_inter: "You may be interested",
        in_header: "In header",
        add_page_info: "TOSHIBA Template Page Info",
        add_page2_info: "SAMSUNG Template Page Info",
        add_page2_info_add: "Add Page 3 Template Info",
        add_page2_info_slider: "Add Template Page 2 Info Slider",
        add_page3_info: "HISENSE Template Page Info",
        add_page3_info_add: "Add Template Page 3 Info",
        add_page3_info_slider: "Template Page Three Info Slider",
        add_page4_info: "VIKASS Template Page Info",
        text_1_en: "Text 1 EN",
        sort_id: "Sort ID",
        text_1_ru: "Text 1 RU",
        text_1_hy: "Text 1 HY",
        text_2_en: "Text 2 EN",
        text_2_ru: "Text 2 RU",
        text_2_hy: "Text 2 HY",
        descr1_en: "Descr 1 En",
        descr1_ru: "Descr 1 Ru",
        descr1_hy: "Descr 1 Hy",
        subtitle1_en: "Sub Title 1 En",
        subtitle1_ru: "Sub Title 1 Ru",
        subtitle1_hy: "Sub Title 1 Hy",
        subtitle2_en: "Sub Title 2 En",
        subtitle2_ru: "Sub Title 2 Ru",
        subtitle2_hy: "Sub Title 2 Hy",
        subtitle3_en: "Sub Title 3 En",
        subtitle3_ru: "Sub Title 3 Ru",
        subtitle3_hy: "Sub Title 3 Hy",
        subtitle4_en: "Sub Title 4 En",
        subtitle4_ru: "Sub Title 4 Ru",
        subtitle4_hy: "Sub Title 4 Hy",
        add_page4_info_add: "Add Template Page 4 Info",
        add_page4_info_slider: "Template Page 4 Info Slider",
        descr2_en: "Descr 2 En",
        descr2_ru: "Descr 2 Ru",
        descr2_hy: "Descr 2 Hy",
        baner_111_en: "Product One Image EN",
        baner_111_ru: "Product One Image RU",
        baner_111_hy: "Product One Image HY",
        baner_gl_en: "glxavor baner EN",
        baner_gl_ru: "glxavor baner RU",
        baner_gl_hy: "glxavor baner HY",
        baner_1_en: "Baner 1 EN",
        baner_1_ru: "Baner 1 RU",
        baner_1_hy: "Baner 1 HY",
        baner_2_en: "Baner 2 EN",
        baner_2_ru: "Baner 2 RU",
        baner_2_hy: "Baner 2 HY",
        baner_3_en: "Baner 3 EN",
        baner_3_ru: "Baner 3 RU",
        baner_3_hy: "Baner 3 HY",
        baner_4_en: "Baner 4 EN",
        baner_4_ru: "Baner 4 RU",
        baner_4_hy: "Baner 4 HY",
        baner_5_en: "Baner 5 EN",
        baner_5_ru: "Baner 5 RU",
        baner_5_hy: "Baner 5 HY",
        baner_6_en: "Baner 6 EN",
        baner_6_ru: "Baner 6 RU",
        baner_6_hy: "Baner 6 HY",
        baner_7_en: "Baner 7 EN",
        baner_7_ru: "Baner 7 RU",
        baner_7_hy: "Baner 7 HY",
        baner_8_en: "Baner 8 EN",
        baner_8_ru: "Baner 8 RU",
        baner_8_hy: "Baner 8 HY",
        character: "Characteristic",
        comparison: "COMPARE",
        similar_products: "SIMILAR PRODUCTS",
        lot_sellers: "SALES HITS ",
        with_product: "THIS PRODUCT GOES WITH",
        installing: "Installation",
        installingText: "The specified price includes the installation service",
        buy_on_credit: "Buy on credit",
        choose_the_gifts: "Choose the gifts",
        from_the_gift_list: "from the gift list",
        add_new_brand: "Add New Brand",
        edit_brand: "Edit Brand",
        my_product_list: "My product list",
        Slug: "Slug",
        stickers: "Stickers",
        total_product: "Total Product",
        num_of_sale: "Num of Sale",
        category_info: "Category info",
        recent_view_config: "Recent View Config",
        recently_viewed_product_configuration:
            "Recently Viewed Product Configuration",
        max_limit_of_product_store_for_per_user:
            "Max Limit of Product Store for per user",
        remove_stored_data_after_days: "Remove Store Data After Days",
        cronjob_url: "Cronjob url",
        bulk_category_upload: "Bulk Category Upload",
        bulk_brand_upload: "Bulk Brand Upload",
        bulk_product_upload: "Bulk Product Upload",
        category_csv: "category csv",
        brand_csv: "brand csv",
        units_csv: "units csv",
        bulk_upload: "Bulk Upload",
        bulk_gift_card_upload: "Bulk Gift Card Upload",
        website_link: "Website Link",
        attribute_grup: "Attribute Groups",
        brand_info: "Brand Info",
        "Sort By Order": "Sort By Order",
        attribute: "Attribute",
        add_new_attribute: "Add New Attribute",
        add_new_attribute_grupe: "Add New Attribute Group",
        i_want_to_manage_stock_for_this_product:
            "I want to manage stock for this product",
        new_product: "New Product",
        existing_product: "Existing Product",
        attributes_value: "Attributes Value",
        clone_product: "Clone Product",
        add_value: "Add Value",
        edit_attribute: "Edit Attribute",
        show_attribute: "Show Attribute",
        edit_attribute_grupe: "Edit Attribute Group",
        show_attribute_grupe: "Show Attribute Group",
        dropdown: "Dropdown",
        check_box: "Check Box",
        radio_button: "Radio Button",
        units: "Units",
        add_new_unit: "Add New Unit",
        edit_unit: "Edit Unit",
        add_new_product: "Add New Product",
        product_information: "Product Information",
        sub_category: "Sub Category",
        select_sub_category: "select Sub Category",
        unit: "Unit",
        select_unit: "Select Unit",
        select_tag: "Select Tag",
        select_barcode: "Select Barcode",
        barcode_type: "Barcode Type",
        minimum_order_qty: "Minimum Order Qty",
        meta_image: "Meta Image",
        pdf_specifications: "Pdf Specifications",
        Browse: "Browse",
        product_shipping_cost: "Product Shipping Cost",
        publish_info: "Publish Info",
        shipping_cost: "Shipping Cost",
        flat_rate: "Flat Rate",
        product_videos_info: "Product Video Info",
        video_link: "Video Link",
        video_provider: "Video Provider",
        youtube: "YouTube",
        daily_motion: "Daily Motion",
        others_info: "Others Info",
        product_image_info: "Product Image Info",
        thumbnail_image: "Thumbnail Image",
        galary_image: "Gallery Image",
        price_info_and_stock: "Price Info And Stock",
        purchase_price: "Purchase Price",
        tax_type: "Tax Type",
        stock_qty: "Stock Qty",
        variant: "Variant",
        select_attribute: "Select Attribute",
        SKU: "SKU",
        variation: "Variation",
        max_order_qty: "Max Order Qty",
        shipping_type: "Shipping Type",
        product_sku: "Product Sku",
        inhouse_product_list: "Inhouse Product List",
        add_inhouse_product_list: "Add Inhouse Product List",
        edit_product: "Edit Product",
        product_name: "Product Name",
        unit_cost: "Unit Cost",
        variant_items: "Variant Items",
        seller_request_product: "Seller Request Product",
        program_file_upload: "program file upload",
        download_file: "download file",
        click_on_it: "Click On It",
        add_category: "Add Category",
        add_category_group: "Add Category Group",
        edit_category_group: "Edit Category Group",
        add_sub_category: "Add Sub Category",
        category_group_list: "Category Group List",
        sorting: "Sorting",
        edit_category: "Edit Category",
        add_as_sub_category: "Add as sub-category",
        show_category: "Show Category",
        attribute_name: "Attribute Name",
        attribute_value: "Attribute Value",
        product_by_sku: "Product By SKU",
        sku_update: "SKU Update",
        show_category_group: "Show Category Group",
        sub_categories: "Sub Categories",
        display_name: "Display Name",
        file_size_must_be_less_than_1mb: "File size need tobe less than 1 MB",
        type_should_be_jpg_jpeg_png:
            "Invalid Type: type of the file need to be jpeg, jpg, png",
        color_name: "Color Name",
        general_information: "General Information",
        specifications: "Specifications",
        is_physical_product: "Is physical Product?",
        download_link: "Download Link",
        additional_shipping_charge: "Additional Shipping Charge",
        shipping_methods: "Shipping Methods",
        thumbnail: "Thumbnail",
        save_information:
            "Save After Fillup Of  All General Information & Related Product, Up Sale, Cross Sale",
        file: "File",
        discount_period: "Promotion Period",
        alert_list: "Alert List",
        out_of_stock_list: "Out Of Stock List",
        disabled_product_list: "Disabled Product List",
        uploading_product_is_disabled_according_to_your_package_right_now:
            "Uploading product is disabled according to your package right now",
        create_gift_card: "Create Gift Card",
        edit_gift_card: "Edit Gift Card",
        card_number: "Card Number",
        product_variants: "Product Variants",
        related_data_exist_in_multiple_directory:
            "Related Data Exist in Multiple Directory",
        to_use_themefy_icon_please_type_here_or_select_fontawesome_from_list:
            "To use themefy icon please type here Or Select fontawesome from list",
        invalid_type_type_should_be_jpeg_jpg_png:
            "Invalid Type: Type should be jpeg, jpg, png",
        create_attribute: "Create Attribute",
        create_brand: "Create Brand",
        create_unit: "Create Unit",
        file_must_be_less_than_1_mb: "File must be less than 1MB",
        please_input_product_name: "Please Input Product Name",
        please_input_product_sku: "Please Input Product Sku",
        please_select_category: "Please Select Category",
        please_select_product_unit: "Please Select Product Unit",
        please_input_minimum_order_qty: "Please Input Minimum order Qty",
        please_input_purchase_price: "Please Input Purchase Price",
        please_input_selling_price: "Please Input Selling Price",
        please_input_tax: "Please Input Tax",
        please_input_discount_minimum_0: "Please Input Discount Minimum 0",
        please_upload_thumnail_image: "Please Upload Thumnail Image",
        please_select_shipping_method: "Please Select Shipping Method",
        please_input_tags: "Please input tags",
        please_select_attribute: "Please select Attribute",
        weight_kg: "Weight (KG)",
        dimension_cm_lenth_x_width_x_height:
            "Dimension (CM) (Length x Width x Height)",
        product_stock_manage: "Product Stock Manage",
        product_stock: "Product Stock",
        select_product_sku: "Select Product SKU",
        stock: "Promotion",
        cart_product: "Cart Product",
        purchased_gift_card: "Purchased gift card",
        discount_start_date: "Discount Start Date",
        discount_end_date: "Discount End Date",
        redeem_successfully: "Redeem Successfully!",
        gift_card_already_used: "Gift card already used.",
        invalid_giftcard: "Invalid gift card.",
        rechaged_successfully: "Recharged Successfully!",
        single_product: "Single Product",
        comma_separated: "Comma Separated",
        color_attribute_is_not_deletable: "Color attribute is not deletable!",
        variant_product_is_not_changable_to_single_product:
            "Variant Product Is Not Changeable To Single Product",
        change_not_possible_for_use: "Change Not Possible for Use",
        attribute_add_not_possible_for_this_product:
            "Attribute Add Not Possible For This Product",
        height: "Height",
        breadth: "Breadth",
        length: "Length",
        weight_height_info: "Weight Height Info",
        please_input_product_weight: "Please Input Product Weight",
        please_input_product_breadth: "Please Input Product Breadth",
        please_input_product_length: "Please Input Product Length",
        please_input_product_height: "Please Input Product Height",
        this_product_already_used_on_order_or_somewhere_so_delete_not_possible:
            "This product already used on order or somewhere else, so it can not be deleated",
        subtitle_1: "Subtitle 1",
        subtitle_2: "Subtitle 2",
        add_page3_info_photos: "Template Page 3 Info Photos",
        refund_manage: "Refund Manage",
        reasons: "Reasons",
        reason_list: "Reason List",
        edit_reason: "Edit Reason",
        refund_time: "Refund Time",
        refund_activate: "Refund Activate",
        in_days: "In Days",
        all_pending_requests: "All Pending Requests",
        all_pending_refund_requests: "All Pending Refund Requests",
        request_confirmation: "Request Confirmation",
        refund_money_status: "Refund Money Status",
        my_refund_requests: "My refund requests",
        pending_refund_requests: "Pending refund requests",
        defects_descr: "Description of defects",
        confirmed_refund_requests: "Confirmed refund requests",
        processing_state: "Processing State",
        payable_refund_request: "payable refund request",
        refund_process: "Refund Process",
        add_refund_process: "Add Refund Process",
        edit_refund_process: "Edit Refund Process",
        process_name: "Process Name",
        process: "Process",
        request_status: "Request Status",
        is_refunded: "Is Refunded",
        refund_success: "Refunded Sucessfully",
        refund_related_info: "Refund Related Info",
        request_sent: "Request Sent",
        account_nb: "Account Nb.",
        post_code: "Post Code",
        drop_of_info: "Drop of Info",
        return_qty: "Return Qty",
        refund: "Refund",
        additional_info: "Additional Info",
        refund_name: "Name",
        refund_surname: "Surname",
        refund_email: "Email",
        "refund_order.number": "Order Number",
        "refund_phone.number": "Phone Number",
        refund_reason: "Refund reason",
        defects: "Description of defects",
        terms_conditions_agree: "I've read and agree to the Terms and Conditions",
        parcel: "The parcel is opened",
        delivery_terms: "Terms of delivery",
        info_product: "Info about product",
        select_criteria_for_filtering: "Select Criteria for Filtering",
        report: "Report",
        number_of_time_visit: "Number of time Visit",
        last_visited: "Last Visited",
        seller_id: "Seller ID",
        seller_wise_sales_report: "Seller Wise Sales Report",
        seller_wise_stock: "Seller Wise Stock",
        seller_wise_sales: "Seller Wise Sales",
        admin_reports: "Admin Reports",
        user_searches: "User Searches",
        visitor: "Visitor",
        user_search_report: "User Search Report",
        keyword_search_report: "Keyword search report",
        keywords: "Keywords",
        number_of_time: "Number of times",
        visitor_report: "Visitor Report",
        wallet_recharge_history: "Wallet recharge history",
        top_selling_item: "Top selling item",
        recently_product_review: "Recently reviewd products",
        recently_seller_review: "Recently seller review",
        inhouse_product_sale: "Inhouse product sale",
        filter_selection_criteria: "Filter selection criteria",
        sale_type: "Sale type",
        number_of_user: "Number of user",
        number_of_wishlist_product: "Number of Wishlist product",
        my_reports: "My Reports",
        pending_product_review_list: "Pending Product Review List",
        approve_all_review: "Approve All Review",
        approve_confirm: "Are you sure to Approve All ?",
        deny_confirm: "Are you sure to Deny ?",
        approve: "Approve",
        deny: "Deny",
        deny_review: "Deny Review",
        customer_feedback: "Customer Feedback",
        customer_time: "Customer & Time",
        approve_all: "Approve All",
        pending_seller_review_list: "Pending Seller Review List",
        declined_seller_review_list: "Declined Seller Review List",
        seller_review_list: "Seller Review List",
        number_of_review: "Number of reviews",
        product_review_list: "Product Review List",
        replied_successfully: "Replied successfully!",
        reply_to_customer: "Reply To Customer",
        my_review_list: "My Review List",
        all_review: "All Review",
        all_product_review_list: "All Product Review List",
        declined_review_list: "Declined Review List",
        product_review: "Product Review",
        seller_review: "Seller Review",
        my_product_review: "My Product Review",
        my_review: "My Review",
        review_done_thanks_for_review: "Review Done. Thanks for Review.",
        review_already_exsist: "Review Already exists.",
        company_review: "Company Review",
        company_review_list: "Company Review List",
        create_a_seller: "Create a Seller",
        basic_info: "Basic Information",
        make_trusted: "Make Trusted",
        remove_from_trusted: "Remove From Trusted",
        alert_message: "Alert Message",
        are_you_confirmed_to_execute_this_operation:
            "Are you confirmed to execute this operation ?",
        business_owner_name: "Legal Name/ Business Owner Name",
        person_in_charge_name: "Person in Charge Name",
        business_registration_number: "Business Registration Number",
        seller_tin: "Seller TIN",
        upload_business_document: "Upload Business Document",
        holiday_start: "Holiday Start",
        holiday_end: "Holiday End",
        upload_cheque_copy: "Upload Cheque Copy",
        same_as_warehouse_address: "Same as Warehouse Address",
        no_of_product: "No. of product",
        approval: "Approval",
        check_category_commissions: "Check Category Commissions",
        category_list_with_commission: "Category list with Commission",
        my_staff: "My Staff",
        add_new_staff: "Add New Staff",
        create_a_staff: "Create A Staff",
        update_staff_info: "Update staff info",
        joined_date: "Joined Date",
        select_from_list: "Select from list",
        add_member_is_disabled_according_to_your_package_right_now:
            "Add Member is disabled according to your package right now",
        seller_list: "Seller List",
        commision_setup: "Commission Setup",
        manage_seller: "Manage Seller",
        subscription_info: "Subscription info",
        subscription_title: "Subscription Title",
        next_payment_before: "Next payment before",
        create_supplier: "Create supplier",
        business_name: "Business name",
        tax_number: "Tax number",
        edit_supplier: "Edit Supplier",
        supplier_id: "Supplier id",
        supplier: "Supplier",
        supplier_list: "Supplier list",
        pay_condition: "Pay condition",
        finance_information: "Finance Information",
        opening_balance: "Opening Balance",
        pay_term: "PAY Term",
        pay_term_condition: "Pay Term Condition",
        alternate_contact_no: "Alternate Contact No",
        supplier_profile: "Supplier Profile",
        office_xtract: "Office extract",
        please_update_business_bank_information_from_profile_first:
            "Please Update Business & Bank Information From Profile First",
        seller_profile: "Seller Profile",
        product_allready_added: "Product Already Added.",
        about_seller: "About Seller",
        commission_calculate_for_multi_category:
            "Commission Calculate For Multi Category",
        minimum_rate: "Minimum Rate",
        maximum_rate: "Maximum Rate",
        average_rate: "Average Rate",
        multi_category: "Multi Category",
        add_new_shipping_method: "Add new shipping method",
        method_name: "Method name",
        shipment_time: "shipment time",
        "ex: 3 - 5 days or 6 -12 hrs": "ex: 3 - 5 days or 6 -12 hrs",
        cost: "cost",
        edit_method_info: "Edit Method Info",
        courier_pick_up: "Courier Pick Up",
        drop_off: "Drop Off",
        courier_pick_up_information: "Courier Pick Up Information",
        drop_off_information: "Drop Off Information",
        requested_by: "Requested By",
        address_info: "Address Info",
        shipping_address: "Shipping Address",
        reset_address: "Reset Address",
        order_packages: "Order Packages",
        please_save_customer_address_before_add_product:
            "Please Save Customer Address Before Adding a Product",
        company_info: "Company Info",
        shipping_info: "Shipping Info",
        shop_name: "Shop Name",
        create_shipping_method: "Create Shipping Method",
        shipping_provider: "Shipping Provider",
        request_history: "Request history",
        order_info: "Order Info",
        shipping: "Shipping",
        carriers: "Carriers",
        carrier: "Carrier",
        shiprocket: "Shiprocket",
        shiprocket_api_password: "Shiprocket API Password",
        shiprocket_api_email: "Shiprocket API Email",
        carrier_logo: "Carrier Logo",
        shipping_rates: "Shipping Rates",
        add_new_shipping_rate: "Add New Shipping Rate",
        based_on: "Based On",
        price: "Price",
        weight: "Weight",
        flat: "Flat",
        edit_shipping_rate: "Edit Shipping Rate",
        configuration: "Configuration",
        order_confirm_and_sync_with_carrier: "Order Confirm and Sync With Carrier",
        manual: "Manual",
        automatic: "Automatic",
        yes: "Yes",
        no: "No",
        "admin_change_shipping_carrier_?": "Admin Change Shipping Carrier ?",
        "customer_call_see_carrier_?": "Customer Can See Carrier ?",
        pending_orders: "Pending Orders",
        shipping_method_change: "Shipping Method Change",
        all_selected_order_change_shipping_method:
            "All Selected Order Change Shipping Method",
        selected_order_shipping_method_change:
            "Selected Order Shipping Method Change",
        selected_order_change_shipping: "Selected Order Change Shipping",
        reset: "Reset",
        method: "Method",
        package_code: "Package Code",
        tracking_id: "Tracking ID",
        "order_will_auto_confirm_?": "Order Will Auto Confirm ?",
        pickup_locations: "Pickup Locations",
        pickup_location: "Pickup Location",
        add_new_pickup_location: "Add New Pickup Location",
        pin_code: "Pin Code",
        address_2: "Address 2",
        latitude: "Latitude",
        longitude: "Longitude",
        edit_pickup_location: "Edit Pickup Location",
        pickup_location_details: "Pickup Location Details",
        label: "Label",
        download: "Download",
        set_pickup_location: "Set Pickup Location",
        shipping_orders: "Shipping Orders",
        label_download: "Label Download",
        add_new_carrier: "Add New Carrier",
        tracking_url: "Tracking Url",
        update_carrier: "Update Carrier",
        Quick: "Quick",
        Custom: "Custom",
        carrier_order_type: "Carrier Order Type",
        packaging: "Packaging",
        packaging_info: "Packaging Info",
        "refund_order_sync_carrier_?": "Refund Order Sync Carrier ?",
        is_default: "Is Default",
        shipping_by: "Shipping By",
        shipping_information: "Shipping Information",
        shiprocket_channel_id: "Shiprocket Channel ID",
        label_terms_condition: "Label Terms & Conditions",
        label_terms_and_conditions: "Label Terms & Conditions",
        terms_and_conditions: "Terms & Conditions",
        add_more: "Add More",
        label_configuration: "Label Configuration",
        invoice: "Invoice",
        "seller_use_shiproket_?": "Seller use Shiproket ?",
        barcode: "Barcode",
        qrcode: "Qrcode",
        both: "both",
        label_generate_use: "Label Generate Use",
        customer_address_update: "Customer Address Update",
        carrier_status: "Carrier Status",
        min_shopping: "Min Shopping",
        collect_from_pickup_location: "Collect from pickup location",
        minimum_shopping_amount: "Minimum shopping amount",
        without_shipping_cost: "without shipping cost",
        minium_shopping_amount_is_not_fulfill:
            "Minimum shopping amount is not fulfilled",
        cart_is_empty_please_add_product_first:
            "Cart is empty. Please add product first.",
        about: "about us",
        more: "more",
        news: "news",
        see_all: "see all",
        contact: "contact",
        shops: "Shops",
        search: "Search",
        select_bank: "Select a bank for more information",
        credit: "Credit",
        delivery: "Delivery",
        order_formating: "Forming an order",
        knows_questions: "Known questions",
        block: "Block",
        title_text: "Title text",
        link_text: "Link text",
        address_icon: "Address Image",
        address_title: "Address Title",
        work_time: "Work time",
        tel_time: "Tel time",
        soc_links_title: "Soc Links Title",
        email_title: "Email Title",
        email_con: "Email Icon",
        tel_title: "Tel Title",
        prepayment: "Prepayment amount",
        interest_rate: "Annual Interest Rate",
        service_fee: "Monthly service fee of the bank",
        payment_term: "Loan repayment term",
        minimum_amount: "Minimum loan amount",
        maximum_amount: "Maximum amount",
        credit_terms: "Credit Terms",
        formulation: "Place of formulation",
        mount: "mount",
        amd: "Amd",
        icon_title: "Icon Title",
        condition_text: "Condition Text",
        question_answer: "Questions and Answers",
        question: "Question",
        answer: "Answer",
        faq_categories: "FAQ Categories",
        main_photo: "Page Main Photo",
        accepted: "The :attribute must be accepted.",
        active_url: "The :attribute is not a valid URL.",
        after: "The :attribute must be a date after :date.",
        after_or_equal: "The :attribute must be a date after or equal to :date.",
        alpha: "The :attribute may only contain letters.",
        alpha_dash:
            "The :attribute may only contain letters, numbers, dashes and underscores.",
        alpha_num: "The :attribute may only contain letters and numbers.",
        array: "The :attribute must be an array.",
        before: "The :attribute must be a date before :date.",
        before_or_equal: "The :attribute must be a date before or equal to :date.",
        boolean: "The :attribute field must be true or false.",
        confirmed_attribute: "The :attribute confirmation does not match.",
        date_attribute: "The :attribute is not a valid date.",
        date_equals: "The :attribute must be a date equal to :date.",
        date_format_attribute: "The :attribute does not match the format :format.",
        different: "The :attribute and :other must be different.",
        digits: "The :attribute must be :digits digits.",
        digits_between: "The :attribute must be between :min and :max digits.",
        dimensions: "The :attribute has invalid image dimensions.",
        distinct: "The :attribute field has a duplicate value.",
        email_attribute: "The :attribute must be a valid email address.",
        ends_with: "The :attribute must end with one of the following: :values.",
        exists: "The selected :attribute is invalid.",
        file_attribute: "The :attribute must be a file.",
        filled: "The :attribute field must have a value.",
        image_attribute: "The :attribute must be an image.",
        in: "The selected :attribute is invalid.",
        in_array: "The :attribute field does not exist in :other.",
        integer: "The :attribute must be an integer.",
        ip_attribute: "The :attribute must be a valid IP address.",
        ipv4: "The :attribute must be a valid IPv4 address.",
        ipv6: "The :attribute must be a valid IPv6 address.",
        json: "The :attribute must be a valid JSON string.",
        mimes: "The :attribute must be a file of type: :values.",
        mimetypes: "The :attribute must be a file of type: :values.",
        multiple_of: "The :attribute must be a multiple of :value",
        not_in: "The selected :attribute is invalid.",
        not_regex: "The :attribute format is invalid.",
        numeric: "The :attribute must be a number.",
        password_attribute: "The password is incorrect.",
        present_attribute: "The :attribute field must be present.",
        regex: "The :attribute format is invalid.",
        required_attribute: "The :attribute field is required.",
        required_if: "The :attribute field is required when :other is :value.",
        required_unless:
            "The :attribute field is required unless :other is in :values.",
        required_with: "The :attribute field is required when :values is present.",
        required_with_all:
            "The :attribute field is required when :values are present.",
        required_without:
            "The :attribute field is required when :values is not present.",
        required_without_all:
            "The :attribute field is required when none of :values are present.",
        same: "The :attribute and :other must match.",
        starts_with:
            "The :attribute must start with one of the following: :values.",
        string: "The :attribute must be a string.",
        timezone: "The :attribute must be a valid zone.",
        unique_attribute: "The :attribute has already been taken.",
        uploaded: "The :attribute failed to upload.",
        url_attribute: "The :attribute format is invalid.",
        uuid: "The :attribute must be a valid UUID.",
        check_unique_phone: "The phone has already been taken.",
        this_field_is_required: "This field is required.",
        please_fill_with_valid_email: "Please Fill In With Valid Email.",
        you_are_already_subscribed: "You Are Already Subscribed.",
        the_amount_is_must_be_gretter_than_0:
            "The amount must be greater than 0.\\",
        Transaction: "Transaction",
        Transactions: "Transactions",
        Credit: "Credit",
        Debit: "Debit",
        Statement: "Statement",
        "Account History": "Account History",
        "Bank Account Details": "Bank Account Details",
        "Current Balance": "Current Balance",
        utilities: "Utilities",
        clear_cache: "Clear Cache",
        clear_log: "Clear Log",
        enable: "Enable",
        disable: "Disable",
        app_debug: "App Debug",
        force_https: "Force HTTPS",
        reset_database: "Reset Database",
        xml_sitemap: "XML Sitemap",
        "It can take some times to execute operation. please wait until completed operation":
            "It can take some times to execute operation. please wait until the operation is completed",
        are_you_sure_to_reset_database: "Are you sure you want to reset database?",
        database_reset_successful: "Database reset successfully",
        choose_sitemap_option: "Choose sitemap option",
        import_demo_database: "Import Demo Database",
        import_database: "Import Database",
        import_demo_note:
            "After Import Demo, You Will Lost Your Current Data. Please Backup Your Database & Uploaded File First, If You Need.",
        reset_database_note:
            "After Reset, You Will Lost Your Current Data. Please Backup Your Database & Uploaded File First, If You Need.",
        are_you_sure_to_import_demo_database:
            "Are you sure you want to  Import Demo database?",
        import_demo_database_successful: "Import Demo Database Successful.",
        my_wallet: "My Wallet",
        recharge: "Recharge",
        transaction_list: "Transaction List",
        recharge_now: "Recharge Now",
        enter_your_amount_to_recharge: "Enter Your Amount To Recharge",
        choose_payment_gateway: "Choose Payment Gateway",
        online_recharge: "Online Recharge",
        wallet_recharge_transactions: "Wallet Recharge Transactions",
        account_holder: "Account Holder",
        check: "Check",
        auto_approve: "Auto approve",
        approved_balance: "Approved Balance",
        pending_balance: "Pending Balance",
        offline_recharge: "Offline Recharge",
        any_comment: "Any Comment",
        wallet_manage: "Wallet Manage",
        running_balance: "Running Balance",
        earning_balance: "Earning Balance",
        withdraw_balance: "Withdraw Balance",
        refund_paid: "Refund Paid",
        withdraw_now: "withdraw now",
        enter_your_amount_to_withdraw: "Enter your amount to withdraw",
        withdraw: "withdraw",
        withdraw_history: "Withdraw history",
        modify_your_amount_to_withdraw: "Modify your amount to withdraw",
        send: "send",
        withdraw_requests: "Withdraw Requests",
        show_details: "Show Details",
        details_info: "Details Info",
        Approval: "Approval",
        pending_withdraw_balance: "Pending withdraw balance",
        pending_withdraw_request_balance: "Pending Withdraw Request Balance",
        remaining_balance: "Remaining Balance",
        withdraw_request_has_been_sent_successfully:
            "Withdraw Request has been sent Successfully!",
        withdraw_request_has_been_modified_successfully:
            "Withdraw Request has been modified Successfully!",
        requested_amount: "Requested amount",
        bank_ibn: "Bank IBN",
        recharge_using_gift_card: "Recharge Using Gift Card",
        cheque_slip: "Cheque Slip",
        flutter_wave_payment: "Flutter wave payment",
        continue_to_recharge: "Continue to Recharge",
        instamojo_payment: "Instamojo payment",
        pay_tm_payment: "Paytm payment",
        pay_u_money_payment: "Pay u money payment",
        recharge_offline_wallet: "Recharge Offline Wallet",
        transection_id: "Transection ID",
        jazz_cash_payment: "JazzCash Payment",
        are_you_sure_to_go_through_this_payment_gateway:
            "Are you sure you want to go through this payment gateway?",
        recharge_wallet_history: "Recharge wallet history",
        continue_to_pay: "Continue to pay",
        google_payment: "Google payment",
        razor_pay: "Razor pay",
        online_recharge_transactions: "Online Recharge Transactions",
        bank_recharge: "Bank Recharge",
        bank_recharge_transactions: "Bank Recharge Transactions",
        mercado_pago_payment: "Mercado Pago Payment",
        Amount: "Amount",
        Balance: "Balance",
        copy_link: "Copy link",
        "You are blocked from admin. Please contact with admin.":
            "You are blocked from admin. Please contact with admin.",
        checkout_product: "Checkout Product",
        percentage: "Percentage",
        tags: "Tags",
        support_lowercase: "support",
        posts: "Posts",
        comments: "Comments",
        email_or_phone: "email or phone",
        terms_conditions: "Terms & Conditions",
        category_show_in_menu: "Category show in menu",
        "Google Merchant Center": "Google Merchant Center",
        "Products Export": "Products Export",
        "Click here go to Google Merchant Center google product category Link":
            "Click here go to Google Merchant Center google product category Link",
        paid: "Paid",
        lead: "Lead",
        leads: "Leads",
        lead_info: "Lead Info",
        lead_images: "Lead Images",
        lead_files: "Lead Files",
        lead_list: "Lead List",
        Cheque: "Cheque",
        Purchase: "Purchase",
        Asset: "Asset",
        Income: "Income",
        Liabilities: "Liabilities",
        Sale: "Sale",
        Cash: "Cash",
        Bank: "Bank",
        Liability: "Liability",
        "GST Tax Account": "GST Tax Account",
        "Product Wise Tax Account": "Product Wise Tax Account",
        "Seller Account": "Seller Account",
        "Seller Commision": "Seller Commission",
        "Sallary Account": "Salary Account",
        price_tag: "Price Tag",
        old_price: "old price",
        basic_price: "regular price",
        product_1: "Product 1",
        product_2: "Product 2",
        product_3: "Product 3",
        "You have no products selected": "You have no products selected",
        images: "Banner Images",
        Marketing_Sales: "Marketing Sales",
        coupon_list: "Coupon List",
        function: "Function",
        reason_lowercase: "reason",
        refused_cancelled_orders: "Refused/Cancelled Orders",
        otp_is_sent: "OTP is sent",
        otp: "OTP",
        enter_otp: "Enter OTP",
        resend_otp: "Resend OTP",
        otp_send_successful: "OTP send successful",
        invalid_otp: "Invalid OTP",
        otp_validation_time_expired: "OTP validation time expired",
        something_wrong_on_otp_send: "Something went wrong with sent OTP",
        please_select_otp_type: "Please select OTP type",
        otp_configuration: "OTP Configuration",
        code_validation_time_min: "Code validation time(min)",
        otp_send_for_customer_registration: "OTP send for customer registration",
        otp_will_be_sent_according_to_customer_register_email_or_phone:
            "(OTP will be sent to customer registerED  email or phone)",
        otp_send_for_seller_registration: "OTP send for seller registration",
        otp_type: "OTP type",
        otp_send_for_order_confiramtion: "OTP send for order confiramtion",
        email_and_sms_should_be_configured_first:
            "EMAIL AND SMS SHOULD BE CONFIGURED FIRST",
        cod: "CODE",
        "Page Builder": "Page Builder",
        Pages: "Pages",
        Page: "Page",
        Title: "Title",
        Body: "Body",
        Create: "Create",
        "Create Page": "Create Page",
        "Update Page": "Update Page",
        Design: "Design",
        previous: "&laquo; Previous",
        next_pagination: "Next &raquo;",
        sent: "We have emailed your password reset link!",
        throttled: "Please wait before retrying.",
        token: "This password reset token is invalid.",
        paypal: "Paypal",
        paypal_configuration: "Paypal Configuration",
        paypal_client_secret: "Paypal Client Secret Key",
        paypal_client_id: "Paypal Client ID",
        stripe: "Stripe",
        stripe_configuration: "Stripe Configuration",
        stripe_key: "Stripe Key",
        stripe_secret_key: "Stripe Secret Key",
        stripe_user_name: "Stripe User Name",
        paystack_configuration: "Paystack Configuration",
        paystack_key: "Paystack Key",
        paystack_secret_key: "Paystack Secret Key",
        paystack_merchant_email: "Paystack Merchant Email",
        paystack: "Paystack",
        razor_secret_key: "Razor Pay Secret Key",
        razor_key: "razor_key",
        razorpay: "RazorPay",
        razorpay_configuration: "RazorPay Configuration",
        paystack_payment_url: "Paystack Payment URL",
        bank_configuration: "Bank Configuration",
        paytm: "PayTM",
        paytm_configuration: "Paytm Configuration",
        paytm_environment: "Paytm Environment",
        merchant_id: "Merchant Id",
        merchant_key: "Merchant Key",
        merchant_website: "Merchant Website",
        paytm_channel: "Paytm Channel",
        paytm_industry_type: "Paytm Industry Type",
        instamojo: "Instamojo",
        instamojo_configuration: "Instamojo Configuration",
        auth_token: "Auth Token",
        instamojo_url: "Instamojo Url",
        midtrans: "Midtrans",
        midtrans_configuration: "Midtrans Configuration",
        merchant_server_key: "Merchant Server Key",
        is_production_mode: "Is Production Mode",
        merchant_client_key: "Merchant Client Key",
        sandbox_environment: "Sandbox Environment",
        production_environment: "Production Environment",
        payumoney: "PayUmoney",
        payumoney_configuration: "Payumoney Configuration",
        payu_money_mode: "PayU Money Mode",
        payumoney_key: "PayUmoney Key",
        payumoney_salt: "PayUmoney Salt",
        payumoney_auth: "PayUmoney Auth",
        jazzcash: "JazzCash",
        jazzcash_configuration: "JazzCash Configuration",
        salt_id: "Salt Id",
        live_url: "Live Url",
        google_pay: "Google Pay",
        google_pay_configuration: "Google Pay Configuration",
        gateway_name: "Gateway Name",
        merchant_name: "Merchant Name",
        flutter_wave_payment_configuration: "Flutter Wave Payment Configuration",
        public_key: "Public Key",
        secret_hash: "Secret Hash",
        paddle: "Paddle",
        paddle_payment_configuration: "Paddle Payment Configuration",
        environment: "Environment",
        vendor_id: "Vendor Id",
        vendor_auth_code: "Vendor Auth Code",
        test: "Test",
        live: "Live",
        sandbox: "Sandbox",
        gateway_logo: "Gateway Logo",
        recharge_successfully: "Recharge successful!",
        payment_details: "Payment Details",
        name_on_card: "Name on Card",
        cvc: "CVC",
        expiration_month: "Expiration Month",
        expiration_year: "Expiration Year",
        please_correct_the_errors_and_try_again:
            "Please correct the errors and try again.",
        pay_now_100: "Pay Now ($100)",
        bank_account_info: "Bank account info",
        bkash: "bkash",
        bkash_configuration: "Bkash Configuration",
        app_key: "App Key",
        app_secret: "App Secret",
        ssl_commerz: "Ssl Commerz",
        sslcommerz_configuration: "SslCommerz Configuration",
        api_domain_url: "Api Domain URL",
        store_id: "Store ID",
        store_password: "Store Password",
        mercado_pago_configuration: "Mercado Pago Configuration",
        mercado_pago: "Mercado Pago",
        card_expiration_date: "Card Expiration Date",
        cardholder_name: "Cardholder Name",
        cardholder_email: "Cardholder Email",
        security_code: "Security Code",
        issuer: "Issuer",
        identification_type: "Identification Type",
        identification_number: "Identification Number",
        installments: "Installments",
        access_token: "Access Token",
        Payroll: "Payroll",
        "Select Criteria For Payroll": "Select Criteria For Payroll",
        "Not generated": "Not generated",
        Generated: "Generated",
        Paid: "Paid",
        "Proceed To Pay": "Proceed To Pay",
        "View PaySlip": "View PaySlip",
        "Generate Payroll": "Generate Payroll",
        Earnings: "Earnings",
        PDF: "PDF",
        Deductions: "Deductions",
        "Payslip Details": "Payslip Details",
        Address: "Address",
        "Payroll Summary": "Payroll Summary",
        "Prepared By": "Prepared By",
        "Approved By": "Approved By",
        "Paid By": "Paid By",
        Calculate: "Calculate",
        "Gross Salary": "Gross Salary",
        Tax: "Tax",
        "Net Salary": "Net Salary",
        "Staff Name": "Staff Name",
        "Payment Date": "Payment Date",
        "Payment Amount": "Payment Amount",
        Note: "Note",
        "Pay Now": "Pay Now",
        "Paid Loan Amount": "Paid Loan Amount",
        "Cheque No": "Cheque No",
        "Account No": "Account No",
        "View Payslip Details": "View Payslip Details",
        "Payslip for the period of": "Payslip for the period of",
        Payslip: "Payslip",
        "Payroll Reports": "Payroll Reports",
        "Paid Date": "Paid Date",
        "Loan Status": "Loan Status",
        "Basic Salary": "Basic Salary",
        "Total Loan": "Total Loan",
        "Due Loan Amount": "Due Loan Amount",
        "Paid Amount": "Paid Amount",
        Installment: "Installment",
        Loan: "Loan",
        "Total Deduction": "Total Deduction",
        update_json_markup: "Update Json Markup",
        create_json_markup: "Create Json Markup",
        home_json_markup: "Home JSON Markup",
        brands_json_markup: "Brands Json Markup",
        percentage_lowercase: "percentage",
        amount_lowercase: "amount",
        reason_en: "Refund En",
        reason_ru: "Refund Ru",
        reason_hy: "Refund Hy",
        basic_info_full: "Basic Information",
        expire_date: "Expire date",
        already_expired: "Already Expired",
        last_payment_date: "Last Payment Date",
        advance_renew_subscription: "Advance renew subscription",
        after_change_and_save_previous_lisence_will_expried:
            "After change and save previous license will expire.",
        "Intro Prefix has been added Successfully":
            "Intro Prefix has been added Successfully",
        "Intro Prefix has been updated Successfully":
            "Intro Prefix has been updated Successfully",
        "A Intro Prefix has been destroyed Successfully":
            "A Intro Prefix has been destroyed Successfully",
        prefix: "Prefix",
        click_here_to_create_your_project: "Click Here To Create Your Project",
        disable_google_analytics: "Disable Google Analytics",
        add_new_intro_prefix: "Add New Intro Prefix",
        intro_prefix_list: "Intro Prefix List",
        intro_prefix: "Intro Prefix",
        prefix_name: "Prefix Name",
        prefix_details: "Prefix Details",
        edit_introprefix: "Edit IntroPrefix",
        add_new_tag: "Add New Tag",
        edit_tag: "Edit Tag",
        payment_configuration: "Payment Configuration",
        analytics: "Analytics Tools",
        phonecode: "Phone Code",
        flag: "Flag",
        google_analytics: "Google Analytics",
        enable_google_analytics: "Enable Google Analytics",
        click_here_to_create_google_analytics:
            "Click here to create Google analytics",
        facebook_pixel: "Facebook Pixel",
        enable_facebook_pixel: "Enable Facebook Pixel",
        click_here_to_create_facebook_pixel: "Click here to create Facebook pixel",
        facebook_pixel_id: "Facebook Pixel ID",
        tracking_id_required: "Tracking ID Required",
        facebook_pixel_id_required: "Facebook Pixel ID Required",
        enable_gs_analytics_for_your_dashboard:
            "Enable GS Analytics for your Dashboard",
        service_account_json_file: "Service Account Json File",
        measurement_id: "Measurement ID",
        measurement_protocol_api_secret: "Measurement Protocol API Secret",
        fill_in_the_two_fields_below_for_the_Google_Analytics_version_4:
            "Fill in the two fields below for the Google Analytics version 4.",
        for_reporting_version_4_see_google_analytics_panel:
            "For reporting version 4 see google analytics panel.",
        description_en: "Dedcription en",
        support_ticket: "Support Ticket",
        my_tickets: "My Tickets",
        ticket: "Ticket",
        priority: "Priority",
        ticket_list: "Ticket List",
        user_agent: "User Agent",
        agent_asign: "Agent Assign",
        unassigned: "Unassigned",
        ticket_info: "Ticket Info",
        ticket_id: "Ticket ID",
        assign_to: "Assign To",
        add_a_comment: "Add A Comment",
        open_a_ticket: "Open a Ticket",
        create_ticket: "Create Ticket",
        update_ticket: "Update Ticket",
        add_new_category: "Add New Category",
        add_new_priority: "Add New Priority",
        add_new_status: "Add New Status",
        priority_list: "Priority List",
        all_ticket: "All Ticket",
        last_update: "Last update",
        create_new_ticket: "Create new ticket",
        all_closed_tickets: "All closed tickets",
        closed_ticket: "Closed tickets",
        all_submmited_ticket: "All Submitted Ticket",
        we_do_not_sell_or_share_your_details_without_your_permission:
            "We do not sell or share your details without your permission",
        submit_message: "Submit message",
        support_ticket_help: "Support ticket & help",
        back_to_list: "Back to list",
        create_support_ticket: "Create support ticket",
        view_ticket: "View ticket",
        please_at_least_one_item: "Please select at least one item",
        attch_upload_limit_is_5: "Attached  upload limit is 5",
        reply_ticket: "Reply Ticket",
        add_your_comment: "Add your Comment",
        password_auth: "The password is incorrect.",
        "Wholesale Price": "Wholesale Price",
        "Min QTY": "Min QTY",
        "Max QTY": "Max QTY",
        "Price per piece": "Price per piece",
        "Add More": "Add More",
        service_brand_crumb: "Service centre",
        services_title: "Non-warranty (paid) service",
        service_type_repair: "Type of repair",
        service_type_repair_price: "The price",
        gift_products: "Gift",
        slider_images_hy: "Slider images HY",
        slider_images_en: "Slider images EN",
        slider_images_ru: "Slider images RU",
        order_alert_text:
            "Your payment details have been successfully sent for verification. Please wait for a reply to your email. to the address.",
        wait_for_redirect_to_payment:
            "Please wait while we are processing your transaction. <br /> You are being redirected to the payment page.",
        wait_for_order_confirm:
            "Please wait while we are processing your transaction.",
        updated_at: "Updated at",
        yesterday: "Yesterday",
        days_ago: "days ago",
        add_attribute: "Add Attribute",
        coment: "Coment",
        key_word_list: "Key word list",
        add_a_new_key_word: "Add a new key word",
        key_words: "Key words",
        order_not_found_products: "Order not found products",
        watched: "Watched",
        not_exists: "Not exists",
        thanks_for_order_wait_for_call: "Thanks for order, please wait for a call",
        go_url: "Go url",
        go_category_brand: "Go category/brand",
    },
    hy: {
        qr_text: 'Սկանավորեք QR կոդը՝ հավելվածը ներբեռնելու համար',
        Favorites: "Հավանած ապրանքնր",
        vlv_type: "VLV Type",
        vlv: "«ՎիԷլՎի Սենթր»",
        many_viewed_products: "Շատ դիտված ապրանքներ",
        srch_plach: "Փնտրիր, որ գտնես",
        filter: "Ֆիլտր",
        branches: 'Մասնաճյուղեր',
        order_search: "Order Search",
        order_product: "Մենք կապ կհաստատենք Ձեզ հետ, մանրամասները քննարկելու համար",
        active_in_filter: "Ակտիվ ֆիլտր",
        bonus_cart: "Բոնուս քարտ",
        spick_voic: "Ինչ ե՞ք փնտրում",
        show_more: "Show more",
        collapse: "Collapse",
        sl: "SL",
        order_number: "Պատվերի №",
        order_accepted: "Ձեր պատվերը ընդունված է",
        fill_fields_ordered_products:
            "Լրացրեք հետևյալ դաշտերը և մենք կապ կհաստատենք Ձեզ հետ մանրամասները քննարկելու համար։",
        back_to_site: "Դեպի կայք",
        fast_delivery: "Էքսպրեսս Առաքում",
        fast_delivery_title: "Էքսպրեսս Առաքում",
        with_installation: "Տեղադրումով",
        without_installation: "Առանց Տեղադրում",
        fast_delivery_descr:
            "Եթե կատարել եք գնում մինչև ժամը 15։00-ը և ցանկանում եք ստանալ ապրանքը գնման նույն օրը, ապա նշենք,որ գործում է Express առաքման ծառայություն: Առաքումը կկատարվի նույն օրը մինչև 20։00։ Ծառայության արժեքը՝ 2000դրամ է, ծառայությունը գործում է միայն ք․Երևանում։",
        to_close: "Փակել",
        "subscribed ": "Դուք արդեն բաժանորդագրվել եք տեղեկագրին",
        discounted_products: "Զեղչված ապրանքներ",
        to_learn_more: "Իմանալ ավելին",
        type_pay: "Վճարման տարբերակներ",
        pay_text: "Ընդունում ենք վճարումներ կանխիկ և անկանխիկ",
        pay_href: "Վճարման տարբերակներ",
        inf_text: "Բաժանորդագրվեք ակցիաներին և  նորություններին",
        dw_app: "Ներբեռնել հավելվածը",
        soc_linkes: "Մենք սոց․ ցանցերում",
        we_sale: "Ակցիաներ",
        "header.category.baner.index": "Վերևի կատեգորիայի նկար",
        famous_category: "Հայտնի բաժիններ",
        header_menu_category: "Վերևի մենյուի կատոգրիա",
        slider1: "Սլայդեր 1",
        slider2: "Սլայդեր 2",
        slider_image_en: "Սլայդեր նկար անգլերեն",
        slider_image_ru: "Սլայդեր նկար ռուսերեն",
        slider_image_hy: "Սլայդեր նկար  հայերեն",
        "header.category.section": "Վերևի մենյուի հատված",
        back: "Հետ",
        section_setup: "Բաժնի կարգավորում",
        add_slider: "Ավելացնել սլայդեր",
        all_category: "Բաժիններ",
        inf: "Տեղեկատվություն",
        buy_er_in: "«ՎիԷլՎի սենթր»-ի մասին",
        title_en: "Վերնագիր անգլերեն",
        title_ru: "Վերնագիր ռուսերեն",
        title_hy: "Վերնագիր հայերեն",
        add: "Ավելացնել",
        buy_two: "Գնիր երկու ապրանք",
        get_a_product: "Ստացիր",
        by_gif: "Նվեր",
        guaranty: "Երաշխիք",
        href: "Հղում",
        by_nou: "Գնել հիմա",
        sticker_list: "Սթիքերի ցուցակ",
        sale_search: "Ակցիայի որոնում",
        by: "Կողմից",
        ship_sot: "Հատուկ առաջարկ",
        stet_ended: "Ակցիան հասանելի է ",
        day: "Օր",
        hours: "Ժամ",
        minutes: "Րոպե",
        seconds: "Վայրկյան",
        here: "Այստեղ",
        baner1: "Բաններ 1",
        baner2: "Բաններ 2",
        related_brand: "Նմանատիպ ապրանքանիշ",
        up_sale_brand: "Բարձր կատեգորիայի ապրանքանիշ",
        cross_sale_brand: "Կից ապրանքանիշ",
        change_password: "Փոխել գաղտնաբառը",
        keyword: "Բանալի բառ",
        number_of_use: "Օգտագործման Քանակը",
        ip_list: "IP ցանկ",
        secret_id: "Գաղտնի նույնականացման №",
        automatic_wallet_approval: "Ավտոմատ դրամապանակի հաստատում",
        pickup_address: "Վերցնելու հասցեն",
        slug: "Slug",
        make_default: "Ստեղծել հիմնական",
        request: "Հարցում",
        restricted_in_demo_mode: "Սահմանափակված է ցուցադրական ռեժիմում",
        list: "Ցանկ",
        enter_your_password: "Մուտքագրեք Ձեր գաղտնաբառը",
        invalid_password: "Սխալ գաղտնաբառ",
        choose: "Ընտրեք",
        social_login: "Մուտք սոցիալական ցանցերով",
        secret_login: "Գաղտնի մուտք",
        my: "Իմ",
        config: "Կոնֆիգուրացիա",
        work_hors_shop_address: "Աշխատանքային ժամեր",
        address_shop_address: "Հասցե",
        phone_shop_address: "Հեռախոս",
        image_alt_shop_address: "Խանութ սրահի նկար",
        image_shop_address: "Խանութ սրահի հասցեի նկար",
        longitude_shop_address: "Խանութ սրահի հասցեի Երկայնություն",
        latitude_shop_address: "Խանութ սրահի հասցեի լայնածավալություն",
        csv_upload: "CSV Ֆայլ",
        upload_csv: "Բեռնել CSV",
        no_results_found: "Արդյունքներ չեն գտնվել",
        merchants: "Մեծածախ վաճառք",
        quick_search: "Արագ որոնում",
        status: "Կարգավիճակ",
        action: "Գործողություն",
        select: "Ընտրել",
        is_trusted: "Վստահելի է",
        minimum_order_quantity: "Պատվերի նվազագույն քանակ",
        maximum_order_quantity: "Պատվերի առավելագույն քանակ",
        listed_date: "Նշված ամսաթիվը",
        active: "Ակտիվ է",
        deactive: "Ակտիվ չէ",
        "in-active": "Ակտիվ է",
        nothing_found: "Ոչինչ չգտնվեց",
        active_status: "Ակտիվ կարգավիճակ",
        orders: "Պատվերներ",
        wallet_histories: "Դրամապանակի պատմություն",
        addresses: "Հասցեներ",
        for: "Համար",
        num_of_uses: "Դիմումների քանակը",
        agent: "Գործակալ",
        device: "Սարք",
        system: "Համակարգ",
        inhouse: "Ներքին",
        inhouse_product: "Ներքին արտադրանք",
        order_summary: "Պատվերի կարճ նկարագրություն",
        summary: "Նկարագրություն",
        danger: "Վտանգ",
        url: "Հղում",
        activate: "Ակտիվացնել",
        are_you_sure_to_activate: "Համոզված ե՞ք, որ ցանկանում եք ակտիվացնել",
        total_orders: "Պատվերների ընդհանուր քանակ",
        total_sale: "Ընդհանուր վաճառք",
        total_discount: "Ընդհանուր զեղչ",
        pending_orders: "Հետաձգված պատվերներ",
        cancelled_orders: "Չեղարկված պատվերներ",
        activate_successful: "Ակտիվացումը հաջողված է",
        confirmed_orders: "Հաստատված պատվեր",
        completed_orders: "Կատարված պատվեր",
        completed: "Ավարտված",
        joined_at: "Միացել է",
        average_rating: "Միջին վարկանիշ",
        total_spend: "Ընդհանուր ծախս",
        total_recharge: "Ընդհանուր վերալիցքավորում",
        wallet_summary: "Դրամապանակի ամփոփագիր",
        pending_balance_approval: "Սպասվելիք հաշվեկշռի հաստատում",
        total_balance: "Ընդհանուր հաշվեկշիռ",
        empty_list: "Դատարկ ցուցակ",
        total: "Ընդհանուր",
        update: "Թարմացում",
        language: "Լեզու",
        clone_successful: "Կրկնօրինակումը հաջողված է",
        clone: "Կրկնօրինակել",
        name: "Անուն",
        name_en: "Անուն անգլերենով",
        name_hy: "Անուն հայերենով",
        name_ru: "Անուն ռուսերենով",
        id: "Նույնականացման քարտ",
        note: "Նշում",
        reply: "Պատասխանել",
        category: "Կատեգորիա",
        create_category: "Ստեղծել կատեգորիա",
        product_qty: "Ապրանքի քանակ",
        category_name: "Կատեգորիայի անուն",
        category_list: "Կատեգորիայի ցանկ",
        product_type: "Ապրանքի տեսակ",
        save: "Պահպանել",
        searchable: "Որոնվող",
        update_title: "Թարմացնել վերնագիրը",
        description: "Նկարագրություն",
        root_category: "Հիմնական բաժին",
        show: "Ցույց տալ",
        group_name: "Խմբի անուն",
        "are_you_sure_to_delete_?": "Համոզված ե՞ք, որ ցանկանում եք ջնջել:",
        cancel: "Չեղարկել",
        main_title: "Գլխավոր վերնագիր",
        sub_title: "Ենթավերնագիր",
        email: "Էլ․ փոստ",
        all_customer: "Բոլոր հաճախորդները",
        submitting: "Տրամադրում",
        updating: "Թարմացում",
        deleting: "Ջնջում",
        hide: "Թաքցնել",
        activity_logs: "Գործունեության մատյաններ",
        all_activity_logs: "Բոլոր գործունեության  մատյանները",
        login_activity: "Մուտքի գործողություն",
        type: "Տեսակ",
        IP: "IP",
        attempted_at: "Փորձված",
        user: "Օգտագործող",
        login_at: "Մուտք գործել",
        logout_at: "Դուրս գալ",
        login_logout_activity: "Մուտք - ելք",
        inactive: "Ոչ ակտիվ",
        browse: "Ընտրել",
        image: "Նկար",
        browse_image: "Ընտրել նկար",
        browse_file: "Ընտրել ֆայլ",
        attach_file: "Կցել ֆայլ",
        browse_image_file: "Կցել նկար",
        "Something Went Wrong": "Ինչ-որ բան սխալ գնաց",
        "Delete Confirmation": "Ջնջել հաստատումը",
        "Delete confirmation message": "Ջնջել հաստատման նամակը",
        choose_file: "Ընտրել ֆայլ",
        seo_info: "SEO տեղեկություն",
        meta_title: "Meta վերնագիր",
        meta_description: "Meta նկարագրություն",
        publish: "Հրապարակել",
        Draft: "Նախագիծ",
        pending: "Ակնկալվող",
        refunded: "Վերադարձված",
        number: "Համար",
        status_info: "Պատվերի կարգավիճակ",
        checkout_product: "Ապրանքի պատվեր",
        choose_one: "Ընտրեք մեկը",
        monthly: "Ամսեկան",
        profile: "Անձնական էջ",
        transactions: "Գործարքներ",
        documents: "Փաստաթղթեր",
        document: "Փաստաթուղթ",
        phone: "Հեռախոս",
        date_of_birth: "Ծննդյան ամսաթիվ",
        address: "Հասցե",
        "Current Address": "Ընթացիկ հասցե",
        "Permanent Address": "Հիմնական հասցե",
        username: "Մուտքանուն",
        view: "Տեսնել",
        size: "Չափ",
        preview: "Նախադիտել",
        basic_info: "Հիմնական տեղեկություն",
        select_one: "Ընտրել մեկը",
        password: "Գաղտնաբառ",
        profile_picture: "Նկար",
        opening_balance: "Բացման մնացորդ",
        employee_id: "Աշխատողի նույնականացման №",
        "Last Date Of Provisional Period": "Ժամանակավոր ժամանակաշրջանի ամսաթիվ",
        personal_info: "Անձնական տվյալներ",
        personal: "Անձնական",
        successfully_registered: "Հաջողությամբ գրանցվել է",
        upload_document: "Ներբեռնել փաստաթուղթ",
        read_all: "Կարդալ ամբողջը",
        document_title: "Փաստաթղթի անվանումը",
        put_your_password: "Մուտքագրեք Ձեր գաղտնաբառը",
        avatar: "Նկար",
        registered_date: "Գրանցման ամսաթիվ",
        submit: "Ներկայացնել",
        select_type: "Ընտրել տեսակը",
        single_day: "Մեկ օր",
        multiple_day: "Մի քանի օր",
        start_date: "Սկսել ամսաթիվը",
        end_date: "Ավարտել ամսաթիվը",
        to_date: "Մինչ օրս",
        select_role: "Ընտրել պաշտոնը",
        Value: "Արժեք",
        year: "Տարի",
        use_as_username: "Օգտագործել որպես օգտվողի անուն",
        your_user_id_is: "Ձեր օգտվողի ID-ն է",
        select_criteria: "Ընտրեք չափանիշները",
        first_name: "Անուն",
        last_name: "Ազգանուն",
        search: "Որոնել",
        display_type: "Ցուցադրման տեսակը",
        error_message: "Ինչ-որ բան սխալ գնաց:",
        update_message: "Հաջողությամբ թարմացվել է:",
        update_successfully: "Հաջողությամբ թարմացվել է:",
        status_change_message: "Կարգավիճակը փոխվեց",
        Timestamp: "Ժամանակահատված",
        second: "Երկրորդ",
        activated: "Ակտիվացված",
        image_second_section: "Նկարի երկրորդ հատված",
        image_first_section: "Նկարի առաջին հատված",
        upload_photo: "Ավելացնել նկար",
        photo: "Նկար",
        single: "Միակ",
        gst_pay: "GST վճարում",
        product_tax_pay: "Ապրանքի հարկի վճարում",
        multiple: "Բազմակի",
        file_less_than_1MB: "1MB-ից քիչ ֆայլ",
        brand: "Արտադրող",
        brands: "Արտադրողներ",
        is_featured: "Ֆիլտրված է",
        featured: "Ֆիլտրված",
        load_more: "Տեսնել ավելին",
        values: "Արժեքներ",
        model_number: "Մոդելի համար",
        amount: "Գումար",
        percentage: "Տոկոս",
        add_more: "Ավելացնել ավելին",
        not_approved: "Հաստատված չէ",
        approved: "Հաստատված",
        select_root_category: "Ընտրեք հիմնական կատեգորիան",
        add_menu_item: "Ավելացնել ընտրացանկի տարր",
        select_menu_item: "Ընտրեք ընտրացանկի տարրը",
        vat_number: "VAT №",
        company_information_format: "Ընկերության տեղեկատվության ձևաչափ",
        zip_code: "Zip կոդ",
        count: "Հաշվել",
        country: "Երկիր",
        location: "Գտնվելու վայրը",
        date_from: "-ից",
        cash: "Կանխիկ",
        bank: "Բանկ",
        banks: "Բանկեր",
        cheque: "Ստուգում",
        dashboard: "Կառավարման համակարգ",
        confirm_password: "Հաստատեք գաղտնաբառը",
        reset_password: "Վերականգնել գաղտնաբառը",
        customer_list: "Հաճախորդների ցուցակ",
        active_customer: "Ակտիվացնել հաճախորդին",
        in_active_customer: "Ապաակտիվացնել հաճախորդին",
        is_active: "Ակտիվ է",
        customer: "Հաճախորդ",
        wallet_balance: "Դրամապանակի հաշիվ",
        "referral_code_(optional)": "Ուղղորդման կոդ(ըստ ցանկության)",
        referral_code: "Ուղղորդման կոդ",
        no: "Ոչ",
        date: "Ամսաթիվ",
        balance: "Հաշվեկշիռ",
        add_new_seller: "Ավելացնել նոր վաճառող",
        shop_name: "Խանութ սրահի անվանումը",
        shop: "Խանութ սրահ",
        no_of_sale: "Վաճառքի համար",
        seller_details: "Վաճառողի տվյալներ",
        product: "Ապրանք",
        post_image: "Հրապարակել նկարը",
        pay_first_for_subcription: "Նախ վճարեք բաժանորդագրության համար",
        pay_for_subcription: "Վճարեք բաժանորդագրության համար",
        trusted_seller: "Վստահելի վաճառող",
        account_information: "Հաշվի տեղեկատվություն",
        holiday_mode: "Holiday Mode",
        on: "Միացնել",
        off: "Անջատել",
        holiday_type: "Տոնի տիպ",
        holiday_date: "Տոնի ամսաթիվ",
        holiday_duration: "Տոնի տևողություն",
        "n/a": "N/A",
        owner_name: "Սեփականատիրոջ անունը",
        address_1: "Հասցե 1",
        address_2: "Հասցե 2",
        state: "Պետություն",
        city: "Քաղաք",
        postcode: "Փոստային կոդ",
        registration_number: "Գրանցման №",
        business_document: "Բիզնես փաստաթուղթ",
        tin: "Tin",
        business_information: "Բիզնես տեղեկատվություն",
        payment_information: "Վճարման տեղեկատվություն",
        bank_cheque: "Բանկային անդորրագիր",
        ibn: "IBN",
        routing_number: "Երթուղու №",
        updated_at: "Թարմացվել է",
        branch_name: "Մասնաճյուղի անվանում",
        bank_name: "Բնակի անվանում",
        account_name: "Հաշվի անվանում",
        account_number: "Հաշվի համար",
        attachment: "Հավելված",
        bank_title: "Բանկ",
        cash_payment: "Կանխիկ վճարում",
        bank_payment: "Բանկային վճարում",
        return_address: "Վերադարձի հասցե",
        warehouse_address: "Պահեստի հասցե",
        added_successfully: "Հաջողությամբ հաստատվել է",
        created_successfully: "Հաջողությամբ ստեղծված է",
        deleted_successfully: "Հաջողությամբ ջնջվեց",
        updated_successfully: "Հաջողությամբ թարմացվեց",
        payment_successfully: "Հաջողությամբ վճարվեց",
        transaction_successfully: "Գործարքը հաջողությամբ կատարվել է",
        status_updated_successfully: "Կարգավիճակը հաջողությամբ թարմացվել է:",
        approved_successfully: "Հաջողությամբ հաստատվեց",
        success: "Հաջողություն",
        seller: "Վաճառող",
        subscription: "Բաժանորդագրվել",
        trx_id: "Trx Id",
        txn: "Txn",
        is_approve: "Հաստատում է",
        method: "Տարբերակ",
        account: "Հաշիվ",
        full_name: "Ամբողջական անուն",
        unique: "Եզակի",
        mobile: "Բջջային",
        cross_sale_product_display_title: "Կից ապրանքի ցուցադրման անվանում",
        up_sale_product_display_title:
            "Բարձր իկատեգորիայով ապրանքի ցուցադրման անվանում",
        title_settings: "Վերնագրի կարգավորումներ",
        settings: "Կարգավորումներ",
        make_Display_in_details_page: "Ցուցադրել մանրամասների էջում",
        up_sale: "Ավելի բարձր",
        up_sale_category: "Ավելի բարձր կատեգորիա",
        cross_sale: "Նմանատիպ ապրանքներ",
        cross_sale_category: "Կից ապրանքների կատեգորիա",
        package: "Փաթեթ",
        of: "-ից",
        total_price: "Ընդհանուր արժեք",
        qty: "Քանակ",
        items_count: "Ապրանքների քանակ",
        coupon: "կուպոն",
        apply: "Դիմել",
        discount: "Զեղչ",
        discount_type: "Զեղչի տեսակը",
        shopping: "Գնումներ",
        cart: "Զամբյուղ",
        payment_options: "Վճարման տարբերակներ",
        confirm: "Հաստատել",
        order: "Պատվեր",
        seller_commission: "Վաճառողի բոնուս",
        commission_rate: "Բոնուսի դրույքաչափ",
        commission_type: "Հանձնաժողովի տեսակ",
        edit_commission_rate: "Խմբագրել հանձնաժողովի դրույքաչափը",
        change: "Փոխել",
        current: "Ընթացիկ",
        re_enter: "Կրկին մուտքագրել",
        make: "Դարձնել",
        default: "Նախընտրելի",
        new: "Նոր",
        old: "Հին",
        region: "Տարածաշրջան",
        page: "Էջ",
        required: "Պահանջվում է",
        banner: "Բաններ",
        link: "Հղում",
        setup: "Տեղադրել",
        price: "Արժեք",
        published: "Հրատարակված",
        all: "Բոլոր",
        send: "Ուղարկել",
        check: "Ստուգել",
        notification: "Ծանուցումներ",
        no_notification_found: "Ծանուցում չի գտնվել",
        error: "Սխալ",
        open_link_in_a_new_tab: "Բացել հղումը նոր էջում",
        total_amount: "Ընդհանուր գումար",
        order_id: "Պատվերի ID",
        contact_us: "Հետադարձ կապ",
        policy: "Քաղաքականություն",
        payment_method: "Վճարման տարբերակ",
        shipping_charge: "Առաքման գումարը",
        warning: "Զգուշացում",
        max: "Առավելագույն",
        min: "Նվազագույն",
        access_permission: "Մուտքի թույլտվություն",
        access_denied: "Մուտքն մերժված է",
        tax: "Հարկ",
        vat: "ԱԱՀ",
        updated_by: "Թարմացվել է",
        user_name: "Օգտագործողի անունը",
        no_file_selected: "Ֆայլն ընտրված չէ",
        file: "Ֆայլ",
        loan: "Վարկ",
        apply_for_loan: "Դիմել վարկի համար",
        monthly_installment: "Ամսական ապառիկ",
        due: "Պայմանավորված",
        cancelled: "Չեղարկված",
        apply_for: "Դիմել",
        General: "Գլխավոր",
        Emergency: "Արտակարգ իրավիճակ",
        loan_date: "Վարկի ամսաթիվ",
        total_month: "Ընդհանուր ամիս",
        department: "Բաժին",
        apply_for_loan_update: "Դիմել վարկի թարմացման համար",
        applied_date: "Կիրառման ամսաթիվը",
        paid_loan_amount: "Վճարված վարկի գումարը",
        apply_loan_details: "Դիմել վարկի մանրամասների համար",
        loan_type: "Վարկի տեսակը",
        applied_loan: "Գործող վարկ",
        staff_id: "Աշխատակազմի ID",
        add_new_ignore_ip: "add_new_ignore_ip",
        ignore_ip_from_visitor_count: "Անտեսել Ip այցելուների քանակից",
        send_successfully: "Հաջողությամբ կցվել է",
        staff_info: "Աշխատակազմի ինֆորմացիա",
        days: "Օրեր",
        download: "Ներբեռնել",
        uploaded_successfully: "Հաջողությամբ ներբեռնվել է",
        quick_summery: "Արագ ամփոփում",
        gift_card: "Նվեր քարտ",
        gift_cards: "Նվեր քարտեր",
        gift_card_list: "Նվեր քարտերի ցանկ",
        number_of_sale: "Վաճառքի քանակը",
        sample_file_download: "Նմուշի ֆայլի ներբեռնում",
        download_warning:
            "Ներբեռնել ճիշտ ձևաչափի ֆայլ: Մի փորձեք վերբեռնել տարբեր ձևաչափի ֆայլ  և տեղեկատվություն",
        not_editable: "Խմբագրման ենթակա չէ",
        not_permit: "Դուք չունեք  թույլտվություն",
        no_action_permitted: "Գործողություն չի թույլատրվում",
        used: "Օգտագործված",
        home: "Գլխավոր էջ",
        home_page_baner: "Գլխավոր էջի բաներ",
        catalog_page_baner: "Կատալոգ էջի բաներ",
        ignore_ip: "IP անտեսում",
        visitors_setup: "Այցելուների կարգավորում",
        subscription_payment: "Բաժանորդագրության վճարում",
        referral: "Ուղղորդում",
        view_all: "Տեսնել բոլորը",
        total_coupon_used: "Ընդհանուր օգտագործված կուպոններ",
        operation_failed: "Գործարքը չստացվեց",
        operation_done_successfully: "Գործողությունը հաջողությամբ կատարվել է է",
        successful: "Հաջողված է",
        create: "Ստեղծել",
        create_template_first: "Ստեղծել ձևանմուշ",
        duplicate_entry_is_exist_in_your_file: "Ֆայլում առկա է կրկնօրինակ գրառում",
        copyright: "Հեղինակային իրավունք",
        remove: "Հեռացնել",
        add_to_cart: "Ավելացնել",
        write_some_messages: "Գրել մի քանի հաղորդագրություն",
        you_don_t_have_this_permission: "Դուք չունեք այս թույլտվություն",
        mail_has_been_sent_successful: "Նամակը հաջողությամբ ուղարկվել է",
        created_at: "Ստեղծվել է",
        info: "Տեղեկատվություն",
        disabled: "Անաշխատունակ",
        upload_pdf: "Վերբեռնել PDF",
        upload_product: "Վերբեռնել ապրանքը",
        recharge_amount: "Վերալիցքավորել գումարը",
        country_region: "Երկիր / տարածաշրջան",
        subtract: "Հանել",
        postal_code: "Փոստային ինդեքս",
        pending_request: "Սպասվող հարցում",
        flash_deals: "flash_deals",
        user_zone: "Օգտագործողի գոտի",
        notifications: "Ծանուցումներ",
        see_more: "Տեսնել ավելին",
        welcome: "Բարի գալուստ",
        please: "Խնդրեմ",
        log_out_space: "Դուրս գալ",
        not_deleted: "Չի ջնջվել",
        transaction_failed: "Գործարքը ձախողվեց",
        enter_secret_code_of_gift_card: "Մուտքագրեք նվեր քարտի գաղտնի կոդը",
        redeem_now: "Օգտագործել հիմա",
        redeem: "Օգտագործել",
        select_cancel_reason: "Ընտրել չեղարկման պատճառը",
        address_already_used: "Հասցեն արդեն օգտագործված է",
        billing_info: "Վճարային տեղեկատվություն",
        website: "Կայք",
        already_a_merchant: "Արդեն մեծածախ վաճառք",
        account_verified_successfully: "Հաշիվը հաջողությամբ հաստատվեց",
        you_have_been_disabled: "Անաշխատունակ է",
        loan_has_been_applied_successfully: "Վարկը հաջողությամբ կիրառվել է",
        not_found: "Չի գտնվել",
        please_agree_with_our_policy_privacy:
            "Խնդրում ենք համաձայնել մեր Գաղտնիության քաղաքականությանը",
        attach_upload_limit_is_5: "Կցել վերբեռնման սահմանաչափը",
        billing_address: "Վճարման հասցե",
        oh_no: "Օ ոչ",
        sidebar_manager: "Կողային վահանակի կառավարիչ",
        setting: "Կարգավորում",
        convert_as_seller: "Փոխակերպել որպես վաճառող",
        verification_link_resend_successfully:
            "Հաստատման հղումը հաջողությամբ ուղարկվել է:",
        account_already_verified: "Հաշիվն արդեն հաստատված է։",
        admin_contact_with_you: "Ադմինիստրատորը կկապվի Ձեզ հետ:",
        subject: "Թեմա",
        file_name: "Ֆայլի անուն",
        page_link: "Էջի հղում",
        click_here: "Սեղմեք այստեղ",
        clean_all: "Մաքրել",
        minimum_8_charecter: "Ամենաքիչը 8 նիշ",
        total_items: "Ընդհանուր ապրանքներ",
        please_configure_mail_settings_first:
            "Խնդրում ենք կարգավորել էլ․փոստի կարգավորումները",
        sms: "Հաղորդագրություն",
        company: "Կազմակերպություն",
        no_data_available_in_table: "Տվյալները բացակայում են",
        company_rating_review: "Ընկերության վարկանիշ և ակնարկ",
        sms_has_been_sent_successfully: "Նամակը հաջողությամբ ուղարկվել է",
        set_sms_credentials: "Սահմանել հաղորդագրության տվյալները",
        postal_code_or_pin_code: "Ինդեքս / Pin կոդ",
        commision: "Հանձնաժողով",
        latitude: "Լայնություն",
        longitude: "Երկարություն",
        facebook: "Ֆեյսբուք",
        twitter: "Twitter",
        linkedin: "Linkedin",
        instagram: "Instagram",
        "vat/tax/gst": "ԱԱՀ/Հարկ",
        link_copied_successfully: "Հղումը հաջողությամբ պատճենվեց:",
        buy_now: "Գնել հիմա",
        quick_buy: "Արագ գնում",
        surname: "Ազգանուն",
        COMPARE: "Համեմատել",
        Add: "Ավելացնել",
        Delivery_Type: "Առաքման տվյալներ",
        "Payment type": "Վճարման տարբերակ",
        "By bank card": "Բանկային քարտով",
        "PAY BY RECEIPT": "Վճարել հաշվի ապրանքագրով",
        "Online credit": "Օնլայն ապառիկ",
        "Product:": "Ապրանք",
        Shipment: "Առաքում",
        "Bonus:": "Բոնուս",
        "Card code": "Քարտի կոդը",
        Confirm: "Հաստատել",
        "Order confirmation": "Պատվերի հաստատում",
        "Do you have a promotion?": "Դուք ունե՞ք պրոմոկոդ",
        "Promo code:": "Պրոմոկոդ",
        Activate: "Ակտիվացնել",
        "City:": "Քաղաք:",
        State: "Մարզ։",
        "Community:": "Համայնք",
        "Postal code:": "Փոստային կոդ",
        "Street, house, apartment": "Փողոց, տուն, բնակարան *",
        "Installment payment": "Ապառիկ վճարում",
        "Payment with bonuses": "Վճարում բոնուսներով",
        "PAY ON THE SPOT BY CASH OR Bank Card":
            "Վճարել տեղում կանխիկ կամ բանկային քարտով",
        "Delivery Regions": "Առաքում մարզեր",
        "Pick up in store": "Վերցնել խանութից",
        "Add an address": "Ավելացնել հասցե",
        "Fill in the data":
            "Լրացրեք ներքևում նշված դաշտը կամ նշեք այն տեղաշարժելով կարմիր կետը",
        "Show on map": "Ցույց տալ քարտեզի վրա",
        "City, region, community, address...": "Քաղաք, մարզ, համայնք, հասցե ...",
        "Delivery in Yerevan": "Առաքում Երևանում",
        Personal_information: "Անձնական տվյալներ",
        Honor_another_persons_data: "Պատվիել այլ անձի տվյալներով",
        Basket: "Զամբյուղ",
        Back_to_shopping: "Վերադառնալ գնումներին",
        sub_title_en: "Ենթավերնագիր En",
        sub_title_ru: "Ենթավերնագիր Ru",
        sub_title_hy: "Ենթավերնագիր  Hy",
        Not_Wishlist: "Նախընտրելի չէ",
        footer_baner: "Ներքևի բաներ",
        pay_by_receipt: "Բանկային փոխանցումով",
        receipt_info: "Կազմակերպության մասին տեղեկատվություն",
        legal_address: "Իրավաբանական հասցե",
        hvhh: "ՀՎՀՀ",
        corporate_name: "Ընկերության անվանումը",
        profile_page: "Անձնական տվյալներ",
        PAY_BY_invoice: "Վճարել հաշիվ ապրանքագրով",
        PAY_ON_THE_SPOT_BY_CASH_OR_Bank_Card_Policy:
            "• Կազմակերպության անվանումը << ՎիԷլՎի Սենթր >> ՍՊԸ<br />    • Իրավաբանական հասցե՝ ք. Երևան Գ. Նժդեհի 21<br />    • Գործ. հասցե՝ ք.Երևան Արշակունյանց 69/5<br />    • ՀՎՀՀ ՝ 02235463<br />    • Էլ. Փոստ՝ vlv_hashvapahutyun@mail.ru<br />    • Տնօրեն՝ Վաղինակ Հովհաննեսյան<br /><br />    • Բանկային տվյալներ՝ (Հ/հ )<br />    << Ինեկոբանկ ՓԲԸ >> 2050022129881001<br />    << ԱԿԲԱ-ԿՐԵԴԻՏ ԱԳՐԻԿՈԼ ԲԱՆԿ ԲԲԸ >> 220090125786000<br />    << ԱՐՑԱԽ ԲԱՆկ ՓԲԸ >> 22317003448000<br />    << ԷՎՈԿԱԲԱՆԿ ՓԲԸ >> 1660010863460100<br />    << ՀԱՅԷԿՈՆՈՄԲԱՆԿ ԲԲԸ >> 1636103950040100<br />    << ԿՈՆՎԵՐՍ ԲԱՆԿ ՓԲԸ >> 1930047229410100<br />    << ՅՈՒՆԻԲԱՆԿ ԲԲԸ >> 24137000146300<br />    << ԱՄԵՐԻԱԲԱՆԿ ՓԲԸ >> 1570018294390200<br />    << ՎՏԲ-ՀԱՅԱՍՏԱՆ ԲԱՆԿ ՓԲԸ >> 16046028825300<br />    << ԱՅԴԻ Բանկ ՓԲԸ >> 11815025411800",
        easy_pay: "Հեշտ վճարում",
        path: "Ճանապարհ",
        level: "Մակարդակ",
        photos1: "Նկար 1",
        photos2: "Նկար 2",
        photos3: "Նկար 3",
        photos_image_en: "Լուսանկար En",
        photos_image_ru: "Լուսանկար Ru",
        photos_image_hy: "Լուսանկար Hy",
        add_photos: "Ավելացնել նկարներ",
        photos: "Նկարներ",
        resumes: "Ինքնակենսագրական",
        success_resume: "Ձեր ինքնակենսագրականը հաջողությամբ ուղարկվել է",
        attach_cv: "Կցել ինքնակենսագրական",
        bonuses: "Բոնուսներ",
        virtual_products: "Վիրտուալ ապրանքներ",
        my_addresses: "Իմ հասցեները",
        add_addresses: "Ավելացնել հասցեներ",
        order_history: "Պատվերի պատմություն",
        personal_information: "Անձնական տվյալներ",
        logout: "Դուրս գալ",
        repeat_password: "Կրկնել գաղտնաբառը",
        not_favs: "Դուք չունեք նախընտրելի ապրանքներ",
        bonus_cartt: "Բոնուս քարտ",
        valid_until: "Ուժի մեջ է մինչև",
        my_address: "Իմ հասցեն",
        add_address: "Ավելացնել հասցե",
        notification_email: "Ուղարկել ծանուցում էլեկտրոնային փոստով",
        repeat: "Կրկնել",
        "Do you have a promo code?": "Ունե՞ք Պրոմոկոդ",
        "Promo code": "Պրոմոկոդ",
        add_bonus_cart: "Ավելացնել բոնուս քարտ",
        "Accumulated bonuses": "Կուտակված բոնուսներ",
        "Bonus points spent": "Օգտագործված բոնուսներ",
        Time: "Ժամ",
        delivery: "Առաքում",
        Orders: "Պատվերներ",
        discounts: "Զեղչեր",
        Community: "Համայնք",
        added_address: "Հասցեն հաջողությամբ ավելացվել է",
        updated_address: "Հասցեն հաջողությամբ թարմացվել է",
        Download: "Վերբեռնել",
        no_order_history: "Դուք չունեք կատարված պատվերներ։",
        no_virtual_product: "Դուք չունեք վիրտուալ ապրանքներ",
        Product: "Ապրանք",
        Bonus: "Բոնուս",
        repeat_order: "Կրկնել պատվերը",
        buy: "Գնել",
        create_product_date: "Ապրանքների վաճառքի ամսաթիվը",
        acba_score:
            'Ծանոթացել եմ  հարցման ազդեցությանը <b style="color:#D10000;text-decoration: underline;"> վարկային ամփոփ գնահատականի վրա </b>',
        thanks_for_subscribe: "Շնորհակալություն բաժանորդագրվելու համար",
        select_payment: "Ընտրեք վճարման տարբերակը",
        coupon_is_avilable: "Այս կուպոնը հասանելի չէ ընտրված ապրանքների համար",
        coupon_have_more_purchase:
            "Դուք ավելի շատ գնումներ ունեք այս կուպոնը ստանալու համար",
        coupon_already: "Այս կուպոն արդեն օգտագործված է",
        print_labels: "Տպել պիտակը",
        create_labels: "Ստեղծել պիտակ",
        coupon_expirad: "կուպոնը ժամկետանց է",
        invalid_coupon: "Անվավեր կուպոն",
        fill_coupon: "Լրացրեք կուպոնի վրաի թվեր",
        date_discount_start: "Զեղչի մեկնարկի ամսաթիվը",
        date_discount_end: "Զեղչի ավարտ",
        meta_keywords: "Meta հիմնաբառ",
        meta_title_en: "Meta անվանում անգլերենով",
        meta_description_en: "Meta նկարագրություն  անգլերենով",
        meta_title_ru: "Meta նկարագրություն ռուսերենով",
        meta_description_ru: "Meta նկարագրություն  ռուսերենով",
        meta_title_hy: "Meta նկարագրություն  հայերենով",
        meta_description_hy: "Meta նկարագրություն  հայերենով",
        read_agree_terms: "Ծանոթացել և համաձայն եմ պայմաններին",
        credit_text: "Ավելացնել տեքստ",
        i_have_read: "Համաձայն եմ պայմաններին",
        check_privacy: "Խնդրում ենք ստուգել այս մուտքագրումը",
        error_product: "Ընտրել ապրանք",
        error_date_start: "Ընտրել մեկնարկի ամսաթիվը",
        error_date_end: "Ընտրել ավարտի ամսաթիվը",
        meta_keywords_en: "Meta հիմնաբառեր անգլերենով",
        meta_keywords_ru: "Meta հիմնաբառեր ռուսերենով",
        meta_keywords_hy: "Meta հիմնաբառեր հայերենով",
        promo_price: "Պրոմո գին",
        rrp: "Առաջարկվող մանրածախ գին",
        comment_order: "Լրացուցիչ մեկնաբանությունները գրեք այստեղ",
        flat_room: "Լրացրեք բնակարան/ տուն / հարկ",
        copy_right:
            "© Հեղինակային իրավունքները պաշտպանված են <<ՎիէլՎի Սենթր>> ՍՊԸ, 2014-2023",
        cite_development: "Կայքը ստեղծվել է",
        inecobank: "INECOBANK",
        discounted_price: "Զեղչված գին",
        shipping_amount: "Առաքման գումար",
        shiping_state:
            "Դեպի ՀՀ մարզեր առաքման գումարը ճշտելու համար զանգահարել հետևյալ հեռախոսահամարով ՝ 091 767117",
        status_is_online: "Առցանց կարգավիճակ",
        status_is_online_active: "Կարգավիճակը ակտիվ է",
        status_is_online_inactive: "Կարգավիճակը չի գործում",
        json_markup: "Json Markup",
        excel_file: "Excel ֆայլ",
        to_learn_more_attr: "Տեսնել ավելին",
        add_json_markup: "Add JSON MarkUp",
        online_price_info: "Օնլայն գին",
        credit_info_product: "Ապառիկի պայմաններ",
        cred_info_prod_popup:
            "Ամսական վճարները և առավելագույն ժամկետը կարող են տարբերվել նշված գումարից տարբեր բանկերի դեպքում: Այս գումարների մեջ արդեն ներառված են սպասարկման վճարները և/կամ տոկոսագումարները։)",
        online_price_prod_popup:
            "Ապրանքի նկարը և տեխնիկական տվյալները կարող են տարբերվել այս էջում ներկայացված տվյալներից: Գինը նշված է Երևան, Աբովյան և Գյումրի քաղաքների սրահների համար։ Մյուս սրահներում՝ լոգիստիկ ծախսերից կախված, գները կարող են տարբերվել։",
        Account: "Հաշիվ",
        "Chart Of Accounts": "Հաշիվների աղյուսակ",
        "Bank Accounts": "Բանկային հաշիվներ",
        Incomes: "Եկամուտներ",
        Expenses: "Ծախսեր",
        "Parent Account": "Հիմնական հաշիվ",
        Name: "Անուն",
        Code: "Կոդ",
        Type: "Տեսակ",
        Description: "Նկարագրություն",
        "Default for": "Նախընտրելի է",
        Amount: "Գումար",
        "Transaction date": "Գործարքի ամսաթիվը",
        Profit: "Շահույթ",
        "From The Beginning": "Սկզբից",
        Balance: "Հաշվեկշիռ",
        "GST / TAX / VAT": "ԱԱՀ",
        "Opening Balance": "Բացման մնացորդը",
        "Main Income Account": "Հիմնական եկամտի հաշիվ",
        "Total Product Wise Tax": "Ընդհանուր ապրանքի հարկ",
        "Email address or phone": "Էլ. փոստի հասցե կամ հեռախոս",
        "Min. 8 Character": "Ամենաքիչը 8 նիշ",
        "Sign In": "Մուտք",
        "Sign Up": "Գրանցվել",
        "Don’t have an Account?": "Չունե՞ք հաշիվ",
        "Forgot Password?": "Մոռացել ե՞ք գաղտնաբառը",
        "Send link": "Ուղարկել հղումը",
        "Please send password link.": "Խնդրում ենք ուղարկել գաղտնաբառի հղումը:",
        "Welcome back": "Բարի վերադարձ",
        "Please confirm with new password.": "Խնդրում ենք հաստատել նոր գաղտնաբառը։",
        "Total Order": "Ընդհանուր պատվեր",
        "Product in Cart": "Ապրանքներ զամբյուղում",
        "Coupon Used": "Օգտագործված կուպոն",
        "Completed Order": "Կատարված պատվեր",
        "Low to high": "Ցածրից բարձր",
        "High to low": "Բարձրից ցածր",
        no_brand: "Ոչ մի ապրանքանիշ",
        free_shipping_note:
            "Այս ապրանքի համար հասանելի է անվճար առաքում առաքման ժամանակ",
        "Daily Deals": "Ամենօրյա գործարքներ",
        refresh: "Թարմացում",
        "Filter Products": "Ֆիլտրեր",
        "Seller Score": "Վաճառողի վարկանիշ",
        "Seller Information": "Տեղեկություններ վաճառողի մասին",
        "Choose pickup location": "Ընտրեք վերցնելու վայրը",
        "Email Delivery": "Էլեկտրոնային փոստով առաքում",
        "email delivery note":
            "Նվեր քարտը միշտ առաքվում է էլեկտրոնային փոստով: Առաքման արժեքը անվճար է: Նվեր քարտը վերադարձման ենթակա չէ:",
        "App link & others": "Հավելվածի հղում և այլ հղումներ",
        "Get it on": "Ձեռք բերել այն",
        "Google Play": "Google Play",
        "Apple Store": "Apple Store",
        "Out of stock": "Առկա չէ",
        "Recharge Amount": "Վերալիցքավորման գումար",
        "Add Coupons": "Ավելացնել կուպոններ",
        "Collected Coupons": "Հավաքված կուպոններ",
        "Shoping Cart": "Գնումների զամբյուղ",
        "Item’s selected": "Ապրանքը ընտրված է",
        "Variant images": "Նկարի տարբերակներ",
        "YOU CAN ALSO BUY": "Դուք կարող եք գնել նաև",
        "Buy Both": "Գնել երկուսը",
        "Customers who viewed this also viewed":
            "Հաճախորդներ ովքեր  նույնպես դիտել են սա",
        "Delivery Info": "Առաքման տեղեկատվություն",
        "Purchase History": "Գնումների պատմություն",
        "All History": "Ամբողջ պատմությունը",
        Received: "Ստացված",
        "Play store link": "Հղում դեպի Play store",
        "App store link": "Հղում դեպի App Store",
        "Sorting by": "Տեսակավորել ըստ",
        Login: "Մուտք",
        please_login: "Խնդրում ենք մուտք գործել ձեր հաշիվ",
        fill_info: "Լրացրեք Ձեր անձնական տվյալները",
        enter_log_pass: "Մուտքագրեք Ձեր անունը և գաղտնաբառը",
        mail: "Էլ․հասցե",
        phone_number: "Հեռախոսահամար",
        wrong_msg: "Էլ. փոստի հասցեն կամ գաղտնաբառը սխալ են",
        social_acc: "Մուտք գործեք սոցիալական ցանցի միջոցով",
        next: "Առաջ",
        check_email: "Ստուգեք Ձեր էլ. փոստը",
        reset_text_password:
            "Խնդրում եմ մուտքագրեք Ձեր էլեկտորանյին հասցեին ուղարկված վեցանիշ ծածկագիրը",
        we_send:
            "Շուտով դուք կստանաք մեկանգամյա օգտագործման կոդ, որն անհրաժեշտ է մուտքագրել դաշտում։",
        "Register Now": "Գրանցվել հիմա",
        themes: "Թեմաներ",
        header_pahes: "Վերևի մենյուի բաժին",
        live_preview: "Նախադիտել",
        theme_details: "Թեմայի մանրամասներ",
        current_theme: "Ընթացիկ թեմա",
        version: "Տարբերակ",
        "header.category": "Վերևի մենյուի բաժիններ",
        black: "Սև",
        scheme: "Մեխանիզմ",
        white: "Սպիտակ",
        solid: "Վստահելի",
        toastr_message_postion: "Toastr message postion",
        toastr_message_time: "Toastr message time",
        top_right: "Վերևի աջ կողմ",
        top_left: "Վերևի ձախ կողմ",
        bottom_right: "Ներքևի աջ կողմ",
        bottom_left: "Ներքևի ձախ կողմ",
        area: "Տարածք",
        feature: "Ֆիլտր",
        footer: "Էջատակ",
        navbar: "Navbar",
        menu: "Մենյու",
        color: "Գույն",
        scroll: "Ոլորել",
        add_new_color: "Ավելացնել նոր գույն",
        background: "Ետնապատկեր",
        border: "Սահման",
        base_color: "Հիմնական գույն",
        upload_title: "Վերբեռնել ֆայլը",
        browse_zip: "Վերբեռնել ZIP ֆայլը",
        "upload-theme": "Վերբեռնել ֆայլը",
        install_now: "Տեղադրել հիմա",
        input_background: "Տեղադրել հետևի պատկերը",
        theme: "Թեմա",
        header_setup: "Վերնագրի կարգավորում",
        column_size: "Սյունակի չափ",
        slider: "Սլայդեր",
        section_general_setting: "Բաժնի ընդհանուր կարգավորում",
        "1_column": "1 սյունակ",
        "2_column": "2 սյունակ",
        "3_column": "3 սյունակ",
        "4_column": "4 սյունակ",
        "5_column": "5 սյունակ",
        "6_column": "6 սյունակ",
        "7_column": "7 սյունակ",
        "8_column": "8 սյունակ",
        "9_column": "9 սյունակ",
        "10_column": "10 սյունակ",
        "11_column": "11 սյունակ",
        "12_column": "12 սյունակ",
        enable_this_section: "Ներառել այս բաժինը",
        slider_section_setup: "Սլայդերի տեղադրում",
        category_section_setup: "Բաժնի տեղադրում",
        product_section_setup: "Ապրանքի տեղադրում",
        new_user_zone_section_setup: "Նոր օգտատիրոջ բաժնի կարգավորում",
        name_required: "Պահանջվում է  անուն",
        url_required: "Պահանջվում է URL",
        category_required: "Պահանջվում է կատեգորիա",
        product_required: "Պահանջվում է ապրանք",
        slider_image_required: "Պահանջվում է սլայդի պատկեր",
        slider_image: "Սլայդ",
        no_categories: "Չկա կատեգորիա",
        no_sliders: "Չկա սլայդ",
        product_list: "Ապրանքների ցանկ",
        slider_list: "Սլայդերների ցանկ",
        upload_theme: "Վերբեռնել թեման",
        menus: "Մենյուներ",
        header: "Վերևի մենյու",
        appearance: "Արտաքին տեսք",
        slider_for: "Սլայդեր",
        warning_message: "Մենյուն արդեն օգտագործվում է, այն հեռացնել հնարավոր չէ։",
        url_is_required: "Պահանջվում է URL",
        slider_type_is_required: "Սլայդերի տեսակը պարտադիր է",
        navigation_label_is_required: "Պահանջվում է զգուշացնող պիտակ",
        title_is_required: "Պահանջվում է վերնագիր",
        priding_is_required: "Պահանջվում է գին",
        new_user_zone_is_required: "Պահանջվում է նոր օգտատերի  տարածք",
        for_product: "Ապրանքի համար",
        for_category: "Բաժնի համար",
        for_brand: "Արտադրողի համար",
        for_tag: "Թագի համար",
        color_mode: "Գունավոր ռեժիմ",
        for_url_not_support_in_mobile_app:
            "URL-ի համար (չի լինում բջջային հավելվածում)",
        gradient: "Թեքություն",
        hide_not_recomanded: "Խորհուրդ չի տրվում փակել",
        verify: "Հաստատել",
        headlist_setup: "Գլխավոր էջի կարգավորում",
        headlist: "Գլխավոր էջ",
        photos_section_setup: "Լուսանկարների բաժնի կարգավորում",
        photos_image_required: "Պահանջվում է նկար",
        photos_image: "Նկար",
        no_photos: "Առանց նկար",
        photos_for: "Նկարի համար",
        photos_type_is_required: "Նկարի տեսակը պարտադիր է",
        failed: "Այս հավատարմագրերը չեն համապատասխանում մեր գրառումներին:",
        password_auth: "Տրամադրված գաղտնաբառը սխալ է",
        throttle:
            "Չափից շատ մուտք գործելու փորձեր: Խնդրում ենք կրկին փորձել մի քանի րոպեից",
        logout_successfully: "Դուրս եկաք հաջողությամբ",
        logged_in_successfully: "Հաջողությամբ մուտք եք գործել",
        multi_vendor_system_is_temporary_disabled:
            "Համակարգը ժամանակավորապես անջատված է",
        please_verify_your_email: "Խնդրում ենք ստուգել ձեր էլ․փոստը",
        wait_for_approval: "Սպասեք հաստատմանը",
        google: "Google",
        client_id: "Հաճախորդի ID",
        client_secret: "Հաճախորդի գաղտնիքը",
        "See your growth and get consulting support!":
            "Կարող եք ստանալ մասնագետի խորհրդատվություն",
        "Sign up with Google": "Գրանցվեք Google-ով",
        "Sign up with Facebook": "Գրանցվեք Facebook-ով",
        "Sign up with Twitter": "Գրանցվեք Twitter-ով",
        "Sign up with LinkedIn": "Գրանցվեք LinkedIn-ով",
        "or Sign in with Email or Phone":
            "Կարող եք մուտք գործել էլ․փոստի-ի կամ հեռախոսահամարի օգնությամբ",
        "or Sign up with Email or Phone":
            "Կարող եք գրանցվել էլ․փոստի կամ հեռախոսահամարի օգնությամբ",
        "Already have an Account?": "Արդեն ունե՞ք հաշիվ",
        "New Account": "Նոր հաշիվ",
        "Select Default Account For": "Ընտրեք նախընտրելի հաշվի համար",
        "The requested bank account deleted successful":
            "Հարցվող բանկային հաշիվը հաջողությամբ ջնջվել է",
        "The requested bank account created successful":
            "Հարցվող բանկային հաշիվը հաջողությամբ ստեղծվել է",
        "The requested bank account updated successful":
            "Հարցվող բանկային հաշիվը հաջողությամբ թարմացվել է",
        "Bank Name": "Բանկի անուն",
        title: "Վերնագիր",
        "Branch Name": "Մասնաճյուղի անվանումը",
        "Account Name": "Հաշվի անվանում",
        "Account Number": "Հաշիվ",
        "You can\\'t delete an account which has child element":
            "Դուք չեք կարող ջնջել հաշիվը, որը ունի փոքր տարր",
        "The requested bank account is not found": "Որոնվող բանկի հաշիվը չի գտնվել",
        blog_category: "Բլոգի կատեգորիաներ",
        blog_tag: "Բլոգի թեգեր",
        blog: "Բլոգ",
        tag: "Թեգ",
        tags: "Թեգեր",
        post_list: "Ցանկ",
        add_new_post: "Ավելացնել",
        post_info: "Տեղեկատվություն",
        blog_list: "Բլոգերի ցանկ",
        author: "Հեղինակ",
        is_approved: "Հաստատված է",
        all_posts: "Տեսնել բոլորը",
        view_post: "Տեսնել հրապարակումը",
        published_at: "Հրապարակվա",
        suggested_tags: "Առաջարկվող թեգեր",
        parent_category: "Գլխավոր բաժին",
        close_comments: "Փակել մեկնաբանությունները",
        edit_post: "Խմբագրել",
        new_article: "Նոր հոդված",
        post_tag: "Թեգեր",
        short_description: "Կարճ նկարագրություն",
        post_article: "Հրապարակել հոդվածը",
        post: "Նյութ",
        add_new_blog: "Ավելացնել",
        blog_tags: "Բլոգի թեգեր",
        support: "Օգնություն",
        select_parent_category: "Ընտրել  հիմնական բաժինը",
        comments_create_successfully:
            "Մեկնաբանությունները հաջողությամբ ստեղծվել են",
        replay_create_successfully: "Պատասխանը հաջողությամբ ստեղծվել է",
        no_post_found: "Չի գտնվել հրապարակում",
        search_posts: "Փնտրել",
        post_successfully_approved: "Հրապարակումը հաջողությամբ հաստատվել է",
        this_post_is_already_approved: "Արդեն հաստատվել է",
        popular_posts: "Հայտնի նյութեր",
        instagram_feed: "Instagram նորություն",
        project: "Պրոյեկտ",
        love: "Հավանել",
        technology: "Տեխնոլոգիա",
        travel: "Ճանապարհորդել",
        restaurant: "Ռեստորան",
        design: "Դիզայն",
        illustration: "Նկարազարդում",
        for_post_a_new_comment_you_need_to_login_first:
            "Նոր մեկնաբանություն տեղադրելու համար նախ պետք է մուտք գործել",
        post_a_comment_now: "Տեղադրել մեկնաբանություն հիմա",
        post_comment: "Հրապարակման մեկնաբանություն",
        posts: "Հրապարակում",
        comments: "Մեկնաբանություններ",
        "Select your Expense Account": "Ընտրեք ձեր ծախսային հաշիվը",
        "Add As A Parent Account": "Ավելացնել որպես գլխավոր հաշիվ",
        "Parent account selection will add your account as a sub account":
            "ՀԻմնական հաշվի ընտրությունը կավելացնի ձեր հաշիվը որպես ենթահաշիվ",
        "Select your Income Account": "Ընտրեք ձեր եկամտի հաշիվը",
        "Account code need to be unique, Leave blank for auto generate an unique account code":
            "Հաշվի կոդը պետք է լինի եզակի, թողեք դատարկ, որպեսզի ավտոմատ ստեղծվի եզակի հաշվի կոդ",
        "Selecting a default Account, will remove previously default account for selected item":
            "Ընտրելով նախըտրելի հաշիվ, կհեռացվի նախկին նախընտրելի հաշիվը ընտրված ապրանքի համար",
        "The requested chart of account is not found":
            "Պահանջվող հաշվային պլանը չի գտնվել",
        "The requested chart of account deleted successful":
            "Պահանջվող հաշվային պլանը հաջողությամբ ջնջվեց",
        "The requested chart of account created successful":
            "Պահանջվող հաշվային պլանը հաջողությամբ ստեղծվեց",
        "Income Account": "Եկամուտի հաշիվ",
        "Expense Account": "Ծախսային հաշիվ",
        "Select Account": "Ընտրել հաշիվ",
        "Payment Method": "Վճարման տարբերակ",
        "Select your Payment method": "Ընտրեք վճարման Ձեր տարբերակը",
        "Edit Account": "Խմբագրել հաշիվը",
        "The requested chart of account updated successful":
            "Պահանջվող հաշիվը հաջողությամբ թարմացվել է",
        contact_mail: "Կոնտակտային էլ․հասցե",
        contact_mail_list: "Կոնտակտային էլ․հասցե-ի ցանկ",
        contact_request: "Կոնտակտային հարցում",
        secret_code: "Գաղտնի կոդ",
        is_used: "Օգտագործվում է",
        purchase_list: "Գնումների ցանկ",
        to_pay: "Վճարել",
        to_ship: "Առաքել",
        to_recieve: "Ստանալ",
        money_has_been_transfered_into_wallet: "Գումարը փոխանցվել է դրամապանակին",
        purchased_digital_products: "Գնված թվային ապրանք",
        coupon_value: "կուպոնի արժեքը",
        store_name: "Խանութի անվանումը",
        validity: "Վավերականություն",
        customer_panel: "Հաճախորդների հատված",
        my_purchases: "Իմ գնումները",
        my_wishlist: "Իմ նախնտրած ապրանքնր",
        refund_dispute: "Գումարի վերադարձ",
        my_coupon: "Իմ կուպոնը",
        my_account: "Իմ հաշիվը",
        my_profile: "Իմ անձնական էջը",
        my_ticket: "Իմ տոմսը",
        digital_product: "Թվային ապրանք",
        my_referral_code: "Իմ ուղղորդման կոդը",
        you_will_get_referral_code_soon: "Դուք շուտով կստանաք ուղղորդման կոդը",
        my_wallet_recharge: "Իմ դրամապանակի վերալիցքավորում",
        customer_profile: "Հաճախորդի անձնական էջ",
        address_already_used_for_shipping_or_billing_address:
            "Հասցեն արդեն օգտագործվել է առաքման ժամանակ",
        address_already_set_for_default_shipping_or_billing_change_first:
            "Հասցեն արդեն սահմանված է նախընտրելի առաքման կամ վճարման համար: Նախ փոխեք այն:",
        my_referral: "Իմ ուղեգիրը",
        quick_summary: "Արագ ամփոփում",
        seller_dashboard: "Վաճառողի կառավարման վահանակ",
        today: "Այսօր",
        this_week: "Այս շաբաթ",
        this_year: "Այս տարի",
        this_month: "Այս ամիս",
        total_seller: "Ընդհանուր վաճառող",
        total_customer: "Ընդհանուր հաճախորդ",
        total_customers: "Ընդհանուր հաճախորդներ",
        total_pending_order: "Սպասող պատվեր",
        total_completed_order: "Ավարտված պատվեր",
        total_review: "Ընդհանուր կարծիք",
        today_revenue: "Այսօրվա եկամուտ",
        active_customers: "Ակտիվ հաճախորդներ",
        total_subscriber: "Ընդհանուր բաժանորդ",
        today_sale_revenue: "Այսօրվա վաճառքի եկամուտ",
        sellers: "Վաճառողներ",
        today_order_summary: "Այսօրվա պատվերների ամփոփում",
        orders_summary: "Պատվերների ամփոփում",
        guest_authorized_order_today: "Լիազորված պատվեր այսօրվա",
        site_analytics: "Կայքի վերլուծություն",
        total_visitor: "Ընդհանուր այցելուների թիվ",
        total_page_views: "Էջի դիտումների ընդհանուր թիվը",
        new_visitors: "Նոր այցելուներ",
        old_visitors: "Հին այցելուներ",
        total_in_sessions: "Ընդհանուր աշխատաշրջան",
        top_10_product: "Թոփ 10 ապրանք",
        top_10_seller: "Թոփ 10 վաճառող",
        category_wise_product_qty: "Կատեգորիայի ապրանքների քանակ",
        category_wise_product_sale: "Կատեգորայի ապրանքի վաճառք",
        coupon_wise_sale: "կուպոնի վաճառք",
        new_customers: "Նոր հաճախորդներ",
        recently_added_products: "Նոր ավելացրած ապրանքներ",
        top_refferers: "Լավագույն հղումներ",
        latest_order: "Վերջին պատվերը",
        latest_search_keyword: "Վերջին որոնման հիմնաբառը",
        appealed_disputed: "Բողոքարկված,վիճարկված",
        top_customers: "Լավագույն հաճախորդներ",
        top_sellers: "Լավագույն վաճառողներ",
        recent_reviews: "Նոր կարծիքներ",
        seller_reviews: "Կարծիքներ վաճառքի մասին",
        dashboard_setup: "Կառավարման վահանակի  կարգավորում",
        make_widget_card_colorful: "Քարտը գունեղ դարձնել",
        normal: "Նորմալ",
        reverse: "Հակադարձ",
        make_visible_in_dashboard: "Դարձրեք տեսանելի կառավարման վահանակում",
        visible: "Տեսանելի",
        shop_link: "Խանութի հղում",
        total_delivered_order: "Ընդհանուր առաքված պատվեր",
        total_non_delivered_order: "Ընդհանուր չառաքված պատվեր",
        shop_review: "Կարծիքներ խանութ սրահի մասին",
        total_product_refund: "Ընդհանուր ապրանքի  փոխհատուցում",
        total_order_summary: "Ընդհանուր պատվերի ամփոփում",
        total_sale_summary: "Ընդհանուր վաճառքի ամփոփում",
        sale_vs_refund: "Վաճառք/Վերադարձ",
        top_sale_products: "Լավագույն վաճառված ապրանքներ",
        latest_uploaded_products: "Վերջին ստացված ապրանքները",
        latest_refund_request: "Վերջին վերադարձի հայտ",
        "become a merchant": "Դարձիր գործընկեր",
        search_resalt: "Որոնման արդյունքներ",
        currency: "Արժույթ",
        yearly: "Տարեկան",
        "best value": "Լավագույն արժեք",
        "per month": "Ամսական",
        "per year": "Տարեկան",
        "transaction charge": "Գործարքի վճար",
        mark_all_as_read: "Նշել բոլորը ընթերցված",
        "commission rate": "Հանձնաժողովի դրույքաչափ",
        "choose plan": "Ընտրեք պլանը",
        send_message: "Ուղարկել նամակ",
        email_address: "Էլ․ փոստի հասցե",
        message: "Հաղորդագրություն",
        inquery_type: "Հարցման տեսակ",
        enter_email_address: "Էլ․ հասցե",
        subscribe: "Բաժանորդագրվել",
        enter_name: "Անուն",
        write_messages: "Գրել հաղորդագրյուն",
        shipping: "Առաքում",
        billing: "Բիլինգ",
        select_from_options: "Ընտրեք կարգավորումներից",
        shippied_by: "Առաքվել է",
        delivery_option: "Առաքման տարբերակ",
        addtional_shipping_charge: "Լրացուցիչ առաքման վճար",
        Est_arrival_date: "Կանխատեսված ժամանման ամսաթիվ",
        Est_arrival_time: "Կանխատեսված  ժամանման ժամանակ",
        bill_to_the_same_address: "Հաշիվ նույն հասցեով",
        add_coupon: "Ավելացնել կուպոն",
        coupon_store_successfully: "Կուպոնները պահեստավորվել են հաջողությամբ",
        coupon_code_in_required: "Կուպոնի կոդը պարտադիր է",
        order_date: "Պատվերի ամսաթիվը",
        order_amount: "Պատվերի գումարը",
        sold_by: "Վաճառված ըստ",
        view_more: "Տեսնել ավելին",
        package_code: "Փաթեթի կոդը",
        store: "Պահեստ",
        confirm_receive_items: "Հաստատեք ապրանքների ստացումը",
        open_dispute: "Բաց բանավեճ",
        cancel_order: "Չեղարկել պատվերը",
        order_cancelled: "Պատվերը չեղարկված է",
        write_a_review: "Գրեք կարծիք",
        shipping_info: "Առաքման տեղեկատվություն",
        total_summary: "Ընդհանուր արժեք",
        paid_by: "Վճարված է",
        payment_info: "Վճարման տեղեկատվություն",
        payment_status: "Վճարման կարգավիճակ",
        order_has_been_recieved: "Պատվերը ստացվել է",
        order_not_recieved: "Պատվերը չի ստացվել",
        order_has_been_cancelled: "Պատվերը չեղարկվել է",
        order_cancellation_has_failed: "Պատվերի չեղարկումը ձախողվեց:",
        download_invoice: "Ներբեռնեք հաշիվ-ապրանքագիր",
        add_invoice: "Ավելացրեք հաշիվ-ապրանքագիր",
        order_details: "Պատվերի մանրամասները",
        contact_seller: "Կապվեք վաճառողի հետ",
        copy_code: "Պատճենել կոդը",
        user_list: "Օգտագործողների ցանկ",
        discount_amount: "Զեղչված գումար",
        already_use: "Արդեն օգտագործում եմ",
        not_used: "Օգտագործված չէ",
        you_will_get_referral_after:
            "Դուք կստանաք ուղղորման կոդը առաջին գնումից հետո",
        code_copied_successfully: "Կոդը հաջողությամբ պատճենվել է",
        wishlist: "Նախընտրած ապրանքնրի ցանկ",
        review: "Կարծիք",
        unlimited: "Անսահմանափակ",
        availability: "Հասանելիություն",
        condition: "Պայման",
        add_to_wishlist: "Ավելացնել նախընտրածների ցանկին",
        share_on: "Կիսվել",
        seller_info: "Վաճառողի տեղեկություններ",
        reviews: "Կարծիքներ",
        product_description: "Ապրանքի նկարագրությունը",
        product_specifications: "Ապրանքի բնութագիրը",
        product_reviews: "Ապրանքի մասին կարծիքներ",
        related_products: "Նմանատիպ ապրանքներ",
        no_stock_found_for_this_seller: "Այս ապրանքը չունի մնացորդ",
        maximum_quantity_limit_is: "Առավելագույն քանակի սահմանաչափն է",
        minimum_quantity_Limit_is: "Նվազագույն քանակի սահմանաչափն է",
        no_more_stock: "Մնացորդ առկա չէ",
        product_already_in_wishList:
            "Ապրանքն արդեն ընախընտրած ապրանքների ցանկում է",
        product_delete_in_wishList:
            "Ապրանքը հեռացված է նախընտրված ապրանքների ցանկից",
        thanks: "Շնորհակալություն",
        successfully_added_to_wishlist:
            "Հաջողությամբ ավելացվել է նախընտրված ապրանքների ցանկին",
        product_successfully_deleted_from_cart: "Ապրանքը հաջողությամբ ջնջվեց",
        adding: "Ավելացված է",
        product_successfully_added_to_cart:
            "Ապրանքը հաջողությամբ ավելացվել է զամբյուղ",
        subscribe_successfully: "Բաժանորդագրվեցիք հաջողությամբ",
        wishlist_product: "Նախընտրելի ապրանքներ",
        showing: "Ցուցադրվում է",
        out_of_total: "Ընդհանուրից",
        low_to_high: "Ցածրից բարձր",
        high_to_low: "Բարձրից ցածր",
        no_product_in_wishlist: "Նախընտրելիների ցանկում ապրանք չկա",
        no_products: "Ապրանք չկա",
        member_since: "Անդամ եք սկսած",
        related_category: "Նմանատիպ կատեգորիա",
        deal_ends_in: "Գործարքն ավարտվում է",
        deal_starts_in: "Գործարքն սկսվում է",
        deal_ends: "Գործարքն ավարտվեց",
        hi_welcome_to: "Ողջույն, բարի գալուստ",
        orders_over: "Պատվերներն ավարտված են",
        get_now: "Ստացեք հիմա",
        time_to_shop: "Ժամանակն է գնումներ կատարելու",
        place_a_refund_request: "Գումարի վերադարձի հարցում",
        additional_information: "Լրացուցիչ տեղեկություն",
        optional: "Հավելյալ",
        set_prefered_option: "Սահմանեք նախընտրելի տարբերակը",
        bank_transfer: "Բանկային փոխանցում",
        bank_information_to_recieve_money:
            "Բանկային տեղեկատվություն գումար ստանալու համար",
        set_shipment_option: "Սահմանեք առաքման տարբերակը",
        please_select_pick_up_courier_you_prefer:
            "Խնդրում ենք ընտրել ձեր նախընտրած առաքիչին",
        Pickup_address: "Վերցնելու հասցե",
        drop_off_your_return_item_at_a_nearby_courier_office:
            "Թողեք Ձեր վերադարձի ապրանքը մոտակա առաքման գրասենյակում:",
        courier_address: "Առաքման գրասենյակ",
        request_sent_date:
            "17 / 5 000 Թարգմանության արդյունքներ Թարգմանություն Հարցում ուղարկելու ամսաթիվը",
        drop_off_info: "Դուրս գրման  ինֆորմացիա",
        refunds: "Վերադարձներ",
        view_details: "Դիտել մանրամասները",
        tax_amount: "Հարկի չափը",
        message_sent_successfully:
            "Հաղորդագրությունը հաջողությամբ ուղարկվել է:Շնորհակալություն",
        question_chat_with_us: "Ունեք հարց? Զրուցեք մեզ հետ",
        welcome_back: "Բարի վերադարձ",
        please_login_to_your_account: "Խնդրում ենք մուտք գործել Ձեռ անձնական էջ",
        minimum_8: "Նվազագույն 8 նիշ",
        by_signing_up_you_agree_to_terms_of_service_and_privacy_policy:
            "Գրանցվելով՝ դուք համաձայնում եք ծառայության պայմաններին և գաղտնիության քաղաքականությանը",
        register: "Գրանցում",
        login_account: "Մուտք գործեք հաշիվ",
        already_a_member_yet: "Արդեն անդամ եք",
        please_confirm_with_new_password: "Խնդրում ենք հաստատել նոր գաղտնաբառով",
        save_change: "Պահպանել",
        track_your_order: "Հետևեք Ձեր պատվերին",
        sign_up: "Գրանցվել",
        login: "Մուտք գործել",
        log_out: "Դուրս գալ",
        continue_shopping: "Շարունակել գնումներ կատարել",
        view_shopping_cart: "Դիտել գնումների զամբյուղը",
        all_categories: "Բոլոր կատեգորիաներ",
        best_deals: "Լավագույն գործարքներ",
        new_user_zone: "Նոր օգտատիրոջ գոտի",
        search_your_item: "Փնտրիր որ գտնես",
        email_or_phone: "Էլ. փոստ կամ հեռախոսահամր",
        remember_me: "Հիշել ինձ",
        forgot_password: "Մեռացել եք գաղտնաբառը",
        login_with: "Մուտք գործել",
        want_to_be_a_new_merchant: "Ցանկանում եմ լինել նոր գործընկեր",
        create_account: "Ստեղծել հաշիվ",
        please_input_new_password: "Խնդրում ենք մուտքագրել նոր գաղտնաբառ:",
        send_link: "Ուղարկել հղումը",
        please_send_password_link: "Խնդրում ենք ուղարկել գաղտնաբառի հղումը",
        please_create_your_account: "Խնդրում ենք ստեղծել Ձեր հաշիվը",
        contact_form: "Կոնտակտային ձև",
        contact_message: "Կոնտակտային հաղորդագրություն",
        maximum_quantity_limit_exceed:
            "Առավելագույն քանակի սահմանաչափը գերազանցում է",
        no_more_stock_available: "Չկա մնացորդ",
        please_select_product_first: "Խնդրում ենք սկզբում ընտրել ապրանքը",
        this_is_undefined: "Սա անորոշ է",
        your_cart_is_empty_please_select_item_s_before_checkout_also_add_address_first:
            "Ձեր զամբյուղը դատարկ է: Խնդրում ենք ընտրել ապրանքները նախքան վճարումը: Ավելացրեք նաև հասցեն",
        wallet_balance_is_not_enough_to_pay_for_this_order:
            "Դրամապանակի մնացորդը բավարար չէ այս պատվերի համար վճարելու համար",
        your_cart_is_empty_please_select_item_s_before_checkout:
            "Զամբյուղը դատարկ է:",
        coupon_applied_successfully: "կուպոնը հաջողությամբ կիրառվեց",
        coupon_field_is_required: "կուպոնի դաշտը պարտադիր է",
        coupon_deleted_successfully: "կուպոնը հաջողությամբ ջնջվեց",
        product_compare: "Ապրանքի համեմատություն",
        click_here_to_request_another: "Սեղմեք ասյտեղ ՝ մեկ այլը պահանջելու համար",
        from_the_same_store: "Նույն խանութից",
        and_up: "և վեր",
        team_member: "Թիմակից",
        choose_plan: "Ընտրել պլան",
        track: "Հետագիծ",
        no_stock_found_for_this_vendor: "Այս վաճառողի համար ոչինչ չի գտնվել",
        maximum_6_image_can_upload: "Հնարավոր է վերբեռնել առավելագույնը 6 պատկեր",
        write_review: "Թողնել կարծիք",
        focus_only_on_the_product_and_its_features:
            "Միայն կենտրոնացեք ապրանքի եւ դրա ֆիլտրների վրա",
        please_share_your_feedback_about_the_product:
            "Խնդրում ենք կիսվել ապրանքի վերաբերյալ ձեր կարծիքներով:",
        how_over_all_experience_with_seller:
            "Որքա՞ն է ընդհանուր փորձը վաճառողի հետ:",
        rate_and_review_your_seller: "Գնահատեք և թողեք Ձեր կարծիքը վաճառողի մասին",
        review_details: "Կարծիքների մասին մանրամասներ",
        anonymous: "Անանուն",
        recently_viewed_items: "RՆոր դիտված ապրանքներ",
        wholesale: "Պահեստ",
        enter_your_order_tracking_number_and_your_secret_id:
            "Մուտքագրեք ձեր պատվերի հետևման համարը և ձեր գաղտնի ID-ն",
        order_tracking_number: "Պատվերի հետեւման համար",
        secret_id_only_for_guest_user:
            "Գաղտնի ID (միայն հյուրընկալվող օգտագործողի համար)",
        phone_used_for_billing: "Հեռախոսահամար (օգտագործվում է վճարումների համար)",
        important: "Կարևոր է",
        maximum_6_images_can_be_uploaded: "Կարելի է վերբեռնել առավելագույնը ւ նկար",
        image_size_can_be_maximum_5mb:
            "Նկարի առավելագույն չափսը կարող է լինել 5 մեգաբայթ",
        delivered_on: "Առաքվել է",
        rate_and_review_purchased_product:
            "Գնահատեք գնված ապրանքը և թողնեք Ձեր   կարծիք",
        review_detail: "Կարծիքի վերաբերյալ կարգավոորումներ",
        how_to_write_a_good_review: "Ինչպես գրել լավ ակնարկ",
        price_range: "Գնային միջակայք",
        refresh_filters: "Թարմացնել ֆիլտրերը",
        rating: "Վարկանիշ",
        product_removed_from_compare_list_successfully:
            "Ապրանքը հաջողությամբ հեռացվեց համեմատության ցանկից",
        compare_reset_successfully: "Համեմատումը հաջողությամբ կատարվել է",
        please_login_first: "Կխնդրեմ նախ մուտք գործել",
        verify_your_email: "Ստուգեք Ձեր էլ. հասցեն",
        before_proceeding_please_check_your_email_for_a_varification_link_if_you_din_not_get_the_email:
            "Նախքան շարուկելը ստուգեք Ձեր  Էլ. փոստը հաստատման հղումը ստանալու համար: Եթե չեք ստացել նամակը",
        thank_you_for_your_purchase: "Շնորհակալություն, Ձեր պատվերը ընդունված է",
        your_order_number_is: "Ձեր պատվերի համարն է",
        your_delivery_dates: "Ձեր առաքման օրեր",
        for_more_details_track_your_delivery_status_order:
            "Լրացուցիչ մանրամասների համար հետևեք Ձեր պատվերի առաքման կարգավիճակին",
        we_have_a_confirmation_email_to: "Մենք ունենք հաստատման հաղորդագրություն",
        with_the_order_details: "Պատվերի մանրամասներով",
        create_your_merchant_account: "Ստեղծել գորընկերոջ հաշիվ",
        subscription_type: "Բաժանորդագրության տեսակ",
        select_all: "Ընտրել բոլորը",
        cart_is_empty: "Զամբյուղը դատարկ է",
        reset_compare: "Ստեղծել համեմատություն",
        compare_list_is_empty: "Համեմատության ցանկը դատարկ է",
        no_gift_card_found: "Ոչ մի նվեր քարտ գտնված չէ",
        no_review_found: "Ոչ մի կարծիք գտնված չէ",
        child_category: "Ենթակատեգորիա",
        product_not_added: "Ապրանքը չի ավելացել",
        product_added_to_compare_list_successfully:
            "Ապրանքը հաջողությամբ ավելացել է համեմատության ցանկ",
        not_added: "Չի ավելացել",
        no_product_found: "Ոչ մի ապրանք  չի գտնվել",
        billing_address_is_not_as_same_as_shipping_address:
            "Վճարման հասցեն նույնը չէ, ինչ առաքման հասցեն",
        this_page: "Այս էջը",
        add_to_compare: "Ավելացնել համեմատելու համար",
        page_expired: "Էջը ժամկետանց է",
        forbidden: "Արգելված",
        sorry_you_are_forbidden_from_accessing_this_page:
            "Ցավոք, ձեզ արգելված է մուտք գործել այս էջ",
        whoops_something_went_wrong_on_our_servers:
            "Ինչ-որ բան սխալ է մեր սերվերներում",
        maximum_image_6_image_can_upload: "Առավելագույնը կարելի է վերբեռնել 6 նկար",
        package_wise_shipping_charge: "Փաթեթի առաքման վճար",
        proceed_to_checkout: "Անցեք վճարման",
        name_a_to_z: "Անուն` Ա-ից Ֆ",
        name_z_to_a: "Անուն` Ֆ-ից Ա",
        price_low_to_high: "Գին` ցածրից բարձր",
        price_high_to_low: "Գին՝ բաձրից ցածր",
        "401_unauthorized": "401 | Unauthorized",
        sorry_you_are_not_authorized_to_access_this_page:
            "Ցավոք, Դուք լիազորված չեք մուտք գործել այս էջ:",
        go_home: "Գնալ դեպի գլխավոր էջ",
        go_back: "Վերադառնալ",
        sorry_page_not_found: "Ցավոք! Էջը չի գտնվել",
        sorry_the_page_you_are_looking_for_could_not_be_found:
            "Ցավոք, Ձեր որոնած էջը չի գտնվել:",
        sorry_your_session_has_expired_please_refresh_and_try_again:
            "Ցավոք ձեր աշխատաշրջանը սպառվել է, խնդրում ենք թարմացնել և նորից փորձել",
        too_many_requests: "Չափից շատ հարցումներ",
        sorry_you_are_making_too_many_requests_to_our_servers:
            "Ցավոք, դուք չափազանց շատ հարցումներ եք կատարել",
        service_unavailable: "Ծառայությունը հասանելի չէ",
        sorry_we_are_doing_some_maintenance_please_check_back_soon:
            "Ներեցեք, մենք տեխնիկական սպասարկում ենք իրականացնում։ Խնդրում ենք փորձել մի փոքր ուշ",
        compare: "Համեմատել",
        please_product_select_from_cart_first: "Ընտրեք զամբյուղից ապրանքը",
        out_of_stock: "Առկա չէ",
        new_member: "Նոր անդամ ե՞ք",
        "I agree with the terms and conditions":
            "Ես համաձայն եմ պայմաններին և դրույթներին",
        process_to_payment: "Վճարման գործընթաց",
        add_fund: "Ավելացնել գումար",
        calculated_at_next_step: "Հաշվարկված է հաջորդ էջում",
        click_here_to_login: "Սեղմեք այստեղ մուտք գործելու համար",
        returning_customer: "Հին հաճախորդ",
        contact_information: "Կոնտակտային տվյալներ",
        email_me_with_news_and_offers:
            "Ուղարկել իմ էլ հասցեին նորություններն ու առաջարկները",
        address_list: "Հասցեների ցանկ",
        new_address: "Նոր հասցե",
        continue_to_shipping: "Շարունակել առաքումը",
        continue_to_payment: "Շարունակել վճարումը",
        return_to_cart: "Return To Cart",
        return_to_shipping: "Վերադառնալ առաքման էջ",
        return_to_information: "Վերադառնալ ինֆորմացիոն էջ",
        ship_to: "Առաքել",
        all_transactions_are_secure_and_encrypted:
            "Բոլոր գործարքները ապահով են և կոդավորված",
        same_as_shipping_address: "Նույնն է ինչ առաքման հասցեն",
        use_a_different_billing_address: "Օգտագործեք վճարման այլ հասցե",
        minimum_quantity_limit_exceed:
            "Նվազագույն քանակի սահմանաչափը գերազանցվել է:",
        select_shipping: "Ընտրել առաքում",
        email_verify: "Հաստատել էլ. հասցեն",
        customer_information: "Հաճախորդի մասին  ինֆորմացիա",
        billing_shipping_info: "Վճարման և առաքման ինֆորմացիա",
        processing: "Խմբագրում է",
        but_it_now: "Գնել հիմա",
        Expense: "Ծախս",
        "New Expense": "Նար ծախս",
        "Edit Expense": "Խմբագրել ծախսը",
        "The requested expense is not found": "Պահանջվող ծախսը չի գտնվել",
        "The requested expense deleted successful":
            "Պահանջվող ծախսը հաջողությամբ ջնջվել է",
        "The requested expense created successful":
            "Պահանջվող ծախսը հաջողությամբ ստեղծվել է",
        "The requested expense updated successful":
            "Պահանջվող ծախսը հաջողությամբ թարմացվել է",
        form_builder: "Ձևանմուշ",
        forms: "Նմուշներ",
        terms_page_link: "Պայմանների էջի հղում",
        privacy_policy_page_link: "Գաղտնիության քաղաքականության էջի հղում",
        form: "Նմուշ",
        no_data: "Տվյալներ չեն գտնվել",
        about_us_contant: "Մեր մասին տվյալներ",
        frontend_cms: "Frontend CMS",
        "main-title": "Գլխավոր վերնագիր",
        shop_address: "Խանութ սրահի հասցե",
        create_shop_address: "Ստեղծել խանու սրահի հասցե",
        "home_page.working_info": "Վեբ կայքի աշխատանքային ինֆորմացիա",
        "home_page.working_info_list": "Վեբ կայքի աշխատանքային ինֆորմացիայի ցանկ",
        benifit_title: "Առավելության անվանում",
        selling_title: "Վաճառքի վերնագիր",
        main_details: "Հիմնական մանրամասներ",
        selling_details: "Վաճառքի մանրամասներ",
        Link: "Հղում",
        features: "Ֆիլտրներ",
        benefit_list: "Առավելությունների ցանկ",
        update_benefit: "Թարմացնել առավելությունները",
        "career list": "Աշխատատեղերի ցանկ",
        "update career": "Թարմացնել աշխատատեղերը",
        "career content": "Աշխատատեղերի կոնտենտ",
        contact_us_contant: "Հետադարձ կապ կոնտենտ",
        feature_list: "Ֆիլտրների ցանկ",
        new_feature: "Նոր ֆիլտր",
        merchant_content: "Գործընկերոջ կոնտենտ",
        "benifit title": "Առավելության անվանում",
        pricing_slogan: "Գնի կարգախոս",
        pricing: "Գին",
        how_it_work_title: "Ինչպես է աշխատում վերնագիր",
        pricing_title: "Գնի վերնագիր",
        pricing_list: "Գնիցանկ",
        faq_title: "Faq Title",
        query_title: "Հարցման վերնագիր",
        benefits_details: "Առավելությունների մանրամասները",
        pricing_details: "Գնային մանրամասներ",
        how_it_work_details: "Ինչպես է այն աշխատում, Մանրամասներ",
        query_details: "Հարցման մանրամասներ",
        faq_details: "Faq Մանրամասներ",
        benefit: "Առավելություն",
        how_it_work: "Ինչպես է այն աշխատում",
        "benefit list": "Առավելությունների ցանկ",
        how_it_work_list: "Ինչպես է այն աշխատում ցանկ",
        faq_list: "Faq ցանկ",
        faq_update: "Faq թարմացում",
        position: "Վիճակ",
        left: "Ձախ",
        right: "Աջ",
        "policy list": "Քաղաքականության ցանկ",
        "edit policy": "Խմբագրել քաղաքականություն",
        "pricing update": "Գների թարմացում",
        pricing_plan: "Գնային փոփոխություն",
        add_pricing_plan: "Ավելացնել գնային փոփոխություն",
        edit_pricing_plan: "Խմբագրել գնային փոփոխությունը",
        "pricing list": "Գների ցանկ",
        "show pricing": "Ցւյց տալ գները",
        monthly_cost: "Ամսավճար",
        yearly_cost: "Տարեկան վճար",
        transaction_fee: "Գործարքի վճար",
        best_for: "Լավագույբը",
        pricing_type: "Գնի տեսակ",
        team_size: "Team Size",
        stock_limit: "Մնացորդի սահմանաչափ",
        commission: "Միջնորդավճար",
        "return list": "Վերադարձի/փոխանակման ցանկ",
        "update title": "Թարմացնել վերադարձը/փոխանակումը",
        page_list: "Էջերի ցանկ",
        dynamic_page: "Դինամիկ էջ",
        create_dynamic_page: "Ստեղծել դինամիկ էջ",
        update_dynamic_page: "Թարմացնել դինամիկ էջ",
        subscribe_content: "Բաժանորդագրման կոնտենտ",
        term_list: "Ժամկետների և պայմանների ցանկ",
        "working process list": "Աշխատանքային գործընթացների ցանկ",
        update_working_process: "Թարմացնել աշխատանքային գորշընթացը",
        add_link: "Ավելացնել հղում",
        edit_link: "Խմբագրել հղումը",
        page_name: "Էջի անվանում",
        select_page: "Ընտրել էջ",
        copyright_text: "Հեղինակային իրավունքի տեքստ",
        about_text: "Տեքստի մասին",
        section_name: "Բաժնի անվանում",
        about_description: "Նկարագրության մասին",
        add_new_page: "Ստեղծել նոր էջ",
        widget_title: "Վիդջեթ վերնագիր",
        add_InQuery: "Ավելացնել հարցում",
        edit_InQuery: "Ստեղծել հարցում",
        "return&exchange": "Վերադարձ և փոխանակում",
        exchange_details: "Փոխանակման մանրամասներ",
        return_title: "Վերդարձի անվանում",
        return_details: "Մանրամասներ վերադարձի մասին",
        inquery_list: "Հարցումների ցանկ",
        footer_settings: "Էջատակի կարգավորումներ",
        frontendCMS: "Կայքի արտաքին CMS",
        "benifit-title": "Առավելության վերնագիր",
        benifits_details: "Առավելությունների մանրամասներ",
        price_monthly: "Ամսավճար",
        home_page: "Գլխավոր էջ",
        category_products: "Ապրանքի կատեգորիա",
        latest_products: "Վերջին ապրանքներ",
        recently_viewed_products: "Նոր ցուցադրված ապրանքներ",
        max_sale: "Առավելագույն վաճառք",
        max_review: "Առավելագույն կարծիքների քանակ",
        custom_products: "Հաճախորդի ապրանքներ",
        top_category: "Լավագույն կատեգորիա",
        latest_category: "Վերջին կատեգորիա",
        new_category: "Նոր կատեգորիա",
        custom_category: "Հաճախորդի կատեգորիա",
        top_brands: "Թոփ ապրանքանիշներ",
        latest_brands: "Վերջին ապրանքանիշ",
        new_brands: "Նոր ապրանքանիշներ",
        custom_brands: "Հաճախորդի ապրանքանիշներ",
        add_feature: "Ավելացնել ֆիլտր",
        edit_feature: "Խմբագրել ֆիլտրը",
        Inquery: "Հարցում",
        individuals: "Անհատներ",
        business: "Բիզնես",
        professional: "Պրոֆեսիոնալ",
        widget: "Վիդջեթ",
        section_list: "Բաժնի ցանկ",
        subscription_crone_job_url: "Բաժանորդագրության crone աշխատանքի url",
        seller_registration_title_for_first_page:
            "Վաճառողի գրանցման անվանում առաջին էջի համար",
        exchange_title: "Փոնականման անվանում",
        return_exchange: "Վերադարձ փոխանակում",
        contact_content: "Կոնտակտի կոնտենտ",
        dynamic_pages: "Դինամիկ էջեր",
        footer_setting: "Էջատակի կարգավորումներ",
        about_us: "Մեր մասին",
        related_sale_setting: "Նմանատիպ վաճառքի կարգավորումներ",
        subscribe_content_update_successfully:
            "Բաժանորդագրության կոնտենտըհաջոությամբ թարմացվել է",
        title_has_been_updated_successfully: "Վերնագիրը հաջողությամբ թարմացվել է",
        promotion_bar: "Promotion bar",
        ads_bar: "Ads bar",
        login_page: "Մուտք գործելու էջ",
        admin: "Ադմին",
        general_settings: "Կարգավորումներ",
        smtp_setting: "SMTP Կարգավորումներ",
        activation: "Ակտիվացում",
        sms_setting: "SMS կարգավորում",
        sms_template: "SMS template",
        symbol: "Սիմվոլ",
        shop_link_banner: "Խանութ սրահի հղման բաներ",
        upload_shop_link_banner: "Վերբեռնել խանութ սրահի հղման բաները",
        currency_list: "Արժույթի ցանկ",
        "Edit Currency Info": "Խմբագրել արժույթի ինֆորմացիան",
        "Currency Updated Successfully": "Արժույթը հաջողությամբ թարմացվել է",
        "Currency Added Successfully": "Արժույթը հաջողությամբ ավելացվել է",
        "Currency has been deleted Successfully": "Արժույթը հաջողությամբ ջնջվել է",
        "SMS Gateways Credentials has been updated Successfully":
            "SMS Gateways-ի հավատարմագրերը հաջողությամբ թարմացվել են",
        "SMS has been sent Successfully":
            "SMS հաղորդագրությունը հաջողությամբ ուղարկվել է",
        "SMTP Gateways Credentials has been updated Successfully":
            "SMTP Gateways Հավատարմագրերը հաջողությամբ թարմացվել են",
        "Mail has been sent Successfully": "Նամակը հաջողությամբ ուղարկվել է",
        "Please Configure SMTP settings first":
            "Խնդրում ենք նախ կարգավորել SMTP կարգավորումները",
        "Language has been deleted Successfully": "Լեզուն հաջողությամբ ջնջվել է",
        "Language Updated Successfully": "Լեզուն հաջողությամբ թարմացվեց",
        "Language Added Successfully": "Լեզուն հաջողությամբ ավելացվեց",
        Active: "Ակտիվ",
        "Email Template": "Email ձևանմուշ",
        Translation: "Թարգմանություն",
        "Native Name": "Մայրենի",
        "Edit Language Info": "Խմբագրել լեզվի տվյալները",
        "Select Translatable File": "Ընտրեք թարգմանվող ֆայլը",
        Key: "Բանալի",
        sender_name: "Ուղարկողի անունը",
        api_key: "API բանալի",
        registered_phone_number: "Գրանցված հեռախոսահամար",
        authentication_token: "Նույնականացման նշան",
        twilio_account_sid: "Twilio Account SID",
        send_test_mail: "Ուղարկել փորձնական նամակ",
        send_a_test_email_to: "Ուղարկել փորձնական էլ. փոստ",
        mail_text: "Mail տեքստ",
        predefined_footer: "Predefined Footer",
        predefined_header: "Predefined Header",
        email_signature: "Email Signature",
        sender_email: "Ուղարկողի Էլ. հասցե",
        email_settings: "Էլ.հասցեի կարգավորումներ",
        email_protocol: "Email Protocol",
        mail_engine: "Mail Engine",
        from_name: "Ում կողմից",
        from_mail: "Ում",
        mail_host: "Mail Host",
        mail_port: "Mail Port",
        mail_username: "Օգտատիրոջ հասցե",
        mail_password: "Օգտատիրոջ գաղտնաբառ",
        mail_encryption: "Mail Encryption",
        email_charset: "Email Charset",
        About: "Մասին",
        Misc: "Misc",
        Tags: "Թագեր",
        "Theme Options": "Թեմաների ըտնրություն",
        Cronjob: "Cronjob",
        "E-Sign": "E-Sign",
        "PDF Settings": "PDF Կարգավորումներ",
        Calendar: "Օրացույց",
        SMS: "Նամակագրություն",
        Support: "Օգնություն",
        "Customer Permission": "Հաճախորդի թույլտվույթուն",
        general: "Գլխավոր",
        Activation: "Ակտիվացում",
        system_default_language: "Համակարգի հիմնական լեզու",
        copywrite_text: "Հեղինակային իրավունքների տեքստ",
        file_supported: "Ֆայլի",
        system_title: "Համակարգի վերնագիր",
        upload_fav_icon: "Վերբեռնել հավանած պատկերը",
        fav_icon: "Հավանած պատկեր",
        upload_logo: "Վերբեռնել լոգո",
        system_logo: "Համակարգի լոգո",
        system_default_currency: "Համակարգի հիմնական արժույթ",
        currency_symbol: "Արժույթի նիշ",
        currency_code: "Արժույթի կոդ",
        SMTP: "SMTP",
        date_format: "Ամսաթվի ձևաչափ",
        time_zone: "Ժամային գոտի",
        activate_sms_gateway: "Ակտիվացնել հաղորդագրության  gateway",
        sms_settings: "Հաղորդագրության կարգավորումներ",
        twilio: "Twilio",
        textlocal: "TextLocal",
        URL: "URL",
        "Margin Price": "Մարժայի արժեք",
        "Agent Commission Type": "Գործակալի կոմիսիոն վճարի տեսակը",
        Quantity: "Քանակ",
        "Invoice Prefix": "Invoice Prefix",
        include_comma_with_each_word:
            "Յյուրաքանչյուր բառի հետ ներառել ստորակետ, օրինակ. csv,doc,docs",
        preloader: "Preloader",
        send_a_test_sms: "Ուղարկեք փորձնական SMS",
        send_test_sms: "Ուղարկեք փորձնական հաղորդագրություն",
        Agent: "Գործակալ",
        "Currency List":
            "Currency List 13 / 5 000 Թարգմանության արդյունքներ Թարգմանություն Արտարժույթի ցանկ",
        add_new_currency:
            "Add New Currency 16 / 5 000 Թարգմանության արդյունքներ Թարգմանություն Ավելացնել նոր արժույթ",
        edit_currency_info: "Խմբագրել արժույթի տվյալները",
        company_name: "Կազմկերպության անվանում",
        company_information: "Կազմակերպության մասին ինֆորմացիա",
        "Payment Gateways": "Payment Gateways",
        order_invoice: "Պատվերի հաշիվ-ապրանքագիր",
        email_footer: "Էլ.փոստի ստորագիր",
        template: "Ձևանմուշ",
        reciepent: "Ստացող",
        manage: "Կառավարել",
        add_new_template: "Ավելացնել նոր ձևանմուշ",
        set_for: "Սահմանել",
        system_settings: "Համակարգի կարգավորումներ",
        short_code: "Կարճ ծածկագիր",
        use_these_to_get_your_neccessary_info:
            "Օգտագործեք սրանք՝  Ձեզ անհրաժեշտ ինֆորմացիան ստանալու համար",
        convert_rate: "Փոխանակման տոկոսադրույք",
        please_select_valid_reciepent_to_create_template:
            "Խնդրում ենք ընտրել Վավեր ստացող՝ ձևանմուշ ստեղծելու համար",
        mail_has_been_sent_successfully: "Էլ. փոստը հաջողությամբ ուղարկվել  է",
        please_configure_smtp_settings_first:
            "36 / 5 000 Թարգմանության արդյունքներ Թարգմանություն Խնդրում ենք նախ կարգավորել SMTP կարգավորումները",
        php_mailer: "PHP Mailer",
        php_mailer2: "PHP Mailer 2",
        logo_banner: "Logo & Banner",
        social_link: "Social Link",
        fontawesome_or_themefy_icon_only: "Note: Font awesome & Themefy Icon only.",
        smtp: "SMTP",
        php_mail: "PHP Mail",
        maintenance: "Տեխնիկական սպասարկում",
        maintenance_page_banner: "Սպասարկման էջի բաններ",
        mode: "Ռեժիմ",
        module: "Գործակից",
        manager: "Կառավարող",
        upload_from_local_directory: "Բեռնել տեղական ցուցակից",
        software_version: "Ծրագրային տարբերակ",
        about_system: "Համակրգի մասին",
        php_version: "PHP Version",
        check_update: "Ստուգել վերբեռնումը",
        curl_enable: "Curl Enable",
        purchase_code: "Գնման կոդը",
        install_domain: "Տեղադրեք Domain",
        system_activated_date: "Համակարգի ակտիվացման ամսաթիվը",
        last_update_at: "Վերջին թարմացման ժամը",
        upload_sql_file: "Վերբեռնել SQL ֆայլ",
        database_backup_list: "Database Backup List",
        generate_new_backup: "Generate New Backup",
        new_database_backup_has_been_created:
            "New database backup has been created",
        add_new_update_module: "Add New / Update Module",
        select_module_file: "Ընտրել մոդուլային ֆայլ",
        backup: "Backup",
        gateway_settings: "Երթուղու կարգավորումներ",
        about_update: "About & Update",
        message_for_system_notification: "Message For System Notification",
        verified: "Ստուգված է",
        currency_symbol_position: "Արժույթի նշանի դիրքը",
        decimal_number_limit: "Decimal Number Limit",
        left_with_space: "Left With Space",
        right_with_space: "Right With Space",
        guest_checkout: "Այցելուների վճարում",
        facebook_messanger: "Facebook Messanger",
        paste_code_here: "Paste Code Here",
        messager_code: "Messanger  Code",
        social_configuration: "Social Configuration",
        send_to_parameter_name: "Send To Parameter Name",
        message_parameter_name: "Message Parameter Name",
        request_method: "Request Method",
        parameter_1_key: "Parameter 1 Key",
        parameter_2_key: "Parameter 2 Key",
        parameter_3_key: "Parameter 3 Key",
        parameter_4_key: "Parameter 4 Key",
        parameter_5_key: "Parameter 5 Key",
        parameter_6_key: "Parameter 6 Key",
        parameter_7_key: "Parameter 7 Key",
        parameter_8_key: "Parameter 8 Key",
        parameter_9_key: "Parameter 9 Key",
        parameter_10_key: "Parameter 10 Key",
        parameter_1_value: "Parameter 1 Value",
        parameter_2_value: "Parameter 2 Value",
        parameter_3_value: "Parameter 3 Value",
        parameter_4_value: "Parameter 4 Value",
        parameter_5_value: "Parameter 5 Value",
        parameter_6_value: "Parameter 6 Value",
        parameter_7_value: "Parameter 7 Value",
        parameter_8_value: "Parameter 8 Value",
        parameter_9_value: "Parameter 9 Value",
        parameter_10_value: "Parameter 10 Value",
        update_sms_setting: "Թարմացնել հաղորդագրության կարգավորումները",
        others: "Այլ",
        cloud_storage: "Cloud Storage",
        amazon_s3: "AmazonS3",
        aws_s3s_setting: "Aws S3 Setting",
        access_key_id: "Access Key Id",
        secret_key: "Secret Key",
        default_region: "Default Region",
        aws_bucket: "AWS Bucket",
        file_storage: "File Storage",
        active_file_storage: "Active File Storage",
        default_currency_not_changeble: "Default Currency Not Changeble.",
        message_for_particular_user: "Message for particular user",
        message_for_admin_site: "Message for admin site",
        homepage_seo_setup: "Homepage SEO Setup",
        meta_site_title: "Meta Site Title",
        preloader_status: "Preloader Status",
        preloader_type: "Preloader Type",
        animation: "Animation",
        preloader_image: "Preloader Image",
        preloader_style: "Preloader Style",
        preloader_setting: "Preloader Setting",
        lazyload_image: "Lazyload Image",
        upload_lazyload_image: "Upload Lazyload Image",
        pwa_app_name: "PWA App Name",
        product_subtitle_show: "Ապրանքի ենթագրերի ցուցադրում",
        category_show_in_menu: "Կատեգորիայի ցուցադրում մենյուում",
        terms_conditions: "Պայմաններ եւ դրույթներ",
        subject_en: "Թեմա անգլերենով",
        subject_ru: "Թեմա ռուսերենով",
        subject_hy: "Թեմա հայերենով",
        template_en: "Ձևանմուշ անգլերենով",
        template_ru: "Ձևանմուշ  ռուսերենով",
        template_hy: "Ձևանմուշ հայերենով",
        gst_setup: "GST/VAT/TAX Կարգավորում",
        gst_list: "GST/VAT/TAX ցանկ",
        gst: "GST",
        rate: "Հարկ",
        add_new_gst: "Ավելացնել նոր GST/VAT/TAX",
        edit_gst: "Խմբագրել  GST/VAT/TAX",
        place_of_delivery_inside_state: "Առաքում երկրի ներսում",
        place_of_delivery_outside_state: "Երկրից դուրս առաքում",
        gst_configuration: "GST/VAT/TAX Configuration",
        select_one_or_multiple: "Ընտրել մեկը կամ մի քանիսը",
        claim_gst: "Claim GST/VAT/TAX",
        gst_claimed: "GST/VAT/TAX Claimed",
        goods_and_services_tax: "Ապրանքների և ծառայությունների հարկ",
        total_gst: "Total GST/VAT/TAX",
        is_active_flat_tax: "Ակտիվ համահավաքային հարկ",
        is_active_gst: "Is Active GST/VAT/TAX",
        flat_tax_percentage: "Flat Tax Percentage",
        flat_tax: "Flat Tax",
        gst_or_flat_rate_claimed_by_seller:
            "GST/VAT/TAX or Flat Rate claimed by seller",
        gst_or_flat_tax_claim_by_seller: "GST/VAT/TAX or Flat tax claim by Seller",
        same_state_GST: "Same State GST/VAT/TAX",
        outsite_state_GST: "Outsite State GST/VAT/TAX",
        GST_group: "GST/VAT/TAX Group",
        human_resource: "Մարդկային ռեսուրսներ",
        applicable_for_leave: "Անվճար արձակուրդ",
        bank_branch_name: "Բանկի մասնաճյուղի անվանումը",
        bank_info: "Բանկային տվյալներ",
        account_no: "Հաշվեհամար",
        cheque_no: "կուպոնի համար",
        pay_now: "Վճարել հիմա",
        bank_account_details: "Բանկային հաշվի մանրամասներ",
        bank_account_number: "Բանկային հաշվեհամար",
        loan_apply: "Դիմել վարկի համար",
        loan_history: "Վարկային պատմություն",
        loan_approval: "Վարկի թուլտվություն",
        "Loan Apply": "Վարկի դիմում",
        date_of_joining: "Միացման ամսաթիվ",
        basic_salary: "Նվազագույն աշխատավարձ",
        employment_type: "Զբաղվածության տեսակը",
        provision: "Տրամադրում",
        contract: "Պայմանագիր",
        permanent: "Անփոփոխ",
        provision_time: "Տրամադրման ժամկետ",
        in_months: "Ամսական",
        staff_list: "Անձնակազմի ցանկ",
        staff: "Անձնակազմ",
        role: "Դեր",
        edit_staff_info: "Խմբագրել անձնակազմի տվյալները",
        attendance: "Հաճախում",
        attendance_report: "Հաճախումների հաշվետվություն",
        system_user: "Համակարգի օգտատեր",
        assign_permission: "Թույլտվություն նշանակել",
        system_role: "Համակարգի դերը",
        regular_user: "Կանոնավոր օգտվող",
        present: "Ներկա",
        late: "Ուշանալ",
        absent: "Բացակայում է",
        holiday: "Տոն",
        P: "P",
        L: "L",
        A: "A",
        H: "H",
        select_month: "Ընտրել ամիսը",
        select_year: "Ընտրել տարին",
        event_list: "Միջոցառումների ցանկ",
        event: "Միջոցառում",
        for_whom: "Ում համար",
        copy_previous_year_settings: "Պատճենել նախորդ տարվա կարգավորումները",
        holiday_name: "Տոնի անվանումը",
        holiday_setup: "Տոնի կարգավորում",
        select_criteria_for_payroll: "Select Criteria For Payroll",
        not_generated: "Չի ստեղծվել",
        generated: "Ստեղծված է",
        generate_payroll: "Ստեղծել աշխատավարձ",
        view_paySlip: "View PaySlip",
        earnings: "Earnings",
        deductions: "Նվազեցումներ",
        payroll_summary: "Աշխատավարձի ամփոփագիր",
        calculate: "Հաշվարկել",
        gross_salary: "Համախառն եկամուտ",
        payroll: "Աշխատավարձ",
        payroll_reports: "Աշխատավարձի հաշվետվություններ",
        payslip_for_the_period_of: "Ժամանակահատվածի համար վճարման կուպոն",
        payslip: "Վարձավճար",
        total_earning: "Ընդհանուր եկամուտ",
        total_deduction: "Ընդհանուր նվազեցում",
        net_salary: "Զուտ աշխատավարձ",
        proceed_to_pay: "Շարունակեք վճարել",
        staff_name: "Աշխատակազմի անվանումը",
        payment_amount: "Վճարի չափը",
        paid_date: "Վճարման ամսաթիվ",
        leave: "Թողնել",
        apply_date: "Դիմելու ամսաթիվը",
        delete_not_possible_role_has_user: "Ջնջել հնարավոր չէ: Դերը ունի օգտատեր:",
        permission_given_successfully:
            "30 / 5 000 Թարգմանության արդյունքներ Թարգմանություն Թույլտվությունը հաջողությամբ տրվել է:",
        attendance_has_been_taken_successfully:
            "Մասնակցությունը հաջողությամբ է ընդունվել է",
        holiday_saved_successfully: "Տոնը հաջողությամբ ստեծվել է",
        year_holiday_not_found: "Տոնը գտնված չէ",
        select_Role_date_from_list: "Ընտրեք դերը և ցանկից ամսաթիվը",
        deleted_not_possible_for_this_customer:
            "Ջնջձումը հնարավոր չէ այս հաճախորդի համար",
        "You cann\\'t delete an income which has child element":
            "Դուք չեք կարող ջնջել եկամուտը, որն ունի ենթատարր",
        "New Income": "Նոր եկամուտ",
        "The requested income is not found": "Պահանջվող եկամուտը չի գտնվել",
        "The requested income deleted successful":
            "Հայցվող եկամուտը հաջողությամբ ջնջվեց",
        "The requested income created successful":
            "Պահանջվող եկամուտը հաջող է ստեղծվել",
        "The requested income updated successful":
            "Հայցվող եկամուտը հաջողությամբ թարմացվել է",
        "Edit Income": "Խմբագրել եկամուտը",
        language_list: "Լեզուների ցանկ",
        add_new_language: "Ավելացնել նոր լեզու",
        code: "Կոդ",
        RTL: "RTL",
        LTL: "LTL",
        "Language Settings": "Լեզվի կարգավորում",
        native_name: "Native Name",
        edit_language_info: "Կարգովորել լեզուն",
        translation: "Թարգմանել",
        select_translatable_file: "Ընտրեք թարգմանվող ֆայլ",
        key: "Բանալի",
        value: "Արժեք",
        lead: "Վարկ",
        leads: "Վարկեր",
        lead_info: "Վարկային ինֆորմացիա",
        lead_images: "Վարկի նկար",
        lead_files: "Վարկի ֆայլ",
        lead_list: "Վարկի ցանկ",
        Cheque: "Կուպոն",
        Purchase: "Վճարել",
        Asset: "Asset",
        Income: "Եկամուտ",
        Liabilities: "Պարտավորություններ",
        Sale: "Վաճառք",
        Cash: "Կանխիկ",
        Loan: "Վարկ",
        Liability: "Պատասխանատվություն",
        "GST Tax Account": "GST Tax Account",
        "Product Wise Tax Account": "Product Wise Tax Account",
        "Seller Account": "Վաճառողի հաշիվ",
        "Seller Commision": "Վաճառողի կոմիսիոն վճար",
        "Sallary Account": "Աշխատավարձի չափ",
        "home.action": "Տնային գործողություններ",
        three_in_one: "3ը մեկում",
        price_tag: "Գնապիտակ",
        old_price: "Հին գին",
        basic_price: "Հիմնական գինը",
        product1: "Մեկ Ապրանք",
        template_1: "Template 1",
        template_2: "Template 2",
        template_3: "Template 3",
        by_template_1: "By Template 1",
        by_template_2: "By Template 2",
        by_template_3: "By Template 3",
        product_1: "Ապրանք 1",
        product_2: "Ապրանք 2",
        product_3: "Ապրանք 3",
        "You have no products selected": "Դուք չունեք ընտրված ապրանքներ",
        images: "Բանների պատկերներ",
        general_setting: "Ընդհանուր կարգավորում",
        product_section: "Ապրանքի բաժին",
        exclusive_price_section: "Բացառիկ գների բաժին",
        coupon_section: "Կուպոների բաժին",
        background_color: "Ֆոնի գույնը",
        text_color: "Տեքստ-գույն",
        setup_products: "Ապրանքների կարգավորումներ",
        navigation_label: "Navigation Label",
        Marketing_Sales: "Մարքետինգ վաճառք",
        slogan: "Slogan",
        select_products: "Ընտրված ապրանքներ",
        selected_product_list: "Ընտրված ապրանքների ցանկ",
        selected_category_list: "Ընտրված կատեգորիաների ցանկ",
        coupon_section_setup: "Կտրեննոերի բաժնի կարգավորումներ",
        coupon_list: "կուպոնների ցանկ",
        create_new_user_zone: "Ստեղծել նոր օգտատիրոջ գոտի",
        flash_deal: "Ֆլեշ գործարք",
        update_flash_deal: "Վերբեռնել Ֆլեշ առաջարկ",
        create_flash_deal: "Ստեղծել Ֆլեշ առաջարկ",
        news_letter: "Նորություն",
        publish_date: "Հրապարակման ամսաթիվ",
        created_by: "Ստեղծվել է",
        mail_to: "Ում",
        create_news_letter: "Ստեղծել նորություն",
        update_news_letter: "Նորությունների թարմացում",
        publish_on: "Հրապարակել",
        send_to: "Ուղարկել",
        all_user: "Բոլոր օգտվողներ",
        role_wise: "Role Wise",
        multiple_role_select_user: "Բազմաթիվ դերերի ընտրության օգտատեր",
        all_subscription: "Բոլոր բաժանորդագրությունները",
        selected_role_user: "Ընտրված օգտագործողի դեր",
        save_test_mail: "Save & Test Mail",
        test_mail_has_been_send_successfully:
            "Փորձնական էլ. հաղորդագրությունն հաջողությամբ ուղարկվել է",
        test_mail: "Փորձնական էլ. հաղորդագրություն",
        bulk_sms: "Bulk SMS",
        sms_list: "SMS ցանկ",
        sending: "Ուղարկել",
        test_sms_has_been_send_successfully:
            "Փորձնական SMS-ը հաջողությամբ ուղարկվեց:",
        message_to: "Ում",
        create_bulk_sms: "Ստեղծել bulk sms",
        update_bulk_sms: "Վերբեռնել bulk հաղորդագրությունը",
        save_test_sms: "Պահպանել փորձնական հաղորդագրությունը",
        test_sms: "Տեքստային հաղորդագրություն",
        select_coupon_type_first: "Նախ ընտրեք կուպոնի տեսակը",
        product_base: "Ապրանքների բազա",
        order_base: "Պատվերների բազա",
        create_coupon: "Ստեղծել կուպոն",
        coupon_type: "Կուպոնի տեսակ",
        add_coupon_for_free_shipping: "Ավելացրեք կուպոնի անվճար առաքման համար",
        add_coupon_based_on_order: "Ավելացնել կուպոն՝  հիմնված պատվերի վրա",
        add_coupon_based_on_products: "Ավելացնել կուպոն՝ հիմնված ապրանքների վրա",
        coupon_code: "Կուպոնի կոդը",
        maximum_discount: "Առավելագույն զեղչ",
        allow_multiple_buy: "Թույլատրել բազմակի գնումներ",
        minimum_shopping: "Նվազագույն գնումներ",
        referral_code_list: "Ուղղորդման կոդերի ցանկ",
        amount_is_getter_than_maximum_limit:
            "Գումարը գերազանցում է առավելագույն սահմանաչափը",
        customer_name: "Հաճախորդի անուն",
        create_date: "Ստեղծել ամսաթիվ",
        maximum_limit: "Առավելագույն սահմանաչափ",
        subscriber: "Բաժանորդ",
        subscriber_list: "Բաժանորդների ցուցակ",
        marketing: "Մարքետինգ",
        coupons: "Կուպոներ",
        subscribers: "Բաժանորդներ",
        news_letters: "Նորություններ",
        referral_code_setup: "Ուղղորդման կոդի կարգավորում",
        this_item_already_added_to_list: "Այս ապրանք արդեն ավելացվել է ցանկին",
        marketing_campaign_planning: "Marketing campaign planning",
        cool_app: "Հաջողված հավելված",
        awesome_app: "Խելացի հավելված",
        what_a_cool_app: "Ի՞նչ հաջողված հավելված է",
        menu_list: "Մենյուի ցանկ",
        add_menu: "Ավելացնել մենյու",
        use_themefy_or_fontawesome_icon: "Use themefy or fontawesome icon",
        mega_menu: "Մեգա մենյու",
        multi_mega_menu: "Մուլտի մեգա մենյու",
        regular_menu: "Regular Menu",
        top_navbar: "Top Navbar",
        main_menu: "Հիմնական մենյու",
        select_display_location: "Ընտեք ցուցադրելու վայրը",
        select_menu_type: "Ընտրել մենյուի տեսակը",
        edit_menu: "Խմբագրել  մենյուն",
        menu_type: "Մենյուի տեսակ",
        display_location: "Ցուցադրման դիրքը",
        right_panel: "Աջ վահանակ",
        bottom_panel: "Ներքևի վահանակ",
        setup_menu: "Կարգավորումների մենյու",
        back_to_menu: "Վերադառնալ մենյուին",
        right_panel_setup: "Աջ վահանակի կարգավորում",
        bottom_panel_setup: "Ներքևի վահանակի կարգավորում",
        add_brand: "Ավելացնել ապրանքանիշ",
        column: "Սյուն",
        element: "Էլեմենտ",
        add_column: "Ավելացնել սյունակ",
        menu_item_list: "Ապրանքների մենյուի ցանկ",
        select_size: "Ընտրել չափս",
        add_to_menu: "Ավելացնել մեյուին",
        add_links: "Ավելացնել լինկեր",
        add_categories: "Ավելացնել կատեգորիաներ",
        add_pages: "Ավելացնել էջեր",
        add_product: "Ավելացնել ապրանքներ",
        add_tag: "Ավելացնել թագ",
        no_brands: "Ոչ մի ապրանքանիշ",
        row_required: "Պահանջվում է տող",
        size_required: "Պահանջվում է չափս",
        title_required: "Պահանջվում է վերնագիր",
        link_required: "Պահանջվում է հղում",
        brand_required: "Պահանջվում է ապրանքանիշ",
        tags_required: "Պահանջվում է տագեր",
        menu_required: "Պահանջվում է մենյու",
        top_bar: "Թոփ բար",
        function: "Ֆունկցիա",
        order_manage: "Պատվերներ",
        my_order: "Իմ պատվերը",
        social_security_card: "Սոց․քարտի համար",
        passport: "Անձնագիր",
        express_american: "AMERICAN EXPRESS",
        add_a_passport_photo: "Ավելացնել նկար",
        download_the_file: "Բեռնել ֆայլը",
        Vtb: "VTB",
        Uni: "UNIBank",
        ineco: "INECOBank",
        acba: "ACBA",
        evoca: "EVOCABank",
        Vtb_info:
            "ՀԱՄԱՁԱՅՆԱԳԻՐ Սույնով տալիս եմ իմ համաձայնությունը, որ.• «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ-ն հարցումներ կատարի «ԱՔՌԱ Քրեդիտ Ռեփորթինգ» ՓԲԸ-ին և վերջինիս խնդրում եմ «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ-ին տրամադրել իմ ներկա և անցյալ ֆինանսական պարտավորությունների վերաբերյալ տեղեկություններ, ինչպես նաև այլ տվյալներ, որոնք «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ կողմից կարող են հաշվի առնվել ինձ հետ վարկային (փոխառության և այլն) պայմանագիր կնքելու վերաբերյալ որոշում կայացնելիս:• «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ կողմից վարկային (փոխառության և այլն) պայմանագիր կնքելու դեպքում տվյալ վարկային (փոխառության և այլն) պայմանագրի գործողության ողջ ընթացքում, իսկ գլխավոր վարկային պայմանագրի առկայության դեպքում նաև վերջինիս գործողության ողջ ընթացքում ցանկացած պահի առանց ինձ նախապես տեղյակ պահելու «ԱՔՌԱ Քրեդիտ Ռեփորթինգ» ՓԲԸ-ն «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ-ին տրամադրի իմ ապագա ֆինանսական պարտավորությունների վերաբերյալ տեղեկություններ, ինչպես նաև այլ տվյալներ:• «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ-ն հարցումներ կատարի «ԱՔՌԱ Քրեդիտ Ռեփորթինգ» ՓԲԸ-ին և վերջինիս խնդրում եմ «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ-ին տրամադրել իմ ներկա և անցյալ ֆինանսական պարտավորությունների վերաբերյալ տեղեկություններ, ինչպես նաև այլ տվյալներ, որոնք «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ կողմից կարող են հաշվի առնվել ինձ հետ վարկային (փոխառության և այլն) պայմանագիր կնքելու վերաբերյալ որոշում կայացնելիս:• «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ կողմից վարկային (փոխառության և այլն) պայմանագիր կնքելու դեպքում տվյալ վարկային (փոխառության և այլն) պայմանագրի գործողության ողջ ընթացքում, իսկ գլխավոր վարկային պայմանագրի առկայության դեպքում նաև վերջինիս գործողության ողջ ընթացքում ցանկացած պահի առանց ինձ նախապես տեղյակ պահելու «ԱՔՌԱ Քրեդիտ Ռեփորթինգ» ՓԲԸ-ն «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ-ին տրամադրի իմ ապագա ֆինանսական պարտավորությունների վերաբերյալ տեղեկություններ, ինչպես նաև այլ տվյալներ:• «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ-ն հարցումներ կատարի «ԱՔՌԱ Քրեդիտ Ռեփորթինգ» ՓԲԸ-ին և վերջինիս խնդրում եմ «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ-ին տրամադրել իմ ներկա և անցյալ ֆինանսական պարտավորությունների վերաբերյալ տեղեկություններ, ինչպես նաև այլ տվյալներ, որոնք «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ կողմից կարող են հաշվի առնվել ինձ հետ վարկային (փոխառության և այլն) պայմանագիր կնքելու վերաբերյալ որոշում կայացնելիս:• «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ կողմից վարկային (փոխառության և այլն) պայմանագիր կնքելու դեպքում տվյալ վարկային (փոխառության և այլն) պայմանագրի գործողության ողջ ընթացքում, իսկ գլխավոր վարկային պայմանագրի առկայության դեպքում նաև վերջինիս գործողության ողջ ընթացքում ցանկացած պահի առանց ինձ նախապես տեղյակ պահելու «ԱՔՌԱ Քրեդիտ Ռեփորթինգ» ՓԲԸ-ն «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ-ին տրամադրի իմ ապագա ֆինանսական պարտավորությունների վերաբերյալ տեղեկություններ, ինչպես նաև այլ տվյալներ:",
        Uni_info:
            "ՀԱՄԱՁԱՅՆԱԳԻՐ  Սույնով տալիս եմ իմ համաձայնությունը, որպեսզի «Յունիբանկ» ԲԲԸ-ի կողմից հարցում կատարվի «ԱՔՌԱ Քրեդիտ Ռեփորթինգ» ՓԲԸ-ին և վերջինիս խնդրում եմ «Յունիբանկ» ԲԲԸ-ին տրամադրել իմ ներկա և անցյալ ֆինանսական պարտավորությունների վերաբերյալ տեղեկություններ, ինչպես նաև այլ տվյալներ, որոնք «Յունիբանկ» ԲԲԸ-ի կողմից կարող են հաշվի առնվել ինձ հետ վարկային (փոխառության և այլն) պայմանագիր կնքելու վերաբերյալ որոշում կայացնելիս: Ինչպես նաև տալիս եմ իմ համաձայնությունը, որպեսզի «Յունիբանկ» ԲԲԸ-ի կողմից վարկային (փոխառության և այլն) պայմանագիր կնքելու դեպքում տվյալ վարկային (փոխառության և այլն) պայմանագրի գործողության ողջ ընթացքում ցանկացած պահին առանց ինձ նախապես տեղյակ պահելու «ԱՔՌԱ Քրեդիտ Ռեփորթինգ» ՓԲԸ-ն «Յունիբանկ» ԲԲԸ-ին տրամադրի իմ ապագա ֆինանսական պարտավորությունների վերաբերյալ տեղեկություններ, ինչպես նաև այլ տվյալներ: Գիտակցում եմ, որ տրամադրված տեղեկությունները և տվյալները, կախված դրանց բովանդակությունից կարող են ազդել «Յունիբանկ» ԲԲԸ-ի կողմից կայացված համապատասխան որոշման վրա: Սույն համաձայնությունը կարդացել եմ և հավաստում են, որ այն ինձ համար ամբողջությամբ հասկանալի և ընդունելի է:",
        ineco_info:
            'ԱՊՐԱՆՔՆԵՐԻ ԵՎ/ԿԱՄ ԾԱՌԱՅՈՒԹՅՈՒՆՆԵՐԻ ԱՊԱՌԻԿ ԿԱՐԳՈՎ ՁԵՌՔԲԵՐՄԱՆ ՖԻՆԱՆՍԱՎՈՐՄԱՆ ՀԱՅՏ ԵՎ ՀԱՄԱՁԱՅՆՈՒԹՅՈՒՆ 1.\tՍույնով դիմում եմ ապառիկ կարգով ապրանք(ներ)ի և/կամ ծառայություն(ներ)ի ձեռքբերման նպատակով "ԻՆԵԿՈԲԱՆԿ" ՓԲԸ-ի կողմից 30.000 – 5.000.000 ՀՀ դրամ գումարի սահմաններում ֆինանսավորում ստանալու համար՝ վերջինիս կողմից սահմանված պայմաններին համապատասխան: 2.\tՏեղեկացված եմ, որ "ԻՆԵԿՈԲԱՆԿ" ՓԲԸ-ի կողմից սույն հայտի վերաբերյալ դրական կամ բացասական որոշում կայացնելու համար տեղեկատվության բավարար չլինելու դեպքում անհրաժեշտ է սույն հայտի ներկայացման պահից 3 (երեք) աշխատանքային օրվա ընթացքում ներկայանալ "ԻՆԵԿՈԲԱՆԿ" ՓԲԸ՝ ներկայացնելով սույն հայտի՝ ինձ տրված մեկ օրինակը, ինչպես նաև իմ վարկարժանության ստուգման հետագա ընթացքի համար անհրաժեշտ փաստաթղթեր և տեղեկատվություն՝ ըստ պահանջի: Հասկանում և ընդունում եմ, որ սույն կետով սահմանված ժամկետում "ԻՆԵԿՈԲԱՆԿ" ՓԲԸ չներկայանալու դեպքում սույն հայտը կմերժվի "ԻՆԵԿՈԲԱՆԿ" ՓԲԸ-ի կողմից: 3.\tՏեղեկացված եմ, որ սույն հայտը մերժելու մասին որոշում կայացնելու դեպքում "ԻՆԵԿՈԲԱՆԿ" ՓԲԸ-ն որոշման կայացման օրվանից առավելագույնը 2 (երկու) աշխատանքային օրվա ընթացքում այդ մասին գրավոր ձևով կհայտնի ինձ՝ "ԻՆԵԿՈԲԱՆԿ" ՓԲԸ-ի տարածքում թղթային օրինակն առձեռն տրամադրելով: 4.\tՍույնով տալիս եմ իմ համաձայնությունը, որպեսզի "ԻՆԵԿՈԲԱՆԿ" ՓԲԸ-ի կողմից հարցում կատարվի "ԱՔՌԱ Քրեդիտ Ռեփորթինգ" ՓԲԸ և վերջինիս խնդրում եմ "ԻՆԵԿՈԲԱՆԿ" ՓԲԸ-ին տրամադրել իմ ներկա և անցյալ ֆինանսական պարտավորությունների վերաբերյալ տեղեկություններ, ինչպես նաև այլ տվյալներ, որոնք "ԻՆԵԿՈԲԱՆԿ" ՓԲԸ-ի կողմից կարող են հաշվի առնվել ինձ հետ վարկային (փոխառության և այլն) պայմանագիր կնքելու վերաբերյալ որոշում կայացնելիս։ Ինչպես նաև տալիս եմ իմ համաձայնությունը, որպեսզի "ԻՆԵԿՈԲԱՆԿ" ՓԲԸ-ի կողմից վարկային (փոխառության և այլն) պայմանագիր կնքելու դեպքում տվյալ վարկային (փոխառության և այլն) պայմանագրի գործողության ողջ ընթացքում ցանկացած պահին` առանց ինձ նախապես տեղյակ պահելու, "ԱՔՌԱ Քրեդիտ Ռեփորթինգ" ՓԲԸ-ն "ԻՆԵԿՈԲԱՆԿ" ՓԲԸ-ին տրամադրի իմ ապագա ֆինանսական պարտավորությունների վերաբերյալ տեղեկություններ, ինչպես նաև այլ տվյալներ։ Գիտակցում եմ, որ տրամադրված տեղեկությունները և տվյալները, կախված դրանց բովանդակությունից կարող են ազդել "ԻՆԵԿՈԲԱՆԿ" ՓԲԸ-ի կողմից կայացված համապատասխան որոշման վրա։ Սույն համաձայնությունը կարդացել եմ և հավաստում եմ, որ այն ինձ համար ամբողջությամբ հասկանալի և ընդունելի է։ 5.\tՍույնով հաստատում եմ, որ սույն փաստաթղթի նախորդ կետով իմ կողմից տրված համաձայնությունն ամբողջ ծավալով տարածվում է նաև ՀՀ կենտրոնական բանկի վարկային ռեգիստրի, "ՆՈՐՔ" սոցիալական ծառայությունների տեխնոլոգիական և իրազեկման կենտրոն հիմնադրամի, հանրային տվյալների բազաների, "ԻՆԵԿՈԲԱՆԿ" ՓԲԸ-ի հետ համագործակցող վարկային բյուրոների և բանկային սպասարկման ոլորտում հաճախորդների վերաբերյալ տվյալներ մշակող անձանց կողմից "ԻՆԵԿՈԲԱՆԿ" ՓԲԸ-ին իմ ներկա և անցյալ ֆինանսական պարտավորությունների (իսկ "ԻՆԵԿՈԲԱՆԿ" ՓԲԸ-ի հետ վարկային (փոխառության և այլն) պայմանագիր կնքվելու դեպքում նաև՝ ապագա ֆինանսական պարտավորությունների) վերաբերյալ տեղեկությունների, ինչպես նաև այլ տվյալների տրամադրման վրա՝ ինչպես սույն համաձայնության տրամադրման պահին, այնպես էլ "ԻՆԵԿՈԲԱՆԿ" ՓԲԸ-ի հետ վարկային (փոխառության և այլն) պայմանագիր կնքելու դեպքում տվյալ վարկային (փոխառության և այլն) պայմանագրի գործողության ողջ ընթացքում:',
        acba_info:
            "ՀԱՄԱՁԱՅՆԱԳԻՐ  Սույնով տալիս եմ իմ համաձայնությունը, որ.  • «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ-ն հարցումներ կատարի «ԱՔՌԱ Քրեդիտ Ռեփորթինգ» ՓԲԸ-ին և վերջինիս խնդրում եմ «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ-ին տրամադրել իմ ներկա և անցյալ ֆինանսական պարտավորությունների վերաբերյալ տեղեկություններ, ինչպես նաև այլ տվյալներ, որոնք «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ կողմից կարող են հաշվի առնվել ինձ հետ վարկային (փոխառության և այլն) պայմանագիր կնքելու վերաբերյալ որոշում կայացնելիս: • «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ կողմից վարկային (փոխառության և այլն) պայմանագիր կնքելու դեպքում տվյալ վարկային (փոխառության և այլն) պայմանագրի գործողության ողջ ընթացքում, իսկ գլխավոր վարկային պայմանագրի առկայության դեպքում նաև վերջինիս գործողության ողջ ընթացքում ցանկացած պահի առանց ինձ նախապես տեղյակ պահելու «ԱՔՌԱ Քրեդիտ Ռեփորթինգ» ՓԲԸ-ն «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ-ին տրամադրի իմ ապագա ֆինանսական պարտավորությունների վերաբերյալ տեղեկություններ, ինչպես նաև այլ տվյալներ:  • «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ-ն հարցում կատարի «Նորք» սոցիալական ծառայությունների տեխնոլոգիական և իրազեկման կենտրոն հիմնադրամին, և խնդրում եմ վերջինիս տրամադրել իմ վերաբերյալ ցանկացած տեղեկատվություն, որը կարող է կիրառվել Բանկի կողմից:  • «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ-ն սեփականության կամ ընդհանուր սեփականության իրավունքով ինձ պատկանող գույքերի վերաբերյալ հարցում կատարի ՀՀ կադաստրի կոմիտե և ստանա սպառիչ տեղեկատվություն իմ գույքային իրավունքների, այդ թվում` դրանց ծագման հիմքերի վերաբերյալ, ինչպես նաև կադաստրային գործից ստանա սեփականության իրավունքի վկայականի, հատակագծի և այլ անհրաժեշտ փաստաթղթերի պատճենները, իմ անունից դիմում ներկայացնի ՀՀ կադաստրի կոմիտե, կատարի անշարժ գույքի նկատմամբ ցանկացած իրավունքի պետական գրանցում, ստանա փաստաթղթեր,կատարի վճարումներ` մինչև իմ վարկային (փոխառության և այլն) պարտավորության լրիվ կատարումը:  • «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ-ն սեփականության կամ ընդհանուր սեփականության իրավունքով ինձ պատկանող տրանսպորտային միջոցների վերաբերյալ հարցում կատարի ՀՀ Ճանապարհային ոստիկանություն և ստանա սպառիչ տեղեկատվություն տրանսպորտային միջոցների նկատմամբ իմ գույքային իրավունքների, այդ թվում` դրանց ծագման հիմքերի վերաբերյալ, ինչպես նաև ստանա սեփականության իրավունքի վկայականի և այլ անհրաժեշտ փաստաթղթերի պատճենները` մինչև իմ վարկային (փոխառության և այլն) պարտավորության լրիվ կատարումը:  • «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ-ն հարցում կատարի «Հայաստանի ավտոապահովագրողների բյուրո» ԻԱՄ-ին և ապահովագրական ընկերություններին և ստանա ցանկացած տեղեկատվություն սեփականության իրավունքով ինձ պատկանող տրանսպորտային միջոցների ապահովագրության վերաբերյալ (այդ թվում՝ ապահովադրի և շահառուների վերաբերյալ տեղեկություններ)` մինչև իմ վարկային (փոխառության և այլն) պարտավորության լրիվ կատարումը:  • «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ կողմից ինձ ուղարկվեն ծանուցումներ` «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ-ի կողմից մատուցվող ծառայությունների հետ կապված ցանկացած տեղեկատվության վերաբերյալ:  • Սույնով ծանուցվում եմ, ինչպես նաև տալիս եմ իմ համաձայնությունը, որ «Անձնական տվյալների պաշտպանության մասին» ՀՀ օրենքի համաձայն՝ «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ-ն (ՀՀ, ք. Երևան, Արամի 82-84) 50 տարվա ընթացքում հարցումներ կատարի «Էլեկտրոնային կառավարման ենթակառուցվածքների ներդրման գրասենյակ» ՓԲԸ (ԷԿԵՆԳ)` ՀՀ Ոստիկանության բնակչության պետական ռեգիստրի, ՀՀ Արդարադատության նախարարության քաղաքացիական կացության ակտերի գրանցման գործակալության, ՀՀ Ոստիկանության ճանապարհային ոստիկանության, ՀՀ ԱՆ Իրավաբանական անձանց պետական ռեգիստրի, ՀՀ Արդարադատության նախարարության հարկադիր կատարման ծառայության, ՀՀ ԿԱ Պետական եկամուտների կոմիտեի և ՀՀ կադաստրի կոմիտեի տվյալներից իմ վերաբերյալ ցանկացած տեղեկատվություն ստանալու նպատակով, որն օգտագործվելու և ուսումնասիրվելու է ծառայությունների մատուցման հետ կապված ցանկացած գործընթացում, ինչպես նաև իմ անձնական տվյալները «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ-ի կողմից փոխանցվի «ԱՔՌԱ Քրեդիտ Ռեփորթինգ» ՓԲԸ, ՀՀ կենտրոնական բանկ, պետական իրավասու մարմիններ և այն իրավաբանական անձանց, որոնց կանոնադրական կապիտալում «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ-ն ունի ուղղակի կամ անուղղակի մասնակցություն: Համաձայնությունը/անձնական տվյալները կարող են հետ կանչվել, ուղղվել, ոչնչացվել, իսկ տվյալների մշակումը՝ դադարեցվել իմ գրավոր դիմումի հիման վրա: Գիտակցում եմ, որ տրամադրված տեղեկությունները և տվյալները, կախված դրանց բովանդակությունից, կարող են ազդել «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ կողմից կայացված համապատասխան որոշման վրա: Սույն համաձայնությունը կարդացել եմ և հավաստում եմ, որ այն ինձ համար ամբողջությամբ հասկանալի և ընդունելի է:",
        evoca_info:
            'Օնլայն ապառիկ Ապառիկ վարկավորման հիմնական պայմաններ Ծանոթացեք պայմաններին և սեղմեք "Սկսել գործընթացը" կոճակը:  Վարկի համար կարող են դիմել 21 տարին լրացած ՀՀ ռեզիդենտները, որոնց տարիքը վարկի սպասարկման ընթացքում չի գերազանցի 63 տարեկանը: Վարկի տրամադրման ժամկետ\t24 ամիս Վարկավորման գումար\t100000.0 ՀՀ դրամից մինչև 3000000.0 ՀՀ դրամ Վարկի տրամադրման եղանակ\tանկանխիկ Գնորդի միջնորդավճար (հաշվարկվում է վարկի սկզբնական մայր գումարի վրա)\t0% ամսական Վարկի անվանական տոկոսադրույք\t21.5% Կանխավճար\t0 ՀՀ դրամ      Համաձայն եմ պայմաններին   Համաձայն եմ, որ «Էվոկաբանկ» ՓԲԸ-ն հարցումներ կատարի և ստանա տեղեկություններ «Նորք» սոցիալական ծառայությունների տեխնոլոգիական և իրազեկման կենտրոն հիմնադրամից, «Էլեկտրոնային կառավարման ենթակառուցվածքների ներդրման գրասենյակ» (ԷԿԵՆԳ) ՓԲԸ-ից և «ԱՔՌԱ Քրեդիտ Ռեփորթինգ» ՓԲԸ-ի կողմից',
        idram: "Idram",
        isy_pay: "Easy pay",
        telcell: "Telcell",
        thank_you: "Շնորհակալություն",
        recipient: "Պատվիրող",
        payment_type: "Վճարման տարբերակ",
        product_quantity: "Ապրանքի քանակ",
        ushadrutyun: "Ուշադրություն",
        insufficient_funds: "Անբավարար միջոցներ",
        close: "Փակել",
        order_num: "Պատվեր №",
        my_order_list: "Իմ պատվերների ցուցակ",
        my_purchase: "Իմ գնումները",
        sellers_order: "Վաճառողների պատվեր",
        complete_order: "Ավառտել պատվերը",
        total_order: "Ընդհանուր պատվեր",
        print: "Տպել",
        order_status: "Պատվերի կարգավիճակը",
        confirmed: "Հաստատված",
        declined: "Մերժված",
        manage_order_process: "Կառավարել պատվերի գործընթացը",
        order_confirmation: "Պատվերի հաստատում",
        paid: "Վճարված",
        delivery_status: "Առաքման կարգավիճակ",
        track_order: "Հետևել պատվերին",
        cancel_reason: "Չեղարկման պատճառը",
        proccessing: "Մշակում",
        shipped: "Առաքվել է",
        grand_total: "Ընդհանուր",
        subtotal: "Ենթագումար",
        delivered: "Առաքվել է",
        delivery_process: "առաքման գործընթաց",
        add_new_delivery_process: "Առաքվում է նոր առաքման գործընթաց",
        edit_delivery_process: "Խմբագրել առաքման գործընթաց",
        order_list: "Պատվերների ցանկ",
        complete: "Ավարտված",
        pending_payment_orders: "Սպասվող վճարման հանձնարարականներ",
        total_product_qty: "Ընդհանուր ապրանքի քանակ",
        is_paid: "Վճարված է",
        order_state: "Պատվեր",
        order_info: "Պատվերի տեղեկատվություն",
        is_cancelled: "Չեղարկված է",
        inhouse_orders: "Ներքին պատվերներ",
        create_new_order: "Ստեղծել նոր պատվեր",
        all_order: "Բոլոր պատվերները",
        create_order: "Ստեղծել պատվեր",
        processing_order: "Պատվերի մշակում",
        no_product_selected: "Ոչ մի ապրանք չի ընտրվել",
        total_quantity: "Ընդհանուր Քանակ",
        sub_total: "Ենթագումար",
        ordered_products: "Պատվիրված ապրանքներ",
        total_shipping_charge: "Ընդհանուր առաքման վճար",
        inhouse_order_list: "Ներքին պատվերների ցանկ",
        please_create_account_for_deposite_main_income_seller_income_product_wise_tax_and_gst_tax:
            "Խնդրում ենք ստեղծել հաշիվ ավանդների հիմնական եկամուտի, վաճառողի եկամուտի, ապրանքի հարկի և GST հարկի համար !!!",
        payment_successful_your_order_will_be_despatched_in_the_next_48_hours:
            "Վճարումը հաջողվեց, ձեր պատվերը կառաքվի 48 ժամվա ընթացքում",
        oredre_created_successfully: "Ձեր պատվերը ընդունված է:",
        order_submit_failed: "Պատվերը չհաջողվեց ուղարկել",
        edit_cancel_reason: "Խմբագրել չեղարկման պատճառը",
        in_house_order: "Ներքին պատվեր",
        no_order_found: "Պատվերը չի գտնվել",
        checkout: "Վճարում",
        your_order_has_been_cancelled: "Ձեր պատվերը չեղարկվել է",
        order_cancellation_failed: "Պատվերի չեղարկումը ձախողվեց:",
        your_order_cancellation_has_been_failed_try_again:
            "Ձեր պատվերի չեղարկումը ձախողվեց: Կրկին փորձեք:",
        your_package_order_has_been_cancelled: "Ձեր փաթեթի պատվերը չեղարկվել է",
        package_order_cancellation_failed: "Փաթեթի պատվերի չեղարկումը ձախողվեց:",
        order_confirm: "Պատվերի հաստատում",
        label: "Պիտակ",
        "Page Builder": "կառուցել Էջ",
        Pages: "Էջեր",
        Page: "Էջ",
        "Add New": "Ավելացնել նորը",
        SL: "SL",
        Title: "Title",
        Status: "Կարգավիճակ",
        Body: "Մարմին",
        Create: "Ստեղծել",
        "Create Page": "Ստեղծել էջ",
        "Update Page": "Վերբեռնել էջը",
        Design: "Դիզայն",
        previous: "Նախորդ",
        next_pagination: "հաջորդ էջավորում",
        reset: "Ձեր գաղտնաբառը վերականգնվել է:",
        sent: "Մենք ձեզ էլեկտրոնային փոստով ուղարկել ենք գաղտնաբառի վերակայման հղումը:",
        throttled: "Խնդրում ենք սպասել, նախքան նորից փորձելը",
        token: "Գաղտնաբառի վերակայման այս նշանն անվավեր է",
        paypal: "Paypal",
        paypal_configuration: "Paypal Կոնֆիգուրացիա",
        paypal_client_secret: "Paypal հաճախորդի գաղտնի բանալի",
        paypal_client_id: "Paypal Հաճախորդի ID",
        stripe: "Stripe",
        stripe_configuration: "Stripe Կոնֆիգուրացիա",
        stripe_key: "Stripe Բանալի",
        stripe_secret_key: "Stripe գաղտնի բանալի",
        stripe_user_name: "Stripe Օգտագործողի անունը",
        paystack_configuration: "Paystack Կոնֆիգուրացիա",
        paystack_key: "Paystack Key",
        paystack_secret_key: "Paystack Secret Key",
        paystack_merchant_email: "Paystack Merchant Email",
        paystack: "Paystack",
        razor_secret_key: "Razor Pay Secret Key",
        razor_key: "razor_key",
        razorpay: "RazorPay",
        instamojo_payment: "Instamojo payment",
        razorpay_configuration: "RazorPay Configuration",
        paystack_payment_url: "Paystack վճարման URL",
        bank_configuration: "Բանկի կոնֆիգուրացիա",
        paytm: "PayTM",
        paytm_configuration: "Paytm կոնֆիգուրացիա",
        paytm_environment: "Paytm Environment",
        merchant_id: "Գործընկերոջ ID",
        merchant_key: "Գործընկերոջ  բանալի",
        merchant_website: "Գործընկերոջ վեբկայք",
        paytm_channel: "Paytm Channel",
        paytm_industry_type: "Paytm Industry Type",
        instamojo: "Instamojo",
        instamojo_configuration: "Instamojo Configuration",
        auth_token: "Auth Token",
        instamojo_url: "Instamojo Url",
        midtrans: "Midtrans",
        midtrans_configuration: "Midtrans Configuration",
        merchant_server_key: "Գործընկերոջ սերվերի բանալի",
        is_production_mode: "Արտադրության ռեժիմ է",
        merchant_client_key: "Գործընկերոջ հաճախորդի բանալին",
        sandbox_environment: "Sandbox Environment",
        production_environment: "Production Environment",
        payumoney: "PayUmoney",
        payumoney_configuration: "Payumoney Configuration",
        payu_money_mode: "PayU Money Mode",
        payumoney_key: "PayUmoney Key",
        payumoney_salt: "PayUmoney Salt",
        payumoney_auth: "PayUmoney Auth",
        jazzcash: "JazzCash",
        jazzcash_configuration: "JazzCash Configuration",
        salt_id: "Salt Id",
        live_url: "Live Url",
        google_pay: "Google Pay",
        google_pay_configuration: "Google Pay Configuration",
        gateway_name: "Gateway Անուն",
        merchant_name: "Գործընկերոջ անուն",
        flutter_wave_payment_configuration: "Flutter Wave Payment Configuration",
        public_key: "Հանրային բանալի",
        secret_hash: "Secret Hash",
        paddle: "Paddle",
        paddle_payment_configuration: "Paddle Payment Configuration",
        environment: "Շրջակա միջավայր",
        vendor_id: "Վաճառողի ID",
        vendor_auth_code: "Վաճառողի վավերացման կոդը",
        test: "Թեստ",
        live: "Ուղիղ",
        sandbox: "Sandbox",
        gateway_logo: "Gateway Logo",
        recharge_successfully: "Վերալիցքավորումը հաջողվեց",
        payment_details: "Վճարման մանրամասներ",
        name_on_card: "Անունը՝ քարտի վրա",
        cvc: "CVC",
        expiration_month: "Վավերականության ամիս",
        expiration_year: "Վավերականության տարի",
        please_correct_the_errors_and_try_again:
            "Խնդրում ենք ուղղել սխալները և կրկին փորձել:",
        pay_now_100: "Pay Now ($100)",
        bank_account_info: "Բանկային հաշվի ինֆորմացիա",
        bkash: "bkash",
        bkash_configuration: "Bkash Configuration",
        app_key: "App Key",
        app_secret: "App Secret",
        ssl_commerz: "Ssl Commerz",
        sslcommerz_configuration: "SslCommerz Configuration",
        api_domain_url: "Api Domain URL",
        store_id: "Խանութ սրահի ID",
        store_password: "Խանութ սրահի գաղտնաբառ",
        mercado_pago_configuration: "Mercado Pago Configuration",
        mercado_pago: "Mercado Pago",
        card_expiration_date: "Քարտի վավերականության ժամկետը",
        cardholder_name: "Քարտապանի անունը",
        cardholder_email: "Քառտապանի Էլ-հսսցե",
        security_code: "Անվտանգության կոդ",
        issuer: "Թողարկող",
        identification_type: "Նույնականացման տեսակը",
        identification_number: "Նույնականացման համար",
        installments: "Ապառիկ",
        access_token: "Հասանելիության նշան",
        Payroll: "Payroll",
        "Select Criteria For Payroll": "Select Criteria For Payroll",
        "Not generated": "Չի ստեղծվել",
        Generated: "Ստեղծված",
        Paid: "Վճարված",
        "Proceed To Pay": "Շարունակեք վճարել",
        "View PaySlip": "Դիտեք PaySlip-ը",
        "Generate Payroll": "Ստեղծեք Աշխատավարձ",
        Earnings: "Եկամուտներ",
        PDF: "PDF",
        Deductions: "Նվազեցումներ",
        "Payslip Details": "Payslip Details",
        Address: "Հասցե",
        "Payroll Summary": "Աշխատավարձի ամփոփագիր",
        "Prepared By": "Պատրաստված է",
        "Approved By": "Հաստատված է",
        "Paid By": "Վճարված է",
        Calculate: "Հաշվեք",
        "Gross Salary": "Համախառն աշխատավարձը",
        Tax: "Հարկ",
        "Net Salary": "Աշխատավարձ",
        "Staff Name": "Աշխատակազմի անվանումը",
        "Payment Date": "Վճարման օր",
        "Payment Amount": "Վճարի չափը",
        Bank: "Բանկ",
        Note: "Նշում",
        "Pay Now": "Վճարել հիմա",
        "Paid Loan Amount": "Վճարված վարկի գումար",
        "Cheque No": "անդորրագրի №",
        "Account No": "Հաշվի №",
        "View Payslip Details": "View Payslip Details",
        "Payslip for the period of": "Payslip for the period of",
        Payslip: "Payslip",
        "Payroll Reports": "Payroll Reports",
        "Paid Date": "Վճարման ամսաթիվ",
        "Loan Status": "Վարկի կարգավիճակ",
        "Basic Salary": "Basic Salary",
        "Total Loan": "Ընդհանուր վարկ",
        "Due Loan Amount": "Ժամկետանց վարկի գումարը",
        "Paid Amount": "Վճարված գումար",
        Installment: "Ապառիկ",
        "Total Earning": "Ընդհանուր եկամուտ",
        "Total Deduction": "Ընդհանուր նվազեցում",
        category_group: "Բաժինների խմբեր",
        products: "Ապրանքներ",
        brand_list: "Ապրանքանիշի ցուցակ",
        add_new_brand: "Ավելացնել նոր բրենդ",
        edit_brand: "Խմբագրել",
        my_product_list: "Իմ ապրանքների ցուցակը",
        Slug: "Հղում",
        stickers: "Սթիկեր",
        total_product: "Ընդհանուր",
        num_of_sale: "Վաճառքի քանակը",
        category_info: "Կատեգորիայի տեղեկություն",
        recent_view_config: "Վերջին դիտումների կոնֆիգուրացիան",
        recently_viewed_product_configuration:
            '"Վերջերս դիտված ապրանքների" կոնֆիգուրացիա',
        max_limit_of_product_store_for_per_user:
            "Max Limit of Product Store for per user",
        remove_stored_data_after_days: "Remove Store Data After Days",
        cronjob_url: "Cronjob url",
        weight: "Քաշ",
        bulk_category_upload: "Զանգվածային կատեգորիայի վերբեռնում",
        bulk_brand_upload: "Բրենդի զանգվածային վերբեռնում",
        bulk_product_upload: "Ապրանքի զանգվածային վերբեռնում",
        category_csv: "Կատեգորիայի csv",
        brand_csv: "Ապրանքանիշի  csv",
        units_csv: "units csv",
        bulk_upload: "Bulk Upload",
        bulk_gift_card_upload: "Զանգվածային նվեր քարտի վերբեռնում",
        website_link: "Կայքի հղում",
        brand_info: "Բրենդի ինֆորմացիա",
        "Sort By Order": "Դասավորել ըստ կարգի",
        attribute: "Ատրիբուտներ",
        add_new_attribute: "Ավելացնել",
        i_want_to_manage_stock_for_this_product:
            "Ես ուզում եմ կառավարել այս ապրանքի պաշարները",
        new_product: "Ավելացնել ապրանք",
        existing_product: "Առկա ապրանք",
        attributes_value: "Ատրիբուտների արժեք",
        clone_product: "Կրկնել ապրանքը",
        add_value: "Ավելացնել արժեք",
        video: "Վիդեո",
        edit_attribute: "Փոփոխել ատրիբուտը",
        show_attribute: "Ցույց տալ ատրիբուտը",
        dropdown: "Dropdown",
        check_box: "Check Box",
        radio_button: "Ռադիո կոճակ",
        units: "Միավորներ",
        add_new_unit: "Ավելացնել նոր միավոր",
        edit_unit: "Փոփոխել միավորը",
        add_new_product: "Ավելացնել նոր ապրանք",
        product_information: "Ապրանքի ինֆորմացիա",
        select_category: "Ընտրել բաժինը",
        logo: "Լոգոտիպ",
        sub_category: "Ենթաբաժին",
        select_sub_category: "Ընտրել ենթաբաժինը",
        select_brand: "Ընտրել բրենդը",
        unit: "Չափման միավոր",
        select_unit: "Ընտրել Չափման միավոր",
        select_tag: "Ընտրել  Tag",
        select_barcode: "Ընտրել շտրիխ կոդ",
        barcode_type: "Շտրիխ կոդ",
        minimum_order_qty: "Նվազագույն Պատվերի Քանակ",
        meta_image: "Մետա նկար",
        pdf_specifications: "Pdf-ի Տեխնիկական պայմաններ",
        Browse: "Ընտրել",
        product_shipping_cost: "Ապրանքի առաքման արժեքը",
        publish_info: "Հրապարակել տեղեկատվությունը",
        shipping_cost: "Առաքման արժեքը",
        free_shipping: "Անվճար առաքում",
        flat_rate: "Ֆիքսված տոկոսադրույք",
        product_videos_info: "Ապրանքի վիդեո տեղեկատվություն",
        video_link: "Տեսանյութի հղում",
        video_provider: "Տեսանյութերի մատակարար",
        youtube: "Youtube",
        daily_motion: "Daily Motion",
        others_info: "Այլ ինֆորմացիա",
        product_image_info: "Dailymotion ապրանքի պատկերի մասին տեղեկություններ",
        thumbnail_image: "Thumbnail-ի նկար",
        galary_image: "Պատկերասրահի նկար",
        price_info_and_stock: "Գների մասին տեղեկություններ և քանակության",
        purchase_price: "Գնման գին",
        selling_price: "Վաճառքի գինը",
        tax_type: "Հարկի տեսակը",
        stock_qty: "Պահեստային Քանակ",
        variant: "Տարբերակ",
        select_attribute: "Ընտրեք attribute",
        SKU: "SKU",
        variation: "Փոփոխություն",
        max_order_qty: "Առավելագույն Պատվեր Քանակ",
        shipping_type: "Առաքման տեսակը",
        product_sku: "Ապրանքի SKU",
        inhouse_product_list: "Ներքին ապրանքների անկ",
        add_inhouse_product_list: "Ավելացնել ներքին ապրանքների  ցանկը",
        edit_product: "Խմբագրել",
        details: "Մանրամասներ",
        product_name: "Ապրանքի անվանում",
        unit_cost: "Միավորի",
        variant_items: "Փոփոխվող մասեր",
        seller_request_product: "Վաճառողի հայցված ապրանք",
        program_file_upload: "ծրագրի ֆայլի վերբեռնում",
        download_file: "Ներբեռնել ֆայլը",
        click_on_it: "Սեղմեք վրան",
        add_category: "Ավելացնել կատեգորիա",
        add_category_group: "Ավելացնել կատեգորիա խումբ",
        edit_category_group: "Խմբագրել կատեգորիայի խումբը",
        add_sub_category: "Ավելացնել ենթակատեգորիա",
        category_group_list: "Ավելացնել ենթակատեգորիա",
        sorting: "Դասակարգել",
        edit_category: "Խմբագրել",
        add_as_sub_category: "Ավելացնել որպես ենթակատեգորիա",
        show_category: "Ցույց տալ կատեգորիա",
        attribute_name: "Attribute-ի անուն",
        attribute_value: "Attribute-ի  արժեքը",
        product_by_sku: "Product By SKU",
        sku_update: "SKU Update",
        in_stock: "Առկա է",
        show_category_group: "Ցույց տալ կատեգորիայի խումբը",
        sub_categories: "Ենթակատեգորիաներ",
        display_name: "Ցուցադրվող անուն",
        file_size_must_be_less_than_1mb: "Ֆայլի չափը պետք է լինի 1 ՄԲ-ից պակաս",
        type_should_be_jpg_jpeg_png:
            "Անվավեր տեսակ., տեսակը պետք է լինի jpeg, jpg, png",
        color_name: "Գույնի անվանում",
        general_information: "Գլխավոր ինֆորմացիա",
        related_product: "Նմանատիպ ապրանքներ",
        specifications: "Տեխնիկական պայմաններ",
        is_physical_product: "Is physical Product?",
        download_link: "Ներբեռնման հղում",
        upload_file: "Ներբեռնել ֆայլ",
        additional_shipping_charge: "Հավելյալ առաքման վճար",
        shipping_methods: "Առաքման եղանակներ",
        thumbnail: "Նկար",
        save_information:
            "Save After Fillup All General Information & Հարակից ապրանքները, կատեգորիայով բարձր ապրանքներն ու կից ապրանքները",
        sku: "SKU",
        discount_period: "Զեղչի ժամանակաշրջան",
        alert_list: "Խնդիրներով ցանկ",
        out_of_stock_list: "Առկա չէ ցանկ",
        disabled_product_list: "Անջատված ապրանքի ցանկ",
        uploading_product_is_disabled_according_to_your_package_right_now:
            "Uploading product is disabled according to your package right now",
        create_gift_card: "Ստեղծել  նվեր քարտ",
        edit_gift_card: "Խմբագրել նվեր քարտը",
        card_number: "Քարտի համարը",
        product_variants: "Ապրանքի տարբերակներ",
        related_data_exist_in_multiple_directory:
            "Related Data Exist in Multiple Directory",
        to_use_themefy_icon_please_type_here_or_select_fontawesome_from_list:
            "To use themefy icon please type here Or Select fontawesome from list",
        invalid_type_type_should_be_jpeg_jpg_png:
            "Invalid Type: Type should be jpeg, jpg, png",
        create_attribute: "Ստեղծել Attribute",
        create_brand: "Ստեղծել Brand",
        create_unit: "Ստեղծել միավոր",
        file_must_be_less_than_1_mb: "Ֆայլը պետք է լինի 1 ՄԲ-ից պակաս",
        please_input_product_name: "Մուտքագրեք ապրանքի անվանումը",
        please_input_product_sku: "Մուտքագրեք ապրանքի մոդելը",
        please_select_category: "Ընտրեք բաժինը",
        please_select_product_unit: "Խնդրում ենք ընտրել ապռանքի միավորը",
        please_input_minimum_order_qty:
            "Խնդրում ենք մուտքագրել նվազագույն պատվերի քանակը",
        please_input_purchase_price: "Խնդրում ենք մուտքագրել գնման գինը",
        please_input_selling_price: "Խնդրում ենք մուտքագրել վաճառքի գինը",
        please_input_tax: "Խնդրում ենք մուտքագրել հարկի չապ",
        please_input_discount_minimum_0:
            "Խնդրում ենք մուտքագրել զեղչ նվազագույնը 0",
        please_upload_thumnail_image: "Խնդրում ենք վերբեռնել thumnail-ի պատկերը",
        please_select_shipping_method: "Խնդրում ենք ընտրել Առաքման եղանակը",
        please_input_tags: "Խնդրում ենք մուտքագրել Թեգեր",
        please_select_attribute: "Խնդրում ենք ընտրել  Attribute",
        no_more_data_to_show: "Ցուցադրելու այլ տվյալներ չկան",
        weight_kg: "Քաշ (կգ)",
        dimension_cm_lenth_x_width_x_height:
            "Չափ (սմ) (երկարություն x լայնություն x բարձրություն)",
        product_stock_manage: "Ապրանքի պահեստաին քանակի կառավարում",
        product_stock: "Product Stock",
        select_product_sku: "Select Product SKU",
        stock: "Stock",
        cart_product: "Cart Product",
        purchased_gift_card: "Purchased gift card",
        discount_start_date: "Discount Start Date",
        discount_end_date: "Discount End Date",
        redeem_successfully: "Redeem Successfully!",
        gift_card_already_used: "Նվեր քարտն արդեն օգտագործված է",
        invalid_giftcard: "Անվավեր նվեր քարտ:",
        rechaged_successfully: "Rechaged Successfully!",
        single_product: "Մեկ ապրանք",
        comma_separated: "Comma Separated",
        color_attribute_is_not_deletable: "Color attribute is not deletable!",
        variant_product_is_not_changable_to_single_product:
            "Variant Product Is Not Changable To Single Product",
        change_not_possible_for_use: "Փոփոխումը հնարավոր չէ օգտագործման համար",
        attribute_add_not_possible_for_this_product:
            "Ատրիբուտի հնարավոր չէ ավելացնել այս ապրանքի համար",
        height: "Բարձրություն",
        breadth: "Breadth",
        length: "Երկարություն",
        weight_height_info: "Լայնության և բարձրության ինգորմացիա",
        please_input_product_weight: "Խնդրում ենք տեղադրել  ապրանքի լայնությունը",
        please_input_product_breadth:
            "Խնդրում ենք մուտքագրել արտադրանքի լայնությունը",
        please_input_product_length:
            "Խնդրում ենք մուտքագրել արտադրանքի երկարությունը",
        please_input_product_height:
            "Խնդրում ենք մուտքագրել արտադրանքի բարձրությունը",
        this_product_already_used_on_order_or_somewhere_so_delete_not_possible:
            "Այս ապրանքն արդեն օգտագործվել է պատվերի կամ այլ ժամանակ: Հետևաբար ջնջել հնարավոր չէ",
        subtitle_1: "Subtitle 1",
        subtitle_2: "Subtitle 2",
        top_piketc: "Վաճառքի հիթեր",
        catalog: "Catalog",
        spec_pric: "Հատուկ գներ",
        promotions: "Ակցիաներ",
        them_1: "TOSHIBA Template",
        them_: "Template",
        them_2: "SAMSUNG Template",
        them_3: "HISENSE Template",
        them_4: "VIKAS Template",
        la_news: "Վերջին նորությունները",
        in_header: "In header",
        be_inter: "Ձեզ կարող է հետաքրքրել",
        add_page_info: "TOSHIBA Template One Info",
        add_page2_info: "SAMSUNG Template Page  Info",
        add_page2_info_add: "Add Template Page Two Info",
        add_page2_info_slider: "Template Page Two Info Slider",
        add_page3_info: "HISENSE Template Page  Info",
        add_page4_info: "VIKAS Template Page  Info",
        text_1_en: "Text 1 EN",
        text_1_ru: "Text 1 RU",
        text_1_hy: "Text 1 HY",
        text_2_en: "Text 2 EN",
        text_2_ru: "Text 2 RU",
        text_2_hy: "Text 2 HY",
        baner_111_en: "Product One Image EN",
        baner_111_ru: "Product One Image RU",
        baner_111_hy: "Product One Image HY",
        baner_gl_en: "Glavni baner EN",
        baner_gl_ru: "Glavni baner RU",
        baner_gl_hy: "Glavni baner HY",
        baner_1_en: "Baner 1 EN",
        baner_1_ru: "Baner 1 RU",
        baner_1_hy: "Baner 1 HY",
        baner_2_en: "Baner 2 EN",
        baner_2_ru: "Baner 2 RU",
        baner_2_hy: "Baner 2 HY",
        baner_3_en: "Baner 3 EN",
        baner_3_ru: "Baner 3 RU",
        baner_3_hy: "Baner 3 HY",
        baner_4_en: "Baner 4 EN",
        baner_4_ru: "Baner 4 RU",
        baner_4_hy: "Baner 4 HY",
        baner_5_en: "Baner 5 EN",
        baner_5_ru: "Baner 5 RU",
        baner_5_hy: "Baner 5 HY",
        baner_6_en: "Baner 6 EN",
        baner_6_ru: "Baner 6 RU",
        baner_6_hy: "Baner 6 HY",
        character: "Բնութագիր",
        comparison: "ՀԱՄԵՄԱՏԵԼ",
        similar_products: "Այս ապրանքի հետ գնում են",
        lot_sellers: "Շատ վաճառվածներ",
        with_product: "Այս ապրանքի հետ գնում են",
        month: "Ամիս",
        buy_on_credit: "Գնել ապառիկ",
        installing: "Տեղադրում",
        installingText: "Նշված արժեքը ներառում է տեղադրման ծառայությունը",
        choose_the_gifts: "Ընտրեք նվերը",
        from_the_gift_list: "from the gift list",
        add_new_attribute_grupe: "Ավելացնել",
        edit_attribute_grupe: "Խմբագրել",
        show_attribute_grupe: "Ցույց տալ ատրիբուտների խումբը",
        attribute_grup: "Ատրիբուտների խումբ",
        hew_you_watched: "Դուք դիտել եք",
        jobo: "Աշխատատեղեր",
        som_wrong: "Ինչ-որ բան սխալ գնաց",
        not_vos_query: "Ձեր հարցումով ոչինչ չի գտնվել",
        porceq_poxel: "Փորձեք փոխել ձևակերպումը կամ գտեք մեր",
        product_not_found: "Ապրանքը չի գտնվել",
        descr1_en: "Descr 1 En",
        descr1_ru: "Descr 1 Ru",
        descr1_hy: "Descr 1 Hy",
        subtitle1_en: "Sub Title 1 En",
        subtitle1_ru: "Sub Title 1 Ru",
        subtitle1_hy: "Sub Title 1 Hy",
        subtitle2_en: "Sub Title 2 En",
        subtitle2_ru: "Sub Title 2 Ru",
        subtitle2_hy: "Sub Title 2 Hy",
        subtitle3_en: "Sub Title 3 En",
        subtitle3_ru: "Sub Title 3 Ru",
        subtitle3_hy: "Sub Title 3 Hy",
        descr2_en: "Descr 2 En",
        descr2_ru: "Descr 2 Ru",
        descr2_hy: "Descr 2 Hy",
        add_page3_info_add: "Add Template Page Three Info",
        add_page3_info_slider: "Template Page Three Info Slider",
        average_price: "Միջին գին",
        sort_id: "Sort ID",
        subtitle4_en: "Sub Title 4 En",
        subtitle4_ru: "Sub Title 4 Ru",
        subtitle4_hy: "Sub Title 4 Hy",
        add_page4_info_add: "Add Template Page Four Info",
        add_page4_info_slider: "Template Page Four Info Slider",
        baner_7_en: "Baner 7 EN",
        baner_7_ru: "Baner 7 RU",
        baner_7_hy: "Baner 7 HY",
        baner_8_en: "Baner 8 EN",
        baner_8_ru: "Baner 8 RU",
        baner_8_hy: "Baner 8 HY",
        add_page3_info_photos: "Template Page Three Info Photos",
        discount_available: "Ակցիան գործում է :star  մինչև :ende",
        select_attribute_grup: "Ընտրեք ատրիբւտի խումբը",
        active_product_list: "Ակտիվ ապրանքների ցանկ",
        new_product_list: "Նոր ապրանքի ցանկ",
        refund_manage: "Վերադարձի կառավարում",
        reasons: "Պատճառներ",
        reason_list: "Պատճառների ցուցակ",
        add_new_reason: "Ավելացնել նոր պատճառ",
        reason: "Վերադարձի պատճառը",
        edit_reason: "Խմբագրել Պատճառը",
        configuration: "Կարգավորում",
        refund_time: "Գումարի վերադարձի ժամանակը",
        refund_activate: "Վերադարձի ակտիվացում",
        in_days: "Օրերով",
        all_pending_requests: "Բոլոր սպասող հարցումները",
        all_pending_refund_requests: "Վերադարձման սպասող բոլոր հարցումները",
        request_confirmation: "Հաստատման հարցում",
        refund_money_status: "Վերադարձի կարգավիճակ",
        my_refund_requests: "Իմ փոխհատուցման հարցումները",
        pending_refund_requests: "Սպասվող վերադարձման հայցեր",
        confirmed_refund_requests: "Հաստատված վերադարձման հայցեր",
        processing_state: "Մշակման կարգավիճակ",
        payable_refund_request: "Վճարման ենթակա գումարի վերադարձ",
        refund_process: "Վերադարձման կարգավիճակ",
        add_refund_process: "Ավելացնել վերադարձման կարգավիճակ",
        edit_refund_process: "Փոխել վերադարձման կարգավիճակը",
        process_name: "Գործընթացի անվանումը",
        process: "Գործընթաց",
        is_completed: "Հաստատված է",
        request_status: "Հարցման կարգավիճակը",
        is_refunded: "Վերադարձված է",
        refund_success: "Հաջողությամբ վերադարձված է",
        select_product_first: "Սկզբում ընտրեք ապրանքը",
        return_qty: "Վերադարձի քանակ",
        refund_related_info: "Վերադարձի հետ կապված տեղեկատվություն",
        request_sent: "Հարցումն ուղարկվել է",
        refund_method: "Գումարի վերադարձման եղանակ",
        account_nb: "Հաշվեհամար",
        pick_up_info: "Ստանալ տեղեկատվություն",
        shipping_gateway: "Առաքման երթուղի",
        shipping_method: "Առաքման տարբերակ",
        post_code: "Փոստային կոդ",
        drop_of_info: "Թողնել ինֆորմացիա",
        additional_info: "Լրացուցիչ ինֆորմացիա",
        refund: "Վերադարձ",
        refund_name: "Անուն",
        refund_surname: "Ազգանուն",
        refund_email: "Էլ հասցե",
        "refund_order.number": "Պատվերի համար",
        "refund_phone.number": "Հեռախոսահամար",
        defects: "Թերությունների նկարագրություն",
        terms_conditions_agree:
            "Ես կարդացել եմ և համաձայն եմ պայմաններին ու դրույթներին",
        yes: "Այո",
        parcel: "Ծանրոցը բացված է",
        quantity: "Քանակ",
        delivery_terms: "Առաքման պայմանները",
        info_product: "Ապրանքի մասին տեղեկավություն",
        select_criteria_for_filtering: "Select Criteria for Filtering",
        report: "Հաշվետվություն",
        ip: "IP",
        number_of_time_visit: "Այցությունների ժամաքանակ",
        last_visited: "Վերջին այցելված",
        seller_id: "Վաճառողի id",
        seller_wise_sales_report: "Վաճաքողի վաճառքների հաշվետվություն",
        seller_wise_stock: "Seller Wise Stock",
        seller_wise_sales: "Վաճառողի վաճառքներ",
        admin_reports: "Ադմինի հաշվետվություններ",
        user_searches: "Օգտագործողի փնտրածներ",
        visitor: "Այցելու",
        user_search_report: "Օգտագործողի որոնման հաշվետվություն",
        keyword_search_report: "Հիմնաբառերի որոնման հաշվետվություն",
        keywords: "Հիմնաբառեր",
        number_of_time: "Ժամաքանակ",
        visitor_report: "Այցելուների հաշվետություն",
        wallet_recharge_history:
            "ՀԱՅԵՐԵՆ  ՌՈՒՍԵՐԵՆ  ԱՆԳԼԵՐԵՆ Բնօրինակի տեքստ Դրամապանակի լիցքավորման պատմություն",
        top_selling_item: "Թոփ վաճառված ապրանքներ",
        recently_product_review: "Ապրանքի մասին նոր մեկնաբանություններ",
        recently_seller_review: "Վաճառողի մասին նոր մեկնաբանություններ",
        inhouse_product_sale: "Ներքին ապրանքիի վաճառք",
        filter_selection_criteria: "Filter selection criteria",
        sale_type: "Վաճառքի տեսակ",
        number_of_user: "Օգտագործողի համար",
        number_of_wishlist_product: "Հավանած ապրանքների թվաքանակ",
        my_reports: "Իմ հաշվետվություններ",
        pending_product_review_list:
            "Սպասվող ապրանքի մասին մեկնաբանությունների ցանկ",
        approve_all_review: "Հաստատել բոլոր մեկնաբանությունները",
        approve_confirm: "Դուք վստահ ե՞ք, որ ուզում եք հաստատել բոլորը:",
        deny_confirm: "Դուք վստահ ե՞ք, որ ուզում եք մերժել",
        approve: "Հաստատել",
        deny: "Մերժել",
        deny_review: "Մերժումների մասին մեկնաբանություններ",
        customer_feedback: "Հաճախորդի կարծիք",
        customer_time: "Հաճախորդ և ժամ",
        approve_all: "Հաստատել բոլորը",
        pending_seller_review_list: "Սպասավող վաճառողի մասին կարծիքների ցանկ",
        declined_seller_review_list: "Մերժված վաճառողի մասին կարծիքներիուցակ",
        seller_review_list: "Վաճառողի մասին կարծիքների ցանկ",
        number_of_review: "Կարծիքների քանակ",
        product_review_list: "Ապրանքի վերաբերյալ կարծիքների ցանկ",
        replied_successfully: "Հաջողությամբ պատասխանված է",
        reply_to_customer: "Պատասխանել հաճախորդին",
        my_review_list: "Իմ կարիքների ցանկ",
        all_review: "Բոլոր կարծիքներ",
        all_product_review_list: "Բոլոր ապրանքների մասին կարծիքների ցանկ",
        declined_review_list: "Մերժված կարծիքների ցանկ",
        product_review: "Ապրանքի մասին կարծիք",
        seller_review: "Վաճառողի մասին կարծիք",
        my_product_review: "Իմ ապրանքի մասին կարծիք",
        my_review: "Իմ կարծիքներ",
        review_done_thanks_for_review:
            "Ձեր կարծիքը հաջողությամբ ընդունված է: Շնորհակալության Ձեր կարծիքով կիսվելու համար",
        review_already_exsist: "Մեկնաբանությունն արդեն գոյություն ունի",
        company_review: "Կազմակերպության մասին կարծիքներ",
        company_review_list: "Կազմակերպության մասին կարծիքների ցանկ",
        create_a_seller: "Ստեղծել վաճառողի",
        make_trusted: "Դարձնել վստահելի",
        remove_from_trusted: "Հեռացնել վստահելի ցանկից",
        alert_message: "Զգուշացման հաղորդագրություն",
        are_you_confirmed_to_execute_this_operation:
            "Դուք արդյոք հաստատված ե՞ք կատարելու այս գործողությունները",
        business_owner_name: "Իրավաբանական անուն/Բիզնեսի սեփականատիրոջ անուն",
        person_in_charge_name: "Լիազորված անձի անուն",
        business_registration_number: "Բիզնեսի գրանցման համարը",
        seller_tin: "Վաճառողի TIN",
        upload_business_document: "Վերբեռնել բիզնես փաստաթուղոը",
        holiday_start: "Տոնը սկսված է",
        holiday_end: "Տոնն ավարտված է",
        upload_cheque_copy: "Վերբեռնել կտրոնի պատճենը",
        same_as_warehouse_address: "Նույնն է ինչ պահեստի հասցեն",
        no_of_product: "Ապրանքի քանակ",
        txn_id: "TXN ID",
        approval: "Հաստատում",
        check_category_commissions: "Check Category Commissions",
        category_list_with_commission: "Category list with Commission",
        my_staff: "Իմ աշխատակազմ",
        add_new_staff: "Ավելացնել նոր աշխատատեղ",
        create_a_staff: "Խմբագրել աշխատատեղ",
        update_staff_info: "Խմբագրել աշխատատեղի ինֆորմացիան",
        joined_date: "Միացման ամսաթիվ",
        select_from_list: "Ընտրել ցանկից",
        add_member_is_disabled_according_to_your_package_right_now:
            "«Ավելացնել անդամ» այս պահին անջատված է ձեր փաթեթի համաձայն",
        seller_list: "Վաճառողների ցանկ",
        commision_setup: "Կոմիսիոն վճարների կարգավորումներ",
        manage_seller: "Փոխել վաճառողին",
        subscription_info: "Բաժանորդագրության ինֆորմացիա",
        subscription_title: "Բաժանորդագրության անվանում",
        next_payment_before: "Նախ հաջորդ վճարումը",
        subscription_payments: "Բաժանորդագրության վճարումներ",
        create_supplier: "Ստեղծել մատակարար",
        business_name: "Բիզնես անվանում",
        tax_number: "Հարկի համար",
        edit_supplier: "Խմբագրել մատակարարին",
        supplier_id: "Մատակարարի id",
        supplier: "Մատակարար",
        supplier_list: "Մատակարարների ցանկ",
        pay_condition: "Ուշադիր եղե՛ք",
        finance_information: "Ֆիանանսական ինֆորմացիա",
        pay_term: "Վճարման ժամկետ",
        pay_term_condition: "Վճարման ժամկետի պայամաններ",
        alternate_contact_no: "Այլընտրանքային կապի համար",
        supplier_profile: "Մատակարարի պրոֆիլը",
        office_xtract: "OfficeXtract",
        please_update_business_bank_information_from_profile_first:
            "Խնդրում ենք նախ պրոֆիլից թարմացնել բիզնեսի և բանկային տեղեկատվությունը",
        seller_profile: "Վաճառողի անձնական էջ",
        product_allready_added: "Ապրանքը արդեն ավելացվել է",
        about_seller: "Վաճառողի մասին",
        commission_calculate_for_multi_category:
            "Կոմիսիոն վճարի հաշվարկ բազմակի կատեգորիայի համար",
        minimum_rate: "Նվազագույն դրույքաչափ",
        maximum_rate: "Առավելագույն դրույքաչափ",
        average_rate: "Միջին դրույքաչափ",
        multi_category: "Բազմակի կատեգորիա",
        expire_date: "Վավերականության ժամկետ",
        already_expired: "Արդեն սպառված է",
        last_payment_date: "Վերջին վճարման ամսաթիվ",
        advance_renew_subscription: "Նախապես նորացնել բաժանորդագրությունը",
        after_change_and_save_previous_lisence_will_expried:
            "Փոփոխելուց և պահպանելուց հետո նախորդ լիցենզիայի ժամկետը կլրանա:",
        "Intro Prefix has been added Successfully":
            "Intro Prefix has been added Successfully",
        "Intro Prefix has been updated Successfully":
            "Intro Prefix has been updated Successfully",
        "A Intro Prefix has been destroyed Successfully":
            "A Intro Prefix has been destroyed Successfully",
        prefix: "Prefix",
        click_here_to_create_your_project:
            "Սեղմեք այստեղ՝ ձեր նախագիծը ստեղծելու համար",
        disable_google_analytics: "Disable Google Analytics",
        add_new_intro_prefix: "Ավելացնել նոր ներածական նախածանց",
        intro_prefix_list: "Ներածական նախածանցի ցանկ",
        intro_prefix: "Ներածական նախածանց",
        prefix_name: "Նախածանցի անվանում",
        prefix_details: "Նախածանցի մանրամասներ",
        edit_introprefix: "Ստեղծել ներածական նախածանց",
        add_new_tag: "Ավելացնել նոր թագ",
        edit_tag: "Խմբագրել թագը",
        payment_configuration: "Վճարման մեխանիզմ",
        analytics: "Վերլուծության գործիքներ",
        phonecode: "Հեռախոսահամարի կոդ",
        flag: "Դրոշ",
        google_analytics: "Google Analytics",
        enable_google_analytics: "Միացնել Google Analytics",
        click_here_to_create_google_analytics:
            "Սեղմեք այստեղ Google analytics ստեղծելու համար",
        facebook_pixel: "Facebook Փիքսել",
        enable_facebook_pixel: "Միացնել Facebook Փիքսել",
        click_here_to_create_facebook_pixel:
            "Սեղմեք այստեղ Facebook Փիքսել ստեղծելու համար",
        facebook_pixel_id: "Facebook Փիքսել ID",
        tracking_id_required: "Հետևելու ID-ն պարտադիր է",
        facebook_pixel_id_required: "Facebook Փիքսել ID պարտադիր է",
        enable_gs_analytics_for_your_dashboard:
            "Enable GS Analytics for your Dashboard",
        service_account_json_file: "Service Account Json File",
        measurement_id: "Չափման ID",
        measurement_protocol_api_secret: "Measurement Protocol API Secret",
        fill_in_the_two_fields_below_for_the_Google_Analytics_version_4:
            "Լրացրեք ստորև նշված երկու դաշտերը Google Analytics 4-րդ տարբերակի համար:",
        for_reporting_version_4_see_google_analytics_panel:
            "4-րդ տարբերակի հաշվետվության համար տես google analytics վահանակը:",
        add_new_shipping_method: "Ավելացնել առաքման նոր եղանակ",
        method_name: "Տարբեևակի անվանում",
        shipment_time: "Առաքման ժամանակ",
        "ex: 3 - 5 days or 6 -12 hrs": "օր.՝ 3-5 օրեր կամ 6 -12 ժամ",
        cost: "Արժեք",
        edit_method_info: "Խմբագրել մեթոդի տեղեկատվությունը",
        courier_pick_up: "Առաքիչի վերցնելը",
        drop_off: "Առաքիչի թողնելը",
        courier_pick_up_information: "Առաքիչի վերցնելու մասին ինֆորմացիա",
        drop_off_information: "Առաքիչի թողնելու մասին ինֆորմացիա",
        requested_by: "Պահաջված է",
        address_info: "Հասցե",
        shipping_address: "Առաքման հասցե",
        reset_address: "Վերականգնել հասցեն",
        order_packages: "Պատվիրեք փաթեթներ",
        please_save_customer_address_before_add_product:
            "Խնդրում ենք պահպանել հաճախորդի հասցեն՝ նախքան ապրանք ավելացնելը",
        company_info: "Կազմակերպության մասին ինֆորմացիա",
        create_shipping_method: "Ստեղծեք առաքման եղանակ",
        shipping_provider: "Առաքման մատակարար",
        request_history: "Հարցման պատմություն",
        carriers: "Առաքիչներ",
        carrier: "Առաքիչ",
        shiprocket: "Shiprocket",
        shiprocket_api_password: "Shiprocket API Password",
        shiprocket_api_email: "Shiprocket API Email",
        carrier_logo: "Առաքիչի լոգո",
        shipping_rates: "Առաքման սակագներ",
        add_new_shipping_rate: "Ավելացնել նոր առաքման սակագին",
        based_on: "Հիմնված",
        flat: "Բնակարան",
        edit_shipping_rate: "Խմբագրել առաքման սակագները",
        order_confirm_and_sync_with_carrier:
            "Պատվերի հաստատում և համաժամեցում առաքիչի  հետ",
        manual: "Ձեռքով",
        automatic: "Ավտոմատ",
        "admin_change_shipping_carrier_?": "Ադմինը փոխե՞լ է առաքիչին",
        "customer_call_see_carrier_?": "Հաճախորդը կարող է տեսնել առաքիչին",
        shipping_method_change: "Փոխել առաքման տարբերակը",
        all_selected_order_change_shipping_method:
            "Փոխել առաքման տարբերակը բոլոր ընտրված պատվերների համար",
        selected_order_shipping_method_change:
            "Փոխել առաքման տարբերակը ընտրված պատվերների համար",
        selected_order_change_shipping: "Ընտրված պատվերը փոխել է առաքման տեսակը",
        tracking_id: "Հետևելու ID",
        "order_will_auto_confirm_?": "Պատվերը կհաստատվի ավտոմատ",
        pickup_locations: "Ապրանքը վերցնելու վայրեր",
        pickup_location: "Ապրանքը վերցնելու վայր",
        add_new_pickup_location: "Ավելացնել ապրանքը վերցնելու վայր",
        pin_code: "Pin Code",
        edit_pickup_location: "Խմբագրել ապրանքը վերցնելու վայր",
        pickup_location_details: "Վերցնելու վայրի մանրամասներ",
        set_pickup_location: "Սահմանեք վերցնելու վայրը",
        shipping_orders: "Առաքման պատվերներ",
        label_download: "Ներբեռնել պիտակ",
        add_new_carrier: "Ավելացնել նոր առաքիչի",
        tracking_url: "Հետևելու  Url",
        update_carrier: "Թարմացնել առաքիչին",
        Quick: "Արագ",
        Custom: "Պատվերով",
        carrier_order_type: "Առաքման պատվերի տեսակը",
        packaging: "Փաթեթավորում",
        packaging_info: "Փաթեթավորման ինֆորմացիա",
        "refund_order_sync_carrier_?": "Պատվերի վերադարձի համաժամացման օպերատորը:",
        is_default: "ՀԻմնական է",
        shipping_by: "Առաքւմը",
        shipping_information: "Առաքման ինֆորմացիա",
        shiprocket_channel_id: "Shiprocket Channel ID",
        label_terms_condition: "Պիտակի պայմաններ և դրույթներ",
        label_terms_and_conditions: "Պիտակի պայմաններ և դրույթներ",
        terms_and_conditions: "Պայմաններ և դրույթներ",
        label_configuration: "Պիտակի կոնֆիգուրացիա",
        invoice: "Հաշիվ-ապրանքագիր",
        "seller_use_shiproket_?": "Seller use Shiproket ?",
        barcode: "Բար կոդ",
        qrcode: "Qr կոդ",
        both: "Եկուսն էլ",
        label_generate_use: "Label Generate Use",
        customer_address_update: "Հաճախորդի հասցեն թարմացված է",
        carrier_status: "Առաքիչի կարգավիճակ",
        min_shopping: "Նվազագույն գնում",
        collect_from_pickup_location: "Հավաքեք հավաքագրման վայրից",
        minimum_shopping_amount: "Նվազագույն գնման գին",
        without_shipping_cost: "Առանց առաքման վճարի",
        minium_shopping_amount_is_not_fulfill: "Նվազագույն գնման գինը լրացված չէ",
        cart_is_empty_please_add_product_first:
            "Զամբյուղը դատարկ է, Խնդրում ենք նախ ընտրել ապրանքը",
        about: "Մեր մասին",
        more: "Մանրամասն",
        news: "Բլոգ",
        see_all: "Տեսնել բոլորը",
        contact: "Կապ",
        shops: "Խանութներ",
        select_bank: "Լրացուցիչ տեղեկությունների համար ընտրեք բանկը",
        credit: "Ապառիկ",
        terms: "Պայմաններ",
        faq: "ՀՏՀ",
        order_formating: "Պատվերի ձևակերպում",
        knows_questions: "Հայտնի հարցեր",
        payment: "Վճարում",
        block: "Block",
        title_text: "Վերնագիր",
        link_text: "Հղման տեքստ",
        address_icon: "Հասցեյի նկար",
        address_title: "Address Title",
        work_time: "Աշխատանքային ժամ",
        tel_time: "Հեռախոս",
        soc_links_title: "Սոցիալական հղումների անուններ",
        email_title: "Էլ․հասցե",
        email_con: "Email Icon",
        tel_title: "Tel Title",
        text: "Տեքստ",
        prepayment: "Prepayment amount",
        interest_rate: "Annual Interest Rate",
        service_fee: "Monthly service fee of the bank",
        payment_term: "Վարկի մարման ժամկետը",
        minimum_amount: "Նվազագույն վարկի սահմանաչափ",
        maximum_amount: "Առավելագույն գումար",
        credit_terms: "Վարկի պայմաններ",
        formulation: "Ձևակերպման վայրը",
        mount: "Ամիս",
        amd: "Amd",
        icon_title: "Icon Title",
        icon: "Icon",
        condition_text: "Պայմանների տեքստ",
        question_answer: "Հարցեր և պատասխաններ",
        question: "Հարց",
        answer: "Պատասխան",
        edit: "Խմբագրել",
        delete: "Ջնջել",
        add_new: "Ավելացնոլ նորը",
        faq_categories: "Faq Categories",
        main_photo: "Page Main Photo",
        description_en: "Նկարագրություն Անգլերենով",
        description_ru: "Նկարագրություն Ռուսերենով",
        description_hy: "Նկարագրություն Հայերենով",
        support_ticket: "Աջակցության տոմս",
        my_tickets: "Իմ տոմսերը",
        ticket: "Տոմս",
        priority: "Առավելություն",
        ticket_list: "Տոմսի ցանկ",
        user_agent: "Օգտատեր գործակալ",
        agent_asign: "Գործակալ նշանակել",
        unassigned: "Չնծշանակված",
        ticket_info: "Տոմսի մասին ինֆորմացիա",
        ticket_id: "Տոմսի ID",
        assign_to: "Նշանակվել է",
        add_a_comment: "Ավելացնել մեկնաբանություն",
        open_a_ticket: "Բացել տոմս",
        create_ticket: "Ստեղծել տոմս",
        update_ticket: "Թարմացնել տոմսը",
        add_new_category: "Ավելացնել նոր կատեգորիա",
        add_new_priority: "Ավելացնել նոր առավելություն",
        add_new_status: "Ավելացնել նոր",
        priority_list: "Առավելությունների լիստ",
        all_ticket: "Բոլոր տոմսերը",
        last_update: "Վերջին թարմացում",
        create_new_ticket: "Ստեղծել նոր տոմս",
        all_closed_tickets: "Բոլոր փակված տոմսերը",
        closed_ticket: "Փակված տոմսեր",
        support_ticket_help: "Աջակցման կտրոն, օգնություն",
        all_submmited_ticket: "Բոլոր ներկայացված տոմսերը",
        we_do_not_sell_or_share_your_details_without_your_permission:
            "Մենք չենք վաճառում կամ կիսում ձեր տվյալները առանց ձեր թույլտվության",
        submit_message: "Ուղարկել հաղորդագրություն",
        back_to_list: "Վերադառնալ ցանկին",
        create_support_ticket: "Ստեղծեք աջակցության տոմս",
        view_ticket: "Դիտել տոմսը",
        please_at_least_one_item: "Խնդրում ենք ընտրել նվազագույնը մեկ ապրանք",
        attch_upload_limit_is_5: "Հավելվածի վերբեռնման սահմանաչափը 5 է",
        reply_ticket: "Պատասխանել տոմսին",
        add_your_comment: "Ավելացրեք Ձեր մեկնաբանությունը",
        Transaction: "Գործողություն",
        Transactions: "Գործողություններ",
        Credit: "Ապառիկ",
        Debit: "Դեբետ",
        Statement: "Հայտարարություն",
        "Account History": "Հաշվի պատմություն",
        "Bank Account Details": "Բանկային հաշվի մանրամասները",
        "Current Balance": "Ընթացիկ հաշվեկշիռ",
        utilities: "Utilities",
        clear_cache: "Clear Cache",
        clear_log: "Clear Log",
        enable: "Միացնել",
        disable: "Անջատել",
        app_debug: "App Debug",
        force_https: "Force HTTPS",
        reset_database: "Reset Database",
        xml_sitemap: "XML Sitemap",
        "It can take some times to execute operation. please wait until completed operation":
            "Գործողությունը կատարելու համար կարող է որոշ ժամանակ պահանջվել: խնդրում ենք սպասել մինչև գործողության  ավարտը:",
        are_you_sure_to_reset_database: "Վերականգնե՞լ տվյալների բազան:",
        database_reset_successful: "Տվյալների բազայի վերակայումը հաջողվեց",
        choose_sitemap_option: "Ընտրեք կայքի քարտեզի տարբերակը",
        import_demo_database: "Ներմուծեք demo տվյալների բազա",
        import_database: "Ներմուծել տվյալների բազա",
        import_demo_note:
            "After Import Demo, You Will Lost Your Current Data. Please Backup Your Database & Uploaded File First, If You Need.",
        reset_database_note:
            "After Reset, You Will Lost Your Current Data. Please Backup Your Database & Uploaded File First, If You Need.",
        are_you_sure_to_import_demo_database:
            "Are you sure to Import Demo database?",
        import_demo_database_successful: "Import Demo Database Successful.",
        accepted: "The :attribute must be accepted.",
        active_url: "The :attribute is not a valid URL.",
        after: "The :attribute must be a date after :date.",
        after_or_equal: "The :attribute must be a date after or equal to :date.",
        alpha: "The :attribute may only contain letters.",
        alpha_dash:
            "The :attribute may only contain letters, numbers, dashes and underscores.",
        alpha_num: "The :attribute may only contain letters and numbers.",
        array: "The :attribute must be an array.",
        before: "The :attribute must be a date before :date.",
        before_or_equal: "The :attribute must be a date before or equal to :date.",
        boolean: "The :attribute field must be true or false.",
        confirmed_attribute: "The :attribute confirmation does not match.",
        date_attribute: "The :attribute is not a valid date.",
        date_equals: "The :attribute must be a date equal to :date.",
        date_format_attribute: "The :attribute does not match the format :format.",
        different: "The :attribute and :other must be different.",
        digits: "The :attribute must be :digits digits.",
        digits_between: "The :attribute must be between :min and :max digits.",
        dimensions: "The :attribute has invalid image dimensions.",
        distinct: "The :attribute field has a duplicate value.",
        email_attribute: "The :attribute must be a valid email address.",
        ends_with: "The :attribute must end with one of the following: :values.",
        exists: "The selected :attribute is invalid.",
        file_attribute: "The :attribute must be a file.",
        filled: "The :attribute field must have a value.",
        image_attribute: "The :attribute must be an image.",
        in: "The selected :attribute is invalid.",
        in_array: "The :attribute field does not exist in :other.",
        integer: "The :attribute must be an integer.",
        ip_attribute: "The :attribute must be a valid IP address.",
        ipv4: "The :attribute must be a valid IPv4 address.",
        ipv6: "The :attribute must be a valid IPv6 address.",
        json: "The :attribute must be a valid JSON string.",
        multiple_of: "The :attribute must be a multiple of :value",
        not_in: "The selected :attribute is invalid.",
        not_regex: "The :attribute format is invalid.",
        numeric: "The :attribute must be a number.",
        password_attribute: "The password is incorrect.",
        present_attribute: "The :attribute field must be present.",
        regex: "The :attribute format is invalid.",
        required_attribute: "The :attribute field is required.",
        required_if: "The :attribute field is required when :other is :value.",
        required_unless:
            "The :attribute field is required unless :other is in :values.",
        required_with: "The :attribute field is required when :values is present.",
        required_with_all:
            "The :attribute field is required when :values are present.",
        required_without:
            "The :attribute field is required when :values is not present.",
        required_without_all:
            "The :attribute field is required when none of :values are present.",
        same: "The :attribute and :other must match.",
        starts_with:
            "The :attribute must start with one of the following: :values.",
        string: "The :attribute must be a string.",
        timezone: "The :attribute must be a valid zone.",
        unique_attribute: "The :attribute has already been taken.",
        uploaded: "The :attribute failed to upload.",
        url_attribute: "The :attribute format is invalid.",
        uuid: "The :attribute must be a valid UUID.",
        check_unique_phone: "The phone has already been taken.",
        this_field_is_required: "This field is required.",
        please_fill_with_valid_email: "Խնդրում ենք լրացնել վավեր էլ.փոստ",
        you_are_already_subscribed: "Դուք արդեն բաժանորդագրված եք.",
        the_amount_is_must_be_gretter_than_0: "Գումարը պետք է լինի 0-ից մեծ:",
        my_wallet: "Իմ դրամապանակը",
        wallet: "Դրամապանակը",
        recharge: "Վերալիցքավորել",
        transaction_list: "Գործարքների ցուցակ",
        recharge_now: "Լիցքավորեք հենց հիմա",
        enter_your_amount_to_recharge:
            "Մուտքագրեք Ձեր Գումարը ՝ Հաշիվը Լիցքավորելու Համար",
        continue: "Շարունակել",
        choose_payment_gateway: "Ընտրեք վճարման տարբերակ",
        online_recharge: "Հաշվի առցանց լիցքավորում",
        wallet_recharge_transactions: "Դրամապանակի համալրման գործարքներ",
        account_holder: "Հաշվի տեր",
        auto_approve: "Ավտոմատ հաստատում",
        approved_balance: "Հաստատված հաշվեկշիռ",
        pending_balance: "Սպասվող մնացորդ",
        offline_recharge: "Անցանց վերալիցքավորում",
        any_comment: "Ցանկացած մեկնաբանություն",
        wallet_manage: "Դրամապանակի կառավարում",
        running_balance: "Running Balance",
        earning_balance: "Earning Balance",
        withdraw_balance: "ՄՆացորդի հանում",
        refund_paid: "Վերադարձը վճարված է",
        withdraw_now: "Հանել հիմա",
        enter_your_amount_to_withdraw: "Մուտքագրեք  հանելու ենթակա գումարը",
        withdraw: "Հանում",
        withdraw_history: "Հանման պատմություն",
        modify_your_amount_to_withdraw: "Փոփոխեք ձեր գումարը հանելու համար",
        withdraw_requests: "Հանման հարցումները",
        show_details: "Ցույց տալ մանրամասներ",
        details_info: "Մանրամանսերի ինֆորմացիա",
        Approval: "Հաստատում",
        pending_withdraw_balance: "Սպասվող հանման մնացորդը",
        pending_withdraw_request_balance: "Սպասվող հանման հայտի մնացորդը",
        remaining_balance: "Մնացած մնացորդը",
        withdraw_request_has_been_sent_successfully:
            "Հանման հայտը հաջողությամբ ուղարկված է",
        withdraw_request_has_been_modified_successfully:
            "Հանման հայտը հաջողությամբ փոփոխված է",
        requested_amount: "Պահանջվող գումարը",
        bank_ibn: "Bank ibn",
        recharge_using_gift_card: "Recharge Using Gift Card",
        cheque_slip: "Cheque Slip",
        flutter_wave_payment: "Flutter wave payment",
        continue_to_recharge: "Continue to Recharge",
        pay_tm_payment: "Paytm payment",
        pay_u_money_payment: "Pay u money payment",
        recharge_offline_wallet: "Recharge Offline Wallet",
        transection_id: "Transection ID",
        jazz_cash_payment: "JazzCash Payment",
        are_you_sure_to_go_through_this_payment_gateway:
            "Are you sure to go through this payment gateway?",
        recharge_wallet_history: "Recharge wallet history",
        continue_to_pay: "Շարունակել վճարել",
        google_payment: "Google payment",
        razor_pay: "Razor pay",
        online_recharge_transactions: "Online Recharge Transactions",
        bank_recharge: "Bank Recharge",
        bank_recharge_transactions: "Bank Recharge Transactions",
        mercado_pago_payment: "Mercado Pago Payment",
        Affiliate: "Affiliate",
        "My Affiliate": "My Affiliate",
        "Update Affiliate Link": "Update Affiliate Link",
        "Create Affiliate Link": "Create Affiliate Link",
        "User Name": "User Name",
        "Enter URL": "Enter URL",
        "Affiliate Link": "Affiliate Link",
        "Affiliate Links": "Affiliate Links",
        Visits: "Visits",
        Registered: "Registered",
        Purchased: "Purchased",
        Commissions: "Commissions",
        Configurations: "Configurations",
        "Affiliate Configurations": "Affiliate Configurations",
        "Minimum Withdraw": "Minimum Withdraw",
        "Commission Type": "Commission Type",
        "Commission Amount": "Commission Amount",
        "Payment Provide Date End Of Month": "Payment Provide Date End Of Month",
        "Referral Duration Type": "Ուղղորդման տևողության տեսակ",
        "Referral Duration": "Ուղղորդման տևողություն",
        "Is GST Applicable ?": "Արդյոք GST կիրառելի՞ է",
        "GST Amount": "GST գումարը",
        Percentage: "Տոկոս",
        Flat: "Ֆիքսված",
        Fixed: "Ամրագրած",
        Lifetime: "Կյանքի ընթացքում",
        Yes: "Այո",
        No: "Ոչ",
        Withdrawn: "Վերցված",
        Pending: "Սպասվում է",
        "Balance Transfer To Wallet": "Մնացորդի փոխանցում դրամապանակին",
        "Withdraw Request": "Հետադարձ հարցում",
        "Add Paypal Account For Withdraw Commissions From System":
            "Ավելացնել Paypal հաշիվ համակարգից միջնորդավճարներ հանելու համար",
        "Update Paypal Account For Withdraw Commissions From System":
            "Թարմացրեք Paypal հաշիվը համակարգից միջնորդավճարներ հանելու համար",
        "Paypal Account": "Paypal հաշիվ",
        "Create Withdraw Request": "Ստեղծել դուրսբերման հարցում",
        "Withdraw Amount": "Գումարի դուրսբերում",
        "Payment Type": "Վճարման տեսակ",
        "Select One": "Ընտրել մեկը",
        Paypal: "Paypal",
        Offline: "Առցանց",
        "Withdraw Commissions By Paypal Add Account":
            "Դուրսբերում Paypal-ի միջոցով Ավելացնել հաշիվ",
        Withdraw: "Հանել",
        "Withdraw History": "Հեռացնել պատմությունը",
        "Request Date": "Հարցման օր",
        "Confirm Date": "Հաստատել ամսաթիվը",
        Cancel: "Չեղարկել",
        Done: "Ավարտված",
        "Balance Transfer To User Wallet":
            "Հաշվեկշռի փոխանցում օգտագործողի դրամապանակին",
        "Transfer Amount": "Փոխանցման գումար",
        "Update Transfer Amount": "Թարմացնել փոխանցման գումարը",
        "Update Withdraw Request": "Թարմացնել դուրս գալու հայտը",
        "Transfer To User Wallet": "Փոխանցում օգտագործողի դրամապանակին",
        "Commission History": "Պատմություն",
        Course: "Դասընթաց",
        From: "Կողմից",
        Date: "Օր",
        "Pending Withdrawn": "Pending Withdrawn",
        "Pending Withdrawn List": "Հանված ցուցակ",
        User: "Օգտատեր",
        "Select Date Range": "Ընտրել ասմաթվերի միջակայքը",
        Filter: "Ֆիլտր",
        Reset: "Վերականգնել",
        "Pending Earning": "Pending Earning",
        "Pending Transfer": "Սպասվող փոխանցում",
        "Complete Withdrawn": "Ամբողջական հանված",
        "Complete Withdrawn List": "Լրացնել հանված ցուցակը",
        "Confirm By": "Հաստատել ըստ",
        "Day End Of Month": "Ամսվա վերջին օրը",
        Email: "Էլ․հասցե",
        "All Purchase": "Բոլոր գնումները",
        Onetime: "Մի անգամ",
        "Balance Add Account After": "Հաշվի մնացորդը ավելացնել",
        "In Days": "Օրերով",
        "Transfer Approval Need ?": "Փոխանցման հաստատման կարիք կա՞",
        "Affiliate Account Current Balance": "Affiliate Account Current Balance",
        "Commission Approved": "Հաստատվել է",
        Email_or_Username: "Էլ․փոստ/ օգտատեր",
        Submit: "Ներկայացնել",
        Save: "Պահպանել",
        Update: "Թարմացում",
        Welcome: "Բարի գալուստ",
        "Join Our Affiliate Program": "Join Our Affiliate Program",
        "Join Affiliate Program": "Join Affiliate Program",
        "Admin Approval Need For Affiliate User ?":
            "Admin Approval Need For Affiliate User ?",
        "Product Wise": "Product Wise",
        "Category Wise": "Category Wise",
        "Amount Type": "Գումարի տեսակը",
        "Category Wise Commission Setup": "Category Wise Commission Setup",
        Others: "Այլ",
        "All Category": "Բոլոր կատեգորիաները",
        Category: "Կատեգորիա",
        "Calculation Method": "Հաշվարկման մեթոդ",
        Users: "Օգտատերեր",
        "All User": "Բոլոր օգտատերերը",
        "Active User": "Ակտիվ օգտատեր",
        "Inactive User": "Պասիվ օգտատեր",
        Info: "Տեղեկություն",
        "Your affiliate joining request is under review. After confirming your request you can join our affiliate program.":
            "Your affiliate joining request is under review. After confirming your request you can join our affiliate program.",
        Copy: "Պատճենել",
        "Commission Calculate For Multi Category":
            "Հաշվարկ բազմակի կատեգորիայի համար",
        Minimum: "Նվազագույն",
        Average: "Միջին",
        Maximum: "Առավելագույն",
        "Common Amount": "Ընդհանուր գումար",
        "Common Calculation Method": "Ընդհանուր հաշվարկման մեթոդ",
        "Are you sure to delete ?": "Վստա՞հ եք, որ ցանկանում եք ջնջել",
        "Wallet Transfer Approval Need ?": "Հաշվի փոխանցման հաստատման կարիք կա՞",
        "Affiliate User Approval ?": "Փոխկապակցված օգտվողի հաստատում",
        copy_link: "Պատճենել հղումը",
        "You are blocked from admin. Please contact with admin.":
            "Դուք արգելափակված եք ադմինիստրատորի կողմից: Խնդրում ենք կապ հաստատել ադմինիստրատորի հետ:",
        select_payment_option: "Ընտրել վճարման տարբերակը",
        email_or_phone_uppercase: "Էլ․հասցե կամ հեռախոս",
        support_lowercase: "Աջակցություն",
        privacy_policy_check: "Գաղտնիության քաղաքականության ստուգում",
        "Google Merchant Center": "Google առևտրի կենտրոն",
        "Products Export": "Արտադրանքի արտահանում",
        "Click here go to Google Merchant Center google product category Link":
            "Սեղմեք այստեղ, գնացեք Google Merchant Center google արտադրանքի կատեգորիայի հղում",
        payroll_info: "Աշխատավարձի մասին տեղեկություններ",
        reason_lowercase: "Պատճառ",
        refused_cancelled_orders: "Մերժված/չեղարկված պատվերներ",
        otp_is_sent: "OTP ուղարկվում է",
        otp: "OTP",
        enter_otp: "Մուտքագրեք OTP",
        resend_otp: "Կրկին ուղարկել OTP",
        otp_send_successful: "OTP հաջողությամբ ուղարկվել է",
        invalid_otp: "Սխալ OTP",
        otp_validation_time_expired: "OTP վավերացման ժամանակը սպառվել է",
        something_wrong_on_otp_send: "Ինչ-որ բան այն չէ OTP ուղարկելիս",
        please_select_otp_type: "Խնդրում ենք ընտրել OTP տեսակը",
        otp_configuration: "OTP կարգավորում",
        code_validation_time_min: "Կոդի վավերացման ժամանակը (րոպե)",
        otp_send_for_customer_registration: "OTP ուղարկել հաճապորդի գրանցման համար",
        otp_will_be_sent_according_to_customer_register_email_or_phone:
            "OTP կուղարկվի ըստ հաճախորդների գրանցման էլ.փոստի կամ հեռախոսի",
        otp_send_for_seller_registration: "OTP ուղարկել վաճառողին գրանցման համար",
        otp_type: "OTP տեսակը",
        otp_send_for_order_confiramtion: "OTP ուղարկել պատվերի հաստատման համար",
        email_and_sms_should_be_configured_first:
            "Սկզբում պետք է հաստատել էլ․հասցեն",
        cod: "Կոդ",
        update_json_markup: "Update Json Markup",
        create_json_markup: "Create Json Markup",
        home_json_markup: "Home JSON Markup",
        brands_json_markup: "Ապրանքանիշ Json Markup",
        percentage_lowercase: "Տոկոսը",
        amount_lowercase: "Գումարը",
        defects_descr: "Թերությունների նկարագրություն",
        reason_en: "պատճառ En",
        reason_ru: "պատճառ Ru",
        reason_hy: "պատճառ Hy",
        refund_reason: "վերադարձման պատճառ",
        basic_info_full: "Հիմնական տեղեկություններ",
        "Wholesale Price": "Մեծածախ գինը",
        "Min QTY": "Նվազագույն քանակ",
        "Max QTY": "Առավելագույն քանակ",
        "Price per piece": "Գինը մեկ հատի համար",
        "Add More": "Ավելացնել ավելին",
        service_brand_crumb: "Սպասարկման կենտրոն",
        services_title: "Ոչ երաշխիքային (վճարովի) սպասարկում",
        service_type_repair: "Վերանորոգման տեսակը",
        service_type_repair_price: "Գինը",
        by_installation: "Տեղադրմամբ",
        no_installation: "Տեղադրում ծառայություն առկա չէ",
        gift_products: "Նվեր-Ապրանք",
        slider_images_hy: "Սլայդերի պատկերներ HY",
        slider_images_en: "Սլայդերի պատկերներ EN",
        slider_images_ru: "Սլայդերի պատկերներ RU",
        order_alert_text:
            "Ձեր վճարման տվյալները հաջողությամբ ուղարկվել են ստուգման: Խնդրում ենք սպասել ձեր էլփոստի պատասխանին: հասցեին։",
        wait_for_redirect_to_payment:
            "Խնդրում ենք սպասել, Ձեր գործարքը ընթացքի մեջ է: <br /> Դուք վերահասցեավորվում եք վճարման էջ:",
        wait_for_order_confirm: "Խնդրում ենք սպասել, Ձեր գործարքը ընթացքի մեջ է:",
        yesterday: "Yesterday",
        days_ago: "days ago",
        add_attribute: "Add Attribute",
        coment: "Coment",
        key_word_list: "Key word list",
        add_a_new_key_word: "Add a new key word",
        key_words: "Key words",
        order_not_found_products: "Order not found products",
        watched: "Watched",
        not_exists: "Not exists",
        thanks_for_order_wait_for_call:
            "Շնորհակալություն պատվերի համար, խնդրում ենք սպասել զանգի",
        go_url: "Go url",
        go_category_brand: "Go category/brand",
    },
    ru: {
        qr_text: 'Сканируй QR код чтобы скачать приложение',
        Favorites: "Закладки",
        sl: "SL",
        cred_info_prod_popup:
            "Ежемесячные выплаты и максимальный срок могут отличатся в зависимости от банка. Ежесесячные суммы обслуживания и/или проценты уже включены в сумму.",
        online_price_prod_popup:
            "Технические данные, спецификация и изображение продукта мЦена указана для магазинов в Ереване, Абовяне и Гюмри. В других магазинах, в зависимости от затрат на логистику, цены могут отличаться.огут отличаться от данных на этой странице․",
        add: "Добавить",
        sticker_list: "Список наклеек",
        sale_search: "Поиск продаж",
        by: "от",
        order_search: "Order Search",
        branches: 'Филиалы',
        order_product: "Мы перезвоним Вам и уточним детали",
        here: "здесь",
        related_brand: "Связанный бренд",
        up_sale_brand: "Распродажа бренда",
        show_more: "Show more",
        collapse: "Collapse",
        back_to_site: "На сайт",
        order_accepted: "Ваш заказ принят",
        updated_at: "Обновлено",
        fill_fields_ordered_products:
            "Заполните следующие поля, и мы с удовольствием свяжемся с вами для обсуждения подробностей.",
        cross_sale_brand: "Бренд кросс-продаж",
        with_installation: "with installation",
        without_installation: "without installation",
        description_hy: "Описания ARM",
        description_ru: "Описания RU",
        fast_delivery: "Экспресс Доставка",
        fast_delivery_title: "Экспресс Доставка",
        fast_delivery_descr:
            "Если вы приобрели оборудование до 15:00 и хотите получить его в день покупки, обратите внимание, что доступна услуга экспресс-доставки. Доставка осуществляется в тот же день до 20:00. Стоимость услуги 2000 драм, услуга доступна только в Ереване.",
        "subscribed ": "Вы уже подписались на рассылку новостей",
        change_password: "Изменить пароль",
        keyword: "Ключ. слова",
        number_of_use: "Количество использований",
        ip_list: "СПИСОК IP-адресов",
        title: "Заголовок",
        see_all: "Посмотреть все",
        secret_id: "Секретный идентификатор",
        details: "Подробнее",
        automatic_wallet_approval: "Автоматическое одобрение кошелька",
        pickup_address: "Выберите адрес",
        coupon_code: "Код купона",
        slug: "Ссылка",
        make_default: "Использовать по умолчани",
        request: "Запрос",
        restricted_in_demo_mode: "Запрещено в демонстрационном режиме",
        list: "Список",
        enter_your_password: "Введите свой пароль",
        invalid_password: "Неверный пароль",
        choose: "Выбрать",
        social_login: "Вход через соц. сети",
        secret_login: "Секретный вход",
        select_product_first: "Сначала выберите продукт",
        my: "Мой",
        config: "Конфигурация",
        work_hors_shop_address: "Рабочее время",
        address_shop_address: "Адрес",
        phone_shop_address: "Телефон",
        image_alt_shop_address: "Alt изображение",
        image_shop_address: "Изображение",
        longitude_shop_address: "Долгота",
        latitude_shop_address: "Широта",
        csv_upload: "CSV Файл",
        upload_csv: "Загрузить CSV-файл",
        no_more_data_to_show: "Больше нет данных для отображени",
        no_results_found: "Результатов не найдено",
        merchants: "Торговцы",
        quick_search: "Быстрый поиск",
        status: "Статус",
        action: "Действие",
        delete: "Удалить",
        select: "Выбрать",
        is_trusted: "Доверяют",
        icon: "Иконка",
        minimum_order_quantity: "Минимальное количество для заказа",
        maximum_order_quantity: "Максимальное количество заказа",
        listed_date: "Указанная дата",
        in_stock: "В наличии",
        active: "Активный",
        deactive: "Деактивированный",
        "in-active": "Неактивный",
        nothing_found: "Ничего не найдено",
        active_status: "Активный статус",
        orders: "Заказ",
        wallet_histories: "истории кошельков",
        addresses: "Адреса",
        for: "Для",
        num_of_uses: "Количество использований",
        device: "Устройство",
        system: "Система",
        inhouse: "Внутренний",
        inhouse_product: "Внутренний продукт",
        summary: "Краткое содержание",
        danger: "Опасность",
        are_you_sure_to_activate: "Вы уверены, что активируете?",
        pending_orders: "Отложенный заказ",
        cancelled_orders: "Отмененный заказ",
        activate_successful: "Активировать успешно",
        confirmed_orders: "Подтвержденный заказ",
        completed_orders: "Выполненный заказ",
        completed: "Завершенный",
        joined_at: "Присоединился в",
        average_rating: "Средний рейтинг",
        total_spend: "Общие расходы",
        total_recharge: "Полная перезарядка",
        wallet_summary: "Сводка кошелька",
        pending_balance_approval: "Ожидает утверждения баланса",
        total_balance: "Итоговый балан",
        empty_list: "Пустой список",
        total: "Итого",
        update: "Обновлять",
        language: "Язык",
        clone_successful: "Клонирование успешно",
        clone: "Клон",
        name_hy: "Имя ARM",
        name_ru: "Имя RU",
        id: "ID",
        note: "Примечание",
        reply: "Отвечать",
        create_category: "Создать категорию",
        product_qty: "Количество продукта",
        category_name: "Название категории",
        category_list: "Список категорий",
        save: "Сохранить",
        searchable: "Доступный для поиска",
        update_title: "Обновить заголовок",
        category_group: "Категория Групп",
        root_category: "Корневая категория",
        show: "Показать",
        group_name: "Имя группы",
        "are_you_sure_to_delete_?": "Вы уверены, что хотите удалить?",
        cancel: "Отменить",
        main_title: "Основное название",
        sub_title: "Подзаголовок",
        email: "Электронная почта",
        all_customer: "Все клиенты",
        submitting: "Отправка",
        updating: "Обновление",
        deleting: "Удаление",
        activity_logs: "Журналы активности",
        all_activity_logs: "Все журналы активности",
        login_activity: "Вход в систему",
        attempted_at: "Попытка",
        login_at: "Войти в",
        logout_at: "Выход в",
        login_logout_activity: "Вход - выход из системы",
        inactive: "Неактивный",
        browse: "Загрузить",
        browse_image: "Загрузить изображения",
        browse_file: "Загрузить файл",
        attach_file: "Прикрепить файл",
        browse_image_file: "Загрузить файл изображения",
        "Something Went Wrong": "Что-то пошло не так",
        "Delete Confirmation": "Удалить подтверждение",
        "Delete confirmation message": "Удалить подтверждающее сообщение",
        choose_file: "Выберите файл",
        seo_info: "SEO-информаци",
        meta_title: "Мета-заголовок",
        meta_description: "Мета-описание",
        publish: "Публиковать",
        Draft: "Черновик",
        refunded: "Возмещено",
        number: "Число",
        status_info: "Информация о статусе",
        checkout_product: "Оформить заказ",
        choose_one: "Выбери один",
        profile: "Профиль",
        transactions: "Транзакции",
        documents: "Документы",
        document: "Документ",
        date_of_birth: "Дата рождения",
        "Current Address": "Текущий адрес",
        "Permanent Address": "Постоянный адрес",
        view: "Вид",
        size: "Размер",
        preview: "Предварительный просмотр",
        select_one: "Выбери оди",
        profile_picture: "Изображение профил",
        opening_balance: "Начальный баланс",
        email_or_phone_uppercase: "По электронной почте или телефону",
        employee_id: "ID сотрудника",
        "Last Date Of Provisional Period": "Поздняя дата условного периода",
        personal_info: "Личная информация",
        personal: "Личный",
        upload_document: "Загрузить документ",
        read_all: "Читать все",
        document_title: "Заголовок документ",
        put_your_password: "Введите свой паро",
        avatar: "Аватар",
        registered_date: "Дата регистрации",
        select_type: "Выберите тип",
        single_day: "Single Day",
        multiple_day: "Несколько дней",
        start_date: "Дата начала",
        end_date: "Дата окончания",
        to_date: "На сегодняшний день",
        select_role: "Выберите роль",
        year: "Год",
        use_as_username: "Использовать как имя пользователя",
        your_user_id_is: "Ваш идентификатор пользователя",
        first_name: "Имя",
        last_name: "Фамилия",
        print: "Распечатать",
        search: "Поиск",
        display_type: "Тип дисплея",
        error_message: "Что-то пошло не так!",
        update_message: "Успешно Обновлено!",
        update_successfully: "Обновление успешно!",
        status_change_message: "Статус успешно изменен!",
        Timestamp: "Отметка времени",
        tag: "Тег",
        second: "Второй",
        activated: "Активировано",
        admin: "Админ",
        image_second_section: "Второй раздел изображения",
        image_first_section: "Первый раздел изображения",
        upload_photo: "Загрузить фото",
        photo: "Фото",
        gst_pay: "Оплата налога на товары и услуги",
        product_tax_pay: "Налог на продукт",
        multiple: "Несколько",
        file_less_than_1MB: "Файл меньше 1 МБ",
        select_brand: "Выберите марку",
        is_featured: "показан",
        featured: "Показан",
        load_more: "Показать еще",
        values: "Цена",
        model_number: "Номер модели",
        amount: "Сумма",
        not_approved: "Не одобрено",
        approved: "Одобренный",
        select_root_category: "Выберите корневую категорию",
        add_menu_item: "Добавить пункт меню",
        select_menu_item: "Выберите пункт меню",
        vat_number: "Номер НДС",
        company_information_format: "Формат информации о компании",
        zip_code: "Почтовый индекс",
        count: "Считать",
        country: "Страна",
        location: "Расположение",
        date_from: "Дата, с",
        bank: "Банк",
        banks: "Банки",
        cheque: "чек",
        dashboard: "Панель приборов",
        confirm_password: "Подтвердите пароль",
        reset_password: "Сброс пароля",
        customer_list: "Список клиентов",
        active_customer: "Активный клиент",
        in_active_customer: "Неактивный клиент",
        is_active: "Активен",
        "referral_code_(optional)": "Реферальный код (необязательно)",
        referral_code: "Реферальный код",
        date: "Дата",
        balance: "Баланс",
        is_approved: "Одобрено",
        add_new_seller: "Добавить нового продавца",
        shop: "Магазин",
        no_of_sale: "№ продажи",
        seller_details: "Сведения о продавце",
        product: "Продукт",
        post_image: "Опубликовать изображение",
        pay_first_for_subcription: "Платите сначала за подписку",
        pay_for_subcription: "Оплатить подписку",
        trusted_seller: "Надежный продавец",
        account_information: "Информация Об Учетной Записи",
        holiday_mode: "Праздничный режим",
        on: "Включить",
        off: "Выключить",
        holiday_type: "Тип отпуска",
        holiday_date: "Дата отпуска",
        holiday_duration: "Продолжительность отпуска",
        "n/a": "Н/Д",
        owner_name: "Имя владельца",
        address_1: "Адрес 1",
        address_2: "Адрес 2",
        state: "Регион",
        city: "Город",
        registration_number: "Регистрационный номер",
        business_document: "Деловой документ",
        tin: "Банка",
        business_information: "Деловая информация",
        payment_information: "Платежная информация",
        bank_cheque: "Банковский чек",
        ibn: "ИБН",
        routing_number: "Номер маршрута",
        attachment: "Приложение",
        bank_title: "Название банка",
        payment_type_accept: "Принимаем к оплате",
        cash_payment: "Наличный платеж",
        bank_payment: "Банковский платеж",
        return_address: "Обратный адрес",
        warehouse_address: "Адрес склада",
        added_successfully: "Добавлено успешно!",
        created_successfully: "Создано успешно!",
        deleted_successfully: "Удален успешно!",
        updated_successfully: "Успешно Обновлено!",
        payment_successfully: "Оплата прошла успешно!",
        transaction_successfully: "Транзакция прошла успешно!",
        status_updated_successfully: "Статус успешно обновлен!",
        approved_successfully: "Успешно одобрено!",
        success: "Успех",
        seller: "Продавец",
        subscription: "Подписка",
        txn_id: "Идентификатор транзакции",
        txn: "транзакция",
        is_approve: "одобрено",
        method: "Метод",
        account: "Личный кабинет",
        full_name: "Имя",
        unique: "Уникальный",
        mobile: "Мобильный",
        cross_sale_product_display_title:
            "Заголовок отображения продукта перекрестной продажи",
        up_sale_product_display_title:
            "Заголовок отображения продукта для распродажи",
        title_settings: "Настройки заголовка",
        settings: "Настройки",
        make_Display_in_details_page: "Сделать отображение на странице сведений",
        up_sale: "Распродажа",
        up_sale_category: "Категория продажи",
        cross_sale: "Перекрестная продажа",
        cross_sale_category: "Категория перекрестных продаж",
        package: "Упаковка",
        of: "из",
        total_price: "Итоговая цена",
        qty: "количество",
        items_count: "Количество предметов",
        coupon: "Купон",
        apply: "Применять",
        discount: "Скидка",
        discount_type: "Тип скидки",
        shopping: "Покупка",
        continue: "Продолжать",
        cart: "Корзина",
        payment_options: "Варианты оплаты",
        confirm: "Подтверждать",
        order: "Заказ",
        seller_commission: "Комиссия продавца",
        rate: "Ставка",
        commission_rate: "Ставка комиссии",
        commission_type: "Тип комиссии",
        edit_commission_rate: "Изменить комиссию",
        current: "Текущий",
        re_enter: "Повторно введите",
        make: "Делать",
        default: "По умолчани",
        new: "Новое",
        old: "Давний",
        region: "Область",
        page: "Страница",
        required: "Необходимый",
        price: "Цена",
        published: "Опубликовано",
        all: "Все",
        check: "Проверять",
        notification: "Уведомление",
        no_notification_found: "Уведомление не найдено",
        error: "Ошибка",
        open_link_in_a_new_tab: "Открыть ссылку в новой вкладке",
        total_amount: "Oбщая сумма",
        order_id: "Идентификатор заказа",
        contact_us: "Связаться с нами",
        policy: "Политика",
        declined: "Отклоненный",
        payment_method: "Способ оплаты",
        approval: "Утверждение",
        paid: "Оплачено",
        shipping_charge: "Стоимость доставки",
        warning: "Предупреждение",
        max: "Максимум",
        min: "Минимум",
        access_permission: "Разрешение на доступ",
        access_denied: "Доступ запрещен",
        vat: "НДС",
        updated_by: "Обновлено от",
        user_name: "Имя пользователя",
        no_file_selected: "Файл не выбран",
        loan: "Кредит",
        apply_for_loan: "Подать заявку на кредит",
        monthly_installment: "Ежемесячный взнос",
        due: "Due",
        cancelled: "Отменено",
        apply_for: "Подать заявку",
        General: "Общий",
        Emergency: "Чрезвычайная ситуация",
        loan_date: "Дата займа",
        total_month: "Всего за месяц",
        apply_for_loan_update: "Подать заявку на обновление кредита",
        applied_date: "Дата применения",
        paid_loan_amount: "Выплаченная сумма кредита",
        apply_loan_details: "Применить детали кредита",
        loan_type: "Тип кредита",
        applied_loan: "Примененный креди",
        staff_id: "Идентификатор персонала",
        add_new_ignore_ip: "Добавить новый игнорируемый IP",
        ignore_ip_from_visitor_count: "Игнорировать IP из подсчета посетителей",
        related_product: "Связанная категория",
        send_successfully: "Отправлено успешно!",
        staff_info: "Информация о персонале",
        days: "Дни",
        download: "Скачать",
        uploaded_successfully: "Загружено успешно!",
        quick_summery: "Краткое содержание",
        gift_card: "Подарочная кар",
        gift_cards: "Подарочные карты",
        gift_card_list: "Список подарочных карт",
        number_of_sale: "Количество продаж",
        sample_file_download: "Скачать образец файла",
        download_warning:
            "Пожалуйста, загрузите образец файла, введите желаемую информацию, а затем загрузите его. Не пытайтесь загрузить другой формат файла и информацию",
        not_editable: "Недоступно для редактирования",
        not_permit: "У вас нет этого разрешения",
        no_action_permitted: "Действия запрещены",
        used: "Использованный",
        home: "Главная страница",
        ignore_ip: "Игнорировать IP",
        visitors_setup: "Настройка посетителя",
        subscription_payment: "Оплата подписки",
        referral: "Направление",
        view_all: "Посмотреть все",
        total_coupon_used: "Всего использовано купонов",
        operation_failed: "Операция не удалась",
        operation_done_successfully: "Операция выполнена успеш",
        successful: "Успешный",
        create: "Создать",
        create_template_first: "Сначала создать шаблон",
        duplicate_entry_is_exist_in_your_file:
            "В вашем файле существует повторяющаяся запись",
        copyright: "Авторские права",
        remove: "Удалить",
        add_to_cart: "Добавить",
        write_some_messages: "Напишите несколько сообщений",
        you_don_t_have_this_permission: "У вас нет этого разрешения",
        mail_has_been_sent_successful: "Почта успешно отправлена",
        created_at: "Создан в",
        info: "Информация",
        disabled: "Несовершенный",
        upload_pdf: "Загрузить PDF",
        upload_product: "Загрузить продукт",
        recharge_amount: "Сумма пополнения",
        country_region: "Страна/регион",
        subtract: "Вычесть",
        select_from_options: "Выберите из вариантов",
        postal_code: "Почтовый индекс",
        pending_request: "Ожидающий запрос",
        flash_deals: "Срочные сделки",
        user_zone: "Пользовательская зона",
        notifications: "Уведомления",
        see_more: "Видеть больше",
        welcome: "Добро пожаловать",
        please: "Пожалуйста",
        log_out_space: "Выйти",
        not_deleted: "Не удалено",
        transaction_failed: "Транзакция не удалась",
        enter_secret_code_of_gift_card: "Введите секретный код подарочной карты",
        redeem_now: "Выкупить сейчас",
        redeem: "Выкупать",
        select_cancel_reason: "Выберите причину отмены",
        address_already_used: "Адрес уже используется",
        billing_info: "Платежная информация",
        website: "Веб-сайт",
        already_a_merchant: "Уже торговец",
        account_verified_successfully: "Аккаунт успешно подтвержден",
        you_have_been_disabled: "Вы были отключены",
        loan_has_been_applied_successfully: "Кредит был успешно подвержден",
        not_found: "Не найдено",
        please_agree_with_our_policy_privacy:
            "Пожалуйста, согласитесь с нашей политикой конфиденциальности",
        attach_upload_limit_is_5:
            "Ограничение на загрузку прикрепленных файлов — 5.",
        billing_address: "Адрес для выставления счета",
        oh_no: "О, нет",
        sidebar_manager: "Менеджер боковой панели",
        setting: "Параметр",
        convert_as_seller: "Преобразовать как продавец",
        verification_link_resend_successfully:
            "Ссылка для подтверждения отправлена повторно.",
        account_already_verified: "Аккаунт уже подтвержден.",
        admin_contact_with_you: "Администрация Связаться с вами.",
        subject: "Объект",
        file_name: "Имя файла",
        page_link: "Ссылка на страницу",
        click_here: "НАЖМИТЕ ЗДЕСЬ",
        clean_all: "Очистить все",
        minimum_8_charecter: "Минимум 8 символов",
        total_items: "Всего предметов",
        please_configure_mail_settings_first: "Сначала настройте параметры почты.",
        sms: "SMS",
        company: "Компания",
        no_data_available_in_table: "Данные отсутствуют в таблице",
        company_rating_review: "Рейтинг и обзор компании",
        sms_has_been_sent_successfully: "Смс успешно отправлено.",
        set_sms_credentials: "Установите учетные данные SMS.",
        postal_code_or_pin_code: "Почтовый индекс / пин-код",
        commision: "Комиссия",
        facebook: "Facebook",
        twitter: "Twitter",
        linkedin: "Linkedin",
        instagram: "Instagram",
        "vat/tax/gst": "НДС/НАЛОГ/НТУ",
        link_copied_successfully: "Ссылка успешно скопирована!",
        buy_now: "Купить в один клик",
        quick_buy: "Быстрая покупка",
        surname: "Фамилия",
        COMPARE: "Сравнивать",
        Add: "Добавлять",
        Delivery_Type: "Данные для доставки",
        "Payment type": "Тип оплаты",
        "By bank card": "С помощью банковской карты",
        "PAY BY RECEIPT": "ОПЛАТА ПО КВИТАНЦИИ",
        "Online credit": "Онлайн-кредит",
        "Product:": "Продукт:",
        Shipment: "Доставка",
        "Bonus:": "Бонус:",
        "Card code": "Код карты",
        Confirm: "Подтверждать",
        "Order confirmation": "Подтверждение заказа",
        "Do you have a promotion?": "У вас есть промо-код?",
        "Promo code:": "Промо-код",
        Activate: "Активировать",
        "City:": "Город:",
        State: "Регион:",
        "Community:": "Сообщество:",
        "Postal code:": "Почтовый индекс:",
        "Street, house, apartment": "Улица, дом, квартира",
        "Installment payment": "Оплата в рассрочку",
        "Payment with bonuses": "Оплата бонусами",
        "PAY ON THE SPOT BY CASH OR Bank Card":
            "ОПЛАТА НА МЕСТЕ НАЛИЧНЫМИ ИЛИ банковской картой",
        "Delivery Regions": "Доставка в регионы",
        "Pick up in store": "Забрать из магазина",
        "Add an address": "Добавить адрес",
        "Fill in the data":
            "Заполните поле ниже или отметьте его перемещая красную точку на карте",
        "Show on map": "Показать на карте",
        "City, region, community, address...":
            "Город, регион, сообщество, адрес...",
        "Delivery in Yerevan": "Доставка по Еревану",
        Personal_information: "Личная информация",
        Honor_another_persons_data: "Добавить данные другого человека",
        Basket: "Корзина",
        Back_to_shopping: "Назад к покупкам",
        vlv_type: "Vlv Type",
        vlv: "VLV",
        many_viewed_products: "Популярные товары",
        srch_plach: "Ищите то, что нужно найти",
        filter: "Фильтр",
        active_in_filter: "Активен в фильтре",
        bonus_cart: "клубная бонусная карта",
        spick_voic: "Высказываться ...",
        to_close: "Закрывать",
        discounted_products: "Товары со скидкой",
        to_learn_more: "Чтобы узнать больше",
        type_pay: "Принимаем к оплате",
        pay_text: "Вы можете оплатить наличными при доставке или выбрать",
        pay_href: "другой способ оплаты",
        inf_text: "Новости и рекламные акции только для участников",
        dw_app: "Скачайте приложение",
        soc_linkes: "Мы в социальных сетях",
        we_sale: "Акции",
        "header.category.baner.index": "Header Category Baners",
        famous_category: "Популярные Категории",
        video: "Видео",
        header_menu_category: "Категории в шапке",
        slider1: "Слайдер 1",
        slider2: "Слайдер 2",
        slider_image_en: "Изображение слайдера En",
        slider_image_ru: "Изображение слайдера Ru",
        slider_image_hy: "Изображение слайдера Hy",
        "header.category.section": "Раздел категории заголовка",
        back: "назад",
        section_setup: "Настройка раздел",
        three_in_one: "Три в одном",
        add_slider: "Добавить слайдер",
        all_category: "Категории",
        inf: "Информация",
        buy_er_in: "Покупателю",
        title_en: "Названия En",
        title_ru: "Названия Ru",
        title_hy: "Названия Hy",
        sub_title_en: "Подзаголовок En",
        sub_title_ru: "Подзаголовок Ru",
        sub_title_hy: "Подзаголовок Hy",
        buy_two: "Купи 2 товара",
        get_a_product: "ПОЛУЧИ 3 в",
        by_gif: "подарок",
        guaranty: "Гарантия",
        href: "Ссылка",
        by_nou: "КУПИТЬ СЕЙЧАС",
        ship_sot: "Специальное предложение",
        stet_ended: "Акция доступна ",
        day: "Дни",
        hours: "Часов",
        minutes: "Минут",
        seconds: "Секунд",
        baner1: "Баннер 1",
        baner2: "Баннер 2",
        news: "Блог",
        name_en: "Названия EN",
        home_page_baner: "Home Page Baner",
        catalog_page_baner: "Catalog Page Baner",
        Not_Wishlist: "Not Wishlist",
        footer_baner: "Баннер в подвале",
        pay_by_receipt: "ОПЛАТА ПО КВИТАНЦИИ",
        receipt_info: "Информация об организации",
        legal_address: "Юридический адрес",
        hvhh: "ИНН",
        corporate_name: "Название компании",
        PAY_BY_invoice: "ОПЛАТА ПО СЧЕТУ",
        PAY_ON_THE_SPOT_BY_CASH_OR_Bank_Card_Policy:
            "• Наименование организации << Виелви Центр >> ООО<br />    • Юридический адрес: Г. Нждеи 21, Ереван<br />    • Бизнес. Адрес: Аршакунянца 69/5, Ереван<br />    • ИНН: 02235463<br />    • Электронная почта Почта: vlv_hashvapahutyun@mail.ru<br />    • Директор: Вагинак Оганесян<br /><br />    • Банковские реквизиты:<br />    << Инекобанк ЗАО >> 2050022129881001<br />    << АКБА-КРЕДИТ СЕЛЬСКОХОЗЯЙСТВЕННЫЙ БАНК ООО >> 220090125786000<br />    << АРЦАХ БАНК ЗАО >> 22317003448000<br />    << ЕВОКАБАНК ЗАО >> 1660010863460100<br />    << АРМЭКОНОМ БАНК ООО >> 1636103950040100<br />    << КОНВЕРС БАНК ЗАО >> 1930047229410100<br />    << ЮНИБАНК ООО >> 24137000146300<br />    << АМЕРИАБАНК ЗАО >> 1570018294390200<br />    << ВТБ-АРМЕНИЯ БАНК ЗАО >> 16046028825300<br />    << IDBank ЗАО >> 11815025411800<br />",
        easy_pay: "Easy Pay",
        path: "Путь",
        level: "Уровень",
        photos1: "Фото 1",
        photos2: "Фото 2",
        photos3: "Фото 3",
        photos_image_en: "Фотографии изображения En",
        photos_image_ru: "Фотографии изображения Ru",
        photos_image_hy: "Фотографии изображения Hy",
        add_photos: "Добавить фотографии",
        photos: "Фото",
        resumes: "Резюме",
        success_resume: "Ваше резюме было успешно отправлено",
        attach_cv: "Прикрепить резюме",
        profile_page: "Личная страница",
        personal_information: "Личная информация",
        not_favs: "Ваши закладки пусты",
        bonuses: "Бонусы",
        bonus_cartt: "Бонусная карта",
        valid_until: "Действителен до тех пор, пока",
        virtual_products: "Виртуальные продукты",
        my_address: "Мой Адрес",
        my_addresses: "Мои Адреса",
        add_address: "Добавить адрес",
        notification_email: "Отправить уведомление на электронную почту",
        order_history: "История заказов",
        logout: "Выйти",
        repeat: "Повторять",
        repeat_password: "Повторите пароль",
        order_number: "Номер заказа",
        "Do you have a promo code?": "У вас есть промо-код?",
        "Promo code": "Промо-код",
        add_bonus_cart: "Добавить бонусную Карточку",
        "Accumulated bonuses": "Накопленные бонусы",
        "Bonus points spent": "Потраченные бонусные баллы",
        Time: "Время",
        delivery: "Доставка",
        Orders: "Заказы",
        discounts: "Скидки",
        Community: "Сообщество",
        added_address: "Адрес был успешно добавлен",
        updated_address: "Адрес был успешно обновлен",
        Download: "Скачать",
        no_order_history: "У вас нет истории заказов",
        no_virtual_product: "У вас нет виртуальных продуктов",
        Product: "Продукт",
        Bonus: "Бонус",
        repeat_order: "Повторять  заказ",
        buy: "Купить",
        date_discount: "Дата скидк",
        meta_title_en: "Мета-заголовок En",
        meta_description_en: "Мета-описание En",
        meta_title_ru: "Мета-заголовок Ru",
        meta_description_ru: "Мета-описание Ru",
        meta_title_hy: "Мета-заголовок Hy",
        meta_description_hy: "Мета-описание Hy",
        create_product_date: "Дата продажи товаров",
        acba_score:
            'ознакомился с влиянием запроса <b style="color:#D10000;text-decoration: underline;"> на итоговый кредитный рейтинг </b>',
        thanks_for_subscribe: "Спасибо за подписку",
        select_payment_option: "Выберите способ оплаты.",
        select_payment: "Выберите платеж",
        coupon_is_avilable: "Этот купон недоступен для выбранных продуктов",
        coupon_have_more_purchase:
            "У вас есть больше покупок, чтобы получить этот купон.",
        coupon_already: "Этот купон уже использован",
        print_labels: "Печать этикетки",
        create_labels: "Создать ярлыки",
        coupon_expirad: "срок действия купона истек",
        invalid_coupon: "недействительный купон",
        fill_coupon: "заполнить купон",
        date_discount_start: "Дата начала скид",
        date_discount_end: "Дата окончания скидки",
        read_agree_terms: "Я прочитал условия и согласен",
        credit_text: "Добавить текст",
        i_have_read: "Я согласен с условиями",
        check_privacy: "Пожалуйста, проверьте этот ввод",
        error_product: "Выберите продук",
        error_date_start: "выберите дату начала",
        error_date_end: "выберите дату окончания",
        meta_keywords_en: "Мета-ключевые слова en",
        meta_keywords_ru: "Мета-ключевые слова ru",
        meta_keywords_hy: "Мета-ключевые слова hy",
        promo_price: "Промо Цена",
        rrp: "Рекомендованная розничная цена",
        comment_order: "Если у вас есть дополнительные комментарий, укажите здесь",
        flat_room: "Заполните квартиру/дом/этаж",
        copy_right: "© Авторские права защищены ВИЭЛВИ Центр ООО, 2014-2023.",
        cite_development: "Разработка сайта:",
        inecobank: "INECOBANK",
        json_markup: "Json Markup",
        flat: "квартира",
        excel_file: "Файл Excel",
        discounted_price: "Цена со скидкой",
        shipping_amount: "Стоимость доставки",
        shiping_state:
            "Уточнить объем доставки в регионы РА можно по телефону: 091 767117",
        status_is_online: "Статус онлайн",
        status_is_online_active: "Статус онлайн активен",
        status_is_online_inactive: "Статус онлайн неактивен",
        online_price_info: "Цена онлайн",
        credit_info_product: "Условия кредита",
        add_json_markup: "Add JSON MarkUp",
        to_learn_more_attr: "Узнать больш",
        Account: "Счет",
        "Chart Of Accounts": "План счетов",
        "Bank Accounts": "Банковские счета",
        Incomes: "Доходы",
        Expenses: "Расходы",
        "Parent Account": "Родительский счет",
        Type: "Тип",
        Description: "Описание",
        "Default for": "По умолчанию для",
        Amount: "Сумма",
        "Transaction date": "Дата сделки",
        Profit: "Выгода",
        "From The Beginning": "С начала",
        Balance: "Баланс",
        "GST / TAX / VAT": "НДС / НАЛОГ / НДС",
        "Opening Balance": "Начальное сальдо",
        "Main Income Account": "Основной счет доходов",
        "Total Product Wise Tax": "Общий налог на продукт",
        "Email address or phone": "Адрес электронной почты или телефон",
        "Min. 8 Character": "Минимум 8 символов",
        "Sign In": "Вход",
        "Sign Up": "Регистрация",
        "Don’t have an Account?": "У вас нет учетной записи?",
        "Forgot Password?": "Забыли пароль?",
        "Send link": "Отправить ссылку",
        "Please send password link.": "Пожалуйста, пришлите ссылку на пароль.",
        "Welcome back": "С возвращением",
        "Please confirm with new password.":
            "Пожалуйста, подтвердите ввод нового пароля.",
        "Total Order": "Общий заказ",
        "Product in Cart": "Товар в корзине",
        "Coupon Used": "Использованный купон",
        "Completed Order": "Выполненный заказ",
        "Low to high": "От низкого к высокому",
        "High to low": "От высокого к низкому",
        no_brand: "Нет бренда",
        free_shipping_note:
            "Для этого продукта доступна бесплатная доставка. Время доставки в пределах",
        "Daily Deals": "Ежедневные предложения",
        refresh: "Обновить",
        "Filter Products": "Фильтрующие продукты",
        "Seller Score": "Оценка продавца",
        "Seller Information": "Информация о продавце",
        "Choose pickup location": "Выберите место самовывоза",
        "Email Delivery": "Доставка по электронной почте",
        "email delivery note":
            "Подарочная карта всегда доставляется по электронной почте. Стоимость доставки бесплатная. Подарочная карта возврату не подлежит.",
        "App link & others": "Ссылка на приложение и другие",
        "Get it on": "Получить на",
        "Google Play": "Google Play",
        "Apple Store": "Apple Store",
        "Out of stock": "Нет в наличии",
        "Recharge Amount": "Сумма пополнения счета",
        "Add Coupons": "Добавить купоны",
        "Collected Coupons": "Собранные купоны",
        "Shoping Cart": "Корзина покупок",
        "Item’s selected": "Элемент выбран",
        "Variant images": "Варианты изображений",
        "YOU CAN ALSO BUY": "ВЫ ТАКЖЕ МОЖЕТЕ КУПИТЬ",
        "Buy Both": "Купите Оба",
        "Customers who viewed this also viewed":
            "Клиенты, которые смотрели это, также смотрели",
        "Delivery Info": "Информация о доставке",
        "Purchase History": "История покупок",
        "All History": "Вся история",
        Received: "Полученный",
        "Play store link": "Ссылка на Play store",
        "App store link": "Ссылка на App store",
        "Sorting by": "Сортировка по",
        Login: "Вход",
        please_login: "Пожалуйста, войдите в свою учетную запись",
        fill_info: "Заполните свою личную информацию",
        enter_log_pass: "Введите свое имя пользователя и пароль",
        mail: "Электронная почта",
        phone_number: "Номер телефона",
        wrong_msg: "Адрес электронной почты или пароль неверны",
        social_acc: "Войдите в систему через социальные аккаунты",
        next: "Следующий",
        check_email: "Проверьте эл. почту",
        reset_text_password:
            "Пожалуйста, введите шестизначный код, отправленный по электронной почте.",
        we_send: "Вы скоро получите одноразовый код, который нужно ввести в поле.",
        "Register Now": "Зарегистрируйтесь сейчас",
        themes: "Темы",
        live_preview: "Предварительный просмотр",
        theme_details: "Детали темы",
        current_theme: "Topic Details",
        version: "версия",
        tags: "Теги",
        black: "Черный",
        scheme: "Схема",
        white: "Белый",
        text: "Текст",
        solid: "Твердый",
        toastr_message_postion: "Сообщение о тостере",
        toastr_message_time: "Время сообщения тостера",
        top_right: "Вверху справа",
        top_left: "Вверху слева",
        bottom_right: "Внизу справа",
        bottom_left: "Нижний левый",
        area: "Область",
        feature: "Особенность",
        footer: "Нижний колонтитул",
        navbar: "Панель навигации",
        menu: "Меню",
        scroll: "Скроллинг",
        add_new_color: "Добавьте новый цвет",
        background: "Фон",
        border: "Граница",
        base_color: "Базовый цвет",
        upload_title: "Загрузить тему. Если вы приобрели ZIP-файл.",
        browse_zip: "Просмотр ZIP-файла",
        "upload-theme": "Загрузить тем",
        install_now: "Установите сейч",
        input_background: "Фон ввода",
        theme: "Тема",
        header_setup: "Настройка заголовка",
        column_size: "Размер столбца",
        section_general_setting: "Раздел Общие настройки",
        "1_column": "1 столбик",
        "2_column": "2 столбик",
        "3_column": "3 столбик",
        "4_column": "4 столбик",
        "5_column": "5 столбик",
        "6_column": "6 столбик",
        "7_column": "7 столбик",
        "8_column": "8 столбик",
        "9_column": "9 столбик",
        "10_column": "10 столбик",
        "11_column": "11 столбик",
        "12_column": "12 столбик",
        enable_this_section: "Включить этот раздел",
        slider_section_setup: "Настройка раздела слайдера",
        category_section_setup: "Настройка раздела категории",
        product_section_setup: "Настройка раздела продукта",
        new_user_zone_section_setup:
            "Настройка раздела новой пользовательской зоны",
        name_required: "Имя (обязательно)",
        url_required: "URL-адрес обязателен",
        category_required: "Категория Обязательно",
        product_required: "Требуется продукт",
        slider_image_required: "Требуется изображение слайдера",
        slider_image: "Изображение слайдера",
        no_categories: "нет категорий",
        no_sliders: "нет ползунков",
        slider_list: "Список слайдеров",
        upload_theme: "Загрузить тему",
        menus: "Меню",
        header: "Заголовок",
        appearance: "Внешний вид",
        slider_for: "Слайдер для",
        warning_message:
            "меню уже используется в мульти мега меню. Удалить невозможно",
        url_is_required: "URL-адрес обязателен",
        slider_type_is_required: "Укажите тип слайдера.",
        navigation_label_is_required: "Укажите метку навигации.",
        title_is_required: "Укажите метку навигации....",
        priding_is_required: "Укажите цену",
        new_user_zone_is_required: "Требуется новая пользовательская зона",
        for_product: "Для продукт",
        for_category: "Для категории",
        for_brand: "Для бренда",
        for_tag: "Для тега",
        color_mode: "Цветовой режим",
        for_url_not_support_in_mobile_app:
            "Для URL (не поддерживается в мобильном приложении)",
        gradient: "Градиент",
        hide_not_recomanded: "Скрывать не рекомендуется",
        header_pahes: "Категории заголовков",
        "header.category": "Категории заголовков",
        headlist_setup: "Настройка главного списка",
        headlist: "Список заголовков",
        photos_section_setup: "Настройка раздела фотографий",
        photos_image_required: "Требуется фотография",
        photos_image: "Изображение",
        no_photos: "никаких фотографий",
        photos_for: "Фотографии для",
        photos_type_is_required: "Требуется указать тип фотографии",
        failed: "Эти учетные данные не соответствуют нашим записям.",
        password: "Предоставленный пароль неверен.",
        throttle:
            "Слишком много попыток входа. Повторите попытку через пару секунд.",
        logout_successfully: "Успешно вышел из системы",
        logged_in_successfully: "Успешно залогинился",
        successfully_registered: "Успешно зарегистрирован",
        multi_vendor_system_is_temporary_disabled:
            "Мультивендорная система временно отключена.",
        please_verify_your_email:
            "Пожалуйста, подтвердите свой адрес электронной почты",
        wait_for_approval: "Дождитесь одобрения",
        google: "Google",
        client_id: "ID Клиента",
        client_secret: "Секрет клиента",
        "See your growth and get consulting support!":
            "Увидьте свой рост и получите консультационную поддержку!",
        "Sign up with Google": "Зарегистрируйтесь в Google",
        "Sign up with Facebook": "Зарегистрируйтесь через Facebook",
        "Sign up with Twitter": "Зарегистрируйтесь в Твиттере",
        "Sign up with LinkedIn": "Зарегистрируйтесь в LinkedIn",
        "or Sign in with Email or Phone":
            "или Войдите с помощью электронной почты или телефона",
        "or Sign up with Email or Phone":
            "или зарегистрируйтесь с электронной почтой или телефоном",
        "Already have an Account?": "У вас уже есть аккаунт?",
        blog_category: "Категории",
        blog_tag: "Теги",
        blog: "Блог",
        post_list: "Список сообщений",
        add_new_post: "Добавить новый пост",
        post_info: "Информация поста",
        blog_list: "Список блогов",
        author: "Автор",
        all_posts: "Все посты",
        view_post: "Посмотреть пост",
        published_at: "Опубликовано в",
        suggested_tags: "Предлагаемые теги",
        parent_category: "Родительская категория",
        close_comments: "Закрыть комментарии",
        edit_post: "Редактировать пост",
        new_article: "Новая статья",
        post_tag: "Опубликовать тег",
        short_description: "Краткое описание",
        post_article: "Опубликовать статью",
        post: "Пост",
        add_new_blog: "Добавить новый блог",
        image: "Изображение",
        blog_tags: "Теги блога",
        select_parent_category: "Выберите главную категорию",
        comments_create_successfully: "Комментарии успешно созданы",
        replay_create_successfully: "Повтор успешно созда",
        no_post_found: "Пост не найден",
        search_posts: "Поиск постов",
        post_successfully_approved: "Сообщение успешно одобрено",
        this_post_is_already_approved: "Этот пост уже одобрен",
        popular_posts: "Популярные посты",
        instagram_feed: "Лента Instagram",
        project: "Проект",
        love: "Любовь",
        technology: "Технологии",
        travel: "Путешествие",
        restaurant: "Ресторан",
        design: "Дизайн",
        illustration: "Иллюстрация",
        for_post_a_new_comment_you_need_to_login_first:
            "Для публикации нового комментария вам необходимо сначала авторизоваться",
        post_a_comment_now: "Опубликовать комментарий сейчас",
        post_comment: "Оставить комментарий",
        posts: "Пост",
        comments: "Комментарий",
        "Select your Expense Account": "Выберите счет расходов",
        "New Account": "Новый аккаунт",
        "Add As A Parent Account": "Добавить в качестве родительского аккаунта",
        "Parent account selection will add your account as a sub account":
            "Выбор главного аккаунта добавит ваш аккаунт в качестве дополнительного аккаунта",
        "Select your Income Account": "Выберите свой счет доходов",
        "Account code need to be unique, Leave blank for auto generate an unique account code":
            "Код аккаунта должен быть уникальным. Оставьте поле пустым для автоматического создания уникального кода аккаунта.",
        "Selecting a default Account, will remove previously default account for selected item":
            "Выбор аккаунта по умолчанию удалит предыдущую аккаунт по умолчанию для выбранного элемента.",
        "Select Default Account For": "Выберите аккаунт по умолчанию для",
        "You can\\'t delete an account which has child element":
            "Вы не можете удалить аккаунт с дочерним элементом",
        "The requested chart of account is not found":
            "Запрошенный план счетов не найден",
        "The requested chart of account deleted successful":
            "Запрошенный план счетов успешно удален",
        "The requested chart of account created successful":
            "Запрошенный план счетов успешно созда",
        "Income Account": "Счет доходов",
        "Expense Account": "Служебные расходы",
        "Select Account": "Выберите аккаунт",
        "Payment Method": "Способ оплаты",
        "Select your Payment method": "Выберите способ оплаты",
        "Edit Account": "Редактировать аккаунт",
        "The requested chart of account updated successful":
            "Запрошенный план счетов успешно обновлен",
        contact_mail: "Контактная почта",
        contact_mail_list: "Список рассылки контактов",
        contact_request: "Контактный запрос",
        secret_code: "Секретный код",
        is_used: "Используется",
        purchase_list: "Список покупок",
        to_pay: "Платить",
        to_ship: "Отправить",
        to_recieve: "Получать",
        money_has_been_transfered_into_wallet: "Деньги переведены на кошелек",
        purchased_digital_products: "Приобретенные цифровые продукты",
        coupon_value: "Стоимость купона",
        store_name: "Название магазина",
        validity: "Период действия",
        customer_panel: "Панель клиентов",
        my_purchases: "Мои покупки",
        my_wishlist: "Мой список желаний",
        refund_dispute: "Возврат и спор",
        my_coupon: "Мой купон",
        my_account: "Мой счет",
        my_profile: "Мой профиль",
        my_ticket: "Мой билет",
        digital_product: "Цифровой продукт",
        my_referral_code: "Мой реферальный код",
        you_will_get_referral_code_soon:
            "Вы получите реферальный код в ближайшее время!",
        company_info: "Информация о компании",
        my_wallet_recharge: "Пополнение моего кошелька",
        customer_profile: "Профиль клиента",
        address_already_used_for_shipping_or_billing_address:
            "Адрес уже используется для доставки или платежного адреса.",
        address_already_set_for_default_shipping_or_billing_change_first:
            "Адрес уже установлен для доставки или выставления счетов по умолчанию. Изменить сначала.",
        my_referral: "Мой реферал",
        quick_summary: "Краткое содержание",
        seller_dashboard: "Панель продавца",
        today: "Сегодня",
        visitor: "Посетитель",
        this_week: "На этой неделе",
        this_year: "В этом году",
        this_month: "Этот месяц",
        total_seller: "Общиe продавцы",
        total_customer: "Общиe клиенты",
        total_customers: "Общиe клиенты",
        total_order: "Общий заказ",
        total_orders: "Общее количество заказов",
        total_pending_order: "Общее количество отложенных ордеров",
        total_completed_order: "Общее количество выполненных заказов",
        total_sale: "Общая сумма продажи",
        total_review: "Общий обзор",
        today_revenue: "Сегодняшняя выручка",
        active_customers: "Активные клиенты",
        total_subscriber: "Общее количество подписчиков",
        today_sale_revenue: "Сегодняшний доход",
        sellers: "Продавцы",
        today_order_summary: "Сводка заказов на сегодняшний день",
        orders_summary: "Сводка заказов",
        guest_authorized_order_today: "Гость/Авторизованный заказ сегодня",
        site_analytics: "Аналитика сайта",
        total_visitor: "Общее количество посетителей",
        total_page_views: "Общее количество просмотров страниц",
        new_visitors: "Новые посетители",
        old_visitors: "Старые посетители",
        total_in_sessions: "Всего в сеансах",
        top_10_product: "Топ-10 продуктов",
        top_10_seller: "Топ-10 продавцов",
        category_wise_product_qty: "Колво товаров в зависимости от категории",
        category_wise_product_sale: "Продажа товаров по категориям",
        coupon_wise_sale: "Распродажа по купону",
        new_customers: "Новые клиенты",
        recently_added_products: "Недавно добавленные продукты",
        top_refferers: "Лучшие клиенты",
        latest_order: "Последний заказ",
        latest_search_keyword: "Последнее ключевое слово для поиска",
        appealed_disputed: "Обжалованный оспариваемый",
        top_customers: "Лучшие Клиенты",
        top_sellers: "Лучшие продавцы",
        recent_reviews: "Последние обзоры",
        seller_reviews: "Отзывы о продавце",
        dashboard_setup: "Настройка панели мониторинга",
        make_widget_card_colorful: "Сделайте карточку виджета красочной",
        normal: "Обычный",
        color: "Цвет",
        reverse: "Обратный",
        make_visible_in_dashboard: "Сделать видимым на панели мониторинга",
        visible: "Видимый",
        hide: "Скрыть",
        shop_link: "Ссылка на магазин",
        total_delivered_order: "Общий объем доставленного заказа",
        total_non_delivered_order: "Общее количество недоставленных заказов",
        shop_review: "Обзор магазина",
        total_product_refund: "Полный возврат товара",
        total_order_summary: "Общая сводка заказов",
        total_sale_summary: "Общая информация о продаже",
        sale_vs_refund: "Продажа против возврата",
        top_sale_products: "Самые продаваемые продукты",
        latest_uploaded_products: "Последние загруженные продукты",
        latest_refund_request: "Последний запрос на возврат средств",
        subscription_payments: "Оплата подписки",
        "become a merchant": "Станьте торговцем",
        search_resalt: "Результаты поиска",
        monthly: "Ежемесячно",
        currency: "Валюта",
        yearly: "Годовой",
        "best value": "Наилучшее цены",
        "per month": "в месяц",
        "per year": "в год",
        products: "Продукты",
        "transaction charge": "комиссия за транзакцию",
        mark_all_as_read: "Отметьте все как прочитанное",
        "commission rate": "Размер комиссии",
        "choose plan": "Выберите план",
        send_message: "отправить сообщение",
        message: "Сообщение",
        inquery_type: "Тип запроса",
        enter_email_address: "Ваш e-mail:",
        subscribe: "Подписываться",
        enter_name: "Введите имя",
        write_messages: "Писать сообщения",
        billing: "Выставление счетов",
        shippied_by: "отправлено",
        delivery_option: "Вариант доставки",
        addtional_shipping_charge: "Дополнительная плата за доставку",
        Est_arrival_date: "Предполагаемая дата прибытия",
        Est_arrival_time: "Предполагаемое время прибытия",
        bill_to_the_same_address: "Счет на тот же адрес",
        add_coupon: "Добавить купон",
        coupon_store_successfully: "Магазин купонов успешно",
        coupon_code_in_required: "Код купона в обязательном порядке",
        order_date: "Дата заказа",
        order_amount: "Сумма заказа",
        sold_by: "Продается компанией",
        view_more: "Посмотреть больше",
        package_code: "Код упаковки",
        store: "Магазин",
        confirm_receive_items: "Подтвердите получение товаров",
        open_dispute: "Открытый спор",
        cancel_order: "Отменить заказ",
        order_cancelled: "Заказ отменен",
        write_a_review: "Написать отзыв",
        shipping_info: "Информация о доставке",
        total_summary: "Общее содержание",
        paid_by: "Оплаченный",
        payment_info: "Информация о платеже",
        payment_status: "Статус платежа",
        order_has_been_recieved: "Заказ был получен.",
        order_not_recieved: "Заказ не получен.",
        order_has_been_cancelled: "Заказ был отменен.",
        order_cancellation_has_failed: "Отмена заказа не удалась.",
        download_invoice: "Скачать счет-фактуру",
        add_invoice: "Добавить счет-фактуру",
        order_details: "Детали заказа",
        contact_seller: "Связаться с продавцом",
        copy_code: "Скопировать код",
        user_list: "Список пользователей",
        discount_amount: "Сумма скидки",
        already_use: "Уже используете",
        not_used: "Не используется",
        you_will_get_referral_after:
            "Вы Получите Реферальный код После Первой Покупки.",
        code_copied_successfully: "Код скопирован успешно.",
        wishlist: "Закладки",
        review: "Обзор",
        unlimited: "Неограниченный",
        availability: "Доступность",
        condition: "Состояние",
        sku: "SKU",
        add_to_wishlist: "Добавить в закладки",
        share_on: "Поделиться на",
        seller_info: "Информация о продавце",
        reviews: "Обзоры",
        product_description: "Описание товара",
        product_specifications: "Технические характеристики продукта",
        product_reviews: "Отзывы о продукте",
        no_stock_found_for_this_seller: "Товар для этого продавца не найден",
        maximum_quantity_limit_is: "Максимальное количество -",
        minimum_quantity_Limit_is: "Минимальное количество -",
        no_more_stock: "Больше никаких запасов!!!",
        product_already_in_wishList: "Товар уже в закладках",
        product_delete_in_wishList: "Удалить товар из закладки",
        thanks: "Спасибо..",
        successfully_added_to_wishlist: "Успешно добавлено в закладки",
        product_successfully_deleted_from_cart: "Товар успешно удален из корзины",
        adding: "Добавление",
        product_successfully_added_to_cart: "Товар успешно добавлен в корзину.",
        subscribe_successfully: "Подписано успешно! Спасибо за подписку.",
        wishlist_product: "Продукт из закладок",
        showing: "Показ",
        out_of_total: "из общего числа",
        low_to_high: "От низкого к высокому",
        high_to_low: "От высокого к низкому",
        no_product_in_wishlist: "Товара нет в списке желаний",
        no_products: "никаких продуктов",
        member_since: "Участник с тех пор, как",
        related_category: "Связанная категория",
        deal_ends_in: "Сделка заканчивается",
        deal_starts_in: "Сделка начинается в",
        deal_ends: "Сделка заканчивается",
        hi_welcome_to: "Привет, добро пожаловать в",
        orders_over: "Приказы окончены",
        get_now: "Получить сейчас",
        time_to_shop: "Время ходить по магазинам",
        place_a_refund_request: "Разместите запрос на возврат средств",
        additional_information: "дополнительная информация",
        optional: "Необязательный",
        set_prefered_option: "Установите предпочтительный вариант",
        wallet: "Кошелек",
        bank_transfer: "Банковский перевод",
        bank_information_to_recieve_money:
            "Банковская информация Для Получения Денег",
        set_shipment_option: "Установите параметр отправки",
        please_select_pick_up_courier_you_prefer:
            "Пожалуйста, выберите курьера, которого вы предпочитаете",
        Pickup_address: "Адрес для получения",
        drop_off_your_return_item_at_a_nearby_courier_office:
            "Доставьте возвращаемый товар в ближайшее курьерское отделение.",
        courier_address: "Адрес курьера",
        request_sent_date: "Дата отправки запроса",
        drop_off_info: "Предоставьте информацию",
        refunds: "Возвраты",
        view_details: "Просмотреть подробную информацию",
        tax_amount: "Сумма НАЛОГА",
        message_sent_successfully: "Сообщение отправлено успешно! Спасибо.",
        question_chat_with_us: "Вопрос? Общайтесь с нами в чате",
        welcome_back: "С возвращением",
        please_login_to_your_account: "Пожалуйста, войдите в свою учетную запись",
        minimum_8: "Минимум 8",
        by_signing_up_you_agree_to_terms_of_service_and_privacy_policy:
            "Регистрируясь, вы соглашаетесь с Условиями предоставления услуг и Политикой конфиденциальности",
        register: "Зарегистрировать",
        login_account: "Учетная запись для входа в систему",
        already_a_member_yet: "Уже являетесь участником?",
        please_confirm_with_new_password:
            "Пожалуйста, подтвердите ввод нового пароля",
        save_change: "Сохранить",
        track_your_order: "Отслеживайте свой заказ",
        support: "Поддержка",
        sign_up: "Зарегистрироваться",
        login: "Вход в систему",
        log_out: "Выход из системы",
        continue_shopping: "Продолжить покупки",
        view_shopping_cart: "Просмотр корзину покупок",
        all_categories: "Все категории",
        best_deals: "Лучшие предложения",
        new_user_zone: "Новая пользовательская зона",
        search_your_item: "Ищите, чтобы найти",
        email_or_phone: "электронная почта или телефон",
        remember_me: "Помни меня",
        forgot_password: "Забыли пароль",
        login_with: "Войдите в систему с помощью:",
        want_to_be_a_new_merchant: "Хотите стать новым продавцом?",
        create_account: "Создать аккаунт",
        please_input_new_password: "Пожалуйста, введите новый пароль.",
        send_link: "Отправить ссылку",
        please_send_password_link: "Пожалуйста, пришлите ссылку на пароль",
        please_create_your_account: "Пожалуйста, создайте свою учетную запись",
        contact_form: "Контактная форма",
        contact_message: "Контактное сообщение",
        maximum_quantity_limit_exceed: "Превышение максимального лимита количества",
        no_more_stock_available: "Больше нет доступных запасов",
        please_select_product_first: "Пожалуйста, сначала выберите продукт",
        this_is_undefined: "Это не определено",
        your_cart_is_empty_please_select_item_s_before_checkout_also_add_address_first:
            "Ваша корзина пуста! Пожалуйста, выберите товар (ы) перед оформлением заказа. Также сначала добавьте адрес.",
        wallet_balance_is_not_enough_to_pay_for_this_order:
            "Баланса кошелька недостаточно для оплаты этого заказа",
        your_cart_is_empty_please_select_item_s_before_checkout: "Корзина пуста",
        coupon_applied_successfully: "Купон успешно применен",
        coupon_field_is_required: "Поле для купона обязательно для заполнения",
        coupon_deleted_successfully: "Купон успешно удален",
        product_compare: "Сравнение продуктов",
        click_here_to_request_another: "нажмите здесь, чтобы запросить другой",
        from_the_same_store: "Из того же магазина",
        and_up: "И вверх",
        team_member: "Член команды",
        choose_plan: "Выберите план",
        track: "Дорожка",
        no_stock_found_for_this_vendor: "Акции этого поставщика не найдены",
        maximum_6_image_can_upload: "Можно загрузить максимум 6 изображений",
        write_review: "Написать отзыв",
        focus_only_on_the_product_and_its_features:
            "Сосредоточьтесь только на продукте и его функциях",
        please_share_your_feedback_about_the_product:
            "Пожалуйста, поделитесь своим отзывом о продукте",
        how_over_all_experience_with_seller: "Каков общий опыт работы с продавцом?",
        rate_and_review_your_seller: "Оцените и оставьте отзыв о вашем продавце",
        review_details: "Подробности обзора",
        anonymous: "Анонимный",
        recently_viewed_items: "Недавно просмотренные элементы",
        wholesale: "Оптовый",
        enter_your_order_tracking_number_and_your_secret_id:
            "Введите номер для отслеживания вашего заказа и свой секретный идентификатор",
        order_tracking_number: "Номер для отслеживания заказа",
        secret_id_only_for_guest_user:
            "Секретный идентификатор (только для гостевого пользователя)",
        phone_used_for_billing: "Телефон (Используется для выставления счетов)",
        important: "Важный:",
        maximum_6_images_can_be_uploaded: "Можно загрузить максимум 6 изображений",
        image_size_can_be_maximum_5mb:
            "Размер изображения может составлять не более 5 мб",
        delivered_on: "Поставленный на",
        rate_and_review_purchased_product:
            "Оцените и просмотрите приобретенный товар",
        review_detail: "Подробная информация о обзоре",
        how_to_write_a_good_review: "How to write a good review",
        track_order: "Track order",
        price_range: "Price Range",
        refresh_filters: "Refresh Filters",
        product_removed_from_compare_list_successfully:
            "Product removed from compare list successfully",
        compare_reset_successfully: "Сравнение сброшено успешно",
        please_login_first: "Пожалуйста, сначала войдите в систему",
        verify_your_email: "Verify Your Email",
        before_proceeding_please_check_your_email_for_a_varification_link_if_you_din_not_get_the_email:
            "Before proceeding, please check your email for a varification link. If you din not get the email",
        thank_you_for_your_purchase: "Спасибо за вашу покупку",
        your_order_number_is: "Your order number is",
        your_delivery_dates: "Your delivery dates",
        for_more_details_track_your_delivery_status_order:
            "For more details track your delivery status order",
        we_have_a_confirmation_email_to: "We have a confirmation email to",
        with_the_order_details: "With the order details",
        order_summary: "Order summary",
        create_your_merchant_account: "Create your merchant account",
        subscription_type: "Subscription Type",
        select_all: "Выбрать все",
        cart_is_empty: "Корзина пусто.",
        reset_compare: "Сброс сравнения",
        compare_list_is_empty: "Список сравнения пуст",
        no_gift_card_found: "No gift card found",
        no_review_found: "No review found.",
        child_category: "Child category",
        product_not_added: "Product not added",
        product_added_to_compare_list_successfully:
            "Продукт успешно добавлен в список сравнения",
        not_added: "Not added",
        no_product_found: "No product found",
        billing_address_is_not_as_same_as_shipping_address:
            "Billing address is not as same as shipping address",
        this_page: "This page",
        add_to_compare: "Добавить для сравнения",
        page_expired: "Page Expired",
        forbidden: "Forbidden",
        sorry_you_are_forbidden_from_accessing_this_page:
            "Извините, вам запрещен доступ к этой странице",
        whoops_something_went_wrong_on_our_servers:
            "Упс, что-то пошло не так на наших серверах.",
        maximum_image_6_image_can_upload: "Maximum image 6 image can upload",
        package_wise_shipping_charge: "Package wise shipping charge",
        proceed_to_checkout: "Proceed to checkout",
        name_a_to_z: "Названию : от А до Я",
        name_z_to_a: "Названию : от Я до А",
        price_low_to_high: "Цена :  мин - макс",
        price_high_to_low: "Цена : макс - мин",
        "401_unauthorized": "401 | Unauthorized",
        sorry_you_are_not_authorized_to_access_this_page:
            "Извините, вы не авторизованы для доступа к этой странице.",
        go_home: "Go Home",
        go_back: "Возвращаться",
        sorry_page_not_found: "Извините! Страница не найдена",
        sorry_the_page_you_are_looking_for_could_not_be_found:
            "Извините, страница, которую вы ищете, не найдена.",
        sorry_your_session_has_expired_please_refresh_and_try_again:
            "Извините, ваш сеанс истек. Пожалуйста, обновите и повторите попытку.",
        too_many_requests: "Слишком много запросов",
        sorry_you_are_making_too_many_requests_to_our_servers:
            "Извините, вы делаете слишком много запросов.",
        service_unavailable: "Service Unavailable",
        sorry_we_are_doing_some_maintenance_please_check_back_soon:
            "Извините, мы проводим кое-какое техническое обслуживание.",
        compare: "Сравнение товаров",
        please_product_select_from_cart_first:
            "Пожалуйста, Сначала Выберите Товар Из Корзины.",
        out_of_stock: "Нет в наличии.",
        new_member: "New Member?",
        "I agree with the terms and conditions":
            "Я согласен с правилами и условиями",
        process_to_payment: "Процесс до Оплаты",
        add_fund: "Добавить фонд",
        calculated_at_next_step: "Вычисляется на следующем шаге",
        click_here_to_login: "Нажмите здесь, чтобы войти в систему",
        returning_customer: "Возвращающийся клиент",
        contact_information: "Контактная информация",
        email_me_with_news_and_offers:
            "Пишите мне по электронной почте с новостями и предложениями",
        address_list: "Список адресов",
        new_address: "Новый адрес",
        continue_to_shipping: "Продолжать отправку",
        continue_to_payment: "Перейти к Оплате",
        return_to_cart: "Вернуться в Корзину",
        return_to_shipping: "Вернуться к отправке",
        return_to_information: "Вернуться к информации",
        contact: "Контакт",
        ship_to: "Отправить в",
        all_transactions_are_secure_and_encrypted:
            "Все транзакции безопасны и зашифрованы",
        same_as_shipping_address: "Совпадает с адресом доставки",
        use_a_different_billing_address: "Используйте другой платежный адрес",
        minimum_quantity_limit_exceed: "Превышение минимального лимита количества",
        select_shipping: "Выберите доставку",
        email_verify: "Проверка электронной почты",
        checkout: "Проверка",
        customer_information: "Информация о клиенте",
        billing_shipping_info: "Информация о выставлении счетов и доставке",
        processing: "Обработка",
        but_it_now: "Купи это сейчас",
        privacy_policy_check:
            'This  <a style="color:#D10000;" href="/privacy-policy" target="_blank">Privacy Policy</a>  test <a style="color:#D10000;" href="/terms-and-conditions" target="_blank">Terms & Condition</a>',
        "New Expense": "Новые расходы",
        "Edit Expense": "Редактировать расходы",
        "The requested expense is not found": "Запрошенный расход не найден",
        "The requested expense deleted successful":
            "Запрошенный расход удален успешно",
        "The requested expense created successful":
            "Запрошенный расход создан успешно",
        "The requested expense updated successful":
            "Запрошенный расход обновлен успешно",
        form_builder: "Конструктор форм",
        forms: "Формы",
        terms_page_link: "Ссылка на страницу условий",
        privacy_policy_page_link: "Ссылка на страницу Политики конфиденциальности",
        form: "Форма",
        about_us_contant: "О нас Свяжитесь с нами",
        frontend_cms: "Интерфейсная CMS",
        "main-title": "Основное название",
        shop_address: "Адрес магазина",
        create_shop_address: "Создать адрес магазина",
        benifit_title: "НАЗВАНИЕ ПОСОБИЯ",
        selling_title: "ПРОДАЮЩИЙ ТИТУЛ",
        main_details: "Основные детали",
        benifits_details: "Подробная информация о преимуществах",
        selling_details: "Детали продажи",
        features: "Особенности",
        benefit_list: "Список льгот",
        update_benefit: "Преимущество обновления",
        "career list": "Список карьеры",
        "update career": "Обновить карьеру",
        "career content": "Содержание карьеры",
        contact_us_contant: "Контент для контактов с нами",
        feature_list: "Список функций",
        new_feature: "Новая функция",
        merchant_content: "Контент продавца",
        "benifit title": "Название пособия",
        pricing_slogan: "Ценовой лозунг",
        pricing: "Ценообразование",
        how_it_work_title: "Как это работает Название",
        pricing_title: "Название цены",
        pricing_list: "Прайс-лист",
        faq_title: "Название часто задаваемых вопросов",
        query_title: "Заголовок запроса",
        benefits_details: "Подробная информация о преимуществах",
        pricing_details: "Подробная информация о ценах",
        how_it_work_details: "Подробности о том, как это работает",
        query_details: "Детали запроса",
        faq_details: "Детали часто задаваемых вопросов",
        benefit: "Выгода",
        how_it_work: "Как это работает",
        "benefit list": "Список льгот",
        how_it_work_list: "Список того, как это работает",
        faq_list: "Список часто задаваемых вопросов",
        faq_update: "Обновление часто задаваемых вопросов",
        position: "Позиция",
        "policy list": "Список политик",
        "edit policy": "Редактировать политику",
        "pricing update": "Обновите цены",
        pricing_plan: "Ценовой план",
        add_pricing_plan: "Добавить тарифный план",
        edit_pricing_plan: "Изменить ценовой план",
        "pricing list": "Прайс-лист",
        "show pricing": "Показать цены",
        monthly_cost: "Цена/месяц",
        yearly_cost: "Цена/год",
        transaction_fee: "Комиссия за транзакцию",
        best_for: "Лучше всего подходит для",
        pricing_type: "Тип ценообразования",
        team_size: "Размер команды",
        stock_limit: "Лимит запасов",
        commission: "Размер комиссии",
        "return list": "Список возврата и обмена",
        "update title": "Возврат и обмен обновлений",
        page_list: "Список страниц",
        dynamic_page: "Динамическая страница",
        create_dynamic_page: "Создать динамическую страницу",
        update_dynamic_page: "Обновить динамическую страницу",
        subscribe_content: "Подписка на контент",
        term_list: "Список терминов и условий",
        "working process list": "Список рабочих процессов",
        update_working_process: "Обновить рабочий процесс",
        add_link: "Добавить ссылку",
        edit_link: "Редактировать ссылку",
        page_name: "Название страницы",
        select_page: "Выберите страницу",
        copyright_text: "Текст, защищенный авторским правом",
        about_text: "О тексте",
        section_name: "Название раздела",
        about_description: "Об описании",
        add_new_page: "Добавить новую страницу",
        widget_title: "Заголовок виджета",
        add_InQuery: "Добавить запрос",
        edit_InQuery: "Редактировать запрос",
        "return&exchange": "Возврат и обмен",
        exchange_details: "Детали обмена",
        return_title: "Вернуть заголовок",
        return_details: "Детали возврата",
        inquery_list: "Список запросов",
        footer_settings: "Настройки нижнего колонтитула",
        frontendCMS: "Интерфейсная CMS",
        "benifit-title": "Пособие-Титул",
        price_monthly: "Цена/Ежемесячно",
        home_page: "Домашняя страница",
        category_products: "Категория Товаров",
        latest_products: "Новейшие продукты",
        recently_viewed_products: "Недавно просмотренные продукты",
        max_sale: "Максимальная продажа",
        max_review: "Максимальный обзор",
        custom_products: "Изготовленные на заказ продукты",
        top_category: "Высшая категория",
        latest_category: "Последняя категория",
        new_category: "Новая категория",
        custom_category: "Пользовательская категория",
        top_brands: "Лучшие бренды",
        latest_brands: "Новейшие бренды",
        new_brands: "Новые бренды",
        custom_brands: "Пользовательские бренды",
        add_feature: "Добавить функцию",
        edit_feature: "Функция редактирования",
        Inquery: "Расследование",
        individuals: "Индивидуумы",
        business: "Бизнес",
        professional: "Профессиональный",
        widget: "Виджет",
        section_list: "Список разделов",
        subscription_crone_job_url: "URL-АДРЕС ЗАДАНИЯ CRONE ДЛЯ ПОДПИСКИ",
        seller_registration_title_for_first_page:
            "Регистрационный заголовок продавца на первой странице",
        exchange_title: "Название биржи",
        return_exchange: "Обратный обмен",
        contact_content: "Содержание контактов",
        dynamic_pages: "Динамические страницы",
        footer_setting: "Настройка нижнего колонтитула",
        about_us: "о нас",
        related_sale_setting: "Соответствующая настройка продажи",
        subscribe_content_update_successfully:
            "Подписка на успешное обновление контента",
        title_has_been_updated_successfully: "Заголовок был успешно обновлен",
        promotion_bar: "Рекламный Панель",
        ads_bar: "Панель объявлений",
        login_page: "Страница входа в систему",
        general_settings: "Общие настройки",
        activate: "Активировать",
        smtp_setting: "Настройка SMTP",
        activation: "Активация",
        sms_setting: "Настройка SMS-сообщений",
        sms_template: "Шаблон SMS-сообщения",
        symbol: "Символ",
        shop_link_banner: "Баннер со ссылкой на магазин",
        upload_shop_link_banner: "Загрузить баннер со ссылкой на магазин",
        currency_list: "Список валют",
        "Edit Currency Info": "Редактировать информацию о валюте",
        "Currency Updated Successfully": "Валюта успешно обновлена",
        "Currency Added Successfully": "Валюта успешно добавлена",
        "Currency has been deleted Successfully": "Валюта была успешно удалена",
        "SMS Gateways Credentials has been updated Successfully":
            "Учетные данные SMS-шлюзов были успешно обновлены",
        "SMS has been sent Successfully": "SMS-сообщение было успешно отправлено",
        "SMTP Gateways Credentials has been updated Successfully":
            "Учетные данные SMTP-шлюзов были успешно обновлены",
        "Mail has been sent Successfully": "Почта была успешно отправлена",
        "Please Configure SMTP settings first":
            "Пожалуйста, сначала настройте параметры SMTP",
        "Language has been deleted Successfully": "Язык был успешно удален",
        "Language Updated Successfully": "Язык успешно обновлен",
        "Language Added Successfully": "Язык успешно добавлен",
        RTL: "RTL",
        Active: "Активный",
        "Email Template": "Шаблон электронной почты",
        Translation: "Перевод",
        "Native Name": "Настоящее имя",
        "Edit Language Info": "Редактировать информацию о языке",
        "Select Translatable File": "Выберите переводимый файл",
        Key: "Ключ",
        sender_name: "Имя отправителя",
        api_key: "Ключ API",
        registered_phone_number: "Зарегистрированный номер телефона",
        authentication_token: "Токен аутентификации",
        twilio_account_sid: "SID учетной записи Twilio",
        send_test_mail: "Отправить тестовое письмо",
        send_a_test_email_to: "Отправьте тестовое электронное письмо по адресу",
        mail_text: "Текст письма",
        predefined_footer: "Предопределенный нижний колонтитул",
        predefined_header: "Предопределенный заголовок",
        email_signature: "Подпись электронной почты",
        sender_email: "Адрес электронной почты отправителя",
        email_settings: "Настройки электронной почты",
        email_protocol: "Протокол электронной почты",
        mail_engine: "Почтовый движок",
        from_name: "От имени",
        from_mail: "Из почты",
        mail_host: "Почтовый узел",
        mail_port: "Почтовый порт",
        mail_username: "Имя пользователя электронной почты",
        mail_password: "Почтовый пароль",
        mail_encryption: "Шифрование почты",
        email_charset: "Кодировка электронной почты",
        About: "О",
        Misc: "Разное",
        Tags: "Теги",
        "Theme Options": "Варианты темы",
        Cronjob: "Закадычный дружок",
        "E-Sign": "Электронная подпись",
        "PDF Settings": "Настройки PDF-файла",
        Calendar: "Календарь",
        SMS: "SMS",
        Support: "Поддержка",
        "Customer Permission": "Разрешение клиента",
        general: "Общие",
        Activation: "Активация",
        system_default_language: "Системный язык по умолчанию",
        copywrite_text: "Текст, защищенный авторским правом",
        file_supported: "Поддерживаемый файл",
        system_title: "Название системы",
        upload_fav_icon: "Загрузить значок",
        fav_icon: "Значок",
        upload_logo: "Загрузить логотип",
        system_logo: "Логотип системы",
        system_default_currency: "Валюта системы по умолчанию",
        currency_symbol: "Символ валюты",
        currency_code: "Код валюты",
        SMTP: "SMTP",
        date_format: "Формат даты",
        time_zone: "Часовой пояс",
        activate_sms_gateway: "Активировать SMS-шлюз",
        sms_settings: "Настройки SMS-сообщений",
        twilio: "Twilio",
        textlocal: "Текстовый локальный",
        URL: "URL",
        IP: "IP",
        agent: "Агент",
        "Margin Price": "Маржинальная цена",
        "Agent Commission Type": "Тип комиссионного вознаграждения агента",
        Quantity: "Количество",
        "Invoice Prefix": "Префикс счета-фактуры",
        include_comma_with_each_word:
            "Ставьте запятую перед каждым словом, например, csv, doc,docx",
        preloader: "Предварительный загрузчик",
        send_a_test_sms: "Отправьте тестовое SMS-сообщение",
        send_test_sms: "Отправить тестовое SMS-сообщение",
        url: "URL",
        Agent: "Агент",
        "Currency List": "Список валют",
        add_new_currency: "Добавить новую валюту",
        edit_currency_info: "Редактировать информацию о валюте",
        company_name: "Название компании",
        company_information: "Информация о компании",
        "Payment Gateways": "Платежные шлюзы",
        order_invoice: "Счет-фактура для заказа",
        email_footer: "Нижний колонтитул электронной почты",
        template: "Шаблон",
        reciepent: "Получатель",
        manage: "Управлять",
        add_new_template: "Добавить новый шаблон",
        set_for: "Набор для",
        customer: "Покупатель",
        system_settings: "Системные настройки",
        short_code: "короткий код",
        use_these_to_get_your_neccessary_info:
            "используйте их, чтобы получить необходимую вам информацию",
        convert_rate: "Коэффициент конвертации",
        please_select_valid_reciepent_to_create_template:
            "Пожалуйста, выберите действительного получателя для создания шаблона",
        mail_has_been_sent_successfully: "Почта была успешно отправлена",
        please_configure_smtp_settings_first:
            "Пожалуйста, сначала настройте параметры SMTP",
        php_mailer: "PHP-почтовая программа",
        php_mailer2: "PHP Mailer 2",
        logo_banner: "Логотип и баннер",
        social_link: "Социальная связь",
        fontawesome_or_themefy_icon_only:
            "Примечание: Только значок Font awesome и Themify.",
        smtp: "SMTP",
        php_mail: "PHP-почта",
        maintenance: "Поддержка",
        maintenance_page_banner: "Баннер страницы обслуживания",
        mode: "Режим",
        module: "Модуль",
        manager: "Менеджер",
        upload_from_local_directory: "Загрузка из Локального каталога",
        software_version: "Версия программного обеспечения",
        about_system: "О системе",
        php_version: "Версия PHP",
        check_update: "Проверьте обновление",
        curl_enable: "Включить скручивание",
        purchase_code: "Код покупки",
        install_domain: "Установить домен",
        system_activated_date: "Дата активации системы",
        last_update_at: "Последнее обновление на",
        upload_sql_file: "Загрузить SQL-файл",
        database_backup_list: "Список резервных копий базы данных",
        generate_new_backup: "Создайте новую резервную копию",
        new_database_backup_has_been_created:
            "Создана новая резервная копия базы данных",
        add_new_update_module: "Добавить новый / Обновить модуль",
        select_module_file: "Выберите файл модуля",
        backup: "Резервная копия",
        gateway_settings: "Настройки шлюза",
        about_update: "Информация и обновления",
        message_for_system_notification: "Сообщение для системного Уведомления",
        verify: "Проверить",
        verified: "Проверенный",
        currency_symbol_position: "Позиция символа валюты",
        decimal_number_limit: "Ограничение на десятичное число",
        left_with_space: "Осталось свободное место",
        right_with_space: "Правильно с Пространством",
        guest_checkout: "Выезд гостя",
        facebook_messanger: "Facebook Messenger",
        paste_code_here: "Вставьте код здесь",
        messager_code: "Код сообщения",
        social_configuration: "Социальная конфигурация",
        send_to_parameter_name: "Отправить по имени параметра",
        message_parameter_name: "Имя параметра сообщения",
        request_method: "Способ запроса",
        parameter_1_key: "Параметр 1 Ключ",
        parameter_2_key: "Параметр 2 Ключ",
        parameter_3_key: "Параметр 3 Ключ",
        parameter_4_key: "Параметр 4 Ключ",
        parameter_5_key: "Параметр 5 Ключ",
        parameter_6_key: "Параметр 6 Ключ",
        parameter_7_key: "Параметр 7 Ключ",
        parameter_8_key: "Параметр 8 Ключ",
        parameter_9_key: "Параметр 9 Ключ",
        parameter_10_key: "Параметр 10 Ключ",
        parameter_1_value: "Значение параметра 1",
        parameter_2_value: "Значение параметра 2",
        parameter_3_value: "Значение параметра 3",
        parameter_4_value: "Значение параметра 4",
        parameter_5_value: "Значение параметра 5",
        parameter_6_value: "Значение параметра 6",
        parameter_7_value: "Значение параметра 7",
        parameter_8_value: "Значение параметра 8",
        parameter_9_value: "Значение параметра 9",
        parameter_10_value: "Значение параметра 10",
        update_sms_setting: "Обновить настройки Sms",
        others: "Другие",
        cloud_storage: "Облачное хранилище",
        amazon_s3: "AmazonS3",
        aws_s3s_setting: "Aws S3 Setting",
        access_key_id: "Идентификатор ключа доступа",
        default_region: "Регион по умолчанию",
        aws_bucket: "AWS Bucket",
        file_storage: "Хранилище файлов",
        active_file_storage: "Активное хранилище файлов",
        default_currency_not_changeble:
            "Валюта по умолчанию не подлежит изменению.",
        message_for_particular_user: "Сообщение для конкретного пользователя",
        message_for_admin_site: "Сообщение для администратора сайта",
        homepage_seo_setup: "Настройка SEO главной страницы",
        meta_site_title: "Заголовок мета-сайта",
        meta_keywords: "Мета-ключевые слова",
        preloader_status: "Статус предварительной загрузки",
        preloader_type: "Тип предварительного загрузчика",
        animation: "Анимация",
        preloader_image: "Изображение предварительного загрузчика",
        preloader_style: "Стиль предварительного загрузчика",
        preloader_setting: "Настройка предварительного загрузчика",
        lazyload_image: "Изображение с отложенной загрузкой",
        upload_lazyload_image: "Загрузить изображение Lazyload",
        pwa_app_name: "Название приложения PWA",
        product_subtitle_show: "Показать субтитры к продукту",
        category_show_in_menu: "Отображение категории в меню",
        gst_setup: "Настройка GST/VAT/TAX",
        gst_list: "GST/НДС/список НАЛОГОВ",
        gst: "GST",
        add_new_gst: "Добавить новый GST/НДС/НАЛОГ",
        edit_gst: "Редактировать GST/НДС/НАЛОГ",
        place_of_delivery_inside_state: "Доставка внутри штата",
        place_of_delivery_outside_state: "Доставка за пределы штата",
        gst_configuration: "Конфигурация GST/VAT/TAX",
        select_one_or_multiple: "Выберите один или несколько",
        claim_gst: "Претензия GST/VAT/TAX",
        gst_claimed: "GST/НДС/заявленный НАЛОГ",
        goods_and_services_tax: "Налог на товары и услуги",
        total_gst: "Общая сумма GST/НДС/НАЛОГА",
        is_active_flat_tax: "Действует Единый налог",
        is_active_gst: "Активен GST/VAT/TAX",
        flat_tax_percentage: "Процент фиксированного налога",
        flat_tax: "Единый налог",
        gst_or_flat_rate_claimed_by_seller:
            "GST/НДС/НАЛОГ или фиксированная ставка, заявленная продавцом",
        gst_or_flat_tax_claim_by_seller:
            "Требование продавца по GST/НДС/НАЛОГУ или фиксированному налогу",
        same_state_GST: "GST/НДС/НАЛОГ в том же штате",
        outsite_state_GST: "GST/НДС/НАЛОГ за пределами штата",
        GST_group: "GST/НДС/НАЛОГОВАЯ группа",
        human_resource: "Человеческие ресурсы",
        applicable_for_leave: "Применимо для получения Отпуска",
        bank_branch_name: "Название филиала банка",
        bank_info: "Банковская информация",
        account_no: "Номер учетной записи",
        cheque_no: "Чека нет",
        pay_now: "заплатить сейчас",
        bank_account_details: "Реквизиты банковского счета",
        bank_account_number: "Номер банковского счета",
        payroll_info: "Информация о заработной плате",
        loan_apply: "Информация о заработной плате",
        loan_history: "Кредитная история",
        loan_approval: "Одобрение кредита",
        "Loan Apply": "Подать заявку на получение кредита",
        date_of_joining: "Дата вступления",
        basic_salary: "Базовая заработная плата",
        employment_type: "Тип занятости",
        provision: "Обеспечение",
        contract: "Договор",
        permanent: "Постоянный",
        provision_time: "Время предоставления",
        in_months: "В месяцах",
        department: "Отдел",
        staff_list: "Штатное расписание",
        staff: "Персонал",
        edit_staff_info: "Редактировать персонал в",
        attendance: "Посещаемость",
        attendance_report: "Отчет о посещении",
        holiday_setup: "Праздничная обстановка",
        system_user: "Системный пользователь",
        assign_permission: "Назначить разрешение",
        system_role: "Системная роль",
        regular_user: "Обычный пользователь",
        present: "Подарок",
        select_criteria: "Выберите критерии",
        late: "Поздно",
        absent: "Отсутствует",
        holiday: "Праздник",
        P: "P",
        L: "L",
        A: "A",
        H: "H",
        select_month: "Выберите месяц",
        select_year: "Выберите год",
        event_list: "Список событий",
        event: "Событие",
        for_whom: "Для кого",
        copy_previous_year_settings: "Скопировать настройки предыдущего года",
        holiday_name: "Название праздника",
        select_criteria_for_payroll:
            "Выберите критерии для расчета заработной платы",
        not_generated: "Не сгенерирован",
        generated: "Сгенерированный",
        generate_payroll: "Формирование заработной платы",
        view_paySlip: "Просмотреть платежную ведомость",
        earnings: "Прибыль",
        deductions: "Вычеты",
        payroll_summary: "Сводка по заработной плате",
        calculate: "Вычислять",
        gross_salary: "Валовая заработная плата",
        payroll: "Платежная ведомость",
        payroll_reports: "Отчеты о заработной плате",
        payslip_for_the_period_of: "Платежная ведомость за период",
        payslip: "Платежная ведомость",
        total_earning: "Общий заработок",
        total_deduction: "Общий вычет",
        net_salary: "Чистая заработная плата",
        proceed_to_pay: "Приступайте к оплате",
        staff_name: "Название персонала",
        payment_amount: "Сумма платежа",
        paid_date: "Оплаченная дата",
        role: "Роль",
        leave: "Покидать",
        apply_date: "Дата подачи заявки",
        delete_not_possible_role_has_user:
            "Удалить невозможно. Роль имеет Пользователя.",
        permission_given_successfully: "Разрешение получено успешно.",
        attendance_has_been_taken_successfully: "Явка была принята успешно.",
        holiday_saved_successfully: "Праздник успешно спасен.",
        year_holiday_not_found: "Новогодний праздник не найден.",
        select_Role_date_from_list: "Выберите Роль и Дату из Списка.",
        deleted_not_possible_for_this_customer:
            "Удалено Невозможно Для Этого Клиента.",
        "You cann\\'t delete an income which has child element":
            "Вы не можете удалить доход, у которого есть дочерний элемент",
        "New Income": "Новый доход",
        "The requested income is not found": "Запрашиваемый доход не найден",
        "The requested income deleted successful":
            "Запрошенный доход успешно удален",
        "The requested income created successful":
            "Запрошенный доход был получен успешно",
        "The requested income updated successful":
            "Запрошенный доход обновлен успешно",
        "Edit Income": "Редактировать доход",
        language_list: "Языки",
        add_new_language: "Добавить язык",
        code: "Код",
        LTL: "LTL",
        "Language Settings": "Языковые настройки",
        native_name: "Native Name",
        edit_language_info: "Редактировать информацию о языке",
        translation: "Перевод",
        select_translatable_file: "Выберите Переводимый Файл",
        key: "Ключ",
        value: "Ценность",
        lead: "Вести",
        leads: "Ведет",
        lead_info: "Привести в",
        lead_images: "Ведущие изображения",
        lead_files: "Лидирующие файлы",
        lead_list: "Список лидеров",
        Purchase: "Покупка",
        Expense: "Расход",
        Asset: "Имущество",
        Income: "Доход",
        Liabilities: "Обязательства",
        Sale: "Распродажа",
        Loan: "Займ",
        Liability: "Ответственность",
        "GST Tax Account": "Налоговый счет GST",
        "Product Wise Tax Account": "Налоговый счет с учетом продукта",
        "Seller Account": "Учетная запись продавца",
        "Seller Commision": "Комиссия продавца",
        "Sallary Account": "Счет заработной платы",
        price_tag: "Ценник",
        product_1: "Продукт 1",
        product_2: "Продукт 2",
        product_3: "Продукт 3",
        images: "Изображения баннеров",
        general_setting: "Общая настройка",
        product_section: "Раздел товаров",
        exclusive_price_section: "Эксклюзивный ценовой раздел",
        coupon_section: "Раздел с купонами",
        background_color: "Цвет фона",
        text_color: "Цвет текста",
        setup_products: "Продукты для настройки",
        navigation_label: "Навигационная метка",
        Marketing_Sales: "Маркетинговые продажи",
        slogan: "Лозунг",
        select_products: "Выберите продукты",
        selected_product_list: "Список выбранных продуктов",
        select_category: "Выберите категорию",
        selected_category_list: "Список выбранных категорий",
        coupon_section_setup: "Настройка раздела купонов",
        coupon_list: "Список купонов",
        create_new_user_zone: "Создать новую пользовательскую зону",
        flash_deal: "Срочная сделка",
        update_flash_deal: "Обновить флэш-сделку",
        create_flash_deal: "Создать флэш-сделку",
        news_letter: "новостная рассылка",
        publish_date: "Дата публикации",
        created_by: "Созданный",
        mail_to: "Отправить по адресу",
        create_news_letter: "Создать рассылку новостей",
        update_news_letter: "Информационный бюллетень обновления",
        publish_on: "Опубликовать на",
        send_to: "Отправить в",
        all_user: "Все пользователи",
        role_wise: "С точки зрения роли",
        multiple_role_select_user: "Пользователь с несколькими ролями для выбора",
        all_subscription: "Вся подписка",
        selected_role_user: "Выбранная роль Пользователя",
        save_test_mail: "Сохранение и тестирование почты",
        test_mail_has_been_send_successfully: "Тестовое письмо отправлено успешно!",
        test_mail: "Тестовая почта",
        bulk_sms: "Массовые SMS-сообщения",
        sms_list: "Список SMS-сообщений",
        sending: "Отправка",
        test_sms_has_been_send_successfully: "Тестовое SMS отправлено успешно!",
        message_to: "Сообщение для",
        create_bulk_sms: "Создавать массовые SMS-сообщения",
        update_bulk_sms: "Массовое обновление SMS-сообщений",
        save_test_sms: "Сохранение и тестирование SMS",
        test_sms: "Тестовое SMS",
        select_coupon_type_first: "Сначала выберите тип купона",
        product_base: "Продуктовая база",
        order_base: "База заказов",
        create_coupon: "Создать купон",
        coupon_type: "Тип купона",
        add_coupon_for_free_shipping: "Добавьте Купон На Бесплатную Доставку",
        add_coupon_based_on_order: "Добавить купон на основе заказа",
        add_coupon_based_on_products: "Добавить купон на основе товаров",
        maximum_discount: "Максимальная скидка",
        allow_multiple_buy: "Разрешить многократную покупку",
        minimum_shopping: "Минимальный объем покупок",
        referral_code_list: "Список реферальных кодов",
        amount_is_getter_than_maximum_limit: "Сумма превышает максимальный лимит",
        customer_name: "Имя клиента",
        create_date: "Дата создания",
        maximum_limit: "Максимальный предел",
        subscriber: "Подписчик",
        subscriber_list: "Список подписчиков",
        marketing: "Маркетинг",
        coupons: "Купоны",
        subscribers: "Абоненты",
        news_letters: "новостная рассылка",
        referral_code_setup: "Настройка реферального кода",
        total_discount: "Общая скидка",
        this_item_already_added_to_list: "Этот элемент уже добавлен в список",
        marketing_campaign_planning: "Планирование маркетинговой кампании",
        cool_app: "Классное приложение",
        awesome_app: "Потрясающее приложение",
        what_a_cool_app: "какое классное приложение",
        menu_list: "Список меню",
        add_menu: "Добавить меню",
        use_themefy_or_fontawesome_icon:
            "Используйте themify или значок font awesome",
        mega_menu: "Мега-меню",
        multi_mega_menu: "Мульти-Мега-меню",
        regular_menu: "Обычное меню",
        top_navbar: "Верхняя панель навигации",
        main_menu: "Основное меню",
        select_display_location: "Выберите местоположение отображения",
        select_menu_type: "Выберите тип меню",
        edit_menu: "Изменить меню",
        menu_type: "Тип меню",
        display_location: "Расположение дисплея",
        right_panel: "Правая панель",
        bottom_panel: "Нижняя панель",
        setup_menu: "Меню настройки",
        back_to_menu: "Вернуться к меню",
        right_panel_setup: "Настройка правой панели",
        bottom_panel_setup: "Настройка нижней панели",
        add_brand: "Добавить бренд",
        column: "Колонка",
        element: "Элемент",
        add_column: "Добавить столбец",
        menu_item_list: "Список пунктов прейскуранта",
        left: "Левый",
        right: "Правый",
        select_size: "Выберите размер",
        add_to_menu: "Добавить в меню",
        add_links: "Добавлять ссылки",
        add_categories: "Добавление категорий",
        add_pages: "Добавление страниц",
        add_product: "Добавить продукт",
        add_tag: "Добавить тег",
        no_brands: "никаких брендов",
        row_required: "Требуемая строка",
        size_required: "Требуемый размер",
        title_required: "Требуемое название",
        link_required: "Требуется ссылка",
        brand_required: "Требуемый бренд",
        tags_required: "Обязательные теги",
        menu_required: "Требуемое меню",
        top_bar: "Верхняя панель",
        function: "Функция",
        order_manage: "Управление заказами",
        my_order: "Мой заказ",
        my_order_list: "Мой список заказов",
        my_purchase: "Моя покупка",
        sellers_order: "Заказ продавцов",
        complete_order: "Полный порядок",
        order_status: "Статус заказа",
        manage_order_process: "Управление процессом заказа",
        order_confirmation: "Подтверждение заказа",
        delivery_status: "Статус доставки",
        cancel_reason: "Причина отмены",
        proccessing: "Обработка",
        shipped: "Отправленный",
        grand_total: "Общий итог",
        subtotal: "Промежуточный итог",
        delivered: "Доставлен",
        delivery_process: "процесс доставки",
        add_new_delivery_process: "добавить новый процесс доставки",
        edit_delivery_process: "редактировать процесс доставки",
        order_list: "список заказов",
        complete: "заканчивать",
        pending_payment_orders: "Отложенные платежные поручения",
        total_product_qty: "Общее КОЛИЧЕСТВО продукции",
        is_paid: "Оплачивается",
        order_state: "Состояние заказа",
        order_info: "Информация о заказе",
        is_cancelled: "Отменяется",
        inhouse_orders: "Внутренние заказы",
        create_new_order: "Создать новый порядок",
        all_order: "весь заказ",
        create_order: "Создать заказ",
        processing_order: "Порядок обработки",
        no_product_selected: "Продукт не выбран",
        total_quantity: "Общее количество",
        sub_total: "Промежуточный итог",
        ordered_products: "Заказанные продукты",
        total_shipping_charge: "Общая стоимость доставки",
        inhouse_order_list: "Список внутренних заказов",
        please_create_account_for_deposite_main_income_seller_income_product_wise_tax_and_gst_tax:
            "Пожалуйста, создайте учетную запись для основного дохода от депозита, дохода продавца, налога на товары и налога GST!!!",
        payment_successful_your_order_will_be_despatched_in_the_next_48_hours:
            "Оплата прошла успешно, ваш заказ будет отправлен в течение следующих 48 часов.",
        oredre_created_successfully: "Заказ создан успешно",
        order_submit_failed: "Не удалось отправить заказ!",
        edit_cancel_reason: "Изменить причину отмены",
        in_house_order: "Внутренний порядок",
        no_order_found: "Заказ не найден",
        your_order_has_been_cancelled: "Ваш заказ был отменен.",
        order_cancellation_failed: "Отмена заказа не удалась.",
        your_order_cancellation_has_been_failed_try_again:
            "Отмена вашего заказа не удалась. Попробуй еще раз!",
        your_package_order_has_been_cancelled: "Ваш заказ на посылку был отменен.",
        package_order_cancellation_failed: "Не удалось отменить заказ посылки.",
        order_confirm: "Подтверждение заказа",
        label: "Этикетка",
        social_security_card: "Социальная карта",
        passport: "Паспорт",
        express_american: "AMERICAN EXPRESS",
        add_a_passport_photo: "Добавить фотографию паспорта",
        download_the_file: "Добавить файл",
        send: "Отправить",
        Vtb: "VTB",
        Uni: "UNIBank",
        ineco: "INECOBank",
        acba: "ACBA",
        evoca: "EVOCABank",
        Vtb_info:
            "ՀԱՄԱՁԱՅՆԱԳԻՐՍույնով տալիս եմ իմ համաձայնությունը, որ.• «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ-ն հարցումներ կատարի «ԱՔՌԱ Քրեդիտ Ռեփորթինգ» ՓԲԸ-ին և վերջինիս խնդրում եմ «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ-ին տրամադրել իմ ներկա և անցյալ ֆինանսական պարտավորությունների վերաբերյալ տեղեկություններ, ինչպես նաև այլ տվյալներ, որոնք «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ կողմից կարող են հաշվի առնվել ինձ հետ վարկային (փոխառության և այլն) պայմանագիր կնքելու վերաբերյալ որոշում կայացնելիս:• «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ կողմից վարկային (փոխառության և այլն) պայմանագիր կնքելու դեպքում տվյալ վարկային (փոխառության և այլն) պայմանագրի գործողության ողջ ընթացքում, իսկ գլխավոր վարկային պայմանագրի առկայության դեպքում նաև վերջինիս գործողության ողջ ընթացքում ցանկացած պահի առանց ինձ նախապես տեղյակ պահելու «ԱՔՌԱ Քրեդիտ Ռեփորթինգ» ՓԲԸ-ն «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ-ին տրամադրի իմ ապագա ֆինանսական պարտավորությունների վերաբերյալ տեղեկություններ, ինչպես նաև այլ տվյալներ:• «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ-ն հարցումներ կատարի «ԱՔՌԱ Քրեդիտ Ռեփորթինգ» ՓԲԸ-ին և վերջինիս խնդրում եմ «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ-ին տրամադրել իմ ներկա և անցյալ ֆինանսական պարտավորությունների վերաբերյալ տեղեկություններ, ինչպես նաև այլ տվյալներ, որոնք «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ կողմից կարող են հաշվի առնվել ինձ հետ վարկային (փոխառության և այլն) պայմանագիր կնքելու վերաբերյալ որոշում կայացնելիս:• «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ կողմից վարկային (փոխառության և այլն) պայմանագիր կնքելու դեպքում տվյալ վարկային (փոխառության և այլն) պայմանագրի գործողության ողջ ընթացքում, իսկ գլխավոր վարկային պայմանագրի առկայության դեպքում նաև վերջինիս գործողության ողջ ընթացքում ցանկացած պահի առանց ինձ նախապես տեղյակ պահելու «ԱՔՌԱ Քրեդիտ Ռեփորթինգ» ՓԲԸ-ն «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ-ին տրամադրի իմ ապագա ֆինանսական պարտավորությունների վերաբերյալ տեղեկություններ, ինչպես նաև այլ տվյալներ:• «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ-ն հարցումներ կատարի «ԱՔՌԱ Քրեդիտ Ռեփորթինգ» ՓԲԸ-ին և վերջինիս խնդրում եմ «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ-ին տրամադրել իմ ներկա և անցյալ ֆինանսական պարտավորությունների վերաբերյալ տեղեկություններ, ինչպես նաև այլ տվյալներ, որոնք «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ կողմից կարող են հաշվի առնվել ինձ հետ վարկային (փոխառության և այլն) պայմանագիր կնքելու վերաբերյալ որոշում կայացնելիս:• «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ կողմից վարկային (փոխառության և այլն) պայմանագիր կնքելու դեպքում տվյալ վարկային (փոխառության և այլն) պայմանագրի գործողության ողջ ընթացքում, իսկ գլխավոր վարկային պայմանագրի առկայության դեպքում նաև վերջինիս գործողության ողջ ընթացքում ցանկացած պահի առանց ինձ նախապես տեղյակ պահելու «ԱՔՌԱ Քրեդիտ Ռեփորթինգ» ՓԲԸ-ն «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ-ին տրամադրի իմ ապագա ֆինանսական պարտավորությունների վերաբերյալ տեղեկություններ, ինչպես նաև այլ տվյալներ:",
        Uni_info:
            "ՀԱՄԱՁԱՅՆԱԳԻՐ  Սույնով տալիս եմ իմ համաձայնությունը, որպեսզի «Յունիբանկ» ԲԲԸ-ի կողմից հարցում կատարվի «ԱՔՌԱ Քրեդիտ Ռեփորթինգ» ՓԲԸ-ին և վերջինիս խնդրում եմ «Յունիբանկ» ԲԲԸ-ին տրամադրել իմ ներկա և անցյալ ֆինանսական պարտավորությունների վերաբերյալ տեղեկություններ, ինչպես նաև այլ տվյալներ, որոնք «Յունիբանկ» ԲԲԸ-ի կողմից կարող են հաշվի առնվել ինձ հետ վարկային (փոխառության և այլն) պայմանագիր կնքելու վերաբերյալ որոշում կայացնելիս: Ինչպես նաև տալիս եմ իմ համաձայնությունը, որպեսզի «Յունիբանկ» ԲԲԸ-ի կողմից վարկային (փոխառության և այլն) պայմանագիր կնքելու դեպքում տվյալ վարկային (փոխառության և այլն) պայմանագրի գործողության ողջ ընթացքում ցանկացած պահին առանց ինձ նախապես տեղյակ պահելու «ԱՔՌԱ Քրեդիտ Ռեփորթինգ» ՓԲԸ-ն «Յունիբանկ» ԲԲԸ-ին տրամադրի իմ ապագա ֆինանսական պարտավորությունների վերաբերյալ տեղեկություններ, ինչպես նաև այլ տվյալներ: Գիտակցում եմ, որ տրամադրված տեղեկությունները և տվյալները, կախված դրանց բովանդակությունից կարող են ազդել «Յունիբանկ» ԲԲԸ-ի կողմից կայացված համապատասխան որոշման վրա: Սույն համաձայնությունը կարդացել եմ և հավաստում են, որ այն ինձ համար ամբողջությամբ հասկանալի և ընդունելի է:",
        ineco_info:
            'ԱՊՐԱՆՔՆԵՐԻ ԵՎ/ԿԱՄ ԾԱՌԱՅՈՒԹՅՈՒՆՆԵՐԻ ԱՊԱՌԻԿ ԿԱՐԳՈՎ ՁԵՌՔԲԵՐՄԱՆ ՖԻՆԱՆՍԱՎՈՐՄԱՆ ՀԱՅՏ ԵՎ ՀԱՄԱՁԱՅՆՈՒԹՅՈՒՆ 1.\tՍույնով դիմում եմ ապառիկ կարգով ապրանք(ներ)ի և/կամ ծառայություն(ներ)ի ձեռքբերման նպատակով "ԻՆԵԿՈԲԱՆԿ" ՓԲԸ-ի կողմից 30.000 – 5.000.000 ՀՀ դրամ գումարի սահմաններում ֆինանսավորում ստանալու համար՝ վերջինիս կողմից սահմանված պայմաններին համապատասխան: 2.\tՏեղեկացված եմ, որ "ԻՆԵԿՈԲԱՆԿ" ՓԲԸ-ի կողմից սույն հայտի վերաբերյալ դրական կամ բացասական որոշում կայացնելու համար տեղեկատվության բավարար չլինելու դեպքում անհրաժեշտ է սույն հայտի ներկայացման պահից 3 (երեք) աշխատանքային օրվա ընթացքում ներկայանալ "ԻՆԵԿՈԲԱՆԿ" ՓԲԸ՝ ներկայացնելով սույն հայտի՝ ինձ տրված մեկ օրինակը, ինչպես նաև իմ վարկարժանության ստուգման հետագա ընթացքի համար անհրաժեշտ փաստաթղթեր և տեղեկատվություն՝ ըստ պահանջի: Հասկանում և ընդունում եմ, որ սույն կետով սահմանված ժամկետում "ԻՆԵԿՈԲԱՆԿ" ՓԲԸ չներկայանալու դեպքում սույն հայտը կմերժվի "ԻՆԵԿՈԲԱՆԿ" ՓԲԸ-ի կողմից: 3.\tՏեղեկացված եմ, որ սույն հայտը մերժելու մասին որոշում կայացնելու դեպքում "ԻՆԵԿՈԲԱՆԿ" ՓԲԸ-ն որոշման կայացման օրվանից առավելագույնը 2 (երկու) աշխատանքային օրվա ընթացքում այդ մասին գրավոր ձևով կհայտնի ինձ՝ "ԻՆԵԿՈԲԱՆԿ" ՓԲԸ-ի տարածքում թղթային օրինակն առձեռն տրամադրելով: 4.\tՍույնով տալիս եմ իմ համաձայնությունը, որպեսզի "ԻՆԵԿՈԲԱՆԿ" ՓԲԸ-ի կողմից հարցում կատարվի "ԱՔՌԱ Քրեդիտ Ռեփորթինգ" ՓԲԸ և վերջինիս խնդրում եմ "ԻՆԵԿՈԲԱՆԿ" ՓԲԸ-ին տրամադրել իմ ներկա և անցյալ ֆինանսական պարտավորությունների վերաբերյալ տեղեկություններ, ինչպես նաև այլ տվյալներ, որոնք "ԻՆԵԿՈԲԱՆԿ" ՓԲԸ-ի կողմից կարող են հաշվի առնվել ինձ հետ վարկային (փոխառության և այլն) պայմանագիր կնքելու վերաբերյալ որոշում կայացնելիս։ Ինչպես նաև տալիս եմ իմ համաձայնությունը, որպեսզի "ԻՆԵԿՈԲԱՆԿ" ՓԲԸ-ի կողմից վարկային (փոխառության և այլն) պայմանագիր կնքելու դեպքում տվյալ վարկային (փոխառության և այլն) պայմանագրի գործողության ողջ ընթացքում ցանկացած պահին` առանց ինձ նախապես տեղյակ պահելու, "ԱՔՌԱ Քրեդիտ Ռեփորթինգ" ՓԲԸ-ն "ԻՆԵԿՈԲԱՆԿ" ՓԲԸ-ին տրամադրի իմ ապագա ֆինանսական պարտավորությունների վերաբերյալ տեղեկություններ, ինչպես նաև այլ տվյալներ։ Գիտակցում եմ, որ տրամադրված տեղեկությունները և տվյալները, կախված դրանց բովանդակությունից կարող են ազդել "ԻՆԵԿՈԲԱՆԿ" ՓԲԸ-ի կողմից կայացված համապատասխան որոշման վրա։ Սույն համաձայնությունը կարդացել եմ և հավաստում եմ, որ այն ինձ համար ամբողջությամբ հասկանալի և ընդունելի է։ 5.\tՍույնով հաստատում եմ, որ սույն փաստաթղթի նախորդ կետով իմ կողմից տրված համաձայնությունն ամբողջ ծավալով տարածվում է նաև ՀՀ կենտրոնական բանկի վարկային ռեգիստրի, "ՆՈՐՔ" սոցիալական ծառայությունների տեխնոլոգիական և իրազեկման կենտրոն հիմնադրամի, հանրային տվյալների բազաների, "ԻՆԵԿՈԲԱՆԿ" ՓԲԸ-ի հետ համագործակցող վարկային բյուրոների և բանկային սպասարկման ոլորտում հաճախորդների վերաբերյալ տվյալներ մշակող անձանց կողմից "ԻՆԵԿՈԲԱՆԿ" ՓԲԸ-ին իմ ներկա և անցյալ ֆինանսական պարտավորությունների (իսկ "ԻՆԵԿՈԲԱՆԿ" ՓԲԸ-ի հետ վարկային (փոխառության և այլն) պայմանագիր կնքվելու դեպքում նաև՝ ապագա ֆինանսական պարտավորությունների) վերաբերյալ տեղեկությունների, ինչպես նաև այլ տվյալների տրամադրման վրա՝ ինչպես սույն համաձայնության տրամադրման պահին, այնպես էլ "ԻՆԵԿՈԲԱՆԿ" ՓԲԸ-ի հետ վարկային (փոխառության և այլն) պայմանագիր կնքելու դեպքում տվյալ վարկային (փոխառության և այլն) պայմանագրի գործողության ողջ ընթացքում:',
        acba_info:
            "ՀԱՄԱՁԱՅՆԱԳԻՐ  Սույնով տալիս եմ իմ համաձայնությունը, որ.  • «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ-ն հարցումներ կատարի «ԱՔՌԱ Քրեդիտ Ռեփորթինգ» ՓԲԸ-ին և վերջինիս խնդրում եմ «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ-ին տրամադրել իմ ներկա և անցյալ ֆինանսական պարտավորությունների վերաբերյալ տեղեկություններ, ինչպես նաև այլ տվյալներ, որոնք «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ կողմից կարող են հաշվի առնվել ինձ հետ վարկային (փոխառության և այլն) պայմանագիր կնքելու վերաբերյալ որոշում կայացնելիս: • «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ կողմից վարկային (փոխառության և այլն) պայմանագիր կնքելու դեպքում տվյալ վարկային (փոխառության և այլն) պայմանագրի գործողության ողջ ընթացքում, իսկ գլխավոր վարկային պայմանագրի առկայության դեպքում նաև վերջինիս գործողության ողջ ընթացքում ցանկացած պահի առանց ինձ նախապես տեղյակ պահելու «ԱՔՌԱ Քրեդիտ Ռեփորթինգ» ՓԲԸ-ն «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ-ին տրամադրի իմ ապագա ֆինանսական պարտավորությունների վերաբերյալ տեղեկություններ, ինչպես նաև այլ տվյալներ:  • «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ-ն հարցում կատարի «Նորք» սոցիալական ծառայությունների տեխնոլոգիական և իրազեկման կենտրոն հիմնադրամին, և խնդրում եմ վերջինիս տրամադրել իմ վերաբերյալ ցանկացած տեղեկատվություն, որը կարող է կիրառվել Բանկի կողմից:  • «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ-ն սեփականության կամ ընդհանուր սեփականության իրավունքով ինձ պատկանող գույքերի վերաբերյալ հարցում կատարի ՀՀ կադաստրի կոմիտե և ստանա սպառիչ տեղեկատվություն իմ գույքային իրավունքների, այդ թվում` դրանց ծագման հիմքերի վերաբերյալ, ինչպես նաև կադաստրային գործից ստանա սեփականության իրավունքի վկայականի, հատակագծի և այլ անհրաժեշտ փաստաթղթերի պատճենները, իմ անունից դիմում ներկայացնի ՀՀ կադաստրի կոմիտե, կատարի անշարժ գույքի նկատմամբ ցանկացած իրավունքի պետական գրանցում, ստանա փաստաթղթեր,կատարի վճարումներ` մինչև իմ վարկային (փոխառության և այլն) պարտավորության լրիվ կատարումը:  • «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ-ն սեփականության կամ ընդհանուր սեփականության իրավունքով ինձ պատկանող տրանսպորտային միջոցների վերաբերյալ հարցում կատարի ՀՀ Ճանապարհային ոստիկանություն և ստանա սպառիչ տեղեկատվություն տրանսպորտային միջոցների նկատմամբ իմ գույքային իրավունքների, այդ թվում` դրանց ծագման հիմքերի վերաբերյալ, ինչպես նաև ստանա սեփականության իրավունքի վկայականի և այլ անհրաժեշտ փաստաթղթերի պատճենները` մինչև իմ վարկային (փոխառության և այլն) պարտավորության լրիվ կատարումը:  • «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ-ն հարցում կատարի «Հայաստանի ավտոապահովագրողների բյուրո» ԻԱՄ-ին և ապահովագրական ընկերություններին և ստանա ցանկացած տեղեկատվություն սեփականության իրավունքով ինձ պատկանող տրանսպորտային միջոցների ապահովագրության վերաբերյալ (այդ թվում՝ ապահովադրի և շահառուների վերաբերյալ տեղեկություններ)` մինչև իմ վարկային (փոխառության և այլն) պարտավորության լրիվ կատարումը:  • «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ կողմից ինձ ուղարկվեն ծանուցումներ` «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ-ի կողմից մատուցվող ծառայությունների հետ կապված ցանկացած տեղեկատվության վերաբերյալ:  • Սույնով ծանուցվում եմ, ինչպես նաև տալիս եմ իմ համաձայնությունը, որ «Անձնական տվյալների պաշտպանության մասին» ՀՀ օրենքի համաձայն՝ «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ-ն (ՀՀ, ք. Երևան, Արամի 82-84) 50 տարվա ընթացքում հարցումներ կատարի «Էլեկտրոնային կառավարման ենթակառուցվածքների ներդրման գրասենյակ» ՓԲԸ (ԷԿԵՆԳ)` ՀՀ Ոստիկանության բնակչության պետական ռեգիստրի, ՀՀ Արդարադատության նախարարության քաղաքացիական կացության ակտերի գրանցման գործակալության, ՀՀ Ոստիկանության ճանապարհային ոստիկանության, ՀՀ ԱՆ Իրավաբանական անձանց պետական ռեգիստրի, ՀՀ Արդարադատության նախարարության հարկադիր կատարման ծառայության, ՀՀ ԿԱ Պետական եկամուտների կոմիտեի և ՀՀ կադաստրի կոմիտեի տվյալներից իմ վերաբերյալ ցանկացած տեղեկատվություն ստանալու նպատակով, որն օգտագործվելու և ուսումնասիրվելու է ծառայությունների մատուցման հետ կապված ցանկացած գործընթացում, ինչպես նաև իմ անձնական տվյալները «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ-ի կողմից փոխանցվի «ԱՔՌԱ Քրեդիտ Ռեփորթինգ» ՓԲԸ, ՀՀ կենտրոնական բանկ, պետական իրավասու մարմիններ և այն իրավաբանական անձանց, որոնց կանոնադրական կապիտալում «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ-ն ունի ուղղակի կամ անուղղակի մասնակցություն: Համաձայնությունը/անձնական տվյալները կարող են հետ կանչվել, ուղղվել, ոչնչացվել, իսկ տվյալների մշակումը՝ դադարեցվել իմ գրավոր դիմումի հիման վրա: Գիտակցում եմ, որ տրամադրված տեղեկությունները և տվյալները, կախված դրանց բովանդակությունից, կարող են ազդել «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ կողմից կայացված համապատասխան որոշման վրա: Սույն համաձայնությունը կարդացել եմ և հավաստում եմ, որ այն ինձ համար ամբողջությամբ հասկանալի և ընդունելի է:",
        evoca_info:
            "ՀԱՄԱՁԱՅՆԱԳԻՐ  Սույնով տալիս եմ իմ համաձայնությունը, որ.  • «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ-ն հարցումներ կատարի «ԱՔՌԱ Քրեդիտ Ռեփորթինգ» ՓԲԸ-ին և վերջինիս խնդրում եմ «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ-ին տրամադրել իմ ներկա և անցյալ ֆինանսական պարտավորությունների վերաբերյալ տեղեկություններ, ինչպես նաև այլ տվյալներ, որոնք «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ կողմից կարող են հաշվի առնվել ինձ հետ վարկային (փոխառության և այլն) պայմանագիր կնքելու վերաբերյալ որոշում կայացնելիս: • «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ կողմից վարկային (փոխառության և այլն) պայմանագիր կնքելու դեպքում տվյալ վարկային (փոխառության և այլն) պայմանագրի գործողության ողջ ընթացքում, իսկ գլխավոր վարկային պայմանագրի առկայության դեպքում նաև վերջինիս գործողության ողջ ընթացքում ցանկացած պահի առանց ինձ նախապես տեղյակ պահելու «ԱՔՌԱ Քրեդիտ Ռեփորթինգ» ՓԲԸ-ն «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ-ին տրամադրի իմ ապագա ֆինանսական պարտավորությունների վերաբերյալ տեղեկություններ, ինչպես նաև այլ տվյալներ:  • «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ-ն հարցում կատարի «Նորք» սոցիալական ծառայությունների տեխնոլոգիական և իրազեկման կենտրոն հիմնադրամին, և խնդրում եմ վերջինիս տրամադրել իմ վերաբերյալ ցանկացած տեղեկատվություն, որը կարող է կիրառվել Բանկի կողմից:  • «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ-ն սեփականության կամ ընդհանուր սեփականության իրավունքով ինձ պատկանող գույքերի վերաբերյալ հարցում կատարի ՀՀ կադաստրի կոմիտե և ստանա սպառիչ տեղեկատվություն իմ գույքային իրավունքների, այդ թվում` դրանց ծագման հիմքերի վերաբերյալ, ինչպես նաև կադաստրային գործից ստանա սեփականության իրավունքի վկայականի, հատակագծի և այլ անհրաժեշտ փաստաթղթերի պատճենները, իմ անունից դիմում ներկայացնի ՀՀ կադաստրի կոմիտե, կատարի անշարժ գույքի նկատմամբ ցանկացած իրավունքի պետական գրանցում, ստանա փաստաթղթեր,կատարի վճարումներ` մինչև իմ վարկային (փոխառության և այլն) պարտավորության լրիվ կատարումը:  • «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ-ն սեփականության կամ ընդհանուր սեփականության իրավունքով ինձ պատկանող տրանսպորտային միջոցների վերաբերյալ հարցում կատարի ՀՀ Ճանապարհային ոստիկանություն և ստանա սպառիչ տեղեկատվություն տրանսպորտային միջոցների նկատմամբ իմ գույքային իրավունքների, այդ թվում` դրանց ծագման հիմքերի վերաբերյալ, ինչպես նաև ստանա սեփականության իրավունքի վկայականի և այլ անհրաժեշտ փաստաթղթերի պատճենները` մինչև իմ վարկային (փոխառության և այլն) պարտավորության լրիվ կատարումը:  • «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ-ն հարցում կատարի «Հայաստանի ավտոապահովագրողների բյուրո» ԻԱՄ-ին և ապահովագրական ընկերություններին և ստանա ցանկացած տեղեկատվություն սեփականության իրավունքով ինձ պատկանող տրանսպորտային միջոցների ապահովագրության վերաբերյալ (այդ թվում՝ ապահովադրի և շահառուների վերաբերյալ տեղեկություններ)` մինչև իմ վարկային (փոխառության և այլն) պարտավորության լրիվ կատարումը:  • «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ կողմից ինձ ուղարկվեն ծանուցումներ` «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ-ի կողմից մատուցվող ծառայությունների հետ կապված ցանկացած տեղեկատվության վերաբերյալ:  • Սույնով ծանուցվում եմ, ինչպես նաև տալիս եմ իմ համաձայնությունը, որ «Անձնական տվյալների պաշտպանության մասին» ՀՀ օրենքի համաձայն՝ «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ-ն (ՀՀ, ք. Երևան, Արամի 82-84) 50 տարվա ընթացքում հարցումներ կատարի «Էլեկտրոնային կառավարման ենթակառուցվածքների ներդրման գրասենյակ» ՓԲԸ (ԷԿԵՆԳ)` ՀՀ Ոստիկանության բնակչության պետական ռեգիստրի, ՀՀ Արդարադատության նախարարության քաղաքացիական կացության ակտերի գրանցման գործակալության, ՀՀ Ոստիկանության ճանապարհային ոստիկանության, ՀՀ ԱՆ Իրավաբանական անձանց պետական ռեգիստրի, ՀՀ Արդարադատության նախարարության հարկադիր կատարման ծառայության, ՀՀ ԿԱ Պետական եկամուտների կոմիտեի և ՀՀ կադաստրի կոմիտեի տվյալներից իմ վերաբերյալ ցանկացած տեղեկատվություն ստանալու նպատակով, որն օգտագործվելու և ուսումնասիրվելու է ծառայությունների մատուցման հետ կապված ցանկացած գործընթացում, ինչպես նաև իմ անձնական տվյալները «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ-ի կողմից փոխանցվի «ԱՔՌԱ Քրեդիտ Ռեփորթինգ» ՓԲԸ, ՀՀ կենտրոնական բանկ, պետական իրավասու մարմիններ և այն իրավաբանական անձանց, որոնց կանոնադրական կապիտալում «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ-ն ունի ուղղակի կամ անուղղակի մասնակցություն: Համաձայնությունը/անձնական տվյալները կարող են հետ կանչվել, ուղղվել, ոչնչացվել, իսկ տվյալների մշակումը՝ դադարեցվել իմ գրավոր դիմումի հիման վրա: Գիտակցում եմ, որ տրամադրված տեղեկությունները և տվյալները, կախված դրանց բովանդակությունից, կարող են ազդել «ԱԿԲԱ ԲԱՆԿ» ԲԲԸ կողմից կայացված համապատասխան որոշման վրա: Սույն համաձայնությունը կարդացել եմ և հավաստում եմ, որ այն ինձ համար ամբողջությամբ հասկանալի և ընդունելի է:",
        idram: "Idram",
        isy_pay: "Easy pay",
        telcell: "Telcell",
        thank_you: "Thank you",
        recipient: "Recipient",
        phone: "Номер телефона",
        email_address: "Ваш E-mail",
        payment_type: "Способ оплаты",
        product_quantity: "Количество продукта",
        ushadrutyun: "Внимание",
        insufficient_funds: "Неполные данные",
        close: "Закрыть",
        order_num: "Заказ №",
        "Page Builder": "Конструктор страниц",
        Pages: "Страницы",
        Page: "Страница",
        "Add New": "Добавить",
        SL: "SL",
        Title: "Title",
        Slug: "Ссылка",
        Status: "Статус",
        Body: "Тело",
        Create: "Создавать",
        "Create Page": "Создать страницу",
        "Update Page": "Страница обновления",
        Design: "Дизайн",
        previous: "Предыдущий",
        next_pagination: "следующая страница",
        reset_auth: "Ваш пароль был сброшен!",
        sent: "Мы отправили вам по электронной почте ссылку для сброса пароля!",
        throttled: "Пожалуйста, подождите, прежде чем повторить попытку.",
        token: "Этот токен сброса пароля недействителен.",
        user: "Мы не можем найти пользователя с этим адресом электронной почты.",
        paypal: "Paypal",
        paypal_configuration: "Paypal Configuration",
        paypal_client_secret: "Секретный ключ клиента Paypal",
        paypal_client_id: "Идентификатор клиента Paypal",
        stripe: "Полоса",
        stripe_configuration: "Конфигурация полосы",
        stripe_key: "Полосатый ключ",
        stripe_secret_key: "Секретный ключ Stripe",
        stripe_user_name: "Имя пользователя Stripe",
        paystack_configuration: "Конфигурация стека выплат",
        paystack_key: "Ключ платежной системы",
        paystack_secret_key: "Секретный ключ Paystack",
        paystack_merchant_email: "Электронная почта продавца Paystack",
        paystack: "Платежный пакет",
        razor_secret_key: "Razor Pay Secret Key",
        razor_key: "razor_key",
        razorpay: "RazorPay",
        razorpay_configuration: "RazorPay Configuration",
        paystack_payment_url: "URL-адрес для оплаты",
        bank_configuration: "Конфигурация банка",
        account_number: "номер счета",
        paytm: "PayTM",
        paytm_configuration: "Конфигурация Paytm",
        paytm_environment: "Среда Paytm",
        merchant_id: "Идентификатор продавца",
        merchant_key: "Ключ продавца",
        merchant_website: "Веб-сайт продавца",
        paytm_channel: "Канал Paytm",
        paytm_industry_type: "Тип отрасли Paytm",
        instamojo: "Instamojo",
        instamojo_configuration: "Конфигурация Instamojo",
        auth_token: "Токен авторизации",
        instamojo_url: "Url-адрес Instamojo",
        midtrans: "Промежуточные переводы",
        midtrans_configuration: "Конфигурация среднего трансивера",
        merchant_server_key: "Ключ торгового сервера",
        is_production_mode: "Является производственным режимом",
        merchant_client_key: "Ключ клиента продавца",
        sandbox_environment: 'Среда "песочницы"',
        production_environment: "Производственная среда",
        payumoney: "PayUmoney",
        payumoney_configuration: "Конфигурация Payumoney",
        payu_money_mode: "Денежный режим PayU",
        payumoney_key: "Ключ PayUmoney",
        payumoney_salt: "PayUmoney Salt",
        payumoney_auth: "PayUmoney Auth",
        jazzcash: "JazzCash",
        jazzcash_configuration: "JazzCash Configuration",
        salt_id: "Salt Id",
        live_url: "Live Url",
        google_pay: "Google Pay",
        google_pay_configuration: "Конфигурация Google Play",
        gateway_name: "Имя шлюза",
        merchant_name: "Имя продавца",
        flutter_wave_payment_configuration: "Конфигурация оплаты Flutter Wave",
        public_key: "Открытый ключ",
        secret_key: "Секретный ключ",
        secret_hash: "Секретный хэш",
        paddle: "Paddle",
        paddle_payment_configuration: "Конфигурация оплаты Paddle",
        environment: "Окружающая среда",
        vendor_id: "Идентификатор поставщика",
        vendor_auth_code: "Код авторизации поставщика",
        test: "Тест",
        live: "Live",
        sandbox: "Sandbox",
        gateway_logo: "Gateway Logo",
        recharge_successfully: "Пополнение счета прошло успешно!",
        payment_details: "Платежные реквизиты",
        name_on_card: "Имя на карточке",
        card_number: "номер карты",
        cvc: "CVC",
        expiration_month: "Месяц истечения срока годности",
        expiration_year: "Год истечения срока годности",
        please_correct_the_errors_and_try_again:
            "Пожалуйста, исправьте ошибки и повторите попытку.",
        pay_now_100: "Заплатите сейчас (100 долларов)",
        bank_account_info: "Информация о банковском счете",
        bkash: "bkash",
        bkash_configuration: "Конфигурация Bkash",
        app_key: "Ключ приложения",
        app_secret: "Секрет приложения",
        username: "Имя пользователя",
        ssl_commerz: "Ssl Commerz",
        sslcommerz_configuration: "Конфигурация SslCommerz",
        api_domain_url: "URL домена Api",
        store_id: "Идентификатор магазина",
        store_password: "Сохранить пароль",
        mercado_pago_configuration: "Конфигурация Mercado Pago",
        mercado_pago: "Mercado Pago",
        card_expiration_date: "Срок действия карты",
        cardholder_name: "имя владельца карты",
        cardholder_email: "Электронная почта владельца карты",
        security_code: "код безопасности",
        issuer: "Эмитент",
        identification_type: "Тип идентификации",
        identification_number: "идентификационный номер",
        installments: "Рассрочка платежа",
        access_token: "Токен доступа",
        cheque_slip: "Чек-квитанция",
        Payroll: "Payroll",
        "Select Criteria For Payroll":
            "Выберите критерии для расчета заработной платы",
        "Not generated": "Не сгенерирован",
        Generated: "Сгенерированный",
        Paid: "Оплачено",
        "Proceed To Pay": "Приступайте к оплате",
        "View PaySlip": "Просмотреть платежную ведомость",
        "Generate Payroll": "Формирование заработной платы",
        Earnings: "Прибыль",
        PDF: "PDF",
        Value: "значение",
        Deductions: "Вычеты",
        "Payslip Details": "Реквизиты платежной ведомости",
        Address: "Адрес",
        "Payroll Summary": "Сводка по заработной плате",
        "Prepared By": "Подготовлено",
        "Approved By": "Одобрено",
        "Paid By": "Оплаченный",
        Calculate: "Вычислять",
        "Gross Salary": "Валовая заработная плата",
        Tax: "Налог",
        "Net Salary": "Чистая заработная плата",
        "Staff Name": "Название персонала",
        "Payment Date": "Дата платежа",
        "Payment Amount": "Сумма платежа",
        Cash: "Наличные",
        Bank: "Банк",
        Cheque: "Чек",
        Note: "Примечание",
        "Pay Now": "заплатить сейчас",
        "Bank Name": "Название банка",
        "Branch Name": "Название филиала",
        "Paid Loan Amount": "Выплаченная сумма кредита",
        "Cheque No": "Номерной знак чека",
        "Account No": "Номер учетной записи",
        "View Payslip Details": "Просмотр сведений о платежной ведомости",
        "Payslip for the period of": "Платежная ведомость за период",
        Payslip: "Платежная ведомость",
        "Payroll Reports": "Отчеты о заработной плате",
        "Paid Date": "Оплаченная дата",
        "Loan Status": "Статус кредита",
        "Basic Salary": "Базовая заработная плата",
        "Total Loan": "Общая сумма кредита",
        "Due Loan Amount": "Причитающаяся сумма кредита",
        "Paid Amount": "Выплаченная сумма",
        Installment: "Частичный взнос",
        "Total Earning": "Общий заработок",
        "Total Deduction": "Общий вычет",
        category: "Категория",
        brand: "Производители",
        brand_list: "Список производителей",
        add_new_brand: "Добавить",
        edit_brand: "Изменить",
        my_product_list: "Мой список продуктов",
        stickers: "Stickers",
        name: "Названия",
        total_product: "Общий продукт",
        num_of_sale: "Количество мест продажи",
        category_info: "Информация о категории",
        recent_view_config: "Конфигурация последнего просмотра",
        recently_viewed_product_configuration:
            "Недавно просмотренная конфигурация продукта",
        max_limit_of_product_store_for_per_user:
            "Максимальный лимит магазина товаров для одного пользователя",
        remove_stored_data_after_days:
            "Удаляйте данные Хранилища по истечении нескольких дней",
        cronjob_url: "URL-адрес Cronjob",
        weight: "вес",
        bulk_category_upload: "Массовая загрузка категорий",
        bulk_brand_upload: "Массовая загрузка бренда",
        bulk_product_upload: "Массовая загрузка продукта",
        category_csv: "категория csv",
        brand_csv: "бренд csv",
        units_csv: "единицы измерения csv",
        bulk_upload: "Массовая загрузка",
        bulk_gift_card_upload: "Массовая загрузка подарочной карты",
        website_link: "Ссылка на веб-сайт",
        brand_info: "Информация о бренде",
        "Sort By Order": "Сортировать по порядку",
        attribute: "Атрибуты",
        add_new_attribute: "Добавить новый атрибут",
        i_want_to_manage_stock_for_this_product:
            "Я хочу управлять запасами для этого продукта",
        percentage: "процент",
        new_product: "Добавить товар",
        existing_product: "Существующий продукт",
        attributes_value: "Значение атрибутов",
        clone_product: "Продукт-клон",
        add_value: "Добавляйте ценность",
        edit_attribute: "Редактировать атрибут",
        show_attribute: "Показать атрибут",
        dropdown: "Выпадающий",
        check_box: "Установите флажок",
        radio_button: "Переключатель",
        units: "Единицы",
        add_new_unit: "Добавить новую единицу измерения",
        edit_unit: "Единица редактирования",
        add_new_product: "Добавить товар",
        product_information: "Информация о продукте",
        logo: "Логотип",
        sub_category: "Подкатегория",
        select_sub_category: "выберите подкатегорию",
        unit: "Единица измерения",
        select_unit: "Выберите единицу измерения",
        select_tag: "Выберите тег",
        select_barcode: "Выберите штрих-код",
        barcode_type: "Тип штрих-кода",
        minimum_order_qty: "Минимальное количество заказов",
        meta_image: "Мета-изображение",
        pdf_specifications: "Спецификации Pdf",
        Browse: "Выбрать",
        product_shipping_cost: "Стоимость доставки товара",
        publish_info: "Опубликовать информацию",
        shipping_cost: "Стоимость доставки",
        free_shipping: "бесплатная доставка",
        flat_rate: "Фиксированная ставка",
        product_videos_info: "Видеоинформация о продукте",
        video_link: "Видеосвязь",
        video_provider: "Поставщик видео",
        youtube: "Youtube",
        daily_motion: "Ежедневное движение",
        others_info: "Другая информация",
        product_image_info: "Информация об изображении продукта",
        thumbnail_image: "Уменьшенное изображение",
        galary_image: "Изображение из галереи",
        price_info_and_stock: "Информация о ценах и наличии на складе",
        purchase_price: "Цена покупки",
        selling_price: "Цена продажи",
        tax: "Налог",
        tax_type: "Тип налога",
        stock_qty: "Количество в наличии",
        single: "Одиночный",
        variant: "Вариант",
        select_attribute: "Выберите атрибут",
        SKU: "Артикул",
        variation: "Изменение",
        max_order_qty: "Максимальное количество заказов",
        shipping_type: "Тип доставки",
        shipping: "Доставка",
        product_sku: "Product Sku",
        product_list: "Список товаров",
        inhouse_product_list: "Список собственных продуктов",
        add_inhouse_product_list: "Добавить список собственных продуктов",
        edit_product: "Изменить",
        product_type: "Тип товара",
        unit_cost: "Стоимость единицы измерения",
        variant_items: "Варианты элементов",
        seller_request_product: "Продавец запрашивает товар",
        program_file_upload: "загрузка файла программы",
        download_file: "загрузить файл",
        click_on_it: "Нажмите на Него",
        add_category: "Добавить",
        add_category_group: "Добавить группу категорий",
        edit_category_group: "Редактировать группу категорий",
        add_sub_category: "Добавить подкатегорию",
        category_group_list: "Список групп категорий",
        sorting: "Сортировать",
        edit_category: "Изменить",
        add_as_sub_category: "Добавить в качестве подкатегории",
        show_category: "Показать категорию",
        attribute_name: "Имя атрибута",
        attribute_value: "Значение атрибута",
        product_by_sku: "Товар по артикулу",
        sku_update: "Обновление артикула",
        show_category_group: "Показать группу категорий",
        sub_categories: "Подкатегории",
        display_name: "отображаемое имя",
        file_size_must_be_less_than_1mb: "Размер файла должен быть менее 1 МБ",
        type_should_be_jpg_jpeg_png:
            "Недопустимый тип: Тип должен быть jpeg, jpg, png",
        color_name: "Название цвета",
        general_information: "основная информация",
        specifications: "Технические характеристики",
        is_physical_product: "Является ли физический продукт?",
        download_link: "Ссылка для скачивания",
        upload_file: "Upload File",
        additional_shipping_charge: "Дополнительная плата за доставку",
        shipping_methods: "Способы доставки",
        thumbnail: "Эскиз",
        save_information:
            "Сохраните после заполнения Всю общую информацию и сопутствующие товары, Предварительная продажа, Перекрестная продажа",
        file: "Файл",
        discount_period: "Период действия скидки",
        alert_list: "Список предупреждений",
        out_of_stock_list: "Нет в наличии на складе",
        disabled_product_list: "Список отключенных продуктов",
        uploading_product_is_disabled_according_to_your_package_right_now:
            "Загрузка продукта отключена в соответствии с вашим пакетом прямо сейчас",
        create_gift_card: "Создать подарочную карту",
        edit_gift_card: "Редактировать подарочную карту",
        product_variants: "Варианты продукта",
        related_data_exist_in_multiple_directory:
            "Связанные данные существуют в нескольких каталогах",
        to_use_themefy_icon_please_type_here_or_select_fontawesome_from_list:
            "Чтобы использовать значок themify, пожалуйста, введите здесь или выберите шрифт awesome из списка",
        invalid_type_type_should_be_jpeg_jpg_png:
            "Недопустимый тип: Тип должен быть jpeg, jpg, png",
        create_attribute: "Создать атрибут",
        create_brand: "Создать бренд",
        create_unit: "Создать единицу измерения",
        file_must_be_less_than_1_mb: "Размер файла должен быть менее 1 МБ",
        please_input_product_name: "Пожалуйста, введите название продукта",
        please_input_product_sku: "Пожалуйста, введите артикул товара",
        please_select_category: "Пожалуйста, выберите категорию",
        please_select_product_unit: "Пожалуйста, выберите единицу продукции",
        please_input_minimum_order_qty:
            "Пожалуйста, введите минимальное количество заказа",
        please_input_purchase_price: "Пожалуйста, введите цену покупки",
        please_input_selling_price: "Пожалуйста, введите цену продажи",
        please_input_tax: "Пожалуйста, укажите налог",
        please_input_discount_minimum_0: "Пожалуйста, укажите минимальную скидку 0",
        please_upload_thumnail_image:
            "Пожалуйста, загрузите уменьшенное изображение",
        please_select_shipping_method: "Пожалуйста, выберите способ доставки",
        please_input_tags: "Пожалуйста, введите теги",
        please_select_attribute: "Пожалуйста, выберите атрибут",
        weight_kg: "Вес(кг)",
        dimension_cm_lenth_x_width_x_height:
            "Размер (см) (длина x ширина x высота)",
        product_stock_manage: "Менеджер по запасам продукции",
        product_stock: "Ассортимент продукции",
        select_product_sku: "Выберите артикул товара",
        stock: "Склад",
        cart_product: "Товар в корзине",
        purchased_gift_card: "Приобретенная подарочная карта",
        discount_start_date: "Дата начала действия скидки",
        discount_end_date: "Дата окончания действия скидки",
        redeem_successfully: "Выкуп выполнен успешно!",
        gift_card_already_used: "Подарочная карта уже использована.",
        invalid_giftcard: "Недействительная подарочная карта.",
        rechaged_successfully: "Успешно заряжен!",
        single_product: "Отдельный продукт",
        comma_separated: "Через запятую",
        color_attribute_is_not_deletable: "Атрибут цвета не подлежит удалению!",
        variant_product_is_not_changable_to_single_product:
            "Вариант Продукта Не Подлежит Замене На Отдельный Продукт",
        change_not_possible_for_use: "Изменение невозможно для использования",
        attribute_add_not_possible_for_this_product:
            "Добавление атрибута для Этого Продукта Невозможно",
        height: "Высота",
        breadth: "Ширина",
        length: "Длина",
        weight_height_info: "Информация о весе и росте",
        please_input_product_weight: "Пожалуйста, введите вес продукта",
        please_input_product_breadth: "Пожалуйста, укажите ширину продукта",
        please_input_product_length: "Пожалуйста, введите длину изделия",
        please_input_product_height: "Пожалуйста, укажите высоту изделия",
        this_product_already_used_on_order_or_somewhere_so_delete_not_possible:
            "Этот продукт уже использовался по заказу или где-то еще. Так что удалить невозможно.",
        subtitle_1: "Подзаголовок 1",
        subtitle_2: "Подзаголовок 2",
        top_piketc: "Хиты продаж",
        change: "Изменить",
        catalog: "Каталог",
        spec_pric: "Специальные цены",
        promotions: "Акции",
        them_1: "Шаблон TOSHIBA",
        them_: "Шаблон",
        them_2: "Шаблон SAMSUNG",
        them_3: "Шаблон HISENSE",
        them_4: "Шаблон VIKAS",
        brands: "Производители",
        la_news: "Последние новости",
        in_header: "В заголовке",
        be_inter: "Возможно, вам будет интересно",
        add_page_info: "Информация о странице шаблона TOSHIBA",
        add_page2_info: "Информация о странице шаблона SAMSUNG",
        add_page2_info_add: "Добавить информацию о второй странице шаблона",
        add_page2_info_slider: "Информационный слайдер второй страницы шаблона",
        add_page3_info: "Информация о странице шаблона HISENSE",
        add_page4_info: "Информация о странице шаблона VIKAS",
        text_1_en: "Текст 1 EN",
        text_1_ru: "Текст 1 RU",
        text_1_hy: "Текст 1 HY",
        text_2_en: "Текст 2 EN",
        text_2_ru: "Текст 2 RU",
        text_2_hy: "Текст 2 HY",
        baner_111_en: "Изображение продукта One EN",
        baner_111_ru: "Изображение продукта One RU",
        baner_111_hy: "Изображение продукта One HY",
        baner_gl_en: "Главный Баннер EN",
        baner_gl_ru: "Главный Баннер RU",
        baner_gl_hy: "Главный Баннер HY",
        baner_1_en: "Баннер 1 EN",
        baner_1_ru: "Баннер 1 RU",
        baner_1_hy: "Баннер 1 HY",
        baner_2_en: "Баннер 2 EN",
        baner_2_ru: "Баннер 2 RU",
        baner_2_hy: "Баннер 2 HY",
        baner_3_en: "Баннер 3 EN",
        baner_3_ru: "Баннер 3 RU",
        baner_3_hy: "Баннер 3 HY",
        baner_4_en: "Баннер 4 EN",
        baner_4_ru: "Баннер 4 RU",
        baner_4_hy: "Баннер 4 HY",
        baner_5_en: "Баннер 5 EN",
        baner_5_ru: "Баннер5 RU",
        baner_5_hy: "Баннер 5 HY",
        baner_6_en: "Баннер 6 EN",
        baner_6_ru: "Баннер 6 RU",
        baner_6_hy: "Баннер 6 HY",
        character: "Характеристика",
        comparison: "Сравнение",
        similar_products: "подобная продукция",
        lot_sellers: "МНОГО ПРОДАНО",
        with_product: "С этим продуктом покупаут",
        month: "месяц",
        cash: "Наличным",
        buy_on_credit: "Купить в кредит",
        installing: "С установкой",
        installingText: "В указанную цену включена услуга установки.",
        choose_the_gifts: "Выберите подарки",
        from_the_gift_list: "из списка подарков",
        add_new_attribute_grupe: "Добавить новую группу атрибутов",
        edit_attribute_grupe: "Редактировать группу атрибутов",
        show_attribute_grupe: "Показать группу атрибутов",
        attribute_grup: "Группа аттрибутов",
        hew_you_watched: "Вы смотрели",
        jobo: "Рабочие места",
        som_wrong: "Что-то пошло не так",
        not_vos_query: "По вашему запросу ничего не найдено",
        porceq_poxel: "Попробуйте изменить запрос или воспользуйтесь нашим",
        product_not_found: "Товар не найден",
        descr1_en: "Описания 1 En",
        descr1_ru: "Описания 1 Ru",
        descr1_hy: "Описания 1 Hy",
        subtitle1_en: "подзаголовок 1 En",
        subtitle1_ru: "подзаголовок 1 Ru",
        subtitle1_hy: "подзаголовок 1 Hy",
        subtitle2_en: "подзаголовок 2 En",
        subtitle2_ru: "подзаголовок 2 Ru",
        subtitle2_hy: "подзаголовок 2 Hy",
        subtitle3_en: "подзаголовок 3 En",
        subtitle3_ru: "подзаголовок 3 Ru",
        subtitle3_hy: "подзаголовок 3 Hy",
        descr2_en: "Описание 2 En",
        descr2_ru: "Описание 2 Ru",
        descr2_hy: "Описание 2 Hy",
        add_page3_info_add: "Добавьте третью страницу шаблона в",
        add_page3_info_slider: "Информационный слайдер третьей страницы шаблона",
        average_price: "Средняя цена",
        sort_id: "Идентификатор сортировки",
        subtitle4_en: "подзаголовок 4 En",
        subtitle4_ru: "подзаголовок 4 Ru",
        subtitle4_hy: "подзаголовок 4 Hy",
        add_page4_info_add:
            "Добавить страницу шаблона для получения дополнительной информации",
        add_page4_info_slider: "Информационный слайдер четвертой страницы шаблона",
        baner_7_en: "Баннер 7 EN",
        baner_7_ru: "Баннер 7 RU",
        baner_7_hy: "Баннер 7 HY",
        baner_8_en: "Баннер 8 EN",
        baner_8_ru: "Баннер 8 RU",
        baner_8_hy: "Баннер 8 HY",
        add_page3_info_photos:
            "Страница шаблона с тремя информационными фотографиями",
        discount_available: "Акция действует с :star  до  :ende",
        select_attribute_grup: "Выбрать группу аттрибутов",
        active_product_list: "активный список продуктов",
        new_product_list: "список новых продуктов",
        refund_manage: "Управление возвратом средств",
        reasons: "Причины",
        reason_list: "Список причин",
        add_new_reason: "Добавить новую причину",
        reason: "Причина возврата",
        edit_reason: "Редактировать причину",
        configuration: "Конфигурация",
        refund_time: "Время возврата денег",
        refund_activate: "Активация возврата средств",
        in_days: "В днях",
        all_pending_requests: "Все ожидающие запросы",
        all_pending_refund_requests:
            "Все ожидающие рассмотрения запросы на возврат средств",
        request_confirmation: "Запрос подтверждения",
        refund_money_status: "Статус возврата денег",
        my_refund_requests: "Мои запросы на возврат средств",
        pending_refund_requests:
            "Ожидающие рассмотрения запросы на возврат средств",
        confirmed_refund_requests: "Подтвержденные запросы на возврат средств",
        pending: "Ожидаемый",
        confirmed: "Подтвержденный",
        processing_state: "Состояние обработки",
        payable_refund_request: "запрос на возврат подлежащей оплате суммы",
        refund_process: "Процесс возврата денег",
        add_refund_process: "Добавить процесс возврата",
        edit_refund_process: "Изменить процесс возврата",
        process_name: "Имя процесса",
        description: "Описание",
        process: "Процесс",
        is_completed: "Завершено",
        request_status: "Статус запроса",
        is_refunded: "Возвращается",
        refund_success: "Успех возврата",
        return_qty: "Возвращаемое количество",
        refund_related_info: "Информация, связанная с возвратом средств",
        request_sent: "Request Sent",
        refund_method: "Способ возврата денег",
        bank_name: "Название банка",
        branch_name: "Название филиала",
        account_name: "Имя учетной записи",
        account_nb: "Номер счета.",
        pick_up_info: "Получить информацию",
        shipping_gateway: "Судоходный шлюз",
        shipping_method: "Способ доставки",
        post_code: "Почтовый индекс",
        drop_of_info: "сбрасывание информации",
        additional_info: "Дополнительная информация",
        refund: "Возврат",
        refund_name: "Имя",
        refund_surname: "Фамилия",
        refund_email: "Электронная почта",
        "refund_order.number": "Номер заказа",
        "refund_phone.number": "Номер телефона",
        defects: "Описание дефектов",
        terms_conditions_agree: "Я прочитал и согласен с Правилами и условиями",
        submit: "Подтвердить",
        yes: "Да",
        no: "Нет",
        product_name: "Имя продукта",
        parcel: "Посылка вскрыта",
        quantity: "Количество",
        delivery_terms: "Условия доставки",
        info_product: "Информация о продукте",
        select_criteria_for_filtering: "Выберите критерии для фильтрации",
        reset: "Сброс",
        report: "Отчет",
        ip: "IP",
        number_of_time_visit: "Количество посещений по времени",
        last_visited: "Последний раз посещенный",
        seller_id: "Идентификатор продавца",
        seller_wise_sales_report: "Отчет о продажах с точки зрения продавца",
        seller_wise_stock: "Мудрый запас продавца",
        seller_wise_sales: "Продажи с точки зрения продавца",
        admin_reports: "Отчеты администратора",
        user_searches: "Поиск пользователей",
        user_search_report: "Отчет о поиске пользователя",
        keyword_search_report: "Отчет о поиске по ключевым словам",
        keywords: "Ключевые слова",
        number_of_time: "Количество раз",
        visitor_report: "Отчет о посетителе",
        wallet_recharge_history: "История пополнения кошелька",
        top_selling_item: "Самый продаваемый товар",
        recently_product_review: "Недавний обзор продукта",
        recently_seller_review: "Недавний отзыв продавца",
        inhouse_product_sale: "Продажа собственной продукции",
        filter_selection_criteria: "Критерии выбора фильтра",
        sale_type: "Тип продажи",
        type: "Тип",
        number_of_user: "Количество пользователей",
        number_of_wishlist_product: "Количество товаров в списке желаний",
        my_reports: "Мои отчеты",
        pending_product_review_list: "Список ожидающих рассмотрения продуктов",
        approve_all_review: "Одобрить все проверки",
        approve_confirm: "Вы уверены, что все одобряете?",
        deny_confirm: "Вы уверены, что будете отрицать?",
        approve: "Одобрить",
        deny: "Отрицать",
        deny_review: "Отклонить отзыв",
        customer_feedback: "Отзывы клиентов",
        rating: "Рейтинг",
        customer_time: "Клиент и время",
        approve_all: "Одобрять все",
        pending_seller_review_list: "Ожидающий рассмотрения список продавцов",
        declined_seller_review_list: "Отклоненный список отзывов продавца",
        seller_review_list: "Список отзывов о продавце",
        number_of_review: "Количество отзывов",
        product_review_list: "Список отзывов о продукте",
        replied_successfully: "Ответил успешно!",
        reply_to_customer: "Ответ Клиенту",
        my_review_list: "Мой обзорный список",
        all_review: "Весь обзор",
        all_product_review_list: "Список отзывов обо всех продуктах",
        declined_review_list: "Отклоненный список рецензий",
        product_review: "Обзор продукта",
        seller_review: "Отзыв продавца",
        my_product_review: "Мой обзор продукта",
        my_review: "Мой отзыв",
        review_done_thanks_for_review: "Обзор сделан. Спасибо за отзыв.",
        review_already_exsist: "Отзыв уже существует.",
        company_review: "Обзор компании",
        company_review_list: "Обзорный список компании",
        create_a_seller: "Создайте продавца",
        basic_info: "Основная информация",
        shop_name: "Название магазина",
        make_trusted: "Сделайте так, чтобы вам доверяли",
        remove_from_trusted: "Удалить из доверенного",
        alert_message: "Предупреждающее сообщение",
        are_you_confirmed_to_execute_this_operation:
            "Вы подтверждены на выполнение этой операции?",
        business_owner_name: "Юридическое название/ Имя владельца бизнеса",
        person_in_charge_name: "Имя ответственного лица",
        business_registration_number: "Регистрационный номер предприятия",
        seller_tin: "Продавец ОЛОВА",
        upload_business_document: "Загрузить деловой документ",
        holiday_start: "Начало отпуска",
        holiday_end: "Конец отпуска",
        upload_cheque_copy: "Загрузить копию чека",
        same_as_warehouse_address: "Совпадает с адресом склада",
        no_of_product: "Номер продукта",
        check_category_commissions: "Проверьте комиссии по категориям",
        category_list_with_commission: "Список категорий с комиссией",
        my_staff: "мои сотрудники",
        add_new_staff: "Добавить новых сотрудников",
        create_a_staff: "Создайте Штат сотрудников",
        update_staff_info: "Обновить информацию о персонале",
        joined_date: "Дата вступления",
        select_from_list: "Выберите из списка",
        add_member_is_disabled_according_to_your_package_right_now:
            "Добавление участника отключено в соответствии с вашим пакетом прямо сейчас",
        seller_list: "Список продавцов",
        commision_setup: "Настройка комиссии",
        manage_seller: "Управлять продавцом",
        subscription_info: "Информация о подписке",
        subscription_title: "Название подписки",
        next_payment_before: "Следующий платеж до",
        create_supplier: "Создать поставщика",
        business_name: "Фирменное наименование",
        tax_number: "Налоговый номер",
        edit_supplier: "Изменить поставщика",
        supplier_id: "Идентификатор поставщика",
        supplier: "Поставщик",
        supplier_list: "Список поставщиков",
        pay_condition: "Условие оплаты",
        finance_information: "Финансовая информация",
        pay_term: "Срок оплаты",
        pay_term_condition: "Условие о сроке оплаты",
        alternate_contact_no: "Альтернативный контакт Нет",
        postcode: "Почтовый индекс",
        supplier_profile: "Профиль поставщика",
        office_xtract: "официальные контракты",
        please_update_business_bank_information_from_profile_first:
            "Пожалуйста, Сначала обновите информацию о Бизнесе и Банке Из Профиля.",
        seller_profile: "Профиль продавца",
        product_allready_added: "Продукт уже добавлен.",
        about_seller: "О продавце",
        commission_calculate_for_multi_category:
            "Расчет комиссии для нескольких категорий",
        minimum_rate: "Минимальная ставка",
        maximum_rate: "Максимальная скорость",
        average_rate: "Средняя ставка",
        multi_category: "Мультикатегория",
        expire_date: "Дата истечения срока действия",
        already_expired: "Уже истек срок годности",
        last_payment_date: "Дата последнего платежа",
        advance_renew_subscription: "Предварительное продление подписки",
        after_change_and_save_previous_lisence_will_expried:
            "После изменения и сохранения срок действия предыдущей лицензии истечет.",
        "Intro Prefix has been added Successfully":
            "Вводный префикс был успешно добавлен",
        "Intro Prefix has been updated Successfully":
            "Вводный префикс был успешно обновлен",
        "A Intro Prefix has been destroyed Successfully":
            "Вводный префикс был успешно уничтожен",
        prefix: "Префикс",
        click_here_to_create_your_project:
            "Нажмите Здесь, Чтобы Создать Свой Проект",
        disable_google_analytics: "Отключить Google Analytics",
        add_new_intro_prefix: "Добавить новый вводный префикс",
        intro_prefix_list: "Список вводных префиксов",
        intro_prefix: "Вступительный префикс",
        prefix_name: "Префиксное имя",
        prefix_details: "Сведения о префиксе",
        edit_introprefix: "Редактировать вводный префикс",
        add_new_tag: "Добавить новый тег",
        edit_tag: "Редактировать тег",
        setup: "Установка",
        payment_configuration: "Конфигурация оплаты",
        analytics: "Аналитические инструменты",
        phonecode: "Телефонный код",
        flag: "Флаг",
        google_analytics: "Google Analytics",
        enable_google_analytics: "Включить Google Analytics",
        click_here_to_create_google_analytics:
            "Нажмите здесь, чтобы создать Google analytics",
        tracking_id: "Идентификатор отслеживания",
        facebook_pixel: "Пиксель Facebook",
        enable_facebook_pixel: "Включить пиксель Facebook",
        click_here_to_create_facebook_pixel:
            "Нажмите здесь, чтобы создать пиксель Facebook",
        facebook_pixel_id: "Идентификатор пикселя Facebook",
        tracking_id_required: "Требуется идентификатор отслеживания",
        facebook_pixel_id_required: "Требуется идентификатор пикселя Facebook",
        enable_gs_analytics_for_your_dashboard:
            "Включите GS Analytics для вашей информационной панели",
        service_account_json_file: "Файл Json учетной записи службы",
        measurement_id: "Идентификатор измерения",
        measurement_protocol_api_secret: "Секрет API протокола измерения",
        fill_in_the_two_fields_below_for_the_Google_Analytics_version_4:
            "Заполните два поля ниже для Google Analytics версии 4.",
        for_reporting_version_4_see_google_analytics_panel:
            "Информацию о версии отчетности 4 смотрите в панели Google analytics.",
        add_new_shipping_method: "Добавить новый способ доставки",
        method_name: "Добавить новый способ доставки",
        shipment_time: "время отгрузки",
        "ex: 3 - 5 days or 6 -12 hrs": "пример: 3-5 дней или 6-12 часов",
        cost: "стоимость",
        edit_method_info: "Редактировать информацию о методе",
        courier_pick_up: "Доставка курьером",
        drop_off: "отпадать",
        courier_pick_up_information: "Информация о доставке курьером",
        drop_off_information: "Передайте информацию",
        requested_by: "Запрошенный",
        address_info: "Информация об адресе",
        shipping_address: "адрес доставки",
        reset_address: "Сбросить адрес",
        order_packages: "Заказывайте пакеты",
        please_save_customer_address_before_add_product:
            "Пожалуйста, сохраните Адрес клиента перед добавлением продукта",
        create_shipping_method: "Создать способ доставки",
        shipping_provider: "Поставщик услуг доставки",
        request_history: "История запросов",
        carriers: "Перевозчики",
        carrier: "Перевозчик",
        shiprocket: "Корабельная ракета",
        shiprocket_api_password: "Пароль Ship rocket API",
        shiprocket_api_email: "Электронная почта Shiprocket API",
        carrier_logo: "Логотип перевозчика",
        shipping_rates: "Тарифы на доставку",
        add_new_shipping_rate: "Добавить новый тариф на доставку",
        based_on: "основанный на",
        edit_shipping_rate: "Изменить стоимость доставки",
        order_confirm_and_sync_with_carrier:
            "Подтверждение заказа и синхронизация с перевозчиком",
        manual: "Инструкция",
        automatic: "Автоматический",
        "admin_change_shipping_carrier_?":
            "Администратор Сменил перевозчика доставки?",
        "customer_call_see_carrier_?": "Клиент может видеть Перевозчика?",
        shipping_method_change: "Изменение способа доставки",
        all_selected_order_change_shipping_method:
            "Все выбранные заказы меняют способ доставки",
        selected_order_shipping_method_change:
            "Изменение выбранного способа доставки заказа",
        selected_order_change_shipping: "Выбранный заказ Изменяет доставку",
        "order_will_auto_confirm_?": "Заказ будет автоматически подтвержден?",
        pickup_locations: "Места самовывоза",
        pickup_location: "Место получения",
        add_new_pickup_location: "Добавить новое место получения",
        pin_code: "Pin-код",
        edit_pickup_location: "Изменить место получения",
        pickup_location_details: "Подробная информация о месте получения",
        set_pickup_location: "Установите место получения",
        shipping_orders: "Заказы на доставку",
        label_download: "Загрузка ярлыка",
        add_new_carrier: "Добавить нового перевозчика",
        tracking_url: "Url-адрес отслеживания",
        update_carrier: "Носитель обновления",
        Quick: "Быстрый",
        Custom: "Обычай",
        carrier_order_type: "Тип заказа перевозчика",
        packaging: "Упаковка",
        packaging_info: "Информация об упаковке",
        "refund_order_sync_carrier_?":
            "Синхронизация заказа на возврат с перевозчиком?",
        is_default: "Является значением по умолчанию",
        shipping_by: "Доставка по",
        shipping_information: "Информация о доставке",
        shiprocket_channel_id: "Shiprocket Channel ID",
        label_terms_condition: "Правила и условия маркировки",
        label_terms_and_conditions: "Правила и условия маркировки",
        terms_and_conditions: "правила и условия",
        add_more: "Добавить еще",
        label_configuration: "Конфигурация этикетки",
        invoice: "Счет-фактура",
        "seller_use_shiproket_?": "Продавец использует Shiprocket?",
        barcode: "Штрих-код",
        qrcode: "QR-код",
        both: "оба",
        label_generate_use: "Ярлык Генерирует использование",
        customer_address_update: "Обновление адреса клиента",
        carrier_status: "Статус перевозчика",
        min_shopping: "Минимальный объем покупок",
        collect_from_pickup_location: "Забрать из пункта самовывоза",
        minimum_shopping_amount: "Минимальная сумма покупки",
        without_shipping_cost: "без стоимости доставки",
        minium_shopping_amount_is_not_fulfill:
            "Минимальная сумма покупки не указана.",
        cart_is_empty_please_add_product_first:
            "Тележка пуста. Пожалуйста, сначала добавьте продукт.",
        about: "о нас",
        more: "Подробнее",
        shops: "Магазины",
        select_bank: "Выберите банк для получения дополнительной информации",
        credit: "Кредит",
        terms: "Условия",
        faq: "Вопрос / Ответ",
        order_formating: "Формирование заказа",
        knows_questions: "Известные вопросы",
        payment: "Платеж",
        block: "Блок",
        banner: "Баннер",
        link: "Ссылка",
        title_text: "Текст заголовка",
        link_text: "Текст ссылки",
        slider: "Слайдер",
        address: "Адрес",
        address_icon: "Изображение адреса",
        address_title: "Название адреса",
        work_time: "Рабочее время",
        tel_time: "Время тел.",
        latitude: "Широта",
        longitude: "Долгота",
        soc_links_title: "Название ссылок",
        email_title: "Заголовок электронного письма",
        email_con: "Иконка электронной почты",
        tel_title: "Название телефона",
        prepayment: "Сумма предоплаты",
        interest_rate: "Годовая процентная ставка",
        service_fee: "Ежемесячная плата за обслуживание банка",
        payment_term: "Срок погашения кредита",
        minimum_amount: "Минимальная сумма кредита",
        maximum_amount: "Максимальная сумма",
        credit_terms: "условия кредита",
        formulation: "Место составления",
        mount: "монтировать",
        amd: "Драм",
        icon_title: "Название значка",
        condition_text: "Текст условия",
        question_answer: "Вопросы и Ответы",
        question: "Вопрос",
        answer: "Ответ",
        add_new: "Добавить новый",
        faq_categories: "Категории",
        main_photo: "Главная фотография страницы",
        description_en: "Описание en",
        support_ticket: "Обращение в службу поддержки",
        my_tickets: "Мои билеты",
        ticket: "Билет",
        priority: "Приоритет",
        ticket_list: "Список билетов",
        user_agent: "Агент пользователя",
        agent_asign: "Назначение агента",
        unassigned: "Неназначенный",
        ticket_info: "Информация о билете",
        ticket_id: "Идентификатор билета",
        assign_to: "Назначить на",
        add_a_comment: "добавить комментарий",
        open_a_ticket: "Откройте билет",
        update_ticket: "Обновить билет",
        add_new_category: "Добавить новую категорию",
        add_new_priority: "Добавить новый приоритет",
        add_new_status: "Добавить новый статус",
        priority_list: "Список приоритетов",
        all_ticket: "Весь билет",
        last_update: "Последнее обновление",
        create_new_ticket: "Создать новый билет",
        all_closed_tickets: "Все закрытые билеты",
        closed_ticket: "Закрытые билеты",
        all_submmited_ticket: "Все отправленные билеты",
        we_do_not_sell_or_share_your_details_without_your_permission:
            "Мы не продаем и не передаем ваши данные без вашего разрешения",
        submit_message: "Отправить сообщение",
        support_ticket_help: "Обращение в службу поддержки и справка",
        back_to_list: "Вернуться к списку",
        create_support_ticket: "Создать обращение в службу поддержки",
        create_ticket: "Создать билет",
        view_ticket: "Просмотреть билет",
        please_at_least_one_item: "Пожалуйста, выберите хотя бы один товар",
        attch_upload_limit_is_5: "Ограничение на загрузку вложений составляет 5",
        reply_ticket: "Ответный билет",
        add_your_comment: "Добавьте свой комментарий",
        Transaction: "Операция",
        Transactions: "Операции",
        Credit: "Кредит",
        Debit: "Дебет",
        Statement: "Заявление",
        "Account History": "История учетной записи",
        "Bank Account Details": "Реквизиты банковского счета",
        "Current Balance": "Текущий баланс",
        utilities: "Коммунальные услуги",
        clear_cache: "Очистить кэш",
        clear_log: "Очистить журнал",
        enable: "Включить",
        disable: "Отключать",
        app_debug: "Отладка приложения",
        force_https: "Принудительный HTTPS",
        reset_database: "Сброс базы данных",
        xml_sitemap: "XML-карта сайта",
        "It can take some times to execute operation. please wait until completed operation":
            "Выполнение операции может занять некоторое время. пожалуйста, дождитесь завершения операции.",
        are_you_sure_to_reset_database: "Вы уверены, что сбросили базу данных?",
        database_reset_successful: "Сброс базы данных выполнен успешно",
        choose_sitemap_option: 'Выберите опцию "Карта сайта"',
        import_demo_database: "Импорт демонстрационной базы данных",
        import_database: "Импорт базы данных",
        import_demo_note:
            "После импорта Демо-Версии Вы потеряете Свои Текущие Данные. Пожалуйста, Сначала сделайте резервную копию Вашей Базы данных и загруженного файла, если Вам нужно.",
        reset_database_note:
            "После Сброса Вы Потеряете Свои Текущие Данные. Пожалуйста, Сначала сделайте резервную копию Вашей Базы данных и загруженного файла, если Вам нужно.",
        are_you_sure_to_import_demo_database:
            "Вы уверены, что хотите импортировать демо-базу данных?",
        import_demo_database_successful:
            "Импорт демонстрационной базы данных выполнен успешно.",
        accepted: "Атрибут : должен быть принят.",
        active_url: "Атрибут : не является допустимым URL-адресом.",
        after: "The :attribute must be a date after :date.",
        after_or_equal: "The :attribute must be a date after or equal to :date.",
        alpha: "The :attribute may only contain letters.",
        alpha_dash:
            "The :attribute may only contain letters, numbers, dashes and underscores.",
        alpha_num: "The :attribute may only contain letters and numbers.",
        array: "The :attribute must be an array.",
        before: "The :attribute must be a date before :date.",
        before_or_equal: "The :attribute must be a date before or equal to :date.",
        boolean: "The :attribute field must be true or false.",
        confirmed_attribute: "The :attribute confirmation does not match.",
        date_attribute: "The :attribute is not a valid date.",
        date_equals: "The :attribute must be a date equal to :date.",
        date_format_attribute: "The :attribute does not match the format :format.",
        different: "The :attribute and :other must be different.",
        digits: "The :attribute must be :digits digits.",
        digits_between: "The :attribute must be between :min and :max digits.",
        dimensions: "The :attribute has invalid image dimensions.",
        distinct: "The :attribute field has a duplicate value.",
        email_attribute: "The :attribute must be a valid email address.",
        ends_with: "The :attribute must end with one of the following: :values.",
        exists: "The selected :attribute is invalid.",
        file_attribute: "The :attribute must be a file.",
        filled: "The :attribute field must have a value.",
        image_attribute: "The :attribute must be an image.",
        in: "The selected :attribute is invalid.",
        in_array: "The :attribute field does not exist in :other.",
        integer: "The :attribute must be an integer.",
        ip_attribute: "The :attribute must be a valid IP address.",
        ipv4: "The :attribute must be a valid IPv4 address.",
        ipv6: "The :attribute must be a valid IPv6 address.",
        json: "The :attribute must be a valid JSON string.",
        multiple_of: "The :attribute must be a multiple of :value",
        not_in: "The selected :attribute is invalid.",
        not_regex: "The :attribute format is invalid.",
        numeric: "The :attribute must be a number.",
        password_attribute: "The password is incorrect.",
        present_attribute: "The :attribute field must be present.",
        regex: "The :attribute format is invalid.",
        required_attribute: "The :attribute field is required.",
        required_if_attribute:
            "The :attribute field is required when :other is :value.",
        required_unless_attribute:
            "The :attribute field is required unless :other is in :values.",
        required_with_attribute:
            "The :attribute field is required when :values is present.",
        required_with_all_attribute:
            "The :attribute field is required when :values are present.",
        required_without_attribute:
            "The :attribute field is required when :values is not present.",
        required_without_all_attribute:
            "The :attribute field is required when none of :values are present.",
        same: "The :attribute and :other must match.",
        starts_with:
            "The :attribute must start with one of the following: :values.",
        string: "The :attribute must be a string.",
        timezone: "The :attribute must be a valid zone.",
        unique_attribute: "The :attribute has already been taken.",
        uploaded: "The :attribute failed to upload.",
        url_attribute: "The :attribute format is invalid.",
        uuid: "The :attribute must be a valid UUID.",
        check_unique_phone: "Телефон уже был взят.",
        this_field_is_required: "Это поле является обязательным.",
        please_fill_with_valid_email:
            "Пожалуйста, укажите действительный адрес Электронной Почты.",
        you_are_already_subscribed: "Вы Уже подписаны.",
        the_amount_is_must_be_gretter_than_0: "Сумма должна быть больше 0.",
        my_wallet: "Мой бумажник",
        recharge: "Перезаряжать",
        wallet_balance: "Баланс кошелька",
        transaction_list: "Список транзакций",
        recharge_now: "Заряжайтесь прямо сейчас",
        enter_your_amount_to_recharge: "Введите сумму Для Пополнения счета",
        choose_payment_gateway: "Выберите платежный шлюз",
        online_recharge: "Пополнение счета онлайн",
        wallet_recharge_transactions: "Транзакции по пополнению кошелька",
        account_holder: "Владелец счета",
        auto_approve: "Автоматическое утверждение",
        approved_balance: "Утвержденный баланс",
        pending_balance: "Отложенный баланс",
        offline_recharge: "Автономная подпитка",
        any_comment: "любой комментарий",
        wallet_manage: "Управление кошельком",
        running_balance: "Текущий баланс",
        earning_balance: "Баланс заработка",
        withdraw_balance: "Вывести баланс",
        refund_paid: "Выплаченный возврат средств",
        withdraw_now: "уходите сейчас же",
        enter_your_amount_to_withdraw: "Введите сумму, которую вы хотите вывести",
        withdraw: "вывести",
        withdraw_history: "История вывода средств",
        edit: "Редактировать",
        modify_your_amount_to_withdraw: "Измените свою сумму для вывода средств",
        withdraw_requests: "Запросы на отзыв",
        show_details: "Показать детали",
        details_info: "Подробная информация",
        Approval: "Утверждение",
        pending_withdraw_balance: "ожидающий вывода баланс",
        pending_withdraw_request_balance:
            "Ожидающий запроса на вывод средств Баланс",
        remaining_balance: "Оставшийся остаток",
        withdraw_request_has_been_sent_successfully:
            "Запрос на вывод средств был успешно отправлен!",
        withdraw_request_has_been_modified_successfully:
            "Запрос на вывод средств был успешно изменен!",
        requested_amount: "Запрашиваемая сумма",
        bank_ibn: "Банк ibn",
        recharge_using_gift_card: "Пополните счет с помощью подарочной карты",
        flutter_wave_payment: "Оплата трепещущей волны",
        continue_to_recharge: "Продолжайте заряжать",
        instamojo_payment: "Оплата Instamojo",
        pay_tm_payment: "Оплата Paytm",
        pay_u_money_payment: "Платеж Payumoney",
        recharge_offline_wallet: "Пополните автономный кошелек",
        transection_id: "Идентификатор транзакции",
        jazz_cash_payment: "JazzCash Payment",
        are_you_sure_to_go_through_this_payment_gateway:
            "Вы уверены, что хотите пройти через этот платежный шлюз?",
        recharge_wallet_history: "История пополнения кошелька",
        continue_to_pay: "Продолжайте платить",
        google_payment: "Оплата Google",
        razor_pay: "Razor pay",
        online_recharge_transactions: "Онлайн-транзакции по пополнению счета",
        bank_recharge: "Пополнение счета в банке",
        bank_recharge_transactions: "Операции по пополнению счета в банке",
        mercado_pago_payment: "Оплата Mercado Pago",
        Name: "Имя",
        Code: "Код",
        Affiliate: "Филиал",
        "My Affiliate": "Мой партнер",
        "Update Affiliate Link": "Обновить партнерскую ссылку",
        "Create Affiliate Link": "Создать партнерскую ссылку",
        "User Name": "имя пользователя",
        "Enter URL": "Введите URL-адрес",
        "Affiliate Link": "Партнерская ссылка",
        "Affiliate Links": "Партнерские ссылки",
        Visits: "Посещения",
        Registered: "Зарегистрированный",
        Purchased: "Приобретенный",
        Commissions: "Комиссии",
        Configurations: "Конфигурации",
        "Affiliate Configurations": "Партнерские конфигурации",
        "Minimum Withdraw": "Минимальный вывод средств",
        "Commission Type": "Тип комиссии",
        "Commission Amount": "Размер комиссии",
        "Payment Provide Date End Of Month":
            "Дата предоставления платежа Конец месяца",
        "Referral Duration Type": "Тип продолжительности обращения",
        "Referral Duration": "Продолжительность направления",
        "Is GST Applicable ?": "Применим ли GST?",
        "GST Amount": "Сумма GST",
        Percentage: "Процент",
        Flat: "равнина",
        Fixed: "Исправлено",
        Lifetime: "Продолжительность жизни",
        Yes: "Да",
        No: "Нет",
        Withdrawn: "вывод средств",
        Pending: "Ожидаемый",
        "Balance Transfer To Wallet": "Перевод баланса на Кошелек",
        "Withdraw Request": "Запрос на вывод средств",
        "Add Paypal Account For Withdraw Commissions From System":
            "Добавьте учетную запись Paypal Для вывода Комиссий из Системы",
        "Update Paypal Account For Withdraw Commissions From System":
            "Обновите Учетную запись Paypal Для снятия Комиссий с Системы",
        "Paypal Account": "Учетная запись Paypal",
        "Create Withdraw Request": "Создать запрос на вывод средств",
        "Withdraw Amount": "Сумма вывода",
        "Payment Type": "Тип платежа",
        "Select One": "выберите один",
        Paypal: "Paypal",
        Offline: "Не в сети",
        "Withdraw Commissions By Paypal Add Account":
            "Вывод комиссионных с помощью дополнительной учетной записи Paypal",
        Withdraw: "вывод средств",
        "Withdraw History": "История вывода средств",
        "Request Date": "Дата запроса",
        "Confirm Date": "Подтвердить дату",
        Cancel: "Отменить",
        Done: "Сделано",
        "Balance Transfer To User Wallet":
            "Перевод баланса на Кошелек Пользователя",
        "Transfer Amount": "Сумма перевода",
        "Update Transfer Amount": "Обновить сумму перевода",
        "Update Withdraw Request": "Обновить запрос на вывод средств",
        "Transfer To User Wallet": "Перевод на Кошелек Пользователя",
        "Commission History": "История комиссий",
        Course: "Курс",
        From: "От",
        Date: "Дата",
        "Pending Withdrawn": "Ожидающий отзыв",
        "Pending Withdrawn List": "Ожидающий отзыва список",
        User: "Пользователь",
        "Select Date Range": "Выберите диапазон дат",
        Filter: "Фильтр",
        Reset: "Сброс",
        "Pending Earning": "Ожидающий получения доход",
        "Pending Transfer": "Ожидающий перевода",
        "Complete Withdrawn": "Полностью изъятый",
        "Complete Withdrawn List": "Полный список отозванных",
        "Confirm By": "Подтвердите с помощью",
        "Day End Of Month": "День Окончания Месяца",
        Email: "Электронная почта",
        "All Purchase": "Все покупки",
        Onetime: "Когда-то",
        "Balance Add Account After": "Баланс Добавьте в учетную запись после",
        "In Days": "В днях",
        "Transfer Approval Need ?": "Требуется одобрение перевода?",
        "Affiliate Account Current Balance": "Текущий баланс партнерского счета",
        "Commission Approved": "Комиссия одобрила",
        Email_or_Username: "Электронная почта / Имя пользователя",
        Submit: "Представить",
        Save: "Сохранить",
        Update: "Обновление",
        Welcome: "Добро пожаловать",
        "Join Our Affiliate Program":
            "Присоединяйтесь к нашей Партнерской программе",
        "Join Affiliate Program": "Присоединяйтесь к Партнерской программе",
        "Admin Approval Need For Affiliate User ?":
            "Требуется одобрение администратора для Аффилированного пользователя?",
        "Product Wise": "С точки зрения продукта",
        "Category Wise": "С точки зрения категории",
        "Amount Type": "Тип суммы",
        "Category Wise Commission Setup": "Создание комиссии по категориям",
        Others: "Другие",
        "All Category": "Все категории",
        Category: "Категория",
        "Calculation Method": "Способ расчета",
        Users: "Пользователи",
        "All User": "Все пользователи",
        "Active User": "Активный пользователь",
        "Inactive User": "Неактивный пользователь",
        Info: "Инфо",
        "Your affiliate joining request is under review. After confirming your request you can join our affiliate program.":
            "Ваш запрос на присоединение к партнерской программе находится на рассмотрении. После подтверждения вашего запроса вы можете присоединиться к нашей партнерской программе.",
        Copy: "Копировать",
        "Commission Calculate For Multi Category":
            "Расчет комиссии для нескольких категорий",
        Minimum: "Минимальный",
        Average: "Средний",
        Maximum: "Максимальный",
        "Common Amount": "Общая сумма",
        "Common Calculation Method": "Распространенный метод расчета",
        "Are you sure to delete ?": "Вы уверены, что хотите удалить?",
        "Wallet Transfer Approval Need ?":
            "Требуется одобрение перевода с кошелька?",
        "Affiliate User Approval ?": "Одобрение аффилированного пользователя?",
        copy_link: "Скопировать ссылку",
        "You are blocked from admin. Please contact with admin.":
            "Вы заблокированы от администратора. Пожалуйста, свяжитесь с администратором.",
        trx_id: "Идентификатор Trx",
        "The requested bank account deleted successful":
            "Запрошенный банковский счет успешно удален",
        "The requested bank account created successful":
            "Запрошенный банковский счет создан успешно",
        "The requested bank account updated successful":
            "Запрошенный банковский счет успешно обновлен",
        "Account Name": "имя учетной записи",
        "Account Number": "номер счета",
        "The requested bank account is not found":
            "Запрошенный банковский счет не найден",
        support_lowercase: "поддержка",
        related_products: "сопутствующие товары",
        no_data: "Данные не найдены",
        "home_page.working_info": "Информация о работе веб-сайта",
        "home_page.working_info_list": "Список рабочей информации веб-сайта",
        Link: "Ссылка",
        terms_conditions: "правила и условия",
        subject_en: "Предмет En",
        subject_ru: "Предметt Ru",
        subject_hy: "Предмет Hy",
        template_en: "Шаблон En",
        template_ru: "Шаблон Ru",
        template_hy: "Шаблон Hy",
        "Google Merchant Center": "Торговый центр Google",
        "Products Export": "Экспорт продукции",
        "Click here go to Google Merchant Center google product category Link":
            "Нажмите здесь перейдите в торговый центр Google ссылка на категорию товаров Google",
        "home.action": "Домашние действия",
        old_price: "старая цена",
        basic_price: "базовая цена",
        product1: "Один продукт",
        template_1: "Шаблон 1",
        template_2: "Шаблон 2",
        template_3: "Шаблон 3",
        by_template_1: "По шаблону 1",
        by_template_2: "По шаблону 2",
        by_template_3: "По шаблону 3",
        "You have no products selected": "У вас нет выбранных продуктов",
        reason_lowercase: "причина",
        refused_cancelled_orders: "Отклоненные/отмененные заказы",
        otp_is_sent: "Отправлено сообщение OTP",
        otp: "OTP",
        enter_otp: "Введите OTP",
        resend_otp: "Повторно отправить OTP",
        otp_send_successful: "Отправка OTP прошла успешно",
        invalid_otp: "Недействительный OTP",
        otp_validation_time_expired: "Время проверки OTP истекло",
        something_wrong_on_otp_send: "Что-то не так с верхней отправкой",
        please_select_otp_type: "Пожалуйста, выберите тип OTP",
        otp_configuration: "Конфигурация OTP",
        code_validation_time_min: "Время проверки кода (мин)",
        otp_send_for_customer_registration: "Отправка OTP для регистрации клиента",
        otp_will_be_sent_according_to_customer_register_email_or_phone:
            "(OTP будет отправлен в соответствии с электронной почтой регистрации клиента или по телефону)",
        otp_send_for_seller_registration: "Отправка OTP для регистрации продавца",
        otp_type: "Тип OTP",
        otp_send_for_order_confiramtion: "Отправка OTP для подтверждения заказа",
        email_and_sms_should_be_configured_first:
            "СНАЧАЛА СЛЕДУЕТ НАСТРОИТЬ ЭЛЕКТРОННУЮ ПОЧТУ И SMS.",
        cod: "COD",
        update_json_markup: "Обновить разметку Json",
        create_json_markup: "Создать разметку в формате Json",
        home_json_markup: "Домашняя разметка JSON",
        brands_json_markup: "Разметка брендов в формате Json",
        percentage_lowercase: "процент",
        amount_lowercase: "сумма",
        defects_descr: "Описание дефектов",
        reason_en: "Возврат En",
        reason_ru: "Возврат Ru",
        reason_hy: "Возврат Hy",
        refund_reason: "Причина возврата денег",
        basic_info_full: "Основная информация",
        password_auth: "Введен неверный пароль.",
        required_if:
            "Поле :атрибут является обязательным, когда :other равно :value.",
        required_unless:
            "The :attribute field is required unless :other is in :values.",
        required_with:
            "Поле :attribute является обязательным, если присутствует параметр :values.",
        required_with_all:
            "Поле :атрибут является обязательным, если присутствуют значения :.",
        required_without:
            "Поле :attribute является обязательным, если параметр :values отсутствует.",
        required_without_all:
            "Поле атрибута : является обязательным, если ни одно из значений : не присутствует.",
        "Wholesale Price": "Оптовая цена",
        "Min QTY": "Минимальное кол-во",
        "Max QTY": "Максимальное кол-во",
        "Price per piece": "Цена за штуку",
        "Add More": "Добавить еще",
        service_brand_crumb: "Сервисный центр",
        services_title: "Негарантийное (платное) обслуживание",
        service_type_repair: "Вид ремонта",
        service_type_repair_price: "Цена",
        by_installation: "Путем установки",
        no_installation: "Нет установки",
        gift_products: "Подарки",
        slider_images_hy: "Изображения слайдера HY",
        slider_images_en: "Изображения слайдера EN",
        slider_images_ru: "Изображения слайдера RU",
        order_alert_text:
            "Ваши платежные реквизиты успешно отправлены для проверки. Пожалуйста, дождитесь ответа на ваше письмо. по адресу.",
        wait_for_redirect_to_payment:
            "Подождите, мы обрабатываем вашу транзакцию. <br /> Вы перенаправлены на страницу оплаты.",
        wait_for_order_confirm: "Подождите, мы обрабатываем вашу транзакцию.",
        yesterday: "Yesterday",
        days_ago: "days ago",
        add_attribute: "Add Attribute",
        coment: "Coment",
        key_word_list: "Key word list",
        add_a_new_key_word: "Add a new key word",
        key_words: "Key words",
        order_not_found_products: "Order not found products",
        watched: "Watched",
        not_exists: "Not exists",
        thanks_for_order_wait_for_call: "Спасибо за заказ, ждите звонка",
        go_url: "Go url",
        go_category_brand: "Go category/brand",
    },
};

export default lang;
